import * as i0 from '@angular/core';
import { EventEmitter, Component, ContentChild, TemplateRef, Input, Output, ElementRef, Directive, ChangeDetectorRef, NgZone, ViewChild, Injectable, Renderer2, HostBinding, HostListener, ViewChildren, Pipe, NgModule } from '@angular/core';
import { FormControl, Validators, FormArray, FormGroup, ReactiveFormsModule } from '@angular/forms';
import * as i1$1 from '@inflight/core-ng';
import { SettingsService, LastResponseService, CoreNg } from '@inflight/core-ng';
import { Subject, BehaviorSubject, interval, Subscription, fromEvent, timer } from 'rxjs';
import { addYears, format, parse, isValid, compareAsc } from 'date-fns';
import * as i1 from '@angular/router';
import { Router, ActivatedRoute, NavigationEnd, RouterModule } from '@angular/router';
import * as i2 from '@ngx-translate/core';
import { TranslateService, TranslateModule } from '@ngx-translate/core';
import { throttle, map, pairwise, share, filter, take } from 'rxjs/operators';
import { UrlUtils } from '@inflight/core-nlx';
import { trigger, state, style, transition, animate, keyframes, query, animateChild, group } from '@angular/animations';
import { CommonModule } from '@angular/common';
import * as i1$2 from '@ngrx/store';
import { createAction, props, Store, createReducer, on, StoreModule } from '@ngrx/store';
import { Title } from '@angular/platform-browser';
import { StepStatus } from '@inflight/core-models';
import * as Bowser from 'bowser';
import { __awaiter } from 'tslib';
import { cloneDeep } from 'lodash-es';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';
import * as ɵngcc2 from '@inflight/core-ng';
import * as ɵngcc3 from '@ngx-translate/core';
import * as ɵngcc4 from '@angular/forms';
import * as ɵngcc5 from '@angular/router';
import * as ɵngcc6 from '@angular/platform-browser';
import * as ɵngcc7 from '@ngrx/store';

const _c0 = function (a0) { return { "value": a0 }; };
function InputRangeComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "input", 2, 3);
    ɵngcc0.ɵɵlistener("change", function InputRangeComponent_ng_container_0_ng_container_2_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const _r4 = ɵngcc0.ɵɵreference(2); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.changeRange(_r4); })("input", function InputRangeComponent_ng_container_0_ng_container_2_Template_input_input_1_listener() { ɵngcc0.ɵɵrestoreView(_r6); const _r4 = ɵngcc0.ɵɵreference(2); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.changeRange(_r4); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "label", 4);
    ɵngcc0.ɵɵelementContainer(4, 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "ui-input", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("background-size", ctx_r1.activeSliderWidth + "% 100%");
    ɵngcc0.ɵɵpropertyInterpolate("min", ctx_r1.min);
    ɵngcc0.ɵɵpropertyInterpolate("max", ctx_r1.max);
    ɵngcc0.ɵɵpropertyInterpolate("value", ctx_r1.value);
    ɵngcc0.ɵɵpropertyInterpolate("step", ctx_r1.step);
    ɵngcc0.ɵɵattribute("data-if-id", ctx_r1.field.extraAttributes == null ? null : ctx_r1.field.extraAttributes.ifId);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(11, _c0, ctx_r1.value));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r1.field)("form", ctx_r1.form);
} }
const _c1 = function (a0) { return { "item": a0 }; };
function InputRangeComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "input", 2, 3);
    ɵngcc0.ɵɵlistener("change", function InputRangeComponent_ng_container_0_ng_container_3_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r10); const _r8 = ɵngcc0.ɵɵreference(2); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.changeRange(_r8); })("input", function InputRangeComponent_ng_container_0_ng_container_3_Template_input_input_1_listener() { ɵngcc0.ɵɵrestoreView(_r10); const _r8 = ɵngcc0.ɵɵreference(2); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.changeRange(_r8); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "label", 4);
    ɵngcc0.ɵɵelementContainer(4, 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "ui-select", 6);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("background-size", ctx_r2.activeSliderWidth + "% 100%");
    ɵngcc0.ɵɵpropertyInterpolate("min", ctx_r2.min);
    ɵngcc0.ɵɵpropertyInterpolate("max", ctx_r2.max);
    ɵngcc0.ɵɵpropertyInterpolate("value", ctx_r2.value);
    ɵngcc0.ɵɵpropertyInterpolate("step", ctx_r2.step);
    ɵngcc0.ɵɵattribute("data-if-id", ctx_r2.field.extraAttributes == null ? null : ctx_r2.field.extraAttributes.ifId);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(11, _c1, ctx_r2.item));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r2.field)("form", ctx_r2.form);
} }
function InputRangeComponent_ng_container_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "input", 7, 3);
    ɵngcc0.ɵɵlistener("input", function InputRangeComponent_ng_container_0_ng_container_4_Template_input_input_1_listener() { ɵngcc0.ɵɵrestoreView(_r14); const _r12 = ɵngcc0.ɵɵreference(2); const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.changeRange(_r12); })("change", function InputRangeComponent_ng_container_0_ng_container_4_Template_input_change_1_listener() { ɵngcc0.ɵɵrestoreView(_r14); const _r12 = ɵngcc0.ɵɵreference(2); const ctx_r15 = ɵngcc0.ɵɵnextContext(2); return ctx_r15.changeRange(_r12); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("background-size", ctx_r3.activeSliderWidth + "% 100%");
    ɵngcc0.ɵɵproperty("id", ctx_r3.field.id)("max", ctx_r3.max)("value", ctx_r3.value);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 6, ctx_r3.active));
} }
function InputRangeComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵtemplate(2, InputRangeComponent_ng_container_0_ng_container_2_Template, 6, 13, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(3, InputRangeComponent_ng_container_0_ng_container_3_Template, 6, 13, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(4, InputRangeComponent_ng_container_0_ng_container_4_Template, 6, 8, "ng-container", 0);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.field.nodeType === "input");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.field.nodeType === "select");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.field.nodeType === "fieldset");
} }
function InputSwitchComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r0.field.id + "-switch");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 2, ctx_r0.field.label));
} }
const _c2 = function (a0, a1) { return { "form-control-danger": a0, "is-invalid": a1 }; };
function InputComponent_ui_form_field_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "input", 3);
    ɵngcc0.ɵɵlistener("input", function InputComponent_ui_form_field_0_ng_template_1_Template_input_input_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const field_r3 = restoredCtx.field; const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.changeOccurred($event, field_r3); })("blur", function InputComponent_ui_form_field_0_ng_template_1_Template_input_blur_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const field_r3 = restoredCtx.field; const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.handleBlur(field_r3); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r3 = ctx.field;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("formControlName", field_r3.name)("field", field_r3)("ngClass", ɵngcc0.ɵɵpureFunction2(11, _c2, ctx_r2.hasError, ctx_r2.hasError))("readonly", field_r3.readonly);
    ɵngcc0.ɵɵattribute("data-if-id", field_r3.extraAttributes == null ? null : field_r3.extraAttributes.ifId)("placeholder", ɵngcc0.ɵɵpipeBind1(1, 9, field_r3.placeholder))("aria-invalid", ctx_r2.hasError)("aria-describedby", ctx_r2.ariaDescribedBy)("aria-errormessage", ctx_r2.ariaErrorMessage);
} }
function InputComponent_ui_form_field_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ui-form-field", 1);
    ɵngcc0.ɵɵtemplate(1, InputComponent_ui_form_field_0_ng_template_1_Template, 2, 14, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("has-value", !!(ctx_r0.FormCtrl == null ? null : ctx_r0.FormCtrl.value));
    ɵngcc0.ɵɵproperty("field", ctx_r0.field)("formGroup", ctx_r0.form)("form", ctx_r0.form)("formCtrl", ctx_r0.FormCtrl)("hasError", ctx_r0.hasError)("updateOn", ctx_r0.updateOn);
} }
function InputFileComponent_ui_form_field_0_ng_template_1_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "input", 6);
    ɵngcc0.ɵɵlistener("input", function InputFileComponent_ui_form_field_0_ng_template_1_div_0_Template_input_input_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const field_r3 = ɵngcc0.ɵɵnextContext().field; const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.fileChangeOccurred($event, field_r3); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "button", 7);
    ɵngcc0.ɵɵelement(3, "i", 8);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r3 = ɵngcc0.ɵɵnextContext().field;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r4.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", field_r3.name)("field", field_r3)("ngClass", ɵngcc0.ɵɵpureFunction2(8, _c2, ctx_r4.hasError, ctx_r4.hasError));
    ɵngcc0.ɵɵattribute("data-if-id", field_r3.extraAttributes == null ? null : field_r3.extraAttributes.ifId);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(5, 6, ctx_r4.uploadText), " ");
} }
function InputFileComponent_ui_form_field_0_ng_template_1_div_1_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 9);
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵelement(3, "i", 11);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 12);
    ɵngcc0.ɵɵelementStart(5, "div", 13);
    ɵngcc0.ɵɵelementStart(6, "div", 14);
    ɵngcc0.ɵɵelementStart(7, "div", 15);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "div", 16);
    ɵngcc0.ɵɵelementStart(10, "button", 17);
    ɵngcc0.ɵɵlistener("click", function InputFileComponent_ui_form_field_0_ng_template_1_div_1_Template_button_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(3); return ctx_r10.removeFile(); });
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵpipe(12, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(8);
    ɵngcc0.ɵɵtextInterpolate(ctx_r5.fileName);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 2, "ui.controls.input-file.delete"));
} }
function InputFileComponent_ui_form_field_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, InputFileComponent_ui_form_field_0_ng_template_1_div_0_Template, 6, 11, "div", 3);
    ɵngcc0.ɵɵtemplate(1, InputFileComponent_ui_form_field_0_ng_template_1_div_1_Template, 13, 4, "div", 4);
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.fileName);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.fileName);
} }
function InputFileComponent_ui_form_field_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ui-form-field", 1);
    ɵngcc0.ɵɵtemplate(1, InputFileComponent_ui_form_field_0_ng_template_1_Template, 2, 2, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r0.field)("form", ctx_r0.form)("formCtrl", ctx_r0.FormCtrl)("hasError", ctx_r0.hasError)("updateOn", ctx_r0.updateOn);
} }
const _c3 = ["datepicker"];
function ButtonGroupComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "button", 7);
    ɵngcc0.ɵɵlistener("click", function ButtonGroupComponent_div_3_Template_button_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.handleClick($event, ctx_r3.primaryAction, ctx_r3.primaryClick); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r0.primaryAction);
    ɵngcc0.ɵɵattribute("data-if-id", (ctx_r0.primaryAction.extraAttributes == null ? null : ctx_r0.primaryAction.extraAttributes.ifId) ? ctx_r0.primaryAction.extraAttributes.ifId + "primary" : "primary");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 3, ctx_r0.primaryAction.text), " ");
} }
function ButtonGroupComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "button", 9);
    ɵngcc0.ɵɵlistener("click", function ButtonGroupComponent_div_4_Template_button_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(); return ctx_r5.handleClick($event, ctx_r5.secondaryAction, ctx_r5.secondaryClick); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r1.secondaryAction);
    ɵngcc0.ɵɵattribute("data-if-id", (ctx_r1.secondaryAction.extraAttributes == null ? null : ctx_r1.secondaryAction.extraAttributes.ifId) ? ctx_r1.secondaryAction.extraAttributes.ifId + "-secondary" : "secondary");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 3, ctx_r1.secondaryAction.text), " ");
} }
function ButtonGroupComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementStart(1, "button", 9);
    ɵngcc0.ɵɵlistener("click", function ButtonGroupComponent_div_5_Template_button_click_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r7 = ɵngcc0.ɵɵnextContext(); return ctx_r7.handleClick($event, ctx_r7.tertiaryAction, ctx_r7.tertiaryClick); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r2.tertiaryAction);
    ɵngcc0.ɵɵattribute("data-if-id", (ctx_r2.tertiaryAction.extraAttributes == null ? null : ctx_r2.tertiaryAction.extraAttributes.ifId) ? ctx_r2.tertiaryAction.extraAttributes.ifId + "-tertiary" : "tertiary");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 3, ctx_r2.tertiaryAction.text), " ");
} }
function ListViewComponent_li_1_a_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 10);
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", item_r1.header, ɵngcc0.ɵɵsanitizeHtml);
} }
const _c4 = function (a0, a1) { return { "item": a0, "idx": a1 }; };
function ListViewComponent_li_1_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r10 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 5);
    ɵngcc0.ɵɵlistener("click", function ListViewComponent_li_1_a_1_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r10); const item_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.action(item_r1); })("keydown.enter", function ListViewComponent_li_1_a_1_Template_a_keydown_enter_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const item_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r11 = ɵngcc0.ɵɵnextContext(); return ctx_r11.action(item_r1, $event); })("keydown.Space", function ListViewComponent_li_1_a_1_Template_a_keydown_Space_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r10); const item_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.action(item_r1, $event); });
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵelement(2, "i");
    ɵngcc0.ɵɵelementStart(3, "div", 7);
    ɵngcc0.ɵɵlistener("keydown.enter", function ListViewComponent_li_1_a_1_Template_div_keydown_enter_3_listener($event) { return $event.stopPropagation(); })("keydown.Space", function ListViewComponent_li_1_a_1_Template_div_keydown_Space_3_listener($event) { return $event.stopPropagation(); });
    ɵngcc0.ɵɵtemplate(4, ListViewComponent_li_1_a_1_div_4_Template, 1, 1, "div", 8);
    ɵngcc0.ɵɵelementContainer(5, 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext();
    const item_r1 = ctx_r17.$implicit;
    const i_r2 = ctx_r17.index;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("role", item_r1.isButton ? "button" : "link");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassMapInterpolate1("ifc-icon ifc-icon-2 p-4 text-center ", item_r1.icon, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.header);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.listItemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(7, _c4, item_r1, i_r2));
} }
function ListViewComponent_li_1_ng_template_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 10);
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", item_r1.header, ɵngcc0.ɵɵsanitizeHtml);
} }
function ListViewComponent_li_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelement(1, "i");
    ɵngcc0.ɵɵelementStart(2, "div", 11);
    ɵngcc0.ɵɵtemplate(3, ListViewComponent_li_1_ng_template_2_div_3_Template, 1, 1, "div", 8);
    ɵngcc0.ɵɵelementContainer(4, 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext();
    const item_r1 = ctx_r20.$implicit;
    const i_r2 = ctx_r20.index;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate1("ifc-icon ifc-icon-2 p-4 text-center ", item_r1.icon, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.header);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.listItemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(6, _c4, item_r1, i_r2));
} }
function ListViewComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 2);
    ɵngcc0.ɵɵtemplate(1, ListViewComponent_li_1_a_1_Template, 6, 10, "a", 3);
    ɵngcc0.ɵɵtemplate(2, ListViewComponent_li_1_ng_template_2_Template, 5, 9, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const _r4 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.action)("ngIfElse", _r4);
} }
function TileViewComponent_li_1_a_1_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("ifc-icon ifc-icon-2 p-4 ", item_r1.icon, "");
} }
function TileViewComponent_li_1_a_1_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 11);
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", item_r1.header, ɵngcc0.ɵɵsanitizeHtml);
} }
function TileViewComponent_li_1_a_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 12);
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", item_r1.subtext, ɵngcc0.ɵɵsanitizeHtml);
} }
function TileViewComponent_li_1_a_1_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementContainer(1, 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r9.tileTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c1, item_r1));
} }
function TileViewComponent_li_1_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r16 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 5);
    ɵngcc0.ɵɵlistener("click", function TileViewComponent_li_1_a_1_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r16); const item_r1 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.action(item_r1.action); });
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵtemplate(2, TileViewComponent_li_1_a_1_i_2_Template, 1, 3, "i", 7);
    ɵngcc0.ɵɵtemplate(3, TileViewComponent_li_1_a_1_div_3_Template, 1, 1, "div", 8);
    ɵngcc0.ɵɵtemplate(4, TileViewComponent_li_1_a_1_div_4_Template, 1, 1, "div", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, TileViewComponent_li_1_a_1_div_5_Template, 2, 4, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("role", item_r1.isButton ? "button" : null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.header);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.subtext);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.tileTemplate);
} }
function TileViewComponent_li_1_ng_template_2_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("ifc-icon ifc-icon-2 p-4 ", item_r1.icon, "");
} }
function TileViewComponent_li_1_ng_template_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 17);
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", item_r1.header, ɵngcc0.ɵɵsanitizeHtml);
} }
function TileViewComponent_li_1_ng_template_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 12);
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵproperty("innerHTML", item_r1.subtext, ɵngcc0.ɵɵsanitizeHtml);
} }
function TileViewComponent_li_1_ng_template_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 13);
    ɵngcc0.ɵɵelementContainer(1, 14);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r21 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r21.tileTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c1, item_r1));
} }
function TileViewComponent_li_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "div", 6);
    ɵngcc0.ɵɵtemplate(2, TileViewComponent_li_1_ng_template_2_i_2_Template, 1, 3, "i", 7);
    ɵngcc0.ɵɵtemplate(3, TileViewComponent_li_1_ng_template_2_div_3_Template, 1, 1, "div", 16);
    ɵngcc0.ɵɵtemplate(4, TileViewComponent_li_1_ng_template_2_div_4_Template, 1, 1, "div", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, TileViewComponent_li_1_ng_template_2_div_5_Template, 2, 4, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.header);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.subtext);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.tileTemplate);
} }
function TileViewComponent_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 2);
    ɵngcc0.ɵɵtemplate(1, TileViewComponent_li_1_a_1_Template, 6, 5, "a", 3);
    ɵngcc0.ɵɵtemplate(2, TileViewComponent_li_1_ng_template_2_Template, 6, 4, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r1 = ctx.$implicit;
    const _r4 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", item_r1.action)("ngIfElse", _r4);
} }
function GenericEditComponent_div_5_ng_container_2_ui_select_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-select", 14);
} if (rf & 2) {
    const field_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", field_r3)("form", ctx_r4.form);
} }
function GenericEditComponent_div_5_ng_container_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(field_r3.text);
} }
function GenericEditComponent_div_5_ng_container_2_ui_input_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-input", 14);
} if (rf & 2) {
    const field_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", field_r3)("form", ctx_r6.form);
} }
function GenericEditComponent_div_5_ng_container_2_ui_input_date_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-input-date", 14);
} if (rf & 2) {
    const field_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", field_r3)("form", ctx_r7.form);
} }
function GenericEditComponent_div_5_ng_container_2_ui_checkbox_radio_7_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ui-checkbox-radio", 16);
    ɵngcc0.ɵɵlistener("change", function GenericEditComponent_div_5_ng_container_2_ui_checkbox_radio_7_Template_ui_checkbox_radio_change_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const field_r3 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r13 = ɵngcc0.ɵɵnextContext(2); return ctx_r13.action(field_r3); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", field_r3)("form", ctx_r8.form);
} }
function GenericEditComponent_div_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, GenericEditComponent_div_5_ng_container_2_ui_select_1_Template, 1, 2, "ui-select", 9);
    ɵngcc0.ɵɵelementStart(2, "div", 10);
    ɵngcc0.ɵɵelementStart(3, "div", 11);
    ɵngcc0.ɵɵtemplate(4, GenericEditComponent_div_5_ng_container_2_div_4_Template, 2, 1, "div", 12);
    ɵngcc0.ɵɵtemplate(5, GenericEditComponent_div_5_ng_container_2_ui_input_5_Template, 1, 2, "ui-input", 9);
    ɵngcc0.ɵɵtemplate(6, GenericEditComponent_div_5_ng_container_2_ui_input_date_6_Template, 1, 2, "ui-input-date", 9);
    ɵngcc0.ɵɵtemplate(7, GenericEditComponent_div_5_ng_container_2_ui_checkbox_radio_7_Template, 1, 2, "ui-checkbox-radio", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const field_r3 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r3.nodeType === "select");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", field_r3.nodeType === "span");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r3.nodeType === "input" && field_r3.type === "text");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r3.nodeType === "input" && field_r3.type === "date");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", field_r3.nodeType === "input" && (field_r3.type === "checkbox" || field_r3.type === "radio"));
} }
function GenericEditComponent_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelement(1, "ui-error-box", 7);
    ɵngcc0.ɵɵtemplate(2, GenericEditComponent_div_5_ng_container_2_Template, 8, 5, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("error", ctx_r0.edit.errors)("invalidFieldSelector", ctx_r0.invalidFieldSelector);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.edit.page.content);
} }
function GenericEditComponent_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "ui-button-group", 18);
    ɵngcc0.ɵɵlistener("primaryClick", function GenericEditComponent_div_6_Template_ui_button_group_primaryClick_1_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(); return ctx_r18.save(); })("secondaryClick", function GenericEditComponent_div_6_Template_ui_button_group_secondaryClick_1_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r20 = ɵngcc0.ɵɵnextContext(); return ctx_r20.cancel(); })("tertiaryClick", function GenericEditComponent_div_6_Template_ui_button_group_tertiaryClick_1_listener() { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r21 = ɵngcc0.ɵɵnextContext(); return ctx_r21.delete(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const actions_r17 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("primaryAction", actions_r17.save)("secondaryAction", actions_r17.cancel)("tertiaryAction", actions_r17.delete);
} }
const _c5 = function (a0) { return { "card p-4": a0 }; };
function LoadingComponent_ui_loading_spinner_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-loading-spinner");
} }
const _c6 = function (a0) { return { "active": a0 }; };
function ErrorComponent_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelementStart(1, "a", 7);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "ui.error.more_details"));
} }
function ErrorComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 8);
    ɵngcc0.ɵɵelementStart(1, "textarea", 9);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.errorDetails);
} }
function ErrorComponent_button_13_Template(rf, ctx) { if (rf & 1) {
    const _r4 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 10);
    ɵngcc0.ɵɵlistener("click", function ErrorComponent_button_13_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r4); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.goHome(); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "ui.error.return_home"));
} }
const _c7 = ["*"];
const _c8 = function (a0, a1) { return { "year": a0, "company": a1 }; };
function AttachmentsComponent_div_0_ng_container_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "ui.attachments.download"));
} }
function AttachmentsComponent_div_0_ng_container_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "ui.attachments.view_attachment"));
} }
function AttachmentsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "div", 3);
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "a", 5);
    ɵngcc0.ɵɵlistener("click", function AttachmentsComponent_div_0_Template_a_click_7_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const attachment_r1 = restoredCtx.$implicit; const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.updateAttachmentList(attachment_r1); });
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵtemplate(9, AttachmentsComponent_div_0_ng_container_9_Template, 3, 3, "ng-container", 6);
    ɵngcc0.ɵɵtemplate(10, AttachmentsComponent_div_0_ng_container_10_Template, 3, 3, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const attachment_r1 = ctx.$implicit;
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 6, "ui.attachments.information"), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("href", ctx_r0.toAttachmentUrl(attachment_r1.url), ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(8, 8, "ui.attachments.title"));
    ɵngcc0.ɵɵattribute("download", ctx_r0.forceDownloadOption ? "" : null);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.forceDownloadOption);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.forceDownloadOption);
} }
function ResponsiveImgComponent_picture_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "picture");
    ɵngcc0.ɵɵelement(1, "img", 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r0.img.src, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵattribute("sizes", ctx_r0.img.sizes)("srcset", ctx_r0.img.srcset, ɵngcc0.ɵɵsanitizeUrl)("alt", ctx_r0.alt || ctx_r0.img.alt)("role", !ctx_r0.alt && !ctx_r0.img.alt ? "presentation" : "");
} }
const _c9 = ["headerTemplate"];
const _c10 = ["bodyTemplate"];
const _c11 = ["footerTemplate"];
function ModalComponent_ng_container_2_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵelementContainer(1, 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.headerTemplate);
} }
function ModalComponent_ng_container_2_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelementContainer(1, 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.bodyTemplate);
} }
function ModalComponent_ng_container_2_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 10);
    ɵngcc0.ɵɵelementContainer(1, 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.footerTemplate);
} }
const _c12 = function (a0) { return { "modal-dialog-scrollable": a0 }; };
function ModalComponent_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵtemplate(3, ModalComponent_ng_container_2_div_3_Template, 2, 1, "div", 4);
    ɵngcc0.ɵɵtemplate(4, ModalComponent_ng_container_2_div_4_Template, 2, 1, "div", 5);
    ɵngcc0.ɵɵtemplate(5, ModalComponent_ng_container_2_div_5_Template, 2, 1, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c12, ctx_r0.scrollable))("focusedElementSelector", ctx_r0.focusedElementSelector)("lastFocusableElementId", ctx_r0.lastFocusableElementId)("isAlertDialog", ctx_r0.isAlertDialog);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.headerTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.bodyTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.footerTemplate);
} }
function ModalComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "div", 11);
    ɵngcc0.ɵɵelementContainerEnd();
} }
const _c13 = function (a0, a1, a2) { return { "show": a0, "d-block": a1, "d-none": a2 }; };
function ProxyUrlComponent_div_0_div_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "ui.proxy_url.popup_blocker_text"));
} }
function ProxyUrlComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "p");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(6, "div", 4);
    ɵngcc0.ɵɵelementStart(7, "div", 5);
    ɵngcc0.ɵɵelementStart(8, "input", 6);
    ɵngcc0.ɵɵlistener("change", function ProxyUrlComponent_div_0_Template_input_change_8_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.promptChanged($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(9, "label", 7);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(12, ProxyUrlComponent_div_0_div_12_Template, 3, 3, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(13, "div", 9);
    ɵngcc0.ɵɵelementStart(14, "a", 10);
    ɵngcc0.ɵɵlistener("click", function ProxyUrlComponent_div_0_Template_a_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.open(); });
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵpipe(16, "translate");
    ɵngcc0.ɵɵelementStart(17, "span", 11);
    ɵngcc0.ɵɵtext(18);
    ɵngcc0.ɵɵpipe(19, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(5, 8, "ui.proxy_url.description"), " ");
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 10, "ui.proxy_url.do_not_prompt_text"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.doNotPrompt);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("title", ctx_r0.data.title)("href", ctx_r0.data.proxyUrl, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate2(" ", ɵngcc0.ɵɵpipeBind1(16, 12, "ui.proxy_url.open"), " ", ctx_r0.data.title, " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(19, 14, "ui.proxy_url.new_window_text"));
} }
function TrackingPixelsComponent_div_0_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 2);
} if (rf & 2) {
    const pixel_r2 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("src", pixel_r2.src, ɵngcc0.ɵɵsanitizeUrl);
} }
function TrackingPixelsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtemplate(1, TrackingPixelsComponent_div_0_img_1_Template, 1, 1, "img", 1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.pixels);
} }
const _c14 = function (a0) { return { "order-lg-1": a0 }; };
const _c15 = function (a0, a1) { return { "order-lg-2 ml-lg-auto": a0, "mr-lg-auto": a1 }; };
const _c16 = function (a0) { return [a0]; };
function CookieAdvisoryBannerComponent_div_0_a_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 4);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(4, _c16, ctx_r1.disclaimerRoute));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 2, "ui.cookie.learn_more"));
} }
function CookieAdvisoryBannerComponent_div_0_ng_template_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("href", ctx_r3.disclaimerRoute, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 2, "ui.cookie.learn_more"));
} }
function CookieAdvisoryBannerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "p");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementStart(5, "span");
    ɵngcc0.ɵɵtemplate(6, CookieAdvisoryBannerComponent_div_0_a_6_Template, 3, 6, "a", 1);
    ɵngcc0.ɵɵtemplate(7, CookieAdvisoryBannerComponent_div_0_ng_template_7_Template, 3, 4, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, ". ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div");
    ɵngcc0.ɵɵelementStart(11, "button", 3);
    ɵngcc0.ɵɵlistener("click", function CookieAdvisoryBannerComponent_div_0_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.closeBanner(); });
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵpipe(13, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r2 = ɵngcc0.ɵɵreference(8);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(4, 4, "ui.cookie.cookie_message"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.isExternal)("ngIfElse", _r2);
    ɵngcc0.ɵɵadvance(6);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(13, 6, "ui.cookie_banner.accept"), " ");
} }
function CookieExplicitBannerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "p");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementStart(5, "span");
    ɵngcc0.ɵɵelementStart(6, "a", 1);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtext(9, ". ");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div");
    ɵngcc0.ɵɵelementStart(11, "button", 2);
    ɵngcc0.ɵɵlistener("click", function CookieExplicitBannerComponent_div_0_Template_button_click_11_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.accept(); });
    ɵngcc0.ɵɵtext(12);
    ɵngcc0.ɵɵpipe(13, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "button", 2);
    ɵngcc0.ɵɵlistener("click", function CookieExplicitBannerComponent_div_0_Template_button_click_14_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r3 = ɵngcc0.ɵɵnextContext(); return ctx_r3.decline(); });
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵpipe(16, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(4, 5, "ui.cookie.cookie_message"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(13, _c16, ctx_r0.disclaimerRoute));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 7, "ui.cookie.learn_more"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(13, 9, "ui.cookie_banner.accept"), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(16, 11, "ui.cookie_banner.decline"), " ");
} }
const _c17 = ["customFooterContent"];
function FooterComponent_ng_container_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function FooterComponent_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FooterComponent_ng_container_3_ng_container_1_Template, 1, 0, "ng-container", 5);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.customFooterContent);
} }
function FooterComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, "ui.footer.copyright", ctx_r1.footerParams));
} }
function FooterComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtext(0);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(1, 1, "ui.copyright_no_company", ctx_r3.footerParams));
} }
function SelectComponent_ui_form_field_0_ng_template_1_select_0_option_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "option", 6);
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const option_r6 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("value", ɵngcc0.ɵɵpipeBind1(1, 5, option_r6.value))("selected", option_r6.selected)("disabled", option_r6.disabled);
    ɵngcc0.ɵɵattribute("data-if-id", option_r6.ifId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 7, option_r6.text));
} }
function SelectComponent_ui_form_field_0_ng_template_1_select_0_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "select", 4);
    ɵngcc0.ɵɵlistener("change", function SelectComponent_ui_form_field_0_ng_template_1_select_0_Template_select_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const field_r3 = ɵngcc0.ɵɵnextContext().field; const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.changeOccurred($event, field_r3); })("blur", function SelectComponent_ui_form_field_0_ng_template_1_select_0_Template_select_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(3); return ctx_r10.checkForError(); });
    ɵngcc0.ɵɵtemplate(1, SelectComponent_ui_form_field_0_ng_template_1_select_0_option_1_Template, 4, 9, "option", 5);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r3 = ɵngcc0.ɵɵnextContext().field;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", field_r3.id)("required", field_r3.required)("formControlName", field_r3.name)("ngClass", ɵngcc0.ɵɵpureFunction2(10, _c2, ctx_r4.hasError, ctx_r4.hasError));
    ɵngcc0.ɵɵattribute("aria-invalid", ctx_r4.hasError)("data-if-id", field_r3.extraAttributes ? field_r3.extraAttributes.ifId : undefined)("aria-describedby", ctx_r4.ariaDescribedBy)("aria-errormessage", ctx_r4.ariaErrorMessage);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", field_r3.options)("ngForTrackBy", ctx_r4.trackByFn);
} }
function SelectComponent_ui_form_field_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SelectComponent_ui_form_field_0_ng_template_1_select_0_Template, 2, 13, "select", 3);
} if (rf & 2) {
    const field_r3 = ctx.field;
    ɵngcc0.ɵɵproperty("ngIf", field_r3 && field_r3.nodeType === "select");
} }
function SelectComponent_ui_form_field_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ui-form-field", 1);
    ɵngcc0.ɵɵtemplate(1, SelectComponent_ui_form_field_0_ng_template_1_Template, 1, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r0.field)("formGroup", ctx_r0.form)("form", ctx_r0.form)("formCtrl", ctx_r0.FormCtrl)("hasError", ctx_r0.hasError)("updateOn", ctx_r0.updateOn);
} }
function HiddensComponent_input_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "input", 2);
} if (rf & 2) {
    const field_r1 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("id", field_r1.id)("formControlName", field_r1.name);
} }
function RadioComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.errorMessage);
} }
const _c18 = function (a0, a1) { return { error: a0, required: a1 }; };
function RadioComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "input", 2);
    ɵngcc0.ɵɵlistener("change", function RadioComponent_div_0_Template_input_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.changeOccurred($event, ctx_r2.field); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(2, "label", 3);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵtemplate(4, RadioComponent_div_0_div_4_Template, 2, 1, "div", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r0.field.name)("type", ctx_r0.field.type)("name", ctx_r0.field.name)("id", ctx_r0.field.id)("value", ctx_r0.field == null ? null : ctx_r0.field.value)("checked", ctx_r0.field.checked);
    ɵngcc0.ɵɵattribute("data-if-id", ctx_r0.field.extraAttributes == null ? null : ctx_r0.field.extraAttributes.ifId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("for", ctx_r0.field.id)("ngClass", ɵngcc0.ɵɵpureFunction2(14, _c18, ctx_r0.hasError, ctx_r0.field.required))("innerHTML", ɵngcc0.ɵɵpipeBind1(3, 12, ctx_r0.field.label), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasError);
} }
function CheckRadioComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "ui-checkbox", 1);
    ɵngcc0.ɵɵlistener("change", function CheckRadioComponent_ng_container_0_Template_ui_checkbox_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.changeOccurred($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r0.field)("form", ctx_r0.form)("validators", ctx_r0.validators)("asyncValidators", ctx_r0.asyncValidators);
} }
function CheckRadioComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "ui-radio", 1);
    ɵngcc0.ɵɵlistener("change", function CheckRadioComponent_ng_container_1_Template_ui_radio_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.changeOccurred($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r1.field)("form", ctx_r1.form)("validators", ctx_r1.validators)("asyncValidators", ctx_r1.asyncValidators);
} }
function TextAreaComponent_ui_form_field_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "textarea", 3);
    ɵngcc0.ɵɵlistener("input", function TextAreaComponent_ui_form_field_0_ng_template_1_Template_textarea_input_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const field_r3 = restoredCtx.field; const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.changeOccurred($event, field_r3); })("blur", function TextAreaComponent_ui_form_field_0_ng_template_1_Template_textarea_blur_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.checkForError(); });
    ɵngcc0.ɵɵtext(1, "          ");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r3 = ctx.field;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", field_r3.id)("formControlName", field_r3.name)("name", field_r3.name)("required", field_r3.required)("ngClass", ɵngcc0.ɵɵpureFunction2(11, _c2, ctx_r2.hasError, ctx_r2.hasError))("maxlength", field_r3.maxlength)("readonly", field_r3.readonly);
    ɵngcc0.ɵɵattribute("data-if-id", field_r3.extraAttributes == null ? null : field_r3.extraAttributes.ifId)("aria-describedby", ctx_r2.ariaDescribedBy)("aria-errormessage", ctx_r2.ariaErrorMessage)("aria-invalid", ctx_r2.hasError);
} }
function TextAreaComponent_ui_form_field_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ui-form-field", 1);
    ɵngcc0.ɵɵtemplate(1, TextAreaComponent_ui_form_field_0_ng_template_1_Template, 2, 14, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r0.field)("formGroup", ctx_r0.form)("form", ctx_r0.form)("formCtrl", ctx_r0.FormCtrl)("hasError", ctx_r0.hasError)("updateOn", ctx_r0.updateOn);
} }
const _c19 = ["customButtonLabel"];
const _c20 = ["selectFieldset"];
function SelectButtonsComponent_ui_form_field_3_ng_template_1_ng_container_1_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c21 = function (a0, a1) { return { "message": a0, "idx": a1 }; };
function SelectButtonsComponent_ui_form_field_3_ng_template_1_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, SelectButtonsComponent_ui_form_field_3_ng_template_1_ng_container_1_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 10);
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext();
    const option_r8 = ctx_r13.$implicit;
    const idx_r9 = ctx_r13.index;
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    const _r2 = ɵngcc0.ɵɵreference(5);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r11.customButtonLabel ? ctx_r11.customButtonLabel : _r2)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c21, option_r8.text, idx_r9));
} }
function SelectButtonsComponent_ui_form_field_3_ng_template_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "ui-radio-button", 8);
    ɵngcc0.ɵɵlistener("updateField", function SelectButtonsComponent_ui_form_field_3_ng_template_1_ng_container_1_Template_ui_radio_button_updateField_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(3); return ctx_r14.updateResponseField($event); })("updateOnNextChange", function SelectButtonsComponent_ui_form_field_3_ng_template_1_ng_container_1_Template_ui_radio_button_updateOnNextChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(3); return ctx_r16.updateNextChange($event); });
    ɵngcc0.ɵɵtemplate(2, SelectButtonsComponent_ui_form_field_3_ng_template_1_ng_container_1_ng_template_2_Template, 1, 5, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const option_r8 = ctx.$implicit;
    const idx_r9 = ctx.index;
    const field_r6 = ɵngcc0.ɵɵnextContext().field;
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleMap(ctx_r7.style && ctx_r7.style[idx_r9] ? ctx_r7.style[idx_r9] : "");
    ɵngcc0.ɵɵproperty("id", field_r6.id + option_r8.index)("name", field_r6.name)("active", option_r8.value === field_r6.value)("label", option_r8.text)("value", option_r8.value);
} }
function SelectButtonsComponent_ui_form_field_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵlistener("focusout", function SelectButtonsComponent_ui_form_field_3_ng_template_1_Template_div_focusout_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); const ctx_r18 = ɵngcc0.ɵɵnextContext(2); return ctx_r18.checkRequired($event); });
    ɵngcc0.ɵɵtemplate(1, SelectButtonsComponent_ui_form_field_3_ng_template_1_ng_container_1_Template, 4, 7, "ng-container", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r6 = ctx.field;
    ɵngcc0.ɵɵclassProp("ng-invalid", !field_r6.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", field_r6.options);
} }
function SelectButtonsComponent_ui_form_field_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ui-form-field", 4);
    ɵngcc0.ɵɵtemplate(1, SelectButtonsComponent_ui_form_field_3_ng_template_1_Template, 2, 3, "ng-template", null, 5, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r1.field)("formGroup", ctx_r1.form)("form", ctx_r1.form)("formCtrl", ctx_r1.FormCtrl)("hasError", ctx_r1.hasError)("updateOn", ctx_r1.updateOn);
} }
function SelectButtonsComponent_ng_template_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r20 = ctx.message;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, message_r20));
} }
function BreadcrumbsComponent_ng_container_0_div_3_div_1_a_1_i_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 9);
} if (rf & 2) {
    const crumb_r3 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵclassMap(crumb_r3.icon);
} }
function BreadcrumbsComponent_ng_container_0_div_3_div_1_a_1_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const crumb_r3 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, crumb_r3.screenReaderOnlyText));
} }
function BreadcrumbsComponent_ng_container_0_div_3_div_1_a_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 6);
    ɵngcc0.ɵɵtemplate(1, BreadcrumbsComponent_ng_container_0_div_3_div_1_a_1_i_1_Template, 1, 3, "i", 7);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵtemplate(4, BreadcrumbsComponent_ng_container_0_div_3_div_1_a_1_span_4_Template, 3, 3, "span", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const crumb_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("routerLink", crumb_r3.route)("queryParamsHandling", crumb_r3.queryParamsHandling)("queryParams", crumb_r3.queryParams);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", crumb_r3 == null ? null : crumb_r3.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1("", ɵngcc0.ɵɵpipeBind1(3, 6, crumb_r3.text), " ");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", crumb_r3 == null ? null : crumb_r3.screenReaderOnlyText);
} }
function BreadcrumbsComponent_ng_container_0_div_3_div_1_span_2_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const crumb_r3 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, crumb_r3.screenReaderOnlyText));
} }
function BreadcrumbsComponent_ng_container_0_div_3_div_1_span_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelement(1, "i");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵtemplate(4, BreadcrumbsComponent_ng_container_0_div_3_div_1_span_2_span_4_Template, 3, 3, "span", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const crumb_r3 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMap(crumb_r3.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 5, crumb_r3.text));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", crumb_r3 == null ? null : crumb_r3.screenReaderOnlyText);
} }
function BreadcrumbsComponent_ng_container_0_div_3_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 4);
    ɵngcc0.ɵɵtemplate(1, BreadcrumbsComponent_ng_container_0_div_3_div_1_a_1_Template, 5, 8, "a", 5);
    ɵngcc0.ɵɵtemplate(2, BreadcrumbsComponent_ng_container_0_div_3_div_1_span_2_Template, 5, 7, "span", 0);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const crumb_r3 = ctx.$implicit;
    ɵngcc0.ɵɵclassProp("active", crumb_r3.isActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !crumb_r3.isActive);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", crumb_r3.isActive);
} }
function BreadcrumbsComponent_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtemplate(1, BreadcrumbsComponent_ng_container_0_div_3_div_1_Template, 3, 4, "div", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.breadcrumbs);
} }
function BreadcrumbsComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "nav");
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵtemplate(3, BreadcrumbsComponent_ng_container_0_div_3_Template, 2, 1, "div", 1);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(2, 2, "ui.breadcrumbs.label"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.breadcrumbs);
} }
function FormControlComponent_ng_container_0_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.labelValue.label);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.labelValue.value);
} }
function FormControlComponent_ng_container_0_ng_container_2_ui_input_1_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ui-input", 5);
    ɵngcc0.ɵɵlistener("change", function FormControlComponent_ng_container_0_ng_container_2_ui_input_1_Template_ui_input_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(3); return ctx_r8.changeOccurred($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("field", ctx_r6.input)("form", ctx_r6.form);
} }
function FormControlComponent_ng_container_0_ng_container_2_ui_input_date_2_Template(rf, ctx) { if (rf & 1) {
    const _r11 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ui-input-date", 5);
    ɵngcc0.ɵɵlistener("change", function FormControlComponent_ng_container_0_ng_container_2_ui_input_date_2_Template_ui_input_date_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r11); const ctx_r10 = ɵngcc0.ɵɵnextContext(3); return ctx_r10.changeOccurred($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("field", ctx_r7.input)("form", ctx_r7.form);
} }
function FormControlComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FormControlComponent_ng_container_0_ng_container_2_ui_input_1_Template, 1, 2, "ui-input", 1);
    ɵngcc0.ɵɵtemplate(2, FormControlComponent_ng_container_0_ng_container_2_ui_input_date_2_Template, 1, 2, "ui-input-date", 1);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.input.dateFormat);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.input.dateFormat);
} }
function FormControlComponent_ng_container_0_ui_checkbox_radio_3_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ui-checkbox-radio", 5);
    ɵngcc0.ɵɵlistener("change", function FormControlComponent_ng_container_0_ui_checkbox_radio_3_Template_ui_checkbox_radio_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return ctx_r12.changeOccurred($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", ctx_r3.input)("form", ctx_r3.form);
} }
function FormControlComponent_ng_container_0_ui_select_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-select", 6);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", ctx_r4.select)("form", ctx_r4.form);
} }
function FormControlComponent_ng_container_0_ui_textarea_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-textarea", 6);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", ctx_r5.textarea)("form", ctx_r5.form);
} }
function FormControlComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, FormControlComponent_ng_container_0_span_1_Template, 6, 2, "span", 0);
    ɵngcc0.ɵɵtemplate(2, FormControlComponent_ng_container_0_ng_container_2_Template, 3, 2, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(3, FormControlComponent_ng_container_0_ui_checkbox_radio_3_Template, 1, 2, "ui-checkbox-radio", 1);
    ɵngcc0.ɵɵtemplate(4, FormControlComponent_ng_container_0_ui_select_4_Template, 1, 2, "ui-select", 2);
    ɵngcc0.ɵɵtemplate(5, FormControlComponent_ng_container_0_ui_textarea_5_Template, 1, 2, "ui-textarea", 2);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.labelValue);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.input && (ctx_r0.input.type === "text" || ctx_r0.input.type === "date"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.input == null ? null : ctx_r0.input.nodeType) === "input" && (ctx_r0.input.type === "checkbox" || ctx_r0.input.type === "radio"));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.select);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.textarea);
} }
function ErrorBoxComponent_div_1_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 9);
    ɵngcc0.ɵɵelement(1, "i", 10);
    ɵngcc0.ɵɵelement(2, "span", 11);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("innerHtml", ɵngcc0.ɵɵpipeBind1(3, 1, ctx_r1.error.title), ɵngcc0.ɵɵsanitizeHtml);
} }
function ErrorBoxComponent_div_1_p_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "p", 11);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHtml", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r2.error.message), ɵngcc0.ɵɵsanitizeHtml);
} }
function ErrorBoxComponent_div_1_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementStart(1, "a", 13);
    ɵngcc0.ɵɵlistener("click", function ErrorBoxComponent_div_1_div_6_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.focusFirstInvalid(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 1, "ui.error-box.go_to_label"), " ");
} }
function ErrorBoxComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "div", 4);
    ɵngcc0.ɵɵelementStart(3, "div", 5);
    ɵngcc0.ɵɵtemplate(4, ErrorBoxComponent_div_1_div_4_Template, 4, 3, "div", 6);
    ɵngcc0.ɵɵtemplate(5, ErrorBoxComponent_div_1_p_5_Template, 2, 3, "p", 7);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, ErrorBoxComponent_div_1_div_6_Template, 4, 3, "div", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.error == null ? null : ctx_r0.error.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.error == null ? null : ctx_r0.error.message);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.firstInvalidField);
} }
function FormFieldComponent_div_1_label_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "label", 8);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("required", ctx_r6.field.required);
    ɵngcc0.ɵɵproperty("for", ctx_r6.field.id)("innerHTML", ɵngcc0.ɵɵpipeBind1(1, 4, ctx_r6.field.label), ɵngcc0.ɵɵsanitizeHtml);
} }
const _c22 = function (a0) { return { "field": a0 }; };
function FormFieldComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵtemplate(1, FormFieldComponent_div_1_label_1_Template, 2, 6, "label", 6);
    ɵngcc0.ɵɵelementContainer(2, 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.field.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.template)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(3, _c22, ctx_r0.field));
} }
function FormFieldComponent_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 9);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r1.field.id + "_error_req")("innerHTML", ɵngcc0.ɵɵpipeBind1(1, 4, "ui.form_field.required_text"), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵattribute("role", !ctx_r1.busy ? "alert" : null)("aria-live", ctx_r1.busy ? "off" : "rude");
} }
function FormFieldComponent_span_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 9);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r2.field.id + "_error_custom")("innerHTML", ɵngcc0.ɵɵpipeBind1(1, 4, ctx_r2.form.controls[ctx_r2.field.name].errors.customErrorMsg), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵattribute("role", !ctx_r2.busy ? "alert" : null)("aria-live", ctx_r2.busy ? "off" : "rude");
} }
const _c23 = function (a0) { return { length: a0 }; };
function FormFieldComponent_span_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 9);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r3.field.id + "_error_minlength")("innerHTML", ɵngcc0.ɵɵpipeBind2(1, 4, "ui.form_field.min_length_required_text", ɵngcc0.ɵɵpureFunction1(7, _c23, ctx_r3.formCtrl == null ? null : ctx_r3.formCtrl.errors == null ? null : ctx_r3.formCtrl.errors.minlength == null ? null : ctx_r3.formCtrl.errors.minlength.requiredLength)), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵattribute("role", !ctx_r3.busy ? "alert" : null)("aria-live", ctx_r3.busy ? "off" : "rude");
} }
function FormFieldComponent_span_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 9);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r4.field.id + "_error_email")("innerHTML", ɵngcc0.ɵɵpipeBind1(1, 4, "ui.form_field.invalid_email_text"), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵattribute("role", !ctx_r4.busy ? "alert" : null)("aria-live", ctx_r4.busy ? "off" : "rude");
} }
function FormFieldComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 10);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r5.field.id + "_help")("innerHTML", ɵngcc0.ɵɵpipeBind1(1, 2, ctx_r5.field.helperText), ɵngcc0.ɵɵsanitizeHtml);
} }
function InputDateComponent_ui_form_field_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelement(1, "span", 4);
    ɵngcc0.ɵɵelementStart(2, "input", 5, 6);
    ɵngcc0.ɵɵlistener("input", function InputDateComponent_ui_form_field_0_ng_template_1_Template_input_input_2_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const field_r3 = restoredCtx.field; const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.changeOccurred($event, field_r3); })("change", function InputDateComponent_ui_form_field_0_ng_template_1_Template_input_change_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r7 = ɵngcc0.ɵɵnextContext(2); $event.stopPropagation(); return ctx_r7.dateChanged(); })("focus", function InputDateComponent_ui_form_field_0_ng_template_1_Template_input_focus_2_listener($event) { return $event.target.select(); })("blur", function InputDateComponent_ui_form_field_0_ng_template_1_Template_input_blur_2_listener() { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.checkForError(); })("keydown.arrowdown", function InputDateComponent_ui_form_field_0_ng_template_1_Template_input_keydown_arrowdown_2_listener($event) { return $event.stopImmediatePropagation(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 7);
    ɵngcc0.ɵɵlistener("click", function InputDateComponent_ui_form_field_0_ng_template_1_Template_button_click_4_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const field_r3 = restoredCtx.field; const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return !field_r3.disabled && ctx_r11.toggle(); });
    ɵngcc0.ɵɵelementStart(5, "span", 8);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(8, "i", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r3 = ctx.field;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", field_r3.id + "_desc")("innerText", ctx_r2.dateFormatDesc);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", field_r3.name)("ngClass", ɵngcc0.ɵɵpureFunction2(18, _c2, ctx_r2.hasError, ctx_r2.hasError))("required", field_r3.required && field_r3.required !== "false")("readonly", field_r3.readonly);
    ɵngcc0.ɵɵattribute("aria-invalid", ctx_r2.hasError)("aria-describedby", ctx_r2.ariaDescribedBy)("aria-errormessage", ctx_r2.ariaErrorMessage)("data-if-id", field_r3.extraAttributes == null ? null : field_r3.extraAttributes.ifId)("name", field_r3.name)("id", field_r3.id)("disabled", field_r3.disabled ? "" : null)("placeholder", field_r3.placeholder ? field_r3.placeholder : "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("data-if-id", field_r3.extraAttributes == null ? null : field_r3.extraAttributes.ifId);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 16, "ui.input-date.toggle_datepicker"));
} }
function InputDateComponent_ui_form_field_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ui-form-field", 1);
    ɵngcc0.ɵɵtemplate(1, InputDateComponent_ui_form_field_0_ng_template_1_Template, 9, 21, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r0.field)("formGroup", ctx_r0.form)("form", ctx_r0.form)("formCtrl", ctx_r0.FormCtrl)("hasError", ctx_r0.hasError)("updateOn", ctx_r0.updateOn);
} }
function ValidationCheckerComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r2 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "span", 2);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "a", 3);
    ɵngcc0.ɵɵlistener("click", function ValidationCheckerComponent_div_0_Template_a_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r2); const ctx_r1 = ɵngcc0.ɵɵnextContext(); return ctx_r1.focusFirstInvalid(); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "ui.validation.invalid_field_text"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(6, 4, "ui.validation.go_to_label"), " ");
} }
function CheckboxComponent_div_0_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.errorMessage);
} }
const _c24 = function (a0) { return { "srText": a0 }; };
function CheckboxComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "input", 2);
    ɵngcc0.ɵɵlistener("change", function CheckboxComponent_div_0_Template_input_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.changeOccurred($event, ctx_r2.field); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(2, "label", 3);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵtemplate(4, CheckboxComponent_div_0_div_4_Template, 2, 1, "div", 4);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", ctx_r0.field.name)("name", ctx_r0.field.name)("id", ctx_r0.field.id)("type", ctx_r0.field.type)("checked", ctx_r0.field.checked);
    ɵngcc0.ɵɵattribute("data-if-id", ctx_r0.field.extraAttributes == null ? null : ctx_r0.field.extraAttributes.ifId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("for", ctx_r0.field.id)("ngClass", ɵngcc0.ɵɵpureFunction2(14, _c18, ctx_r0.hasError, ctx_r0.field.required))("innerHTML", ɵngcc0.ɵɵpipeBind2(3, 11, ctx_r0.field.label, ɵngcc0.ɵɵpureFunction1(17, _c24, ctx_r0.srText)), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasError);
} }
const _c25 = function (a0) { return { "header": a0 }; };
function PageLayoutComponent_header_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "header");
    ɵngcc0.ɵɵelement(1, "ui-skip-to-main");
    ɵngcc0.ɵɵelementContainer(2, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.headerTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c25, ctx_r0.header));
} }
function PageLayoutComponent_ui_footer_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-footer");
} }
const _c26 = function (a0) { return { "footer": a0 }; };
function PageLayoutComponent_footer_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "footer");
    ɵngcc0.ɵɵelementContainer(1, 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.footerTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c26, ctx_r2.footer));
} }
const _c27 = ["custom"];
function NavBarComponent_a_3_img_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "img", 11);
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵpipe(2, "translate");
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("src", ɵngcc0.ɵɵpipeBind1(1, 2, ctx_r4.header.logoSrc), ɵngcc0.ɵɵsanitizeUrl)("alt", ɵngcc0.ɵɵpipeBind1(2, 4, ctx_r4.header.siteName));
} }
function NavBarComponent_a_3_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementStart(1, "span", 13);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, ctx_r5.header.siteName));
} }
const _c28 = function () { return ["/"]; };
function NavBarComponent_a_3_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 8);
    ɵngcc0.ɵɵlistener("click", function NavBarComponent_a_3_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r7); const ctx_r6 = ɵngcc0.ɵɵnextContext(); return ctx_r6.toggleNavbar(false); });
    ɵngcc0.ɵɵtemplate(1, NavBarComponent_a_3_img_1_Template, 3, 6, "img", 9);
    ɵngcc0.ɵɵtemplate(2, NavBarComponent_a_3_div_2_Template, 4, 3, "div", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction0(3, _c28));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.header.logoSrc);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.header.logoSrc);
} }
function NavBarComponent_ui_panel_alerts_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-panel-alerts", 14);
} }
function NavBarComponent_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 15);
    ɵngcc0.ɵɵlistener("click", function NavBarComponent_button_6_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(); return ctx_r8.toggleNavbar(); });
    ɵngcc0.ɵɵelement(1, "i", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-expanded", ctx_r2.isActive);
} }
function NavBarComponent_div_7_li_2_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const navLink_r14 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("ifc-icon ", navLink_r14.icon, " mr-2 align-middle");
} }
const _c29 = function () { return { exact: true }; };
function NavBarComponent_div_7_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 22);
    ɵngcc0.ɵɵelementStart(1, "a", 23);
    ɵngcc0.ɵɵlistener("click", function NavBarComponent_div_7_li_2_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(2); return ctx_r17.toggleNavbar(false); });
    ɵngcc0.ɵɵtemplate(2, NavBarComponent_div_7_li_2_i_2_Template, 1, 3, "i", 24);
    ɵngcc0.ɵɵelementStart(3, "span", 25);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const navLink_r14 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", navLink_r14.routerLink)("queryParams", navLink_r14.queryParams)("routerLinkActiveOptions", ɵngcc0.ɵɵpureFunction0(7, _c29));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", navLink_r14.icon);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 5, navLink_r14.text));
} }
function NavBarComponent_div_7_li_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 26);
    ɵngcc0.ɵɵelement(1, "ui-panel-alerts");
    ɵngcc0.ɵɵelementEnd();
} }
function NavBarComponent_div_7_ng_container_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c30 = function (a0) { return { "toggleNavbar": a0 }; };
function NavBarComponent_div_7_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NavBarComponent_div_7_ng_container_4_ng_container_1_Template, 1, 0, "ng-container", 27);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r12 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r12.custom)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c30, ctx_r12.toggleNavbar.bind(ctx_r12)));
} }
function NavBarComponent_div_7_ng_container_5_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r23 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 29);
    ɵngcc0.ɵɵelementStart(1, "a", 30);
    ɵngcc0.ɵɵlistener("click", function NavBarComponent_div_7_ng_container_5_li_1_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r23); const ctx_r22 = ɵngcc0.ɵɵnextContext(3); ctx_r22.signout.emit(); return ctx_r22.toggleNavbar(false); });
    ɵngcc0.ɵɵelement(2, "i", 31);
    ɵngcc0.ɵɵelementStart(3, "span", 25);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 1, "ui.navbar.signout"));
} }
function NavBarComponent_div_7_ng_container_5_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 29);
    ɵngcc0.ɵɵelementStart(1, "a", 30);
    ɵngcc0.ɵɵlistener("click", function NavBarComponent_div_7_ng_container_5_li_2_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r25); const ctx_r24 = ɵngcc0.ɵɵnextContext(3); ctx_r24.signin.emit(); return ctx_r24.toggleNavbar(false); });
    ɵngcc0.ɵɵelement(2, "i", 32);
    ɵngcc0.ɵɵelementStart(3, "span", 25);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 1, "ui.navbar.signin"));
} }
function NavBarComponent_div_7_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, NavBarComponent_div_7_ng_container_5_li_1_Template, 6, 3, "li", 28);
    ɵngcc0.ɵɵtemplate(2, NavBarComponent_div_7_ng_container_5_li_2_Template, 6, 3, "li", 28);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r13 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r13.isLoggedIn);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r13.isLoggedIn);
} }
const _c31 = function (a0) { return { "show": a0 }; };
function NavBarComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "ul", 18);
    ɵngcc0.ɵɵtemplate(2, NavBarComponent_div_7_li_2_Template, 6, 8, "li", 19);
    ɵngcc0.ɵɵtemplate(3, NavBarComponent_div_7_li_3_Template, 2, 0, "li", 20);
    ɵngcc0.ɵɵtemplate(4, NavBarComponent_div_7_ng_container_4_Template, 2, 4, "ng-container", 21);
    ɵngcc0.ɵɵtemplate(5, NavBarComponent_div_7_ng_container_5_Template, 3, 2, "ng-container", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c31, ctx_r3.isActive));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r3.navLinks);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.showNotifications && ctx_r3.isLoggedIn);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.custom);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r3.isLoggedIn !== undefined);
} }
const _c32 = ["headerTitleTemplate"];
function HeaderComponent_div_0_video_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "video", 7);
    ɵngcc0.ɵɵelement(1, "source", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("muted", true);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("src", ctx_r1.header == null ? null : ctx_r1.header.video, ɵngcc0.ɵɵsanitizeUrl);
} }
function HeaderComponent_div_0_ui_dynamic_heading_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ui-dynamic-heading", 9);
    ɵngcc0.ɵɵelement(1, "span", 10);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("headingLevel", 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(2, 2, ctx_r2.header == null ? null : ctx_r2.header.title), ɵngcc0.ɵɵsanitizeHtml);
} }
function HeaderComponent_div_0_div_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 11);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r3.header == null ? null : ctx_r3.header.description), ɵngcc0.ɵɵsanitizeHtml);
} }
const _c33 = function (a0) { return { "headerContext": a0 }; };
function HeaderComponent_div_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 12);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.headerTitleTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c33, ctx_r4.headerContext));
} }
function HeaderComponent_div_0_ng_container_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 12);
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.headerTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c33, ctx_r5.headerContext));
} }
const _c34 = function (a0) { return { "background": a0, "background-size": "cover" }; };
function HeaderComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, HeaderComponent_div_0_video_1_Template, 2, 2, "video", 2);
    ɵngcc0.ɵɵelementStart(2, "div", 3);
    ɵngcc0.ɵɵelementStart(3, "header");
    ɵngcc0.ɵɵtemplate(4, HeaderComponent_div_0_ui_dynamic_heading_4_Template, 3, 4, "ui-dynamic-heading", 4);
    ɵngcc0.ɵɵtemplate(5, HeaderComponent_div_0_div_5_Template, 2, 3, "div", 5);
    ɵngcc0.ɵɵtemplate(6, HeaderComponent_div_0_ng_container_6_Template, 1, 4, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, HeaderComponent_div_0_ng_container_7_Template, 1, 4, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("darken", ctx_r0.header == null ? null : ctx_r0.header.video)("bg-header", !(ctx_r0.header == null ? null : ctx_r0.header.video));
    ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(10, _c34, ctx_r0.bannerImg ? "linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7)), url(" + ctx_r0.bannerImg + ")" : ""));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.header == null ? null : ctx_r0.header.video);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.header == null ? null : ctx_r0.header.title);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.header == null ? null : ctx_r0.header.description);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.headerTitleTemplate);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.headerTemplate);
} }
const _c35 = ["customTableRowTemplate"];
const _c36 = ["customTableHeadingTemplate"];
function ResponsiveTableComponent_table_0_caption_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "caption");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMap(ctx_r1.captionStyle);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.caption);
} }
function ResponsiveTableComponent_table_0_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ResponsiveTableComponent_table_0_ng_template_5_th_0_ng_container_1_a_1_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 9);
    ɵngcc0.ɵɵlistener("click", function ResponsiveTableComponent_table_0_ng_template_5_th_0_ng_container_1_a_1_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const heading_r9 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r13 = ɵngcc0.ɵɵnextContext(4); return ctx_r13.colHeaderClicked(heading_r9); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const heading_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", heading_r9.text, " ");
} }
function ResponsiveTableComponent_table_0_ng_template_5_th_0_ng_container_1_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const heading_r9 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", heading_r9, " ");
} }
function ResponsiveTableComponent_table_0_ng_template_5_th_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ResponsiveTableComponent_table_0_ng_template_5_th_0_ng_container_1_a_1_Template, 2, 1, "a", 7);
    ɵngcc0.ɵɵtemplate(2, ResponsiveTableComponent_table_0_ng_template_5_th_0_ng_container_1_ng_template_2_Template, 2, 1, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const heading_r9 = ctx.$implicit;
    const _r11 = ɵngcc0.ɵɵreference(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", heading_r9.nodeType === "a")("ngIfElse", _r11);
} }
function ResponsiveTableComponent_table_0_ng_template_5_th_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "th", 5);
    ɵngcc0.ɵɵtemplate(1, ResponsiveTableComponent_table_0_ng_template_5_th_0_ng_container_1_Template, 4, 2, "ng-container", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const headingKey_r7 = ctx.$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r6.table.headings[headingKey_r7]);
} }
function ResponsiveTableComponent_table_0_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ResponsiveTableComponent_table_0_ng_template_5_th_0_Template, 2, 1, "th", 4);
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.headings);
} }
function ResponsiveTableComponent_table_0_ng_container_8_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ResponsiveTableComponent_table_0_ng_container_8_ng_template_2_td_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "td");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const key_r24 = ctx.$implicit;
    const row_r18 = ɵngcc0.ɵɵnextContext(2).$implicit;
    const ctx_r23 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵattribute("data-label", (ctx_r23.table.headings[key_r24] == null ? null : ctx_r23.table.headings[key_r24].text) || ctx_r23.table.headings[key_r24]);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", row_r18[key_r24], "");
} }
function ResponsiveTableComponent_table_0_ng_container_8_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "tr");
    ɵngcc0.ɵɵtemplate(1, ResponsiveTableComponent_table_0_ng_container_8_ng_template_2_td_1_Template, 2, 2, "td", 3);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r22 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r22.headings);
} }
const _c37 = function (a0, a1, a2) { return { "row": a0, "rowIndex": a1, "headings": a2 }; };
function ResponsiveTableComponent_table_0_ng_container_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, ResponsiveTableComponent_table_0_ng_container_8_ng_container_1_Template, 1, 0, "ng-container", 1);
    ɵngcc0.ɵɵtemplate(2, ResponsiveTableComponent_table_0_ng_container_8_ng_template_2_Template, 2, 1, "ng-template", null, 10, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const row_r18 = ctx.$implicit;
    const i_r19 = ctx.index;
    const _r21 = ɵngcc0.ɵɵreference(3);
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r5.customTableRowTemplate ? ctx_r5.customTableRowTemplate : _r21)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction3(2, _c37, row_r18, i_r19, ctx_r5.headings));
} }
const _c38 = function (a0) { return { "headings": a0 }; };
function ResponsiveTableComponent_table_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "table");
    ɵngcc0.ɵɵtemplate(1, ResponsiveTableComponent_table_0_caption_1_Template, 2, 3, "caption", 0);
    ɵngcc0.ɵɵelementStart(2, "thead");
    ɵngcc0.ɵɵelementStart(3, "tr");
    ɵngcc0.ɵɵtemplate(4, ResponsiveTableComponent_table_0_ng_container_4_Template, 1, 0, "ng-container", 1);
    ɵngcc0.ɵɵtemplate(5, ResponsiveTableComponent_table_0_ng_template_5_Template, 1, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "tbody");
    ɵngcc0.ɵɵtemplate(8, ResponsiveTableComponent_table_0_ng_container_8_Template, 4, 6, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r3 = ɵngcc0.ɵɵreference(6);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMapInterpolate1("table table-responsive ", ctx_r0.style, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.caption);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.customTableHeadingTemplate ? ctx_r0.customTableHeadingTemplate : _r3)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(7, _c38, ctx_r0.headings));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.table.rows);
} }
const _c39 = ["customOption"];
const _c40 = ["listitems"];
function InputTypeaheadComponent_div_0_label_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "label", 10);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("required", ctx_r1.field.required);
    ɵngcc0.ɵɵproperty("for", ctx_r1.field.id)("innerHTML", ɵngcc0.ɵɵpipeBind1(1, 4, ctx_r1.field.label), ɵngcc0.ɵɵsanitizeHtml);
} }
function InputTypeaheadComponent_div_0_div_6_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 15);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "ui.input-typeahead.results"));
} }
function InputTypeaheadComponent_div_0_div_6_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 16);
    ɵngcc0.ɵɵelement(2, "ui-loading-spinner");
    ɵngcc0.ɵɵelementStart(3, "div", 17);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(5, 1, "ui.input-typeahead.search", ctx_r7.filterParams));
} }
const _c41 = function (a0, a1) { return { "customOptionContext": a0, "matchContext": a1 }; };
function InputTypeaheadComponent_div_0_div_6_ng_container_4_li_1_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0, 23);
} if (rf & 2) {
    const match_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r14 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r14.customOption)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c41, ctx_r14.customOptionContext, match_r11));
} }
function InputTypeaheadComponent_div_0_div_6_ng_container_4_li_1_ng_template_3_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 26);
    ɵngcc0.ɵɵelementStart(2, "div", 27);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 28);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const match_r11 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate1(" ", match_r11.id, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(match_r11.text);
} }
function InputTypeaheadComponent_div_0_div_6_ng_container_4_li_1_ng_template_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 29);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const match_r11 = ɵngcc0.ɵɵnextContext(2).$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(match_r11);
} }
function InputTypeaheadComponent_div_0_div_6_ng_container_4_li_1_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, InputTypeaheadComponent_div_0_div_6_ng_container_4_li_1_ng_template_3_ng_container_0_Template, 6, 2, "ng-container", 24);
    ɵngcc0.ɵɵtemplate(1, InputTypeaheadComponent_div_0_div_6_ng_container_4_li_1_ng_template_3_ng_template_1_Template, 2, 1, "ng-template", null, 25, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r19 = ɵngcc0.ɵɵreference(2);
    const match_r11 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵproperty("ngIf", match_r11.id)("ngIfElse", _r19);
} }
function InputTypeaheadComponent_div_0_div_6_ng_container_4_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r25 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 19, 20);
    ɵngcc0.ɵɵlistener("mousedown", function InputTypeaheadComponent_div_0_div_6_ng_container_4_li_1_Template_li_mousedown_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r25); const match_r11 = restoredCtx.$implicit; const ctx_r24 = ɵngcc0.ɵɵnextContext(4); return ctx_r24.setMatch(match_r11, true); });
    ɵngcc0.ɵɵtemplate(2, InputTypeaheadComponent_div_0_div_6_ng_container_4_li_1_ng_container_2_Template, 1, 5, "ng-container", 21);
    ɵngcc0.ɵɵtemplate(3, InputTypeaheadComponent_div_0_div_6_ng_container_4_li_1_ng_template_3_Template, 3, 2, "ng-template", null, 22, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r12 = ctx.index;
    const _r15 = ɵngcc0.ɵɵreference(4);
    const ctx_r10 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵattribute("aria-selected", i_r12 === ctx_r10.selectedMatchIdx);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r10.customOption)("ngIfElse", _r15);
} }
function InputTypeaheadComponent_div_0_div_6_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, InputTypeaheadComponent_div_0_div_6_ng_container_4_li_1_Template, 5, 3, "li", 18);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r8 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r8.matches);
} }
function InputTypeaheadComponent_div_0_div_6_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 30);
    ɵngcc0.ɵɵelementStart(2, "span", 31);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 1, "ui.input-typeahead.empty"));
} }
function InputTypeaheadComponent_div_0_div_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, InputTypeaheadComponent_div_0_div_6_span_1_Template, 3, 3, "span", 12);
    ɵngcc0.ɵɵelementStart(2, "ul", 13);
    ɵngcc0.ɵɵtemplate(3, InputTypeaheadComponent_div_0_div_6_ng_container_3_Template, 6, 4, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(4, InputTypeaheadComponent_div_0_div_6_ng_container_4_Template, 2, 1, "ng-container", 14);
    ɵngcc0.ɵɵtemplate(5, InputTypeaheadComponent_div_0_div_6_ng_container_5_Template, 5, 3, "ng-container", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.matches == null ? null : ctx_r2.matches.length);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.matches);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r2.matches == null ? null : ctx_r2.matches.length) > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r2.matches == null ? null : ctx_r2.matches.length) === 0);
} }
function InputTypeaheadComponent_div_0_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 32);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", ctx_r3.field.id + "_error_req");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 2, "ui.form_field.required_text"));
} }
function InputTypeaheadComponent_div_0_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 32);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", ctx_r4.field.id + "_error_custom");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 2, ctx_r4.form.controls[ctx_r4.field.name].errors.customErrorMsg, ctx_r4.FormCtrl));
} }
function InputTypeaheadComponent_div_0_span_10_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 33);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("id", ctx_r5.field.id + "_help")("innerHTML", ɵngcc0.ɵɵpipeBind1(1, 2, ctx_r5.field.helperText), ɵngcc0.ɵɵsanitizeHtml);
} }
function InputTypeaheadComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    const _r27 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵtemplate(2, InputTypeaheadComponent_div_0_label_2_Template, 2, 6, "label", 3);
    ɵngcc0.ɵɵelementStart(3, "input", 4);
    ɵngcc0.ɵɵlistener("keydown", function InputTypeaheadComponent_div_0_Template_input_keydown_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r26 = ɵngcc0.ɵɵnextContext(); return ctx_r26.handleKeypress($event); })("input", function InputTypeaheadComponent_div_0_Template_input_input_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r28 = ɵngcc0.ɵɵnextContext(); return ctx_r28.onChange($event); })("blur", function InputTypeaheadComponent_div_0_Template_input_blur_3_listener() { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r29 = ɵngcc0.ɵɵnextContext(); return ctx_r29.setMatch(ctx_r29.field.value, true); })("focus", function InputTypeaheadComponent_div_0_Template_input_focus_3_listener($event) { ɵngcc0.ɵɵrestoreView(_r27); const ctx_r30 = ɵngcc0.ɵɵnextContext(); return ctx_r30.onFocus($event); });
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(5, "div", 5);
    ɵngcc0.ɵɵtemplate(6, InputTypeaheadComponent_div_0_div_6_Template, 6, 4, "div", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "div", 7);
    ɵngcc0.ɵɵtemplate(8, InputTypeaheadComponent_div_0_span_8_Template, 3, 4, "span", 8);
    ɵngcc0.ɵɵtemplate(9, InputTypeaheadComponent_div_0_span_9_Template, 3, 5, "span", 8);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(10, InputTypeaheadComponent_div_0_span_10_Template, 2, 4, "span", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.field.label);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("results-visible", ctx_r0.matches)("is-invalid", ctx_r0.hasError);
    ɵngcc0.ɵɵproperty("id", ctx_r0.field.id)("value", ctx_r0.field.value)("required", ctx_r0.field.required)("formControlName", ctx_r0.field.name);
    ɵngcc0.ɵɵattribute("autocomplete", ctx_r0.autocomplete)("name", ctx_r0.field.name)("placeholder", ctx_r0.field.placeholder ? ɵngcc0.ɵɵpipeBind1(4, 24, ctx_r0.field.placeholder) : "")("aria-expanded", ctx_r0.matches == null ? null : ctx_r0.matches.length)("aria-owns", ctx_r0.field.id + "-resultsList")("data-if-id", ctx_r0.field.extraAttributes == null ? null : ctx_r0.field.extraAttributes.ifId)("aria-invalid", ctx_r0.hasError)("aria-describedby", ctx_r0.ariaDescribedBy)("aria-errormessage", ctx_r0.ariaErrorMessage);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("id", ctx_r0.field.id + "-resultsList");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isLoading);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasError && !(ctx_r0.FormCtrl == null ? null : ctx_r0.FormCtrl.errors == null ? null : ctx_r0.FormCtrl.errors.customErrorMsg) && ctx_r0.field.required && !ctx_r0.FormCtrl.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.hasError && (ctx_r0.FormCtrl == null ? null : ctx_r0.FormCtrl.errors == null ? null : ctx_r0.FormCtrl.errors.customErrorMsg));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.field.helperText);
} }
function SearchComponent_div_14_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "a", 12);
    ɵngcc0.ɵɵlistener("click", function SearchComponent_div_14_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.showAdvancedFilters = !ctx_r2.showAdvancedFilters; });
    ɵngcc0.ɵɵelementStart(2, "span", 13);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(5, "i", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-expanded", ctx_r0.showAdvancedFilters);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 6, "ui.search.advanced_filters_label"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("ifc-chevron-down", ctx_r0.showAdvancedFilters)("ifc-chevron-right", !ctx_r0.showAdvancedFilters);
} }
function SearchComponent_div_15_div_2_ui_form_control_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "ui-form-control", 20);
} if (rf & 2) {
    const filter_r5 = ɵngcc0.ɵɵnextContext().$implicit;
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", filter_r5)("form", ctx_r6.form);
} }
function SearchComponent_div_15_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 18);
    ɵngcc0.ɵɵtemplate(1, SearchComponent_div_15_div_2_ui_form_control_1_Template, 1, 2, "ui-form-control", 19);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const filter_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", filter_r5);
} }
function SearchComponent_div_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "div", 16);
    ɵngcc0.ɵɵtemplate(2, SearchComponent_div_15_div_2_Template, 2, 1, "div", 17);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵattribute("aria-expanded", ctx_r1.showAdvancedFilters);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.filters);
} }
function CheckradioGroupComponent_ng_container_0_div_4_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "input", 6);
    ɵngcc0.ɵɵlistener("change", function CheckradioGroupComponent_ng_container_0_div_4_Template_input_change_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const field_r3 = restoredCtx.$implicit; const idx_r4 = restoredCtx.index; const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.checkboxChangeOccurred($event, field_r3, idx_r4); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(2, "label", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r3 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("custom-checkbox", !ctx_r1.isRadioGroup)("custom-radio", ctx_r1.isRadioGroup);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControl", field_r3.control)("name", field_r3.name)("id", field_r3.id)("type", field_r3.type)("checked", field_r3.checked);
    ɵngcc0.ɵɵattribute("data-if-id", field_r3.ifId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("for", field_r3.id)("innerHTML", field_r3.label, ɵngcc0.ɵɵsanitizeHtml);
} }
function CheckradioGroupComponent_ng_container_0_small_5_span_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, "ui.form_field.required_text"));
} }
function CheckradioGroupComponent_ng_container_0_small_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small", 8);
    ɵngcc0.ɵɵtemplate(1, CheckradioGroupComponent_ng_container_0_small_5_span_1_Template, 3, 3, "span", 9);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.form.controls[ctx_r2.fieldset.name] && ctx_r2.form.controls[ctx_r2.fieldset.name].touched && ctx_r2.form.controls[ctx_r2.fieldset.name].errors);
} }
function CheckradioGroupComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "fieldset", 1);
    ɵngcc0.ɵɵelement(2, "legend", 2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵtemplate(4, CheckradioGroupComponent_ng_container_0_div_4_Template, 3, 12, "div", 3);
    ɵngcc0.ɵɵtemplate(5, CheckradioGroupComponent_ng_container_0_small_5_Template, 2, 1, "small", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("error", (ctx_r0.form.controls[ctx_r0.fieldset.name] == null ? null : ctx_r0.form.controls[ctx_r0.fieldset.name].errors) && (ctx_r0.fieldset == null ? null : ctx_r0.fieldset.required));
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("required", ctx_r0.fieldset.required);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(3, 8, ctx_r0.fieldset.legend), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.fields);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.fieldset == null ? null : ctx_r0.fieldset.name);
} }
function NotificationComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 2);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(1, 1, ctx_r0.alert), ɵngcc0.ɵɵsanitizeHtml);
} }
function MaintenanceComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelement(3, "h1", 3);
    ɵngcc0.ɵɵelement(4, "p", 3);
    ɵngcc0.ɵɵelementStart(5, "a", 4);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.page.title, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ctx_r0.page.message, ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("routerLink", ɵngcc0.ɵɵpureFunction1(6, _c16, ctx_r0.page.homeRoute));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(7, 4, "ui.maintenance.home"));
} }
function YesNoComponent_ui_form_field_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵlistener("focusout", function YesNoComponent_ui_form_field_0_ng_template_1_Template_div_focusout_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.checkRequired($event); });
    ɵngcc0.ɵɵelementStart(1, "button", 4);
    ɵngcc0.ɵɵlistener("click", function YesNoComponent_ui_form_field_0_ng_template_1_Template_button_click_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const field_r3 = restoredCtx.field; const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.updateResponseField($event, field_r3.no); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 5);
    ɵngcc0.ɵɵlistener("click", function YesNoComponent_ui_form_field_0_ng_template_1_Template_button_click_4_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r5); const field_r3 = restoredCtx.field; const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.updateResponseField($event, field_r3.yes); });
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "input", 6);
} if (rf & 2) {
    const field_r3 = ctx.field;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassProp("ng-invalid", !field_r3.value);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("active", (field_r3 == null ? null : field_r3.value) === (field_r3 == null ? null : field_r3.no == null ? null : field_r3.no.value));
    ɵngcc0.ɵɵattribute("aria-describedby", ctx_r2.ariaDescribedBy)("aria-errormessage", ctx_r2.ariaErrorMessage)("data-if-id", (field_r3.extraAttributes == null ? null : field_r3.extraAttributes.ifId) ? field_r3.extraAttributes.ifId + "-no" : "no");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 15, field_r3 == null ? null : field_r3.no == null ? null : field_r3.no.label));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵclassProp("active", (field_r3 == null ? null : field_r3.value) === (field_r3 == null ? null : field_r3.yes == null ? null : field_r3.yes.value));
    ɵngcc0.ɵɵattribute("aria-describedby", ctx_r2.ariaDescribedBy)("aria-errormessage", ctx_r2.ariaErrorMessage)("data-if-id", (field_r3.extraAttributes == null ? null : field_r3.extraAttributes.ifId) ? field_r3.extraAttributes.ifId + "-yes" : "yes");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 17, field_r3 == null ? null : field_r3.yes == null ? null : field_r3.yes.label));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("formControlName", field_r3.name);
} }
function YesNoComponent_ui_form_field_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ui-form-field", 1);
    ɵngcc0.ɵɵtemplate(1, YesNoComponent_ui_form_field_0_ng_template_1_Template, 8, 19, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r0.field)("formGroup", ctx_r0.form)("form", ctx_r0.form)("formCtrl", ctx_r0.FormCtrl)("updateOn", ctx_r0.updateOn)("hasError", ctx_r0.hasError);
} }
const _c42 = ["carouselItemTemplate"];
const _c43 = ["carouselTitle"];
const _c44 = ["carousel"];
function CarouselComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function CarouselComponent_ng_container_0_ng_container_5_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c45 = function (a0, a1, a2, a3, a4) { return { item: a0, next: a1, prev: a2, goToSlide: a3, index: a4 }; };
function CarouselComponent_ng_container_0_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 11);
    ɵngcc0.ɵɵtemplate(2, CarouselComponent_ng_container_0_ng_container_5_ng_container_2_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const item_r5 = ctx.$implicit;
    const idx_r6 = ctx.index;
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("active", idx_r6 === 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r3.carouselItemTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction5(4, _c45, item_r5, ctx_r3.next.bind(ctx_r3), ctx_r3.prev.bind(ctx_r3), ctx_r3.goToSlide.bind(ctx_r3), idx_r6));
} }
const _c46 = function (a0) { return { num: a0 }; };
function CarouselComponent_ng_container_0_ng_container_6_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r12 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelementStart(1, "button", 15);
    ɵngcc0.ɵɵlistener("click", function CarouselComponent_ng_container_0_ng_container_6_li_2_Template_button_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r12); const idx_r10 = restoredCtx.index; const ctx_r11 = ɵngcc0.ɵɵnextContext(3); return ctx_r11.goToSlide(idx_r10); });
    ɵngcc0.ɵɵelementStart(2, "span", 8);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const idx_r10 = ctx.index;
    ɵngcc0.ɵɵclassProp("active", idx_r10 === 0);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(4, 3, "ui.carousel.go-to-slide", ɵngcc0.ɵɵpureFunction1(6, _c46, idx_r10 + 1)));
} }
function CarouselComponent_ng_container_0_ng_container_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "ol", 13);
    ɵngcc0.ɵɵtemplate(2, CarouselComponent_ng_container_0_ng_container_6_li_2_Template, 5, 8, "li", 14);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r4.items);
} }
function CarouselComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1, 2);
    ɵngcc0.ɵɵtemplate(3, CarouselComponent_ng_container_0_ng_container_3_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementStart(4, "div", 4);
    ɵngcc0.ɵɵtemplate(5, CarouselComponent_ng_container_0_ng_container_5_Template, 3, 10, "ng-container", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(6, CarouselComponent_ng_container_0_ng_container_6_Template, 3, 1, "ng-container", 0);
    ɵngcc0.ɵɵelementStart(7, "button", 6);
    ɵngcc0.ɵɵlistener("click", function CarouselComponent_ng_container_0_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r13 = ɵngcc0.ɵɵnextContext(); return ctx_r13.prev(); });
    ɵngcc0.ɵɵelement(8, "i", 7);
    ɵngcc0.ɵɵelementStart(9, "span", 8);
    ɵngcc0.ɵɵtext(10);
    ɵngcc0.ɵɵpipe(11, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(12, "button", 9);
    ɵngcc0.ɵɵlistener("click", function CarouselComponent_ng_container_0_Template_button_click_12_listener() { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(); return ctx_r15.next(); });
    ɵngcc0.ɵɵelement(13, "i", 10);
    ɵngcc0.ɵɵelementStart(14, "span", 8);
    ɵngcc0.ɵɵtext(15);
    ɵngcc0.ɵɵpipe(16, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.carouselTitle);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.items);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r0.hideIndicators);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(11, 5, "ui.carousel.previous"));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(16, 7, "ui.carousel.next"));
} }
function MessageLoaderComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 2);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@fadeIn", undefined);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 2, ctx_r0.loadingMessage));
} }
function MultiSelectToCheckboxComponent_ng_container_0_div_6_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelementStart(1, "input", 7);
    ɵngcc0.ɵɵlistener("change", function MultiSelectToCheckboxComponent_ng_container_0_div_6_Template_input_change_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const f_r3 = restoredCtx.$implicit; const idx_r4 = restoredCtx.index; const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.changeOccurred($event, f_r3, idx_r4); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "label", 8);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const f_r3 = ctx.$implicit;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("name", f_r3.name)("id", f_r3.id)("type", f_r3.type)("checked", f_r3.checked)("formControl", f_r3.control);
    ɵngcc0.ɵɵattribute("data-if-id", f_r3.ifId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("for", f_r3.id)("ngClass", ɵngcc0.ɵɵpureFunction2(11, _c18, ctx_r1.hasError, f_r3.required));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(4, 9, f_r3.label), "");
} }
function MultiSelectToCheckboxComponent_ng_container_0_small_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "small", 9);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "ui.form_field.required_text"), " ");
} }
function MultiSelectToCheckboxComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "fieldset", 2);
    ɵngcc0.ɵɵelement(3, "legend", 3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementStart(5, "div");
    ɵngcc0.ɵɵtemplate(6, MultiSelectToCheckboxComponent_ng_container_0_div_6_Template, 5, 14, "div", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, MultiSelectToCheckboxComponent_ng_container_0_small_7_Template, 3, 3, "small", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formGroup", ctx_r0.form);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("error", ctx_r0.fieldset.required && (ctx_r0.hasError || ctx_r0.checkTouchedStatus()));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("required", ctx_r0.fieldset.required);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(4, 8, ctx_r0.fieldset.legend), ɵngcc0.ɵɵsanitizeHtml);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.fieldset.elements);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.fieldset.required && ctx_r0.checkTouchedStatus());
} }
const _c47 = ["stepList"];
function StepsComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function StepsComponent_ng_template_2_ul_0_ng_container_1_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 8);
    ɵngcc0.ɵɵelement(1, "span", 9);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r9 = ctx.$implicit;
    const ctx_r8 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵclassProp("active", step_r9.active)("overdue", ctx_r8.checkOverdue(step_r9))("completed", step_r9.status === ctx_r8.completed)("d-none", step_r9.hidden)("d-flex", !step_r9.hidden);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(2, 11, step_r9.text), ɵngcc0.ɵɵsanitizeHtml);
} }
function StepsComponent_ng_template_2_ul_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, StepsComponent_ng_template_2_ul_0_ng_container_1_li_1_Template, 3, 13, "li", 7);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const steps_r3 = ɵngcc0.ɵɵnextContext(2).steps;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", steps_r3);
} }
function StepsComponent_ng_template_2_ul_0_ng_template_2_li_0_Template(rf, ctx) { if (rf & 1) {
    const _r14 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 11);
    ɵngcc0.ɵɵlistener("click", function StepsComponent_ng_template_2_ul_0_ng_template_2_li_0_Template_li_click_0_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r14); const step_r12 = restoredCtx.$implicit; const ctx_r13 = ɵngcc0.ɵɵnextContext(4); return ctx_r13.stepClicked($event, step_r12); })("keydown", function StepsComponent_ng_template_2_ul_0_ng_template_2_li_0_Template_li_keydown_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r14); const ctx_r15 = ɵngcc0.ɵɵnextContext(4); return ctx_r15.keydownSwitchToStep($event); });
    ɵngcc0.ɵɵelement(1, "span", 9);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const step_r12 = ctx.$implicit;
    const ctx_r11 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵclassProp("active", step_r12.active)("disabled", step_r12.disabled)("overdue", ctx_r11.checkOverdue(step_r12))("completed", step_r12.status === ctx_r11.completed)("d-none", step_r12.hidden)("d-flex", !step_r12.hidden);
    ɵngcc0.ɵɵattribute("tabindex", step_r12.status === ctx_r11.completed ? "0" : "-1");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(2, 14, step_r12.text), ɵngcc0.ɵɵsanitizeHtml);
} }
function StepsComponent_ng_template_2_ul_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, StepsComponent_ng_template_2_ul_0_ng_template_2_li_0_Template, 3, 16, "li", 10);
} if (rf & 2) {
    const steps_r3 = ɵngcc0.ɵɵnextContext(2).steps;
    ɵngcc0.ɵɵproperty("ngForOf", steps_r3);
} }
function StepsComponent_ng_template_2_ul_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 4);
    ɵngcc0.ɵɵtemplate(1, StepsComponent_ng_template_2_ul_0_ng_container_1_Template, 2, 1, "ng-container", 5);
    ɵngcc0.ɵɵtemplate(2, StepsComponent_ng_template_2_ul_0_ng_template_2_Template, 1, 1, "ng-template", null, 6, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r6 = ɵngcc0.ɵɵreference(3);
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r4.readOnly)("ngIfElse", _r6);
} }
function StepsComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, StepsComponent_ng_template_2_ul_0_Template, 4, 2, "ul", 3);
} if (rf & 2) {
    const steps_r3 = ctx.steps;
    ɵngcc0.ɵɵproperty("ngIf", steps_r3);
} }
const _c48 = function (a0) { return { steps: a0 }; };
const _c49 = function (a0, a1) { return { "ifc-circle-add": a0, "ifc-circle-remove": a1 }; };
const _c50 = function (a0, a1) { return { "current": a0, "total": a1 }; };
function StepsHeaderComponent_nav_0_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "nav", 2);
    ɵngcc0.ɵɵelementStart(1, "a", 3);
    ɵngcc0.ɵɵlistener("click", function StepsHeaderComponent_nav_0_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.toggleSteps(); });
    ɵngcc0.ɵɵelement(2, "i", 4);
    ɵngcc0.ɵɵelementStart(3, "span", 5);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(5, _c49, !ctx_r0.isShown, ctx_r0.isShown));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(5, 2, "ui.steps.step_num_of_total", ɵngcc0.ɵɵpureFunction2(8, _c50, ctx_r0.getActive(), ctx_r0.shownStepList.length)), " ");
} }
function StepsHeaderComponent_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 6);
    ɵngcc0.ɵɵelement(1, "div", 7);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleProp("width", ctx_r1.getPercentageWidth());
    ɵngcc0.ɵɵattribute("aria-valuenow", ctx_r1.getPercentage());
} }
function InputGroupComponent_ui_form_field_0_ng_template_1_i_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵclassMapInterpolate1("", ctx_r4.icon, " p-2");
} }
function InputGroupComponent_ui_form_field_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "input", 4);
    ɵngcc0.ɵɵlistener("input", function InputGroupComponent_ui_form_field_0_ng_template_1_Template_input_input_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const field_r3 = restoredCtx.field; const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.changeOccurred($event, field_r3); })("blur", function InputGroupComponent_ui_form_field_0_ng_template_1_Template_input_blur_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const field_r3 = restoredCtx.field; const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.handleBlur(field_r3); })("keydown.enter", function InputGroupComponent_ui_form_field_0_ng_template_1_Template_input_keydown_enter_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const field_r3 = restoredCtx.field; const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.handleEnter($event, field_r3); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "button", 5);
    ɵngcc0.ɵɵlistener("click", function InputGroupComponent_ui_form_field_0_ng_template_1_Template_button_click_2_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const field_r3 = restoredCtx.field; const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.handleClick($event, ctx_r9.button, field_r3); });
    ɵngcc0.ɵɵtemplate(3, InputGroupComponent_ui_form_field_0_ng_template_1_i_3_Template, 1, 3, "i", 6);
    ɵngcc0.ɵɵelementStart(4, "span");
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r3 = ctx.field;
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", field_r3 == null ? null : field_r3.name)("field", field_r3)("ngClass", ɵngcc0.ɵɵpureFunction2(11, _c2, ctx_r2.hasError, ctx_r2.hasError));
    ɵngcc0.ɵɵattribute("data-if-id", field_r3 == null ? null : field_r3.extraAttributes == null ? null : field_r3.extraAttributes.ifId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r2.button);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r2.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("sr-only", ctx_r2.icon);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 9, ctx_r2.button.text));
} }
function InputGroupComponent_ui_form_field_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ui-form-field", 1);
    ɵngcc0.ɵɵtemplate(1, InputGroupComponent_ui_form_field_0_ng_template_1_Template, 7, 14, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r0.field)("formGroup", ctx_r0.form)("form", ctx_r0.form)("formCtrl", ctx_r0.FormCtrl)("hasError", ctx_r0.hasError)("updateOn", ctx_r0.updateOn);
} }
function BrowserDetectionComponent_ng_container_0_span_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "ui.browser-detection.title"), " ");
} }
function BrowserDetectionComponent_ng_container_0_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "ui.browser-detection.unsupported_title"), " ");
} }
const _c51 = function (a0, a1) { return { "browser": a0, version: a1 }; };
function BrowserDetectionComponent_ng_container_0_span_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(2, 1, "ui.browser-detection.description", ɵngcc0.ɵɵpureFunction2(4, _c51, ctx_r4.details == null ? null : ctx_r4.details.name, ctx_r4.details == null ? null : ctx_r4.details.version)), " ");
} }
function BrowserDetectionComponent_ng_container_0_ng_template_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r6 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(2, 1, "ui.browser-detection.unsupported_description", ɵngcc0.ɵɵpureFunction2(4, _c51, ctx_r6.details == null ? null : ctx_r6.details.name, ctx_r6.details == null ? null : ctx_r6.details.version)), " ");
} }
const _c52 = function (a0) { return { "browser": a0 }; };
function BrowserDetectionComponent_ng_container_0_a_15_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "a", 14);
    ɵngcc0.ɵɵelement(1, "img", 15);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementStart(3, "div", 16);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r7 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("href", ctx_r7.currentBrowserInfo == null ? null : ctx_r7.currentBrowserInfo.link, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", ctx_r7.currentBrowserInfo.icon, ɵngcc0.ɵɵsanitizeUrl)("title", ɵngcc0.ɵɵpipeBind1(2, 4, ctx_r7.currentBrowserInfo.name));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(5, 6, "ui.browser-detection.update", ɵngcc0.ɵɵpureFunction1(9, _c52, ctx_r7.details == null ? null : ctx_r7.details.name)));
} }
function BrowserDetectionComponent_ng_container_0_span_18_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "ui.browser-detection.optional"), " ");
} }
function BrowserDetectionComponent_ng_container_0_ng_template_19_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "ui.browser-detection.try"), " ");
} }
const _c53 = function (a0) { return { browser: a0 }; };
function BrowserDetectionComponent_ng_container_0_div_21_ng_container_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 19);
    ɵngcc0.ɵɵelementStart(2, "a", 14);
    ɵngcc0.ɵɵelement(3, "img", 20);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementStart(5, "div", 16);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const bi_r13 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("href", bi_r13.link, ɵngcc0.ɵɵsanitizeUrl);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("src", bi_r13.icon, ɵngcc0.ɵɵsanitizeUrl)("title", ɵngcc0.ɵɵpipeBind1(4, 4, bi_r13.name));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(7, 6, "ui.browser-detection.install", ɵngcc0.ɵɵpureFunction1(11, _c53, ɵngcc0.ɵɵpipeBind1(8, 9, bi_r13.name))));
} }
function BrowserDetectionComponent_ng_container_0_div_21_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, BrowserDetectionComponent_ng_container_0_div_21_ng_container_1_ng_container_1_Template, 9, 13, "ng-container", 0);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const bi_r13 = ctx.$implicit;
    const ctx_r12 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", bi_r13.modern && (!ctx_r12.currentBrowserInfo || bi_r13.key !== ctx_r12.currentBrowserInfo.key));
} }
function BrowserDetectionComponent_ng_container_0_div_21_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtemplate(1, BrowserDetectionComponent_ng_container_0_div_21_ng_container_1_Template, 2, 1, "ng-container", 18);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r11.supportedBrowserInfo);
} }
function BrowserDetectionComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "section", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "h1");
    ɵngcc0.ɵɵtemplate(4, BrowserDetectionComponent_ng_container_0_span_4_Template, 3, 3, "span", 3);
    ɵngcc0.ɵɵtemplate(5, BrowserDetectionComponent_ng_container_0_ng_template_5_Template, 3, 3, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(7, "button", 5);
    ɵngcc0.ɵɵlistener("click", function BrowserDetectionComponent_ng_container_0_Template_button_click_7_listener() { ɵngcc0.ɵɵrestoreView(_r17); const ctx_r16 = ɵngcc0.ɵɵnextContext(); return ctx_r16.dismiss(); });
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelement(9, "i", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "p");
    ɵngcc0.ɵɵtemplate(11, BrowserDetectionComponent_ng_container_0_span_11_Template, 3, 7, "span", 3);
    ɵngcc0.ɵɵtemplate(12, BrowserDetectionComponent_ng_container_0_ng_template_12_Template, 3, 7, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(14, "div", 8);
    ɵngcc0.ɵɵtemplate(15, BrowserDetectionComponent_ng_container_0_a_15_Template, 6, 11, "a", 9);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(16, "div", 10);
    ɵngcc0.ɵɵelementStart(17, "h2", 11);
    ɵngcc0.ɵɵtemplate(18, BrowserDetectionComponent_ng_container_0_span_18_Template, 3, 3, "span", 3);
    ɵngcc0.ɵɵtemplate(19, BrowserDetectionComponent_ng_container_0_ng_template_19_Template, 3, 3, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(21, BrowserDetectionComponent_ng_container_0_div_21_Template, 2, 1, "div", 13);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const _r2 = ɵngcc0.ɵɵreference(6);
    const _r5 = ɵngcc0.ɵɵreference(13);
    const _r9 = ɵngcc0.ɵɵreference(20);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("@toggle", ctx_r0.showDialog ? "visible" : "hidden");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isSupported)("ngIfElse", _r2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(8, 10, "ui.browser-detection.dismiss"));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.isSupported)("ngIfElse", _r5);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.currentBrowserInfo == null ? null : ctx_r0.currentBrowserInfo.modern) && ctx_r0.isSupported);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r0.currentBrowserInfo == null ? null : ctx_r0.currentBrowserInfo.modern) && ctx_r0.isSupported)("ngIfElse", _r9);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.supportedBrowserInfo);
} }
function ProgressBarComponent_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "number");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r0.percentComplete, ctx_r0.valueFormat), "% ");
} }
const _c54 = function (a0) { return { "width": a0 }; };
const _c55 = ["dropdownInput"];
const _c56 = function (a0) { return { "optionName": a0 }; };
function MultiSelectDropdownComponent_ng_container_0_ng_container_2_span_5_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 7);
    ɵngcc0.ɵɵelementStart(1, "span");
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "a", 8);
    ɵngcc0.ɵɵlistener("click", function MultiSelectDropdownComponent_ng_container_0_ng_container_2_span_5_Template_a_click_4_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const selected_r5 = restoredCtx.$implicit; const ctx_r6 = ɵngcc0.ɵɵnextContext(3); return ctx_r6.removeSelected(selected_r5); });
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelement(6, "i", 9);
    ɵngcc0.ɵɵelementStart(7, "span", 10);
    ɵngcc0.ɵɵtext(8);
    ɵngcc0.ɵɵpipe(9, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const selected_r5 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 3, selected_r5.text));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ɵngcc0.ɵɵpipeBind2(5, 5, "ui.controls.multi-select-dropdown.remove_option", ɵngcc0.ɵɵpureFunction1(11, _c56, selected_r5.text)));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(9, 8, "ui.controls.multi-select-dropdown.remove_option", ɵngcc0.ɵɵpureFunction1(13, _c56, selected_r5.text)));
} }
function MultiSelectDropdownComponent_ng_container_0_ng_container_2_span_6_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span", 11);
    ɵngcc0.ɵɵelementStart(1, "button", 12);
    ɵngcc0.ɵɵlistener("click", function MultiSelectDropdownComponent_ng_container_0_ng_container_2_span_6_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(3); return ctx_r8.removeAllSelected(); });
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(2, 2, "ui.controls.multi-select-dropdown.clear_all"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 4, "ui.controls.multi-select-dropdown.clear_all"));
} }
function MultiSelectDropdownComponent_ng_container_0_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 3);
    ɵngcc0.ɵɵelementStart(2, "span", 4);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, MultiSelectDropdownComponent_ng_container_0_ng_container_2_span_5_Template, 10, 15, "span", 5);
    ɵngcc0.ɵɵtemplate(6, MultiSelectDropdownComponent_ng_container_0_ng_container_2_span_6_Template, 6, 6, "span", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 4, "ui.controls.multi-select-dropdown.selected_options"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r1.selectedSet)("ngForTrackBy", ctx_r1.trackBySelected);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r1.selectedSet.length > 0);
} }
function MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_button_6_i_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r17 = ɵngcc0.ɵɵnextContext(5);
    ɵngcc0.ɵɵclassMap(ctx_r17.btnIconCss);
} }
function MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_button_6_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 27);
    ɵngcc0.ɵɵlistener("click", function MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_button_6_Template_button_click_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r19); ɵngcc0.ɵɵnextContext(); const _r13 = ɵngcc0.ɵɵreference(2); const ctx_r18 = ɵngcc0.ɵɵnextContext(3); return ctx_r18.btnClickAction($event, _r13); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵtemplate(2, MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_button_6_i_2_Template, 1, 3, "i", 21);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r14 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(1, 2, ctx_r14.btnTitle));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r14.btnIconCss);
} }
function MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_i_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i");
} if (rf & 2) {
    const ctx_r15 = ɵngcc0.ɵɵnextContext(4);
    ɵngcc0.ɵɵclassMap(ctx_r15.btnIconCss);
} }
function MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_ul_12_ng_container_1_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r28 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 30, 31);
    ɵngcc0.ɵɵlistener("click", function MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_ul_12_ng_container_1_li_1_Template_li_click_0_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r28); const item_r24 = restoredCtx.$implicit; const idx_r25 = restoredCtx.index; ɵngcc0.ɵɵnextContext(3); const _r13 = ɵngcc0.ɵɵreference(2); const ctx_r27 = ɵngcc0.ɵɵnextContext(3); return ctx_r27.updateInput(item_r24, _r13, idx_r25); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r24 = ctx.$implicit;
    const idx_r25 = ctx.index;
    const ctx_r23 = ɵngcc0.ɵɵnextContext(6);
    ɵngcc0.ɵɵclassProp("active", ctx_r23.dropdownActiveIndex === idx_r25);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 3, item_r24.text), " ");
} }
const _c57 = function (a0) { return { filter: a0 }; };
function MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_ul_12_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵtemplate(1, MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_ul_12_ng_container_1_li_1_Template, 4, 5, "li", 29);
    ɵngcc0.ɵɵpipe(2, "optionFilter");
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r20 = ɵngcc0.ɵɵnextContext(5);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind2(2, 1, ctx_r20.dropdownSet, ɵngcc0.ɵɵpureFunction1(4, _c57, ctx_r20.filterBy)));
} }
function MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_ul_12_ng_container_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 32);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 1, "ui.controls.multi-select-dropdown.empty"), "");
} }
function MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_ul_12_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "li", 32);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(3, 1, "ui.controls.multi-select-dropdown.no_match"), "");
} }
function MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_ul_12_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 28);
    ɵngcc0.ɵɵtemplate(1, MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_ul_12_ng_container_1_Template, 3, 6, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(2, MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_ul_12_ng_container_2_Template, 4, 3, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(3, MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_ul_12_ng_container_3_Template, 4, 3, "ng-container", 0);
    ɵngcc0.ɵɵpipe(4, "optionFilter");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r12 = ɵngcc0.ɵɵnextContext().field;
    const ctx_r16 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("id", field_r12.id + "_list");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r16.dropdownSet == null ? null : ctx_r16.dropdownSet.length) > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r16.dropdownSet == null ? null : ctx_r16.dropdownSet.length) === 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", (ctx_r16.dropdownSet == null ? null : ctx_r16.dropdownSet.length) > 0 && ɵngcc0.ɵɵpipeBind2(4, 4, ctx_r16.dropdownSet, ɵngcc0.ɵɵpureFunction1(7, _c57, ctx_r16.filterBy)).length === 0);
} }
const _c58 = function (a0) { return { "input-group-lg": a0 }; };
function MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 15);
    ɵngcc0.ɵɵelementStart(1, "input", 16, 17);
    ɵngcc0.ɵɵlistener("keydown", function MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_Template_input_keydown_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const _r13 = ɵngcc0.ɵɵreference(2); const ctx_r30 = ɵngcc0.ɵɵnextContext(3); return ctx_r30.iterateList($event, _r13); })("focus", function MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_Template_input_focus_1_listener() { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r32 = ɵngcc0.ɵɵnextContext(3); ctx_r32.listToggle = true; return ctx_r32.dropdownActiveIndex = 0; })("input", function MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_Template_input_input_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r31); const ctx_r33 = ɵngcc0.ɵɵnextContext(3); return ctx_r33.filterBy = $event.currentTarget.value; });
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "div", 18);
    ɵngcc0.ɵɵelement(5, "i", 19);
    ɵngcc0.ɵɵtemplate(6, MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_button_6_Template, 3, 4, "button", 20);
    ɵngcc0.ɵɵtemplate(7, MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_i_7_Template, 1, 3, "i", 21);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(8, "input", 22);
    ɵngcc0.ɵɵelementStart(9, "div", 23);
    ɵngcc0.ɵɵelementStart(10, "div", 24);
    ɵngcc0.ɵɵelementStart(11, "div", 25);
    ɵngcc0.ɵɵtemplate(12, MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_ul_12_Template, 5, 9, "ul", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r12 = ctx.field;
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(12, _c58, ctx_r11.showBtn));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate("placeholder", ɵngcc0.ɵɵpipeBind1(3, 10, "ui.controls.multi-select-dropdown.placeholder"));
    ɵngcc0.ɵɵproperty("id", field_r12.id)("value", ctx_r11.selectedQuery == null ? null : ctx_r11.selectedQuery.text);
    ɵngcc0.ɵɵattribute("aria-owns", field_r12.id + "_list")("aria-expanded", !!ctx_r11.dropdownSet && !!(ctx_r11.dropdownSet == null ? null : ctx_r11.dropdownSet.length));
    ɵngcc0.ɵɵadvance(5);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.showBtn);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r11.showBtn && ctx_r11.btnIconCss);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", field_r12.name);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r11.listToggle && ctx_r11.dropdownSet);
} }
function MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ui-form-field", 13);
    ɵngcc0.ɵɵtemplate(1, MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_ng_template_1_Template, 13, 14, "ng-template", null, 14, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("field", ctx_r2.field)("formGroup", ctx_r2.form)("form", ctx_r2.form)("formCtrl", ctx_r2.FormCtrl)("updateOn", ctx_r2.updateOn)("hasError", ctx_r2.hasError);
} }
function MultiSelectDropdownComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r35 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵlistener("focusout", function MultiSelectDropdownComponent_ng_container_0_Template_div_focusout_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r35); const ctx_r34 = ɵngcc0.ɵɵnextContext(); return ctx_r34.closeList($event); });
    ɵngcc0.ɵɵtemplate(2, MultiSelectDropdownComponent_ng_container_0_ng_container_2_Template, 7, 6, "ng-container", 0);
    ɵngcc0.ɵɵtemplate(3, MultiSelectDropdownComponent_ng_container_0_ui_form_field_3_Template, 3, 6, "ui-form-field", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.selectedSet && ctx_r0.selectedSet.length > 0);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.field);
} }
const _c59 = ["tabPanelTemplate"];
function TabGroupComponent_ng_container_0_li_2_Template(rf, ctx) { if (rf & 1) {
    const _r6 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 4);
    ɵngcc0.ɵɵelementStart(1, "a", 5);
    ɵngcc0.ɵɵlistener("keydown", function TabGroupComponent_ng_container_0_li_2_Template_a_keydown_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r6); const ctx_r5 = ɵngcc0.ɵɵnextContext(2); return ctx_r5.keyPress($event); })("click", function TabGroupComponent_ng_container_0_li_2_Template_a_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r6); const i_r4 = restoredCtx.index; const ctx_r7 = ɵngcc0.ɵɵnextContext(2); ctx_r7.activeTabIndex = i_r4; ctx_r7.focusTabIndex = i_r4; return ctx_r7.emitTabChange(); });
    ɵngcc0.ɵɵelementStart(2, "div", 6);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const tab_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "tab_", i_r4, "_", ctx_r1.random, "");
    ɵngcc0.ɵɵattributeInterpolate2("aria-controls", "tabpanel_", i_r4, "_", ctx_r1.random, "");
    ɵngcc0.ɵɵattribute("aria-selected", ctx_r1.focusTabIndex === i_r4)("tabindex", ctx_r1.focusTabIndex == i_r4 ? 0 : -1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(tab_r3);
} }
function TabGroupComponent_ng_container_0_div_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c60 = function (a0) { return { activeTabIndex: a0 }; };
function TabGroupComponent_ng_container_0_div_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 7);
    ɵngcc0.ɵɵtemplate(1, TabGroupComponent_ng_container_0_div_3_ng_container_1_Template, 1, 0, "ng-container", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate2("id", "tabpanel_", ctx_r2.focusTabIndex, "_", ctx_r2.random, "");
    ɵngcc0.ɵɵattribute("tabindex", ctx_r2.focusTabIndex == ctx_r2.activeTabIndex ? 0 : -1)("aria-labelledby", "tab_" + ctx_r2.activeTabIndex + "_" + ctx_r2.random);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.tabPanelTemplate)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(6, _c60, ctx_r2.focusTabIndex));
} }
function TabGroupComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "ul", 1);
    ɵngcc0.ɵɵtemplate(2, TabGroupComponent_ng_container_0_li_2_Template, 4, 7, "li", 2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(3, TabGroupComponent_ng_container_0_div_3_Template, 2, 8, "div", 3);
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r0.tabHeadings);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.tabPanelTemplate);
} }
function InlineTimePickerComponent_div_10_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 12);
    ɵngcc0.ɵɵelementStart(1, "ui-select", 13);
    ɵngcc0.ɵɵlistener("change", function InlineTimePickerComponent_div_10_Template_ui_select_change_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.toggleChange($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("d-none", ctx_r0.config == null ? null : ctx_r0.config.is24HourFormat);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("field", ctx_r0.amPmToggle)("form", ctx_r0.form);
} }
function InlineTimePickerComponent_div_16_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵelementStart(1, "button", 15);
    ɵngcc0.ɵɵlistener("click", function InlineTimePickerComponent_div_16_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.done(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "ui.input-timepicker.btn.done.label"));
} }
function InputTimePickerComponent_ng_container_0_ng_template_3_Template(rf, ctx) { if (rf & 1) {
    const _r9 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelement(1, "span", 6);
    ɵngcc0.ɵɵelementStart(2, "input", 7, 8);
    ɵngcc0.ɵɵlistener("keydown", function InputTimePickerComponent_ng_container_0_ng_template_3_Template_input_keydown_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r8 = ɵngcc0.ɵɵnextContext(2); return ctx_r8.handleKeypress($event); })("change", function InputTimePickerComponent_ng_container_0_ng_template_3_Template_input_change_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); $event.stopPropagation(); return ctx_r10.timeValueChanged($event); })("blur", function InputTimePickerComponent_ng_container_0_ng_template_3_Template_input_blur_2_listener() { ɵngcc0.ɵɵrestoreView(_r9); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.checkForError(); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "button", 9);
    ɵngcc0.ɵɵlistener("click", function InputTimePickerComponent_ng_container_0_ng_template_3_Template_button_click_4_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r9); const field_r6 = restoredCtx.field; const ctx_r12 = ɵngcc0.ɵɵnextContext(2); return !field_r6.disabled && ctx_r12.toggle(); });
    ɵngcc0.ɵɵelement(5, "i", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r6 = ctx.field;
    const ctx_r4 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", field_r6.id + "_desc")("innerText", ctx_r4.timeFormatDesc);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("id", field_r6.id)("formControlName", field_r6.name)("ngClass", ɵngcc0.ɵɵpureFunction2(16, _c2, ctx_r4.hasError, ctx_r4.hasError))("required", field_r6.required && field_r6.required !== "false")("readonly", field_r6.readonly);
    ɵngcc0.ɵɵattribute("aria-invalid", ctx_r4.hasError)("aria-describedby", ctx_r4.ariaDescribedBy ? ctx_r4.ariaDescribedBy : "")("aria-errormessage", ctx_r4.ariaErrorMessage)("data-if-id", field_r6.extraAttributes == null ? null : field_r6.extraAttributes.ifId)("name", field_r6.name)("id", field_r6.id)("disabled", field_r6.disabled ? "" : null)("placeholder", field_r6.placeholder ? field_r6.placeholder : "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵattribute("data-if-id", field_r6.extraAttributes == null ? null : field_r6.extraAttributes.ifId);
} }
function InputTimePickerComponent_ng_container_0_ui_inline_time_picker_5_Template(rf, ctx) { if (rf & 1) {
    const _r15 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ui-inline-time-picker", 11, 12);
    ɵngcc0.ɵɵlistener("change", function InputTimePickerComponent_ng_container_0_ui_inline_time_picker_5_Template_ui_inline_time_picker_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r14 = ɵngcc0.ɵɵnextContext(2); return ctx_r14.timeChanged($event); })("close", function InputTimePickerComponent_ng_container_0_ui_inline_time_picker_5_Template_ui_inline_time_picker_close_0_listener() { ɵngcc0.ɵɵrestoreView(_r15); const ctx_r16 = ɵngcc0.ɵɵnextContext(2); return ctx_r16.toggle(); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵclassMapInterpolate1("input-timepicker timepicker-", ctx_r5.orientation, "");
    ɵngcc0.ɵɵpropertyInterpolate1("id", "timepicker_", ctx_r5.field.id, "");
    ɵngcc0.ɵɵproperty("config", ctx_r5.timepickerSettings);
} }
function InputTimePickerComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div");
    ɵngcc0.ɵɵelementStart(2, "ui-form-field", 2);
    ɵngcc0.ɵɵtemplate(3, InputTimePickerComponent_ng_container_0_ng_template_3_Template, 6, 19, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(5, InputTimePickerComponent_ng_container_0_ui_inline_time_picker_5_Template, 2, 5, "ui-inline-time-picker", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("field", ctx_r0.field)("formGroup", ctx_r0.form)("form", ctx_r0.form)("formCtrl", ctx_r0.FormCtrl)("hasError", ctx_r0.hasError)("updateOn", ctx_r0.updateOn);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.showTimePicker);
} }
function InputTimePickerComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r18 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ui-input-time", 13);
    ɵngcc0.ɵɵlistener("change", function InputTimePickerComponent_ng_template_1_Template_ui_input_time_change_0_listener($event) { ɵngcc0.ɵɵrestoreView(_r18); const ctx_r17 = ɵngcc0.ɵɵnextContext(); return ctx_r17.timeValueChangedMobile($event); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r2.field)("form", ctx_r2.form)("updateOn", ctx_r2.mobileTimepickerUpdateOn || ctx_r2.updateOn);
} }
const _c61 = ["customToastBodyTemplate"];
function ToastComponent_ng_container_0_ng_container_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
const _c62 = function (a0, a1) { return { "message": a0, "hideToast": a1 }; };
function ToastComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "div", 2);
    ɵngcc0.ɵɵelementStart(2, "div");
    ɵngcc0.ɵɵtemplate(3, ToastComponent_ng_container_0_ng_container_3_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r1 = ɵngcc0.ɵɵreference(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("active", ctx_r0.active);
    ɵngcc0.ɵɵproperty("ngClass", ctx_r0.position);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassMapInterpolate2("alert ", ctx_r0.style ? ctx_r0.style : "", " ", ctx_r0.position, "");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.customToastBodyTemplate ? ctx_r0.customToastBodyTemplate : _r1)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(9, _c62, ctx_r0.message, ctx_r0.hideToast.bind(ctx_r0)));
} }
function ToastComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r7 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "button", 4);
    ɵngcc0.ɵɵlistener("click", function ToastComponent_ng_template_1_Template_button_click_3_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r7); const hideToast_r5 = restoredCtx.hideToast; return hideToast_r5(); });
    ɵngcc0.ɵɵelementStart(4, "span", 5);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(7, "i", 6);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r4 = ctx.message;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 2, message_r4));
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 4, "ui.toast.close"));
} }
function RadioButtonGroupComponent_legend_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "legend", 9);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r0.field.id + "_legend")("innerHTML", ɵngcc0.ɵɵpipeBind1(1, 2, ctx_r0.field.legend), ɵngcc0.ɵɵsanitizeHtml);
} }
function RadioButtonGroupComponent_label_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "label", 10);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassProp("required", ctx_r1.field.required);
    ɵngcc0.ɵɵproperty("id", ctx_r1.field.id + "_legend_label")("innerHTML", ɵngcc0.ɵɵpipeBind1(1, 4, ctx_r1.field.legend), ɵngcc0.ɵɵsanitizeHtml);
} }
function RadioButtonGroupComponent_ng_container_5_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function RadioButtonGroupComponent_ng_container_5_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, RadioButtonGroupComponent_ng_container_5_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 13);
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext();
    const option_r6 = ctx_r11.$implicit;
    const idx_r7 = ctx_r11.index;
    const ctx_r9 = ɵngcc0.ɵɵnextContext();
    const _r4 = ɵngcc0.ɵɵreference(10);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r9.customButtonLabel ? ctx_r9.customButtonLabel : _r4)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c21, option_r6.label, idx_r7));
} }
function RadioButtonGroupComponent_ng_container_5_Template(rf, ctx) { if (rf & 1) {
    const _r13 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "ui-radio-button", 11);
    ɵngcc0.ɵɵlistener("updateField", function RadioButtonGroupComponent_ng_container_5_Template_ui_radio_button_updateField_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r12 = ɵngcc0.ɵɵnextContext(); return ctx_r12.updateResponseField($event); })("updateOnNextChange", function RadioButtonGroupComponent_ng_container_5_Template_ui_radio_button_updateOnNextChange_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r13); const ctx_r14 = ɵngcc0.ɵɵnextContext(); return ctx_r14.updateNextChange($event); });
    ɵngcc0.ɵɵtemplate(2, RadioButtonGroupComponent_ng_container_5_ng_template_2_Template, 1, 5, "ng-template", null, 12, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const option_r6 = ctx.$implicit;
    const idx_r7 = ctx.index;
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵstyleMap(ctx_r2.style && ctx_r2.style[idx_r7] ? ctx_r2.style[idx_r7] : "");
    ɵngcc0.ɵɵproperty("id", option_r6.id)("name", option_r6.name)("active", option_r6.checked)("label", option_r6.label)("value", option_r6.value);
} }
function RadioButtonGroupComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "span", 14);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("id", ctx_r3.field.id + "_error_req")("innerHTML", ɵngcc0.ɵɵpipeBind1(1, 2, "ui.form_field.required_text"), ɵngcc0.ɵɵsanitizeHtml);
} }
function RadioButtonGroupComponent_ng_template_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const message_r15 = ctx.message;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, message_r15));
} }
const _c63 = ["fieldLabel"];
function RadioButtonComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ExpandCollapseComponent_ui_dynamic_heading_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ui-dynamic-heading", 7);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵstyleMap(ctx_r0.headingClass);
    ɵngcc0.ɵɵproperty("headingLevel", 1);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 4, ctx_r0.title), " ");
} }
function ExpandCollapseComponent_div_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r1.headingClass || "expander-heading");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 4, ctx_r1.title), "");
} }
function ExpandCollapseComponent_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵprojection(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("@animateCollapse", ctx_r2.state);
} }
const _c64 = function (a0) { return { linkText: a0 }; };
function InformationBannerComponent_section_0_a_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 9);
    ɵngcc0.ɵɵlistener("click", function InformationBannerComponent_section_0_a_7_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(2); return ctx_r2.handleNavigation(ctx_r2.informationBanner.link); });
    ɵngcc0.ɵɵpipe(1, "translate");
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵelement(4, "i", 10);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵpropertyInterpolate("title", ɵngcc0.ɵɵpipeBind2(1, 2, "ui.information-banner.link_title", ɵngcc0.ɵɵpureFunction1(7, _c64, ɵngcc0.ɵɵpipeBind1(2, 5, ctx_r1.informationBanner.linkText))));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.informationBanner.linkText);
} }
function InformationBannerComponent_section_0_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "section");
    ɵngcc0.ɵɵelementStart(1, "div", 1);
    ɵngcc0.ɵɵelementStart(2, "div", 2);
    ɵngcc0.ɵɵelementStart(3, "span", 3);
    ɵngcc0.ɵɵelement(4, "i", 4);
    ɵngcc0.ɵɵelementStart(5, "span");
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, InformationBannerComponent_section_0_a_7_Template, 5, 9, "a", 5);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "button", 6);
    ɵngcc0.ɵɵlistener("click", function InformationBannerComponent_section_0_Template_button_click_8_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(); return ctx_r4.closeBanner(); });
    ɵngcc0.ɵɵelement(9, "i", 7);
    ɵngcc0.ɵɵelementStart(10, "span", 8);
    ɵngcc0.ɵɵtext(11);
    ɵngcc0.ɵɵpipe(12, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵclassMap(ctx_r0.informationBanner.position);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵclassMapInterpolate1("ifc-icon mt-1 mr-2 ", ctx_r0.informationBanner.icon, "");
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.informationBanner.description);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r0.informationBanner.link && ctx_r0.informationBanner.linkText);
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(12, 9, "ui.information-banner.close_text"));
} }
function PasswordCriteriaComponent_li_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li");
    ɵngcc0.ɵɵelement(1, "i", 5);
    ɵngcc0.ɵɵelementStart(2, "div", 6);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const criterion_r1 = ctx.$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("list-group-item ", criterion_r1 == null ? null : criterion_r1.status, " d-flex flex-row align-items-center border-0 py-2 px-0");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 4, criterion_r1 == null ? null : criterion_r1.title));
} }
function MobilePasswordCriteriaComponent_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    const _r3 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "span", 4);
    ɵngcc0.ɵɵlistener("click", function MobilePasswordCriteriaComponent_ng_container_1_Template_span_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r3); const ctx_r2 = ɵngcc0.ɵɵnextContext(); return ctx_r2.showCriteria = !ctx_r2.showCriteria; });
    ɵngcc0.ɵɵelement(2, "i", 5);
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(6, "i", 6);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵattribute("aria-expanded", ctx_r0.showCriteria);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 2, "ui.password-criteria-mobile.requirements_met"));
} }
function MobilePasswordCriteriaComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span");
    ɵngcc0.ɵɵelement(1, "i", 7);
    ɵngcc0.ɵɵelementStart(2, "span");
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const criterion_r4 = ctx.$implicit;
    ɵngcc0.ɵɵclassMapInterpolate1("criteria ", criterion_r4.status, "");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 4, criterion_r4.description));
} }
const _c65 = function (a0, a1) { return { "collapse": a0, "show": a1 }; };
function DynamicHeadingComponent_h1_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DynamicHeadingComponent_h1_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h1");
    ɵngcc0.ɵɵtemplate(1, DynamicHeadingComponent_h1_0_ng_container_1_Template, 1, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵclassMap(ctx_r0.style ? ctx_r0.style : null);
    ɵngcc0.ɵɵattribute("data-heading-level", ctx_r0.headingLevel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6);
} }
function DynamicHeadingComponent_h2_1_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DynamicHeadingComponent_h2_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h2");
    ɵngcc0.ɵɵtemplate(1, DynamicHeadingComponent_h2_1_ng_container_1_Template, 1, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵclassMap(ctx_r1.style ? ctx_r1.style : null);
    ɵngcc0.ɵɵattribute("data-heading-level", ctx_r1.headingLevel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6);
} }
function DynamicHeadingComponent_h3_2_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DynamicHeadingComponent_h3_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h3");
    ɵngcc0.ɵɵtemplate(1, DynamicHeadingComponent_h3_2_ng_container_1_Template, 1, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵclassMap(ctx_r2.style ? ctx_r2.style : null);
    ɵngcc0.ɵɵattribute("data-heading-level", ctx_r2.headingLevel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6);
} }
function DynamicHeadingComponent_h4_3_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DynamicHeadingComponent_h4_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h4");
    ɵngcc0.ɵɵtemplate(1, DynamicHeadingComponent_h4_3_ng_container_1_Template, 1, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵclassMap(ctx_r3.style ? ctx_r3.style : null);
    ɵngcc0.ɵɵattribute("data-heading-level", ctx_r3.headingLevel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6);
} }
function DynamicHeadingComponent_h5_4_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DynamicHeadingComponent_h5_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h5");
    ɵngcc0.ɵɵtemplate(1, DynamicHeadingComponent_h5_4_ng_container_1_Template, 1, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵclassMap(ctx_r4.style ? ctx_r4.style : null);
    ɵngcc0.ɵɵattribute("data-heading-level", ctx_r4.headingLevel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6);
} }
function DynamicHeadingComponent_h6_5_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function DynamicHeadingComponent_h6_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "h6");
    ɵngcc0.ɵɵtemplate(1, DynamicHeadingComponent_h6_5_ng_container_1_Template, 1, 0, "ng-container", 2);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    const _r6 = ɵngcc0.ɵɵreference(7);
    ɵngcc0.ɵɵclassMap(ctx_r5.style ? ctx_r5.style : null);
    ɵngcc0.ɵɵattribute("data-heading-level", ctx_r5.headingLevel);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", _r6);
} }
function DynamicHeadingComponent_ng_template_6_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵprojection(0);
} }
function InputPasswordComponent_ui_form_field_0_ng_template_1_ng_container_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelement(1, "i", 8);
    ɵngcc0.ɵɵelementStart(2, "span", 9);
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 1, "ui.input-password.show_password"));
} }
function InputPasswordComponent_ui_form_field_0_ng_template_1_ng_template_5_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "i", 10);
    ɵngcc0.ɵɵelementStart(1, "span", 9);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "ui.input-password.hide_password"));
} }
function InputPasswordComponent_ui_form_field_0_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    const _r8 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 3);
    ɵngcc0.ɵɵelementStart(1, "input", 4);
    ɵngcc0.ɵɵlistener("input", function InputPasswordComponent_ui_form_field_0_ng_template_1_Template_input_input_1_listener($event) { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); const field_r3 = restoredCtx.field; const ctx_r7 = ɵngcc0.ɵɵnextContext(2); return ctx_r7.changeOccurred($event, field_r3); })("blur", function InputPasswordComponent_ui_form_field_0_ng_template_1_Template_input_blur_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r8); const field_r3 = restoredCtx.field; const ctx_r9 = ɵngcc0.ɵɵnextContext(2); return ctx_r9.handleBlur(field_r3); })("keydown", function InputPasswordComponent_ui_form_field_0_ng_template_1_Template_input_keydown_1_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r10 = ɵngcc0.ɵɵnextContext(2); return ctx_r10.checkForEnter($event); });
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(2, "button", 5);
    ɵngcc0.ɵɵlistener("click", function InputPasswordComponent_ui_form_field_0_ng_template_1_Template_button_click_2_listener($event) { ɵngcc0.ɵɵrestoreView(_r8); const ctx_r11 = ɵngcc0.ɵɵnextContext(2); return ctx_r11.handleClick($event); });
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵtemplate(4, InputPasswordComponent_ui_form_field_0_ng_template_1_ng_container_4_Template, 5, 3, "ng-container", 6);
    ɵngcc0.ɵɵtemplate(5, InputPasswordComponent_ui_form_field_0_ng_template_1_ng_template_5_Template, 4, 3, "ng-template", null, 7, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const field_r3 = ctx.field;
    const _r5 = ɵngcc0.ɵɵreference(6);
    const ctx_r2 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("formControlName", field_r3 == null ? null : field_r3.name)("field", field_r3)("ngClass", ɵngcc0.ɵɵpureFunction2(9, _c2, ctx_r2.hasError, ctx_r2.hasError));
    ɵngcc0.ɵɵattribute("data-if-id", field_r3 == null ? null : field_r3.extraAttributes == null ? null : field_r3.extraAttributes.ifId);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("title", ɵngcc0.ɵɵpipeBind1(3, 7, ctx_r2.showPassword ? "ui.input-password.hide_password" : "ui.input-password.show_password"));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", !ctx_r2.showPassword)("ngIfElse", _r5);
} }
function InputPasswordComponent_ui_form_field_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ui-form-field", 1);
    ɵngcc0.ɵɵtemplate(1, InputPasswordComponent_ui_form_field_0_ng_template_1_Template, 7, 12, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("field", ctx_r0.field)("formGroup", ctx_r0.form)("form", ctx_r0.form)("formCtrl", ctx_r0.FormCtrl)("updateOn", ctx_r0.updateOn)("hasError", ctx_r0.hasError);
} }
const _c66 = ["modalAlertTemplate"];
function ModalAlertsComponent_ng_template_2_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function ModalAlertsComponent_ng_template_2_ng_template_1_div_7_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div", 9);
    ɵngcc0.ɵɵpipe(1, "translate");
} if (rf & 2) {
    const longDesc_r7 = ctx.$implicit;
    ɵngcc0.ɵɵproperty("innerHtml", ɵngcc0.ɵɵpipeBind1(1, 1, longDesc_r7), ɵngcc0.ɵɵsanitizeHtml);
} }
function ModalAlertsComponent_ng_template_2_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 5);
    ɵngcc0.ɵɵelementStart(1, "h1", 6);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "p", 7);
    ɵngcc0.ɵɵtext(5);
    ɵngcc0.ɵɵpipe(6, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(7, ModalAlertsComponent_ng_template_2_ng_template_1_div_7_Template, 2, 3, "div", 8);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r5 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 3, ctx_r5.modalAlerts[0] == null ? null : ctx_r5.modalAlerts[0].title));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 5, ctx_r5.modalAlerts[0] == null ? null : ctx_r5.modalAlerts[0].description));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r5.modalAlerts[0] == null ? null : ctx_r5.modalAlerts[0].longDesc);
} }
const _c67 = function (a0, a1) { return { "alert": a0, "dismiss": a1 }; };
function ModalAlertsComponent_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ModalAlertsComponent_ng_template_2_ng_container_0_Template, 1, 0, "ng-container", 3);
    ɵngcc0.ɵɵtemplate(1, ModalAlertsComponent_ng_template_2_ng_template_1_Template, 8, 7, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r4 = ɵngcc0.ɵɵreference(2);
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r1.modalAlertTemplate ? ctx_r1.modalAlertTemplate : _r4)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c67, ctx_r1.modalAlerts[0], ctx_r1.dismiss));
} }
function ModalAlertsComponent_4_ng_template_0_div_1_button_1_Template(rf, ctx) { if (rf & 1) {
    const _r17 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "button", 17);
    ɵngcc0.ɵɵlistener("click", function ModalAlertsComponent_4_ng_template_0_div_1_button_1_Template_button_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r17); const action_r12 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r15 = ɵngcc0.ɵɵnextContext(3); return ctx_r15.handleAction(action_r12); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r12 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, action_r12.text));
} }
function ModalAlertsComponent_4_ng_template_0_div_1_a_2_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "a", 18);
    ɵngcc0.ɵɵlistener("click", function ModalAlertsComponent_4_ng_template_0_div_1_a_2_Template_a_click_0_listener() { ɵngcc0.ɵɵrestoreView(_r21); const action_r12 = ɵngcc0.ɵɵnextContext().$implicit; const ctx_r19 = ɵngcc0.ɵɵnextContext(3); return ctx_r19.handleNavigation(action_r12); });
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r12 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, action_r12.text));
} }
function ModalAlertsComponent_4_ng_template_0_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 14);
    ɵngcc0.ɵɵtemplate(1, ModalAlertsComponent_4_ng_template_0_div_1_button_1_Template, 3, 3, "button", 15);
    ɵngcc0.ɵɵtemplate(2, ModalAlertsComponent_4_ng_template_0_div_1_a_2_Template, 3, 3, "a", 16);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const action_r12 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", !action_r12.href);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", action_r12.href);
} }
function ModalAlertsComponent_4_ng_template_0_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r24 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelementStart(1, "button", 20);
    ɵngcc0.ɵɵlistener("click", function ModalAlertsComponent_4_ng_template_0_div_2_Template_button_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r24); const ctx_r23 = ɵngcc0.ɵɵnextContext(3); return ctx_r23.dismiss(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "ui.modal-alerts.dismiss_label"));
} }
function ModalAlertsComponent_4_ng_template_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, ModalAlertsComponent_4_ng_template_0_div_1_Template, 3, 2, "div", 12);
    ɵngcc0.ɵɵtemplate(2, ModalAlertsComponent_4_ng_template_0_div_2_Template, 4, 3, "div", 13);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.modalAlerts[0] == null ? null : ctx_r9.modalAlerts[0].action);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.modalAlerts[0] == null ? null : ctx_r9.modalAlerts[0].dismissible);
} }
function ModalAlertsComponent_4_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, ModalAlertsComponent_4_ng_template_0_Template, 3, 2, "ng-template", null, 10, ɵngcc0.ɵɵtemplateRefExtractor);
} }
const _c68 = ["bannerTemplate"];
function BannerAlertsComponent_div_0_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function BannerAlertsComponent_div_0_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    const _r5 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "ui-information-banner", 4);
    ɵngcc0.ɵɵlistener("close", function BannerAlertsComponent_div_0_ng_template_2_Template_ui_information_banner_close_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r4 = ɵngcc0.ɵɵnextContext(2); return ctx_r4.dismiss(); })("action", function BannerAlertsComponent_div_0_ng_template_2_Template_ui_information_banner_action_0_listener() { ɵngcc0.ɵɵrestoreView(_r5); const ctx_r6 = ɵngcc0.ɵɵnextContext(2); return ctx_r6.handleAction(ctx_r6.bannerAlerts[0] == null ? null : ctx_r6.bannerAlerts[0].action); });
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r3 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("informationBanner", ctx_r3.displayedAlert);
} }
const _c69 = function (a0, a1) { return { "displayedAlert": a0, "dismiss": a1 }; };
function BannerAlertsComponent_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 1);
    ɵngcc0.ɵɵtemplate(1, BannerAlertsComponent_div_0_ng_container_1_Template, 1, 0, "ng-container", 2);
    ɵngcc0.ɵɵtemplate(2, BannerAlertsComponent_div_0_ng_template_2_Template, 1, 1, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r2 = ɵngcc0.ɵɵreference(3);
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r0.bannerTemplate ? ctx_r0.bannerTemplate : _r2)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c69, ctx_r0.displayedAlert, ctx_r0.dismiss));
} }
const _c70 = ["panelAlertsTemplate"];
const _c71 = ["allAlertsTemplate"];
function PanelAlertsComponent_span_3_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r0.panelAlerts == null ? null : ctx_r0.panelAlerts.length);
} }
function PanelAlertsComponent_span_8_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 10);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ctx_r1.panelAlerts == null ? null : ctx_r1.panelAlerts.length);
} }
function PanelAlertsComponent_div_11_ng_container_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function PanelAlertsComponent_div_11_ng_template_2_div_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(2, 1, "ui.panel-alerts.empty_state"), " ");
} }
function PanelAlertsComponent_div_11_ng_template_2_ul_1_li_1_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 27);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const alert_r14 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, alert_r14.dateTime));
} }
function PanelAlertsComponent_div_11_ng_template_2_ul_1_li_1_Template(rf, ctx) { if (rf & 1) {
    const _r19 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 20);
    ɵngcc0.ɵɵelementStart(1, "a", 21);
    ɵngcc0.ɵɵlistener("click", function PanelAlertsComponent_div_11_ng_template_2_ul_1_li_1_Template_a_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r19); const alert_r14 = restoredCtx.$implicit; const ctx_r18 = ɵngcc0.ɵɵnextContext(4); return ctx_r18.handleNavigation(alert_r14.action); });
    ɵngcc0.ɵɵelementStart(2, "span", 22);
    ɵngcc0.ɵɵelementStart(3, "span", 23);
    ɵngcc0.ɵɵelement(4, "i");
    ɵngcc0.ɵɵelementStart(5, "span");
    ɵngcc0.ɵɵelementStart(6, "span", 24);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, PanelAlertsComponent_div_11_ng_template_2_ul_1_li_1_span_9_Template, 3, 3, "span", 25);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(10, "i", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const alert_r14 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵclassMapInterpolate1("ifc-icon ", alert_r14.icon, " ifc-icon-2 mr-2 mt-1");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 5, alert_r14.title));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", alert_r14.dateTime);
} }
function PanelAlertsComponent_div_11_ng_template_2_ul_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 18);
    ɵngcc0.ɵɵtemplate(1, PanelAlertsComponent_div_11_ng_template_2_ul_1_li_1_Template, 11, 7, "li", 19);
    ɵngcc0.ɵɵpipe(2, "slice");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r11 = ɵngcc0.ɵɵnextContext(3);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", ɵngcc0.ɵɵpipeBind3(2, 1, ctx_r11.panelAlerts, 0, ctx_r11.maxAlerts));
} }
function PanelAlertsComponent_div_11_ng_template_2_div_2_Template(rf, ctx) { if (rf & 1) {
    const _r21 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div");
    ɵngcc0.ɵɵelementStart(1, "a", 28);
    ɵngcc0.ɵɵlistener("click", function PanelAlertsComponent_div_11_ng_template_2_div_2_Template_a_click_1_listener() { ɵngcc0.ɵɵrestoreView(_r21); const ctx_r20 = ɵngcc0.ɵɵnextContext(3); return ctx_r20.openAllNotifications(); });
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 1, "ui.panel-alerts.view_all"));
} }
function PanelAlertsComponent_div_11_ng_template_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, PanelAlertsComponent_div_11_ng_template_2_div_0_Template, 3, 3, "div", 14);
    ɵngcc0.ɵɵtemplate(1, PanelAlertsComponent_div_11_ng_template_2_ul_1_Template, 3, 5, "ul", 15);
    ɵngcc0.ɵɵtemplate(2, PanelAlertsComponent_div_11_ng_template_2_div_2_Template, 4, 3, "div", 16);
} if (rf & 2) {
    const ctx_r9 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵproperty("ngIf", !(ctx_r9.panelAlerts == null ? null : ctx_r9.panelAlerts.length));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.panelAlerts == null ? null : ctx_r9.panelAlerts.length);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", ctx_r9.panelAlerts.length > ctx_r9.maxAlerts);
} }
const _c72 = function (a0, a1, a2, a3) { return { "alerts": a0, "openAllNotifications": a1, "closeNotifications": a2, "togglePanel": a3 }; };
function PanelAlertsComponent_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 11);
    ɵngcc0.ɵɵtemplate(1, PanelAlertsComponent_div_11_ng_container_1_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵtemplate(2, PanelAlertsComponent_div_11_ng_template_2_Template, 3, 3, "ng-template", null, 13, ɵngcc0.ɵɵtemplateRefExtractor);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const _r8 = ɵngcc0.ɵɵreference(3);
    const ctx_r2 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r2.panelAlertsTemplate ? ctx_r2.panelAlertsTemplate : _r8)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction4(2, _c72, ctx_r2.panelAlerts, ctx_r2.openAllNotifications, ctx_r2.closeNotifications, ctx_r2.togglePanel));
} }
function PanelAlertsComponent_ng_template_13_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function PanelAlertsComponent_ng_template_13_ng_template_1_li_5_span_9_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "span", 36);
    ɵngcc0.ɵɵtext(1);
    ɵngcc0.ɵɵpipe(2, "translate");
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const alert_r26 = ɵngcc0.ɵɵnextContext().$implicit;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(2, 1, alert_r26.dateTime));
} }
function PanelAlertsComponent_ng_template_13_ng_template_1_li_5_Template(rf, ctx) { if (rf & 1) {
    const _r31 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "li", 33);
    ɵngcc0.ɵɵelementStart(1, "a", 34);
    ɵngcc0.ɵɵlistener("click", function PanelAlertsComponent_ng_template_13_ng_template_1_li_5_Template_a_click_1_listener() { const restoredCtx = ɵngcc0.ɵɵrestoreView(_r31); const alert_r26 = restoredCtx.$implicit; const ctx_r30 = ɵngcc0.ɵɵnextContext(3); return ctx_r30.handleNavigation(alert_r26.action); });
    ɵngcc0.ɵɵelementStart(2, "span", 22);
    ɵngcc0.ɵɵelementStart(3, "span", 23);
    ɵngcc0.ɵɵelement(4, "i");
    ɵngcc0.ɵɵelementStart(5, "span");
    ɵngcc0.ɵɵelementStart(6, "span", 24);
    ɵngcc0.ɵɵtext(7);
    ɵngcc0.ɵɵpipe(8, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵtemplate(9, PanelAlertsComponent_ng_template_13_ng_template_1_li_5_span_9_Template, 3, 3, "span", 35);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelement(10, "i", 26);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const alert_r26 = ctx.$implicit;
    ɵngcc0.ɵɵadvance(4);
    ɵngcc0.ɵɵclassMapInterpolate1("ifc-icon ", alert_r26.icon, " ifc-icon-2 mr-2 mt-1");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 5, alert_r26.title));
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", alert_r26.dateTime);
} }
function PanelAlertsComponent_ng_template_13_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 30);
    ɵngcc0.ɵɵelementStart(1, "h1", 31);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵpipe(3, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(4, "ul", 18);
    ɵngcc0.ɵɵtemplate(5, PanelAlertsComponent_ng_template_13_ng_template_1_li_5_Template, 11, 7, "li", 32);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r24 = ɵngcc0.ɵɵnextContext(2);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "ui.panel-alerts.all_notifications_heading"));
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngForOf", ctx_r24.panelAlerts);
} }
function PanelAlertsComponent_ng_template_13_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, PanelAlertsComponent_ng_template_13_ng_container_0_Template, 1, 0, "ng-container", 12);
    ɵngcc0.ɵɵtemplate(1, PanelAlertsComponent_ng_template_13_ng_template_1_Template, 6, 4, "ng-template", null, 29, ɵngcc0.ɵɵtemplateRefExtractor);
} if (rf & 2) {
    const _r23 = ɵngcc0.ɵɵreference(2);
    const ctx_r4 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx_r4.allAlertsTemplate ? ctx_r4.allAlertsTemplate : _r23)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction4(2, _c72, ctx_r4.panelAlerts, ctx_r4.openAllNotifications, ctx_r4.closeNotifications, ctx_r4.togglePanel));
} }
function PanelAlertsComponent_ng_template_15_Template(rf, ctx) { if (rf & 1) {
    const _r33 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementStart(0, "div", 37);
    ɵngcc0.ɵɵelementStart(1, "div", 38);
    ɵngcc0.ɵɵelementStart(2, "button", 39);
    ɵngcc0.ɵɵlistener("click", function PanelAlertsComponent_ng_template_15_Template_button_click_2_listener() { ɵngcc0.ɵɵrestoreView(_r33); const ctx_r32 = ɵngcc0.ɵɵnextContext(); return ctx_r32.closeNotifications(); });
    ɵngcc0.ɵɵtext(3);
    ɵngcc0.ɵɵpipe(4, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 1, "ui.panel-alerts.close_label"));
} }
const _c73 = ["trainTemplate"];
function TrainComponent_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementContainer(0);
} }
function TrainComponent_ng_template_1_ng_container_0_ul_2_li_1_div_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 17);
    ɵngcc0.ɵɵelementStart(1, "span", 18);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const i_r10 = ɵngcc0.ɵɵnextContext().index;
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", i_r10 + 1, " ");
} }
function TrainComponent_ng_template_1_ng_container_0_ul_2_li_1_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 19);
    ɵngcc0.ɵɵelement(1, "i", 20);
    ɵngcc0.ɵɵelementEnd();
} }
function TrainComponent_ng_template_1_ng_container_0_ul_2_li_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "li", 13);
    ɵngcc0.ɵɵtemplate(1, TrainComponent_ng_template_1_ng_container_0_ul_2_li_1_div_1_Template, 3, 1, "div", 14);
    ɵngcc0.ɵɵtemplate(2, TrainComponent_ng_template_1_ng_container_0_ul_2_li_1_div_2_Template, 2, 0, "div", 15);
    ɵngcc0.ɵɵelementStart(3, "div", 16);
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const stop_r9 = ctx.$implicit;
    const i_r10 = ctx.index;
    const currentStopIdx_r4 = ɵngcc0.ɵɵnextContext(3).currentStopIdx;
    ɵngcc0.ɵɵclassProp("active", currentStopIdx_r4 === i_r10)("completed", currentStopIdx_r4 > i_r10)("border-right-0", i_r10 > 0);
    ɵngcc0.ɵɵattribute("tabindex", currentStopIdx_r4 > i_r10 ? "0" : "-1");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", currentStopIdx_r4 <= i_r10);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngIf", currentStopIdx_r4 > i_r10);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(5, 10, stop_r9.title), " ");
} }
function TrainComponent_ng_template_1_ng_container_0_ul_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "ul", 11);
    ɵngcc0.ɵɵtemplate(1, TrainComponent_ng_template_1_ng_container_0_ul_2_li_1_Template, 6, 12, "li", 12);
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const trainStops_r3 = ɵngcc0.ɵɵnextContext(2).trainStops;
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", trainStops_r3);
} }
function TrainComponent_ng_template_1_ng_container_0_div_11_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelementStart(0, "div", 21);
    ɵngcc0.ɵɵelementStart(1, "span", 22);
    ɵngcc0.ɵɵtext(2);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "span");
    ɵngcc0.ɵɵtext(4);
    ɵngcc0.ɵɵpipe(5, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
} if (rf & 2) {
    const stop_r16 = ctx.$implicit;
    const i_r17 = ctx.index;
    const currentStopIdx_r4 = ɵngcc0.ɵɵnextContext(2).currentStopIdx;
    ɵngcc0.ɵɵclassProp("stop-list-active", currentStopIdx_r4 === i_r17)("stop-list-inactive", currentStopIdx_r4 !== i_r17);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(i_r17 + 1);
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 6, stop_r16.title));
} }
const _c74 = function (a0, a1) { return { "ifc-menu": a0, "ifc-circle-remove": a1 }; };
function TrainComponent_ng_template_1_ng_container_0_Template(rf, ctx) { if (rf & 1) {
    const _r20 = ɵngcc0.ɵɵgetCurrentView();
    ɵngcc0.ɵɵelementContainerStart(0);
    ɵngcc0.ɵɵelementStart(1, "section", 3);
    ɵngcc0.ɵɵtemplate(2, TrainComponent_ng_template_1_ng_container_0_ul_2_Template, 2, 1, "ul", 4);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(3, "section", 5);
    ɵngcc0.ɵɵelementStart(4, "div", 6);
    ɵngcc0.ɵɵlistener("click", function TrainComponent_ng_template_1_ng_container_0_Template_div_click_4_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r19 = ɵngcc0.ɵɵnextContext(2); return ctx_r19.toggleStepListShown(); })("focusout", function TrainComponent_ng_template_1_ng_container_0_Template_div_focusout_4_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r21 = ɵngcc0.ɵɵnextContext(2); return ctx_r21.toggleStepListShown(); });
    ɵngcc0.ɵɵelement(5, "i", 7);
    ɵngcc0.ɵɵtext(6);
    ɵngcc0.ɵɵpipe(7, "translate");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(8, "div", 8);
    ɵngcc0.ɵɵelement(9, "span");
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementStart(10, "div", 9);
    ɵngcc0.ɵɵlistener("click", function TrainComponent_ng_template_1_ng_container_0_Template_div_click_10_listener() { ɵngcc0.ɵɵrestoreView(_r20); const ctx_r22 = ɵngcc0.ɵɵnextContext(2); return ctx_r22.toggleStepListShown(); });
    ɵngcc0.ɵɵtemplate(11, TrainComponent_ng_template_1_ng_container_0_div_11_Template, 6, 8, "div", 10);
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementEnd();
    ɵngcc0.ɵɵelementContainerEnd();
} if (rf & 2) {
    const ctx_r23 = ɵngcc0.ɵɵnextContext();
    const trainStops_r3 = ctx_r23.trainStops;
    const currentStopIdx_r4 = ctx_r23.currentStopIdx;
    const ctx_r5 = ɵngcc0.ɵɵnextContext();
    ɵngcc0.ɵɵadvance(2);
    ɵngcc0.ɵɵproperty("ngIf", trainStops_r3);
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(13, _c74, !ctx_r5.stepListShown, ctx_r5.stepListShown));
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind2(7, 10, "ui.steps.step_num_of_total", ɵngcc0.ɵɵpureFunction2(16, _c50, currentStopIdx_r4 + 1, trainStops_r3.length)), " ");
    ɵngcc0.ɵɵadvance(3);
    ɵngcc0.ɵɵstyleProp("width", (currentStopIdx_r4 + 1) / (trainStops_r3.length + 1) * 100, "%");
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵclassProp("d-none", !ctx_r5.stepListShown)("d-flex", ctx_r5.stepListShown);
    ɵngcc0.ɵɵadvance(1);
    ɵngcc0.ɵɵproperty("ngForOf", trainStops_r3);
} }
function TrainComponent_ng_template_1_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵtemplate(0, TrainComponent_ng_template_1_ng_container_0_Template, 12, 19, "ng-container", 2);
} if (rf & 2) {
    const trainStops_r3 = ctx.trainStops;
    ɵngcc0.ɵɵproperty("ngIf", trainStops_r3);
} }
const _c75 = function (a0, a1) { return { "trainStops": a0, "currentStopIdx": a1 }; };
class InputRangeComponent {
    constructor() {
        this.step = 1;
        this.slidechange = new EventEmitter();
    }
    ngOnChanges(changes) {
        const inputChanges = changes.field;
        if (inputChanges) {
            if (!this.form.contains(this.field.name)) {
                this.form.addControl(this.field.name, new FormControl());
            }
            const options = this.field.options;
            const elements = this.field.elements;
            if (options && Array.isArray(options)) {
                this.options = options;
                this.elements = undefined;
                this.inputField = undefined;
            }
            else if (elements && Array.isArray(elements)) {
                this.elements = elements;
                this.options = undefined;
                this.inputField = undefined;
            }
            else {
                this.inputField = this.field;
                this.options = undefined;
                this.elements = undefined;
            }
            this.setUpRange();
        }
    }
    setUpRange() {
        if (this.elements) {
            this.min = 0;
            this.max = this.elements.length - 1;
            this.value = this.setValue(this.field).toString();
            this.activeSliderWidth = this.getActiveSliderWidth(parseInt(this.value, 10), this.elements.length - 1);
            this.active = this.elements[this.value].label;
        }
        else {
            if (this.inputField) {
                this.min = (this.inputField.hasOwnProperty("min")) ? this.inputField.min : 0;
                this.max = this.inputField.max;
            }
            else {
                this.min = 0;
                this.max = this.options.length - 1;
            }
            this.updateValue();
            this.activeSliderWidth = this.getActiveSliderWidth(this.value, this.max);
            this.slidechange.emit(this.value);
        }
    }
    updateValue(ref) {
        let refVal;
        if (this.options) {
            if (this.options.length === 0) {
                return;
            }
            refVal = ref ? ref.value : this.options.findIndex((x) => x.selected);
            if (refVal === -1) {
                refVal = 0;
            }
            this.item = this.options[refVal];
            this.value = refVal;
        }
        else {
            this.value = ref ? ref.value : this.field.value;
        }
    }
    changeRange(ref) {
        if (this.inputField || this.options) {
            this.updateValue(ref);
            this.form.value[this.field.name] = this.options ? this.item.value : this.value;
            this.activeSliderWidth = this.getActiveSliderWidth(ref.value, this.max);
        }
        if (this.elements) {
            this.value = ref.value;
            this.activeSliderWidth = this.getActiveSliderWidth(parseInt(this.value, 10), this.elements.length - 1);
            this.active = this.elements[this.value].label;
            this.form.controls[this.field.name].setValue(this.elements[this.value].value);
        }
        this.slidechange.emit(this.value);
    }
    getActiveSliderWidth(value, length) {
        return value * (100 / (length));
    }
    setValue(radios) {
        let val = 0;
        const checkedRadio = radios.elements.find((field, idx) => {
            if (field.checked) {
                val = idx;
                return true;
            }
        });
        if (checkedRadio && this.form.contains(radios.name)) {
            this.form.controls[radios.name].setValue(checkedRadio.value);
        }
        return val;
    }
}
InputRangeComponent.ɵfac = function InputRangeComponent_Factory(t) { return new (t || InputRangeComponent)(); };
InputRangeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputRangeComponent, selectors: [["ui-input-range"]], contentQueries: function InputRangeComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.template = _t.first);
    } }, inputs: { step: "step", field: "field", form: "form" }, outputs: { slidechange: "slidechange" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "slider"], ["type", "range", 3, "min", "max", "value", "step", "change", "input"], ["ref", ""], [1, "form-control-label", "mb-0"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "d-none", 3, "field", "form"], ["ifPII", "", "type", "range", "min", "0", "step", "1", 3, "id", "max", "value", "input", "change"]], template: function InputRangeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, InputRangeComponent_ng_container_0_Template, 5, 3, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.field);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, InputComponent, SelectComponent, ɵngcc2.IfPersonallyIdentifiableInformationDirective]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, encapsulation: 2 });
InputRangeComponent.ctorParameters = () => [];
InputRangeComponent.propDecorators = {
    template: [{ type: ContentChild, args: [TemplateRef,] }],
    step: [{ type: Input }],
    field: [{ type: Input }],
    form: [{ type: Input }],
    slidechange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputRangeComponent, [{
        type: Component,
        args: [{
                selector: 'ui-input-range',
                template: "<ng-container *ngIf=\"field\">\n  <div class=\"slider\">\n    <ng-container *ngIf=\"field.nodeType === 'input'\">\n      <input type=\"range\" #ref (change)=\"changeRange(ref)\" (input)=\"changeRange(ref)\" [style.background-size]=\"activeSliderWidth+'% 100%'\" min=\"{{min}}\" max=\"{{max}}\" value=\"{{value}}\" step=\"{{step}}\" [attr.data-if-id]=\"field.extraAttributes?.ifId\">\n      <label class=\"form-control-label mb-0\">\n        <ng-container [ngTemplateOutlet]=\"template\" [ngTemplateOutletContext]=\"{'value': value}\"></ng-container>\n      </label>\n      <ui-input [field]=\"field\" [form]=\"form\" class=\"d-none\"></ui-input>\n    </ng-container>\n\n    <ng-container *ngIf=\"field.nodeType === 'select'\">\n        <input type=\"range\" #ref (change)=\"changeRange(ref)\" (input)=\"changeRange(ref)\" [style.background-size]=\"activeSliderWidth+'% 100%'\" min=\"{{min}}\" max=\"{{max}}\" value=\"{{value}}\" step=\"{{step}}\" [attr.data-if-id]=\"field.extraAttributes?.ifId\">\n        <label class=\"form-control-label mb-0\">\n          <ng-container [ngTemplateOutlet]=\"template\" [ngTemplateOutletContext]=\"{'item': item}\"></ng-container>\n        </label>\n        <ui-select [field]=\"field\" [form]=\"form\" class=\"d-none\"></ui-select>\n    </ng-container>\n\n    <ng-container *ngIf=\"field.nodeType === 'fieldset'\">\n        <input ifPII type=\"range\" #ref [id]=\"field.id\" (input)=\"changeRange(ref)\" (change)=\"changeRange(ref)\" [style.background-size]=\"activeSliderWidth+'% 100%'\"\n              min=\"0\" [max]=\"max\" [value]=\"value\" step=\"1\">\n        <span>{{active | translate }}</span>\n    </ng-container>\n  </div>\n</ng-container>\n"
            }]
    }], function () { return []; }, { step: [{
            type: Input
        }], slidechange: [{
            type: Output
        }], template: [{
            type: ContentChild,
            args: [TemplateRef]
        }], field: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();

/* NOTE: If this component appears unchecked and will not check, build themes before debugging */
var KeyCode$1;
(function (KeyCode) {
    KeyCode[KeyCode["SPACE"] = 13] = "SPACE";
    KeyCode[KeyCode["ENTER"] = 32] = "ENTER";
})(KeyCode$1 || (KeyCode$1 = {}));
;
class InputSwitchComponent {
    constructor(el) {
        this.el = el;
        this.switch = new EventEmitter();
    }
    ngOnInit() {
    }
    action(button) {
        this.switch.emit(button);
    }
    keyPress(event) {
        if (event.keyCode === KeyCode$1.SPACE || event.keyCode === KeyCode$1.ENTER) {
            this.el.nativeElement.querySelector('div.switch').click();
            event.preventDefault();
        }
    }
}
InputSwitchComponent.ɵfac = function InputSwitchComponent_Factory(t) { return new (t || InputSwitchComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
InputSwitchComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputSwitchComponent, selectors: [["ui-input-switch"]], inputs: { field: "field", form: "form" }, outputs: { switch: "switch" }, decls: 5, vars: 12, consts: [[1, "switch"], [1, "d-none", 3, "field", "form", "change", "click"], ["role", "checkbox", 1, "slider", "round", 3, "keypress"], ["class", "pl-md-2 pl-3", 3, "id", 4, "ngIf"], [1, "pl-md-2", "pl-3", 3, "id"]], template: function InputSwitchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "label");
        ɵngcc0.ɵɵelementStart(1, "div", 0);
        ɵngcc0.ɵɵelementStart(2, "ui-checkbox-radio", 1);
        ɵngcc0.ɵɵlistener("change", function InputSwitchComponent_Template_ui_checkbox_radio_change_2_listener() { return ctx.action(ctx.field); })("click", function InputSwitchComponent_Template_ui_checkbox_radio_click_2_listener($event) { return $event.stopPropagation(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵlistener("keypress", function InputSwitchComponent_Template_div_keypress_3_listener($event) { return ctx.keyPress($event); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, InputSwitchComponent_span_4_Template, 3, 4, "span", 3);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("disabled", ctx.field.disabled);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassProp("checked", ctx.field.checked);
        ɵngcc0.ɵɵproperty("field", ctx.field)("form", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("disabled", ctx.field.disabled);
        ɵngcc0.ɵɵattribute("aria-checked", ctx.field.checked)("aria-labelledby", ctx.field.id + "-switch")("tabindex", ctx.field.disabled ? -1 : 0);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.field.label);
    } }, directives: function () { return [CheckRadioComponent, ɵngcc1.NgIf]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, encapsulation: 2 });
InputSwitchComponent.ctorParameters = () => [
    { type: ElementRef }
];
InputSwitchComponent.propDecorators = {
    field: [{ type: Input }],
    form: [{ type: Input }],
    switch: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputSwitchComponent, [{
        type: Component,
        args: [{
                selector: 'ui-input-switch',
                template: "<label [class.disabled]=\"field.disabled\">\n  <div class=\"switch\">\n    <ui-checkbox-radio class=\"d-none\" [field]=\"field\" [form]=\"form\" (change)=\"action(field)\" (click)=\"$event.stopPropagation()\" [class.checked]=\"field.checked\"></ui-checkbox-radio>\n    <div class=\"slider round\" [class.disabled]=\"field.disabled\" (keypress)=\"keyPress($event)\" role=\"checkbox\" [attr.aria-checked]=\"field.checked\"\n      [attr.aria-labelledby]=\"field.id+'-switch'\" [attr.tabindex]=\"field.disabled ? -1 : 0\"></div>\n  </div>\n  <span class=\"pl-md-2 pl-3\" [id]=\"field.id+'-switch'\" *ngIf=\"field.label\">{{field.label | translate}}</span>\n</label>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { switch: [{
            type: Output
        }], field: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();

const UPDATE_ON_CONFIGURATION = 'formControlsUpdateOn';

class FieldComponent {
    constructor(settings) {
        this.settings = settings;
        this.defaultUpdateOnOptions = {
            updateOnType: "blur" /* Blur */,
            fieldType: "default" /* Default */
        };
    }
    set FormCtrl(value) {
        this.formCtrl = value;
    }
    get FormCtrl() {
        if (!this.formCtrl) {
            this.initFormControl();
        }
        return this.formCtrl;
    }
    onChangePreProcessor(event) {
        if (this.updateOn === "blur" /* Blur */ && this.hasError && this.formCtrl.validator) { // clear error as soon as input is valid without re-triggering errors
            const tempCtrl = new FormControl(this.field.value);
            if (!this.formCtrl.validator(tempCtrl)) {
                this.hasError = false;
                this.formCtrl.setErrors(null);
            }
        }
        FieldComponent.onChangePreProcessorSubject.next(event);
    }
    ngOnInit() {
        this.setDefaultUpdateStrategy();
        this.syncFieldToForm();
        this.checkForError();
        this.updateAriaDescribedBy();
    }
    /**
     * Sets the class property for the default update strategy if one is not set through the updateOn Input.
     * An unspecified Update strategy will default to what is set at the project level config or fallback to the component default.
     */
    setDefaultUpdateStrategy() {
        var _a;
        if (!this.updateOn) {
            const configUpdateOnSetting = ((_a = this.settings) === null || _a === void 0 ? void 0 : _a.Properties.has(UPDATE_ON_CONFIGURATION)) ? this.settings.Properties.get(UPDATE_ON_CONFIGURATION) : null;
            this.updateOn = (configUpdateOnSetting === null || configUpdateOnSetting === void 0 ? void 0 : configUpdateOnSetting[this.defaultUpdateOnOptions.fieldType]) || this.defaultUpdateOnOptions.updateOnType;
        }
    }
    ngOnChanges(changes) {
        const fieldChanges = changes['field'];
        if (fieldChanges) {
            this.updateOriginalValue();
            if (!fieldChanges.firstChange) {
                this.syncFieldToForm();
            }
        }
        this.checkForError();
        this.updateAriaDescribedBy();
    }
    updateOriginalValue() {
        this.originalValue = this.field.value;
    }
    syncFieldToForm() {
        if (this.field.value) {
            this.FormCtrl.setValue(this.field.value);
        }
        else {
            this.FormCtrl.setValue('');
        }
    }
    checkForError() {
        this.hasError =
            (this.field.hasError && this.valueNotChanged()) ||
                (this.FormCtrl &&
                    this.FormCtrl.invalid &&
                    !(this.FormCtrl.pristine && this.FormCtrl.untouched) &&
                    !this.FormCtrl.pending);
    }
    initFormControl() {
        this.setDefaultUpdateStrategy();
        if (this.field['type'] !== 'radio' && this.form.contains(this.field.name)) {
            this.form.removeControl(this.field.name);
        }
        if (!this.form.contains(this.field.name) ||
            this.field['type'] === 'radio') {
            this.formCtrl = new FormControl('', { updateOn: this.updateOn });
            this.form.addControl(this.field.name, this.formCtrl);
            let validators;
            if (this.validators) {
                if (Array.isArray(this.validators)) {
                    validators = this.validators;
                }
                else if (this.validators) {
                    validators = [this.validators];
                }
            }
            else {
                validators = [];
            }
            if (this.field.required) {
                validators.push(Validators.required);
            }
            validators.push(() => {
                if (this._hasServerError()) {
                    return {
                        customErrorMsg: this.field.error || 'This field is invalid.'
                    };
                }
                return null;
            });
            const ctrl = this.form.controls[this.field.name];
            if (validators) {
                ctrl.setValidators(validators);
            }
            if (this.asyncValidators) {
                ctrl.setAsyncValidators(this.asyncValidators);
            }
            if (this.field.disabled) {
                ctrl.disable();
            }
            else if (ctrl.disabled) {
                ctrl.enable();
            }
        }
        if (!this.originalValue) {
            this.originalValue = this.field.value;
        }
        this.FormCtrl.statusChanges.subscribe(() => {
            this.checkForError();
            this.updateAriaDescribedBy();
        });
        return this.formCtrl;
    }
    _hasServerError() {
        return this.valueNotChanged() && this.field.hasError;
    }
    valueNotChanged() {
        return (this.field && this.FormCtrl && this.FormCtrl.value === this.originalValue);
    }
    updateAriaDescribedBy() {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
        this.ariaDescribedBy = this.customAriaDescribedBy ? `${this.customAriaDescribedBy} ` : '';
        if ((_a = this.field) === null || _a === void 0 ? void 0 : _a.helperText) {
            this.ariaDescribedBy += this.field.id + '_help ';
        }
        this.ariaDescribedBy = this.ariaDescribedBy.trim();
        this.ariaErrorMessage = '';
        if (this.hasError &&
            !((_c = (_b = this.formCtrl) === null || _b === void 0 ? void 0 : _b.errors) === null || _c === void 0 ? void 0 : _c.customErrorMsg) && ((_d = this.field) === null || _d === void 0 ? void 0 : _d.required) &&
            !((_e = this.formCtrl) === null || _e === void 0 ? void 0 : _e.value)) {
            this.ariaErrorMessage += this.field.id + '_error_req ';
        }
        if (this.hasError && ((_g = (_f = this.formCtrl) === null || _f === void 0 ? void 0 : _f.errors) === null || _g === void 0 ? void 0 : _g.customErrorMsg)) {
            this.ariaErrorMessage += this.field.id + '_error_custom ';
        }
        if (this.hasError && ((_j = (_h = this.formCtrl) === null || _h === void 0 ? void 0 : _h.errors) === null || _j === void 0 ? void 0 : _j.minlength)) {
            this.ariaErrorMessage += this.field.id + '_error_minlength ';
        }
        if (this.hasError && ((_l = (_k = this.formCtrl) === null || _k === void 0 ? void 0 : _k.errors) === null || _l === void 0 ? void 0 : _l.email)) {
            this.ariaErrorMessage += this.field.id + '_error_email ';
        }
        this.ariaErrorMessage = this.ariaErrorMessage.trim();
    }
}
FieldComponent.ɵfac = function FieldComponent_Factory(t) { return new (t || FieldComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.SettingsService)); };
FieldComponent.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: FieldComponent, inputs: { updateOn: "updateOn", form: "form", validators: "validators", asyncValidators: "asyncValidators", customAriaDescribedBy: "customAriaDescribedBy" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
FieldComponent.onChangePreProcessorSubject = new Subject();
FieldComponent.onChangePreProcessorObservable = FieldComponent.onChangePreProcessorSubject.asObservable();
FieldComponent.ctorParameters = () => [
    { type: SettingsService }
];
FieldComponent.propDecorators = {
    form: [{ type: Input }],
    validators: [{ type: Input }],
    asyncValidators: [{ type: Input }],
    updateOn: [{ type: Input }],
    customAriaDescribedBy: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FieldComponent, [{
        type: Directive
    }], function () { return [{ type: ɵngcc2.SettingsService }]; }, { updateOn: [{
            type: Input
        }], form: [{
            type: Input
        }], validators: [{
            type: Input
        }], asyncValidators: [{
            type: Input
        }], customAriaDescribedBy: [{
            type: Input
        }] }); })();

class InputComponent extends FieldComponent {
    constructor() {
        super(...arguments);
        this.change = new EventEmitter();
        this.blur = new EventEmitter();
    }
    ngOnDestroy() {
        this.change.complete();
        this.blur.complete();
    }
    changeOccurred($event, field) {
        $event.preventDefault();
        $event.stopPropagation();
        field.value = $event.currentTarget.value;
        this.form.value[field.name] = field.value;
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(field);
    }
    handleBlur(field) {
        this.blur.emit(field);
    }
}
InputComponent.ɵfac = /*@__PURE__*/ function () { let ɵInputComponent_BaseFactory; return function InputComponent_Factory(t) { return (ɵInputComponent_BaseFactory || (ɵInputComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(InputComponent)))(t || InputComponent); }; }();
InputComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputComponent, selectors: [["ui-input"]], inputs: { field: "field" }, outputs: { change: "change", blur: "blur" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "field", "formGroup", "form", "formCtrl", "hasError", "has-value", "updateOn", 4, "ngIf"], [3, "field", "formGroup", "form", "formCtrl", "hasError", "updateOn"], ["template", ""], ["ifPII", "", "base-input", "", 1, "form-control", 3, "formControlName", "field", "ngClass", "readonly", "input", "blur"]], template: function InputComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, InputComponent_ui_form_field_0_Template, 3, 8, "ui-form-field", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.field);
    } }, directives: function () { return [ɵngcc1.NgIf, FormFieldComponent, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.DefaultValueAccessor, ɵngcc2.IfPersonallyIdentifiableInformationDirective, InputDirective, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, ɵngcc1.NgClass]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, encapsulation: 2 });
InputComponent.propDecorators = {
    field: [{ type: Input }],
    change: [{ type: Output }],
    blur: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputComponent, [{
        type: Component,
        args: [{
                selector: 'ui-input',
                template: "<ui-form-field *ngIf=\"field\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\"\n    [hasError]=\"hasError\" [class.has-value]=\"!!FormCtrl?.value\" [updateOn]=\"updateOn\">\n  <ng-template #template let-field=\"field\">\n    <input ifPII base-input class=\"form-control\" [formControlName]=\"field.name\" (input)=\"changeOccurred($event, field)\"\n      [field]=\"field\" (blur)=\"handleBlur(field)\" [attr.data-if-id]=\"field.extraAttributes?.ifId\" [attr.placeholder]=\"field.placeholder | translate\"\n      [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\" [attr.aria-invalid]=\"hasError\" [attr.aria-describedby]=\"ariaDescribedBy\" [attr.aria-errormessage]=\"ariaErrorMessage\" [readonly]=\"field.readonly\"/>\n  </ng-template>\n</ui-form-field>\n"
            }]
    }], null, { change: [{
            type: Output
        }], blur: [{
            type: Output
        }], field: [{
            type: Input
        }] }); })();

class InputFileComponent extends InputComponent {
    constructor(changesRef, settings) {
        super(settings);
        this.changesRef = changesRef;
        this.fileChange = new EventEmitter();
        this.uploadText = 'ui.controls.input-file.file_upload';
    }
    fileChangeOccurred($event, field) {
        const file = this.getFile($event);
        if (file) {
            this.fileName = file.name;
        }
        super.changeOccurred($event, field);
        this.fileChange.emit(file);
    }
    removeFile() {
        this.fileName = undefined;
        this.field.value = '';
        this.form.controls[this.field.name].setValue('');
        this.changesRef.detectChanges();
        this.fileChange.emit(undefined);
    }
    syncFieldToForm() {
        return;
    }
    ngOnDestroy() {
        super.ngOnDestroy();
        this.fileChange.complete();
    }
    getFile($event) {
        const eventObj = $event;
        const target = eventObj.target;
        if (target.files && target.files.length > 0) {
            return target.files[0];
        }
        return undefined;
    }
}
InputFileComponent.ɵfac = function InputFileComponent_Factory(t) { return new (t || InputFileComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.SettingsService)); };
InputFileComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputFileComponent, selectors: [["ui-input-file"]], inputs: { uploadText: "uploadText" }, outputs: { fileChange: "fileChange" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "field", "form", "formCtrl", "hasError", "updateOn", 4, "ngIf"], [3, "field", "form", "formCtrl", "hasError", "updateOn"], ["template", ""], ["class", "input-group", "style", "overflow: hidden", 3, "formGroup", 4, "ngIf"], [4, "ngIf"], [1, "input-group", 2, "overflow", "hidden", 3, "formGroup"], ["ifPII", "", "base-input", "", 1, "form-control", 2, "position", "absolute", "opacity", "0", "width", "100%", "height", "100%", 3, "formControlName", "field", "ngClass", "input"], ["tabindex", "-1", "type", "button", 1, "btn", "btn-primary"], [1, "ifc-icon", "ifc-upload", "pr-2"], [1, "card", "d-flex", "flex-row", "mb-2"], [1, "card-header", "p-3", "d-none", "d-md-block"], [1, "ifc-icon", "ifc-single-paragraph"], [1, "flex-column", "w-100", "mw-0", 2, "min-width", "0px"], [1, "d-flex", "flex-row"], [1, "flex-column", "p-3", 2, "min-width", "0px"], ["ifPII", "", 1, "h5", "my-1", "font-weight-bold", "text-truncate"], [1, "flex-column", "p-3", "ml-auto"], [1, "btn", "btn-outline-danger", "btn-sm", 3, "click"]], template: function InputFileComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, InputFileComponent_ui_form_field_0_Template, 3, 5, "ui-form-field", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.field);
    } }, directives: function () { return [ɵngcc1.NgIf, FormFieldComponent, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.DefaultValueAccessor, ɵngcc2.IfPersonallyIdentifiableInformationDirective, InputDirective, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, ɵngcc1.NgClass]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, encapsulation: 2 });
InputFileComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: SettingsService }
];
InputFileComponent.propDecorators = {
    fileChange: [{ type: Output }],
    uploadText: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputFileComponent, [{
        type: Component,
        args: [{
                selector: 'ui-input-file',
                template: "<ui-form-field *ngIf=\"field\" [field]=\"field\" [form]=\"form\" [formCtrl]=\"FormCtrl\" [hasError]=\"hasError\" [updateOn]=\"updateOn\">\n  <ng-template #template let-field=\"field\">\n\n    <div *ngIf=\"!fileName\" class=\"input-group\" style=\"overflow: hidden\" [formGroup]=\"form\">\n      <input ifPII base-input class=\"form-control\" [formControlName]=\"field.name\" (input)=\"fileChangeOccurred($event, field)\" [field]=\"field\"\n        [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\" style=\"position: absolute; opacity: 0; width: 100%; height: 100%\"\n        [attr.data-if-id]=\"field.extraAttributes?.ifId\"\n      />\n\n      <button tabindex=\"-1\" class=\"btn btn-primary\" type=\"button\">\n        <i class=\"ifc-icon ifc-upload pr-2\"></i>{{ uploadText | translate }}\n      </button>\n    </div>\n\n    <div *ngIf=\"fileName\">\n      <div class=\"card d-flex flex-row mb-2\">\n        <div class=\"card-header p-3 d-none d-md-block\">\n          <i class=\"ifc-icon ifc-single-paragraph\"></i>\n        </div>\n        <div class=\"flex-column w-100 mw-0\" style=\"min-width: 0px;\">\n          <div class=\"d-flex flex-row\">\n            <div class=\"flex-column p-3\" style=\"min-width: 0px;\">\n              <div class=\"h5 my-1 font-weight-bold text-truncate\" ifPII>{{fileName}}</div>\n            </div>\n            <div class=\"flex-column p-3 ml-auto\">\n              <button class=\"btn btn-outline-danger btn-sm\" (click)=\"removeFile();\">{{'ui.controls.input-file.delete' | translate}}</button>\n            </div>\n          </div>\n\n        </div>\n      </div>\n\n    </div>\n\n  </ng-template>\n</ui-form-field>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc2.SettingsService }]; }, { fileChange: [{
            type: Output
        }], uploadText: [{
            type: Input
        }] }); })();

class InlineDatepickerComponent {
    constructor(elRef, zone) {
        this.elRef = elRef;
        this.zone = zone;
        this.change = new EventEmitter();
        this.dateFormat = 'yyyy-MM-dd';
        this.oldvalue = '';
        this.defaultMaxView = 3;
        this.minDate = new Date(1950, 0, 1);
        this.maxDate = addYears((new Date()).setHours(23, 59, 59), 10);
    }
    ngOnDestroy() {
        this.change.complete();
        const node = this.getDatePickerElement();
        if (node) {
            $(node).datepicker('destroy');
        }
    }
    ngOnInit() {
        if (this.config) {
            this.setDateFormat(this.config.dateFormat.replace('YYYY', 'yyyy').replace('DD', 'dd').replace('D', 'd').replace('YY', 'yy'));
            this.setMinMaxDate(this.config);
        }
    }
    ngAfterViewInit() {
        const node = this.getDatePickerElement();
        if (node) {
            this.zone.runOutsideAngular(() => {
                const datepickerSettings = {
                    autoclose: false,
                    endDate: format(this.maxDate, this.dateFormat),
                    format: this.dateFormat.toLowerCase(),
                    maxViewMode: this.config.maxView ? this.config.maxView : this.defaultMaxView,
                    minViewMode: this.config.minView,
                    startView: this.config.startView,
                    startDate: format(this.minDate, this.dateFormat),
                    showOnFocus: false,
                    keyboardNavigation: false
                };
                $(node)
                    .datepicker(datepickerSettings)
                    .on('show', () => {
                    this.timeSinceClose = null;
                    this.datepickerShowing = true;
                })
                    .on('hide', (evt) => {
                    this.datepickerShowing = false;
                    this.timeSinceClose = Date.now();
                })
                    .on('changeDate', () => {
                    this.dateChanged();
                    if (this.datepickerShowing) {
                        this.toggle();
                    }
                });
            });
        }
    }
    toggle() {
        if (this.timeSinceClose && Date.now() - this.timeSinceClose < 250) {
            return;
        }
        const node = this.getDatePickerElement();
        if (node) {
            if (this.datepickerShowing) {
                $(node).datepicker('hide');
            }
            else {
                $(node).datepicker('show')
                    .focus();
            }
            this.timeSinceClose = null;
        }
    }
    dateChanged() {
        const dp = this.getDatePickerElement();
        const value = $(dp).datepicker('getFormattedDate');
        if (dp && value !== this.oldvalue) {
            this.oldvalue = value;
            this.change.emit(value);
        }
    }
    getDatePickerElement() {
        if (this.datepickerChild) {
            return this.datepickerChild.nativeElement;
        }
    }
    setMinMaxDate(config) {
        if (config.minDate) {
            if (config.minDate === 'today') {
                const now = new Date();
                this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
            }
            else {
                this.minDate = parse(config.minDate, this.dateFormat, new Date());
            }
        }
        if (config.maxDate) {
            if (config.maxDate === 'today') {
                const now = new Date();
                this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
            }
            else {
                this.maxDate = parse(config.maxDate, this.dateFormat, new Date());
            }
        }
    }
    setDateFormat(dateFormat) {
        if (!dateFormat) {
            this.dateFormat = `MM/dd/yyyy`;
            return;
        }
        const isPSDate = /^[YMD]{3}.$/;
        if (dateFormat !== 'yyyy' && dateFormat.length === 4 && dateFormat.match(isPSDate)) {
            const formatString = dateFormat.substring(0, 3); // date formats are expected to be 4 characters
            let separator = dateFormat.substring(3, 4); // first 3 are the format, last 1 is the separator
            if (!separator) {
                separator = '/';
            }
            if (formatString === 'MDY') {
                this.dateFormat = `MM${separator}dd${separator}yyyy`;
            }
            else if (formatString === 'DMY') {
                this.dateFormat = `dd${separator}MM${separator}yyyy`;
            }
            else if (formatString === 'YMD') {
                this.dateFormat === `yyyy${separator}MM${separator}dd`;
            }
            else {
                this.dateFormat = `MM${separator}dd${separator}yyyy`;
            }
        }
        else {
            this.dateFormat = dateFormat;
        }
    }
}
InlineDatepickerComponent.ɵfac = function InlineDatepickerComponent_Factory(t) { return new (t || InlineDatepickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone)); };
InlineDatepickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InlineDatepickerComponent, selectors: [["ui-inline-datepicker"]], viewQuery: function InlineDatepickerComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 7);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datepickerChild = _t.first);
    } }, inputs: { config: "config" }, outputs: { change: "change" }, decls: 2, vars: 0, consts: [["id", "datepicker"], ["datepicker", ""]], template: function InlineDatepickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0, 1);
    } }, encapsulation: 2 });
InlineDatepickerComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone }
];
InlineDatepickerComponent.propDecorators = {
    datepickerChild: [{ type: ViewChild, args: ['datepicker', { static: true },] }],
    config: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InlineDatepickerComponent, [{
        type: Component,
        args: [{
                selector: 'ui-inline-datepicker',
                template: `<div id="datepicker" #datepicker></div>`
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }]; }, { change: [{
            type: Output
        }], datepickerChild: [{
            type: ViewChild,
            args: ['datepicker', { static: true }]
        }], config: [{
            type: Input
        }] }); })();

class ButtonGroupComponent {
    constructor() {
        this.click = new EventEmitter();
        this.primaryClick = new EventEmitter();
        this.secondaryClick = new EventEmitter();
        this.tertiaryClick = new EventEmitter();
    }
    ngOnDestroy() {
        this.click.complete();
    }
    handleClick(event, field, output) {
        output.emit(field);
        this.click.emit(field);
        event.stopPropagation();
    }
}
ButtonGroupComponent.ɵfac = function ButtonGroupComponent_Factory(t) { return new (t || ButtonGroupComponent)(); };
ButtonGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ButtonGroupComponent, selectors: [["ui-button-group"]], inputs: { primaryAction: "primaryAction", secondaryAction: "secondaryAction", tertiaryAction: "tertiaryAction" }, outputs: { click: "click", primaryClick: "primaryClick", secondaryClick: "secondaryClick", tertiaryClick: "tertiaryClick" }, decls: 6, vars: 7, consts: [[1, "row", 3, "click"], [1, "col-12", "col-lg-auto", "order-lg-2"], [1, "row"], ["class", "col-12 order-lg-2 col-lg-auto pl-lg-1 mb-2 mb-lg-0", 4, "ngIf"], ["class", "col-12 order-lg-1 col-lg-auto px-lg-1 mb-2 mb-lg-0", 4, "ngIf"], ["class", "col-12 col-lg-auto order-lg-1", 4, "ngIf"], [1, "col-12", "order-lg-2", "col-lg-auto", "pl-lg-1", "mb-2", "mb-lg-0"], ["base-button", "", 1, "btn", "btn-primary", "btn-block", 3, "field", "click"], [1, "col-12", "order-lg-1", "col-lg-auto", "px-lg-1", "mb-2", "mb-lg-0"], ["base-button", "", 1, "btn", "btn-default", "btn-block", 3, "field", "click"], [1, "col-12", "col-lg-auto", "order-lg-1"]], template: function ButtonGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("click", function ButtonGroupComponent_Template_div_click_0_listener($event) { return $event.stopPropagation(); });
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, ButtonGroupComponent_div_3_Template, 4, 5, "div", 3);
        ɵngcc0.ɵɵtemplate(4, ButtonGroupComponent_div_4_Template, 4, 5, "div", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, ButtonGroupComponent_div_5_Template, 4, 5, "div", 5);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("justify-content-end", !ctx.tertiaryAction)("justify-content-between", ctx.tertiaryAction);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.primaryAction);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.secondaryAction);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.tertiaryAction);
    } }, directives: function () { return [ɵngcc1.NgIf, ButtonDirective]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, encapsulation: 2 });
ButtonGroupComponent.propDecorators = {
    primaryAction: [{ type: Input }],
    secondaryAction: [{ type: Input }],
    tertiaryAction: [{ type: Input }],
    click: [{ type: Output }],
    primaryClick: [{ type: Output }],
    secondaryClick: [{ type: Output }],
    tertiaryClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonGroupComponent, [{
        type: Component,
        args: [{
                selector: 'ui-button-group',
                template: "<div class=\"row\" [class.justify-content-end]=\"!tertiaryAction\" [class.justify-content-between]=\"tertiaryAction\"\n  (click)=\"$event.stopPropagation()\">\n  <div class=\"col-12 col-lg-auto order-lg-2\">\n    <div class=\"row\">\n      <div class=\"col-12 order-lg-2 col-lg-auto pl-lg-1 mb-2 mb-lg-0\" *ngIf=\"primaryAction\">\n        <button\n          base-button\n          class=\"btn btn-primary btn-block\"\n          [field]=\"primaryAction\" (click)=\"handleClick($event, primaryAction, primaryClick)\"\n          [attr.data-if-id]=\"primaryAction.extraAttributes?.ifId? primaryAction.extraAttributes.ifId + 'primary' : 'primary'\">\n          {{primaryAction.text | translate}}\n        </button>\n      </div>\n      <div class=\"col-12 order-lg-1 col-lg-auto px-lg-1 mb-2 mb-lg-0\" *ngIf=\"secondaryAction\">\n        <button\n          base-button class=\"btn btn-default btn-block\"\n          [field]=\"secondaryAction\"\n          (click)=\"handleClick($event, secondaryAction, secondaryClick)\"\n          [attr.data-if-id]=\"secondaryAction.extraAttributes?.ifId? secondaryAction.extraAttributes.ifId + '-secondary' : 'secondary'\">\n          {{secondaryAction.text | translate}}\n        </button>\n      </div>\n    </div>\n  </div>\n  <div class=\"col-12 col-lg-auto order-lg-1\" *ngIf=\"tertiaryAction\">\n    <button\n      base-button\n      class=\"btn btn-default btn-block\"\n      [field]=\"tertiaryAction\"\n      (click)=\"handleClick($event, tertiaryAction, tertiaryClick)\"\n      [attr.data-if-id]=\"tertiaryAction.extraAttributes?.ifId? tertiaryAction.extraAttributes.ifId + '-tertiary': 'tertiary'\">\n      {{tertiaryAction.text | translate}}\n    </button>\n  </div>\n</div>\n"
            }]
    }], function () { return []; }, { click: [{
            type: Output
        }], primaryClick: [{
            type: Output
        }], secondaryClick: [{
            type: Output
        }], tertiaryClick: [{
            type: Output
        }], primaryAction: [{
            type: Input
        }], secondaryAction: [{
            type: Input
        }], tertiaryAction: [{
            type: Input
        }] }); })();

class ListViewComponent {
    constructor() {
        this.actionTriggered = new EventEmitter();
    }
    action(item, event) {
        if (event) {
            if (event.key === 'Enter' || item.isButton) {
                event.preventDefault();
                this.actionTriggered.emit([item.action]);
            }
        }
        else {
            this.actionTriggered.emit([item.action]);
        }
    }
}
ListViewComponent.ɵfac = function ListViewComponent_Factory(t) { return new (t || ListViewComponent)(); };
ListViewComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ListViewComponent, selectors: [["ui-list-view"]], contentQueries: function ListViewComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.listItemTemplate = _t.first);
    } }, inputs: { list: "list" }, outputs: { actionTriggered: "actionTriggered" }, decls: 2, vars: 1, consts: [[1, "row", "cards", "p-0"], ["class", "list-unstyled col-lg-6 mb-lg-3", 4, "ngFor", "ngForOf"], [1, "list-unstyled", "col-lg-6", "mb-lg-3"], ["href", "javascript:void(0)", "tabindex", "0", 3, "click", "keydown.enter", "keydown.Space", 4, "ngIf", "ngIfElse"], ["notAction", ""], ["href", "javascript:void(0)", "tabindex", "0", 3, "click", "keydown.enter", "keydown.Space"], [1, "card", "h-100", "d-flex", "flex-row"], [1, "card-body", "pl-3", 3, "keydown.enter", "keydown.Space"], ["class", "card-title h4 mb-1", 3, "innerHTML", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "card-title", "h4", "mb-1", 3, "innerHTML"], [1, "card-body", "pl-3"]], template: function ListViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, ListViewComponent_li_1_Template, 4, 2, "li", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.list);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], encapsulation: 2 });
ListViewComponent.ctorParameters = () => [];
ListViewComponent.propDecorators = {
    listItemTemplate: [{ type: ContentChild, args: [TemplateRef,] }],
    list: [{ type: Input }],
    actionTriggered: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ListViewComponent, [{
        type: Component,
        args: [{
                selector: 'ui-list-view',
                template: "<ul class=\"row cards p-0\">\n  <li class=\"list-unstyled col-lg-6 mb-lg-3\" *ngFor=\"let item of list; let i = index\">\n    <a href=\"javascript:void(0)\" *ngIf=\"item.action; else notAction\" (click)=\"action(item)\"\n      [attr.role]=\"item.isButton ? 'button' : 'link'\" tabindex=\"0\"\n      (keydown.enter)=\"action(item, $event)\" (keydown.Space)=\"action(item, $event)\">\n      <div class=\"card h-100 d-flex flex-row\">\n        <i class=\"ifc-icon ifc-icon-2 p-4 text-center {{item.icon}}\"></i>\n        <div class=\"card-body pl-3\" (keydown.enter)=\"$event.stopPropagation()\" (keydown.Space)=\"$event.stopPropagation()\" >\n          <div *ngIf=\"item.header\" class=\"card-title h4 mb-1\" [innerHTML]=\"item.header\">\n          </div>\n          <ng-container [ngTemplateOutlet]=\"listItemTemplate\" [ngTemplateOutletContext]=\"{'item': item, 'idx' : i}\"></ng-container>\n        </div>\n      </div>\n    </a>\n    <ng-template #notAction>\n      <div class=\"card h-100 d-flex flex-row\">\n        <i class=\"ifc-icon ifc-icon-2 p-4 text-center {{item.icon}}\"></i>\n        <div class=\"card-body pl-3\">\n          <div *ngIf=\"item.header\" class=\"card-title h4 mb-1\" [innerHTML]=\"item.header\">\n          </div>\n          <ng-container [ngTemplateOutlet]=\"listItemTemplate\" [ngTemplateOutletContext]=\"{'item': item, 'idx' : i}\"></ng-container>\n        </div>\n      </div>\n    </ng-template>\n  </li>\n</ul>\n"
            }]
    }], function () { return []; }, { actionTriggered: [{
            type: Output
        }], listItemTemplate: [{
            type: ContentChild,
            args: [TemplateRef]
        }], list: [{
            type: Input
        }] }); })();

class TileViewComponent {
    constructor() {
        this.actionTriggered = new EventEmitter();
    }
    action(action) {
        this.actionTriggered.emit([action]);
    }
}
TileViewComponent.ɵfac = function TileViewComponent_Factory(t) { return new (t || TileViewComponent)(); };
TileViewComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TileViewComponent, selectors: [["ui-tile-view"]], contentQueries: function TileViewComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tileTemplate = _t.first);
    } }, inputs: { list: "list" }, outputs: { actionTriggered: "actionTriggered" }, decls: 2, vars: 1, consts: [[1, "row", "cards", "p-0"], ["class", "list-unstyled col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 mb-4", 4, "ngFor", "ngForOf"], [1, "list-unstyled", "col-xs-12", "col-sm-6", "col-md-6", "col-lg-6", "col-xl-4", "mb-4"], ["class", "card h-100", "href", "javascript:void(0);", 3, "click", 4, "ngIf", "ngIfElse"], ["notAction", ""], ["href", "javascript:void(0);", 1, "card", "h-100", 3, "click"], [1, "card-body", "d-flex", "flex-column", "justify-content-center", "text-center"], [3, "class", 4, "ngIf"], ["class", "tile-header mb-1 h1 text-primary", 3, "innerHTML", 4, "ngIf"], ["class", "tile-subtext text-muted m-0", 3, "innerHTML", 4, "ngIf"], ["class", "card-footer border-0 small text-muted", 4, "ngIf"], [1, "tile-header", "mb-1", "h1", "text-primary", 3, "innerHTML"], [1, "tile-subtext", "text-muted", "m-0", 3, "innerHTML"], [1, "card-footer", "border-0", "small", "text-muted"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "card", "h-100"], ["class", "tile-header mb-1 h1", 3, "innerHTML", 4, "ngIf"], [1, "tile-header", "mb-1", "h1", 3, "innerHTML"]], template: function TileViewComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ul", 0);
        ɵngcc0.ɵɵtemplate(1, TileViewComponent_li_1_Template, 4, 2, "li", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.list);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], encapsulation: 2 });
TileViewComponent.ctorParameters = () => [];
TileViewComponent.propDecorators = {
    tileTemplate: [{ type: ContentChild, args: [TemplateRef,] }],
    list: [{ type: Input }],
    actionTriggered: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TileViewComponent, [{
        type: Component,
        args: [{
                selector: 'ui-tile-view',
                template: "<ul class=\"row cards p-0\">\n  <li class=\"list-unstyled col-xs-12 col-sm-6 col-md-6 col-lg-6 col-xl-4 mb-4\" *ngFor=\"let item of list; let i = index\">\n    <a *ngIf=\"item.action; else notAction\" class=\"card h-100\" href=\"javascript:void(0);\" (click)=\"action(item.action)\" [attr.role]=\"item.isButton ? 'button' : null\">\n      <div class=\"card-body d-flex flex-column justify-content-center text-center\">\n        <i *ngIf=\"item.icon\" class=\"ifc-icon ifc-icon-2 p-4 {{item.icon}}\"></i>\n        <div *ngIf=\"item.header\" class=\"tile-header mb-1 h1 text-primary\" [innerHTML]=\"item.header\">\n        </div>\n        <div class=\"tile-subtext text-muted m-0\" *ngIf=\"item.subtext\" [innerHTML]=\"item.subtext\"></div>\n      </div>\n      <div class=\"card-footer border-0 small text-muted\" *ngIf=\"tileTemplate\">\n        <ng-container [ngTemplateOutlet]=\"tileTemplate\" [ngTemplateOutletContext]=\"{'item': item}\"></ng-container>\n      </div>\n    </a>\n    <ng-template #notAction>\n      <div class=\"card h-100\">\n        <div class=\"card-body d-flex flex-column justify-content-center text-center\">\n          <i *ngIf=\"item.icon\" class=\"ifc-icon ifc-icon-2 p-4 {{item.icon}}\"></i>\n          <div *ngIf=\"item.header\" class=\"tile-header mb-1 h1\" [innerHTML]=\"item.header\">\n          </div>\n          <div class=\"tile-subtext text-muted m-0\" *ngIf=\"item.subtext\" [innerHTML]=\"item.subtext\"></div>\n        </div>\n        <div class=\"card-footer border-0 small text-muted\" *ngIf=\"tileTemplate\">\n          <ng-container [ngTemplateOutlet]=\"tileTemplate\" [ngTemplateOutletContext]=\"{'item': item}\"></ng-container>\n        </div>\n      </div>\n    </ng-template>\n  </li>\n</ul>\n"
            }]
    }], function () { return []; }, { actionTriggered: [{
            type: Output
        }], tileTemplate: [{
            type: ContentChild,
            args: [TemplateRef]
        }], list: [{
            type: Input
        }] }); })();

class GenericEditComponent {
    constructor(eleRef) {
        this.showInline = false;
        this.invalidFieldSelector = 'ui-generic-edit .form-control.ng-invalid';
        this.saveClicked = new EventEmitter();
        this.deleteClicked = new EventEmitter();
        this.cancelClicked = new EventEmitter();
        this.genericAction = new EventEmitter();
        this.eleRef = eleRef;
    }
    save() {
        this.saveClicked.emit(this.edit.page.actions.save);
    }
    delete() {
        this.deleteClicked.emit(this.edit.page.actions.delete);
    }
    cancel() {
        this.cancelClicked.emit(this.edit.page.actions.cancel);
    }
    action(action) {
        this.genericAction.emit(action);
    }
    ngAfterViewInit() {
        let header = this.eleRef.nativeElement.querySelector('header>h1');
        if (header) {
            header.focus();
        }
    }
}
GenericEditComponent.ɵfac = function GenericEditComponent_Factory(t) { return new (t || GenericEditComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
GenericEditComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: GenericEditComponent, selectors: [["ui-generic-edit"]], inputs: { showInline: "showInline", invalidFieldSelector: "invalidFieldSelector", edit: "edit", form: "form" }, outputs: { saveClicked: "saveClicked", deleteClicked: "deleteClicked", cancelClicked: "cancelClicked", genericAction: "genericAction" }, decls: 8, vars: 11, consts: [[1, "w-100"], [3, "ngClass"], [1, "d-flex", "flex-row", "align-items-start"], ["tabindex", "-1", 3, "headingLevel"], [4, "ngIf"], ["class", "mt-5", 4, "ngIf"], [3, "fields", "form"], [3, "error", "invalidFieldSelector"], [4, "ngFor", "ngForOf"], [3, "field", "form", 4, "ngIf"], [1, "row"], [1, "col-12", "py-2"], ["class", "h4", 4, "ngIf"], [3, "field", "form", "change", 4, "ngIf"], [3, "field", "form"], [1, "h4"], [3, "field", "form", "change"], [1, "mt-5"], [3, "primaryAction", "secondaryAction", "tertiaryAction", "primaryClick", "secondaryClick", "tertiaryClick"]], template: function GenericEditComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "article", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "header", 2);
        ɵngcc0.ɵɵelementStart(3, "ui-dynamic-heading", 3);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(5, GenericEditComponent_div_5_Template, 3, 3, "div", 4);
        ɵngcc0.ɵɵtemplate(6, GenericEditComponent_div_6_Template, 2, 3, "div", 5);
        ɵngcc0.ɵɵelement(7, "ui-hiddens", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(9, _c5, !ctx.showInline));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("d-none", ctx.showInline);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("headingLevel", 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.edit.header);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.edit);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.edit.page.actions);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("fields", ctx.edit.hiddens)("form", ctx.form);
    } }, directives: function () { return [ɵngcc1.NgClass, DynamicHeadingComponent, ɵngcc1.NgIf, HiddensComponent, ErrorBoxComponent, ɵngcc1.NgForOf, SelectComponent, InputComponent, InputDateComponent, CheckRadioComponent, ButtonGroupComponent]; }, encapsulation: 2 });
GenericEditComponent.ctorParameters = () => [
    { type: ElementRef }
];
GenericEditComponent.propDecorators = {
    edit: [{ type: Input }],
    form: [{ type: Input }],
    showInline: [{ type: Input }],
    invalidFieldSelector: [{ type: Input }],
    saveClicked: [{ type: Output }],
    deleteClicked: [{ type: Output }],
    cancelClicked: [{ type: Output }],
    genericAction: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GenericEditComponent, [{
        type: Component,
        args: [{
                selector: 'ui-generic-edit',
                template: "<article class=\"w-100\">\n  <div [ngClass]=\"{'card p-4': !showInline}\">\n    <header class=\"d-flex flex-row align-items-start\" [class.d-none]=\"showInline\">\n      <ui-dynamic-heading [headingLevel]=\"1\" tabindex=\"-1\">{{edit.header}}</ui-dynamic-heading>\n    </header>\n    <div *ngIf=\"edit\">\n      <ui-error-box [error]=\"edit.errors\" [invalidFieldSelector]=\"invalidFieldSelector\"></ui-error-box>\n      <ng-container *ngFor=\"let field of edit.page.content\">\n        <ui-select *ngIf=\"field.nodeType === 'select'\" [field]=\"field\" [form]=\"form\"></ui-select>\n        <div class=\"row\">\n          <div class=\"col-12 py-2\">\n            <div class=\"h4\" *ngIf=\"field.nodeType === 'span'\">{{field.text}}</div>\n            <ui-input *ngIf=\"field.nodeType === 'input' && field.type === 'text'\" [field]=\"field\" [form]=\"form\">\n            </ui-input>\n            <ui-input-date *ngIf=\"field.nodeType === 'input' && field.type === 'date'\" [field]=\"field\" [form]=\"form\">\n            </ui-input-date>\n            <ui-checkbox-radio\n              *ngIf=\"field.nodeType === 'input' && (field.type === 'checkbox' || field.type === 'radio')\"\n              [field]=\"field\" [form]=\"form\" (change)=\"action(field)\"></ui-checkbox-radio>\n          </div>\n        </div>\n      </ng-container>\n    </div>\n    <div class=\"mt-5\" *ngIf=\"edit.page.actions; let actions\">\n      <ui-button-group [primaryAction]=\"actions.save\" [secondaryAction]=\"actions.cancel\"\n        [tertiaryAction]=\"actions.delete\" (primaryClick)=\"save()\" (secondaryClick)=\"cancel()\"\n        (tertiaryClick)=\"delete()\"></ui-button-group>\n    </div>\n    <ui-hiddens [fields]=\"edit.hiddens\" [form]=\"form\"></ui-hiddens>\n  </div>\n</article>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { showInline: [{
            type: Input
        }], invalidFieldSelector: [{
            type: Input
        }], saveClicked: [{
            type: Output
        }], deleteClicked: [{
            type: Output
        }], cancelClicked: [{
            type: Output
        }], genericAction: [{
            type: Output
        }], edit: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();

class LoadingService {
    constructor(router, translate) {
        this.router = router;
        this.translate = translate;
        this.loadingSpinnerCompleteId = "LoadingSpinnerComplete";
        this.subject = new BehaviorSubject(false);
        this.observable = this.subject.asObservable();
    }
    setStatus(status) {
        this.subject.next(status);
    }
    get status() {
        return this.observable;
    }
    ngOnDestroy() {
        this.subject.complete();
    }
}
LoadingService.ɵfac = function LoadingService_Factory(t) { return new (t || LoadingService)(ɵngcc0.ɵɵinject(ɵngcc5.Router), ɵngcc0.ɵɵinject(ɵngcc3.TranslateService)); };
LoadingService.ɵprov = i0.ɵɵdefineInjectable({ factory: function LoadingService_Factory() { return new LoadingService(i0.ɵɵinject(i1.Router), i0.ɵɵinject(i2.TranslateService)); }, token: LoadingService, providedIn: "root" });
LoadingService.ctorParameters = () => [
    { type: Router },
    { type: TranslateService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoadingService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc5.Router }, { type: ɵngcc3.TranslateService }]; }, null); })();

class LoadingSpinnerComponent {
    constructor() {
        this.notificationToggle = true;
    }
}
LoadingSpinnerComponent.ɵfac = function LoadingSpinnerComponent_Factory(t) { return new (t || LoadingSpinnerComponent)(); };
LoadingSpinnerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LoadingSpinnerComponent, selectors: [["ui-loading-spinner"]], inputs: { notificationToggle: "notificationToggle" }, decls: 8, vars: 0, consts: [["version", "1.1", "xmlns", "http://www.w3.org/2000/svg", 0, "xmlns", "xlink", "http://www.w3.org/1999/xlink", "x", "0px", "y", "0px", "viewBox", "0 0 64 64", 0, "xml", "space", "preserve", "width", "64", "height", "64"], ["fill", "#444444", 1, "nc-icon-wrapper"], [1, "nc-loop_dots-07-64"], ["data-color", "color-2", "fill", "none", "stroke", "#444444", "stroke-width", "2", "stroke-linecap", "square", "stroke-miterlimit", "10", "cx", "32", "cy", "32", "r", "6", "transform", "translate(9.071078400034459 9.071078400034459) scale(0.7165287999989232)", "stroke-linejoin", "miter", 2, "opacity", "0.7165287999989232"], ["fill", "none", "stroke", "#444444", "stroke-width", "2", "stroke-linecap", "square", "stroke-miterlimit", "10", "cx", "8", "cy", "32", "r", "6", "stroke-linejoin", "miter", "transform", "translate(2.532230399991386 10.128921599965544) scale(0.6834712000010768)", 2, "opacity", "0.6834712000010768"], ["fill", "none", "stroke", "#444444", "stroke-width", "2", "stroke-linecap", "square", "stroke-miterlimit", "10", "cx", "56", "cy", "32", "r", "6", "transform", "translate(33.6 19.2) scale(0.4)", "stroke-linejoin", "miter", 2, "opacity", "0.4"]], template: function LoadingSpinnerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵnamespaceSVG();
        ɵngcc0.ɵɵelementStart(0, "svg", 0);
        ɵngcc0.ɵɵelementStart(1, "g", 1);
        ɵngcc0.ɵɵelementStart(2, "g", 2);
        ɵngcc0.ɵɵelement(3, "circle", 3);
        ɵngcc0.ɵɵelement(4, "circle", 4);
        ɵngcc0.ɵɵelement(5, "circle", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "script");
        ɵngcc0.ɵɵtext(7, " ! function () { function t(t) { this.element = t, this.dots = [this.element.getElementsByTagName(\"circle\")[1], this.element.getElementsByTagName( \"circle\")[0], this.element.getElementsByTagName(\"circle\")[2]], this.animationId, this.start = null, this.init() } if (!window.requestAnimationFrame) { var e = null; window.requestAnimationFrame = function (t, i) { var n = (new Date).getTime(); e || (e = n); var a = Math.max(0, 16 - (n - e)), s = window.setTimeout(function () { t(n + a) }, a); return e = n + a, s } } t.prototype.init = function () { var t = this; this.animationId = window.requestAnimationFrame(t.triggerAnimation.bind(t)) }, t.prototype.reset = function () { var t = this; window.cancelAnimationFrame(t.animationId) }, t.prototype.triggerAnimation = function (t) { var e = this; this.start || (this.start = t); var i = t - this.start, n = Math.min(i / 250, 4), a = (n = 4 == n ? 0 : n) % 1, s = Math.ceil(n); 1e3 > i || (this.start = this.start + 1e3); var r = [], o = [8, 32, 56], m = [32, 32, 32]; switch (r[0] = r[1] = r[2] = .4, s) { case 1: r[0] = 1 - 3 * a / 5, r[1] = .4 + 3 * a / 5; break; case 2: r[1] = 1 - 3 * a / 5, r[2] = .4 + 3 * a / 5; break; case 3: r[1] = .4 + 3 * a / 5, r[2] = 1 - 3 * a / 5; break; case 4: r[0] = .4 + 3 * a / 5, r[1] = 1 - 3 * a / 5; break; default: r[0] = 1 } for (var c = 0; 3 > c; c++) this.dots[c].setAttribute(\"style\", \"opacity:\" + r[c] + \";\"), this.dots[c].setAttribute( \"transform\", \"translate(\" + (1 - r[c]) * o[c] + \" \" + (1 - r[c]) * m[c] + \") scale(\" + r[c] + \")\"); if (document.documentElement.contains(this.element)) window.requestAnimationFrame(e.triggerAnimation.bind( e)) }; var i = document.getElementsByClassName(\"nc-loop_dots-07-64\"), n = []; if (i) for (var a = 0; i.length > a; a++) ! function (e) { n.push(new t(i[e])) }(a); document.addEventListener(\"visibilitychange\", function () { \"hidden\" == document.visibilityState ? n.forEach(function (t) { t.reset() }) : n.forEach(function (t) { t.init() }) }) }(); ");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, encapsulation: 2 });
LoadingSpinnerComponent.propDecorators = {
    notificationToggle: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoadingSpinnerComponent, [{
        type: Component,
        args: [{
                selector: 'ui-loading-spinner',
                template: "\n<svg version=\"1.1\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" x=\"0px\" y=\"0px\" viewBox=\"0 0 64 64\"\n  xml:space=\"preserve\" width=\"64\" height=\"64\">\n  <g class=\"nc-icon-wrapper\" fill=\"#444444\">\n    <g class=\"nc-loop_dots-07-64\">\n      <circle data-color=\"color-2\" fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\"\n        cx=\"32\" cy=\"32\" r=\"6\" transform=\"translate(9.071078400034459 9.071078400034459) scale(0.7165287999989232)\" style=\"opacity:0.7165287999989232;\"\n        stroke-linejoin=\"miter\"></circle>\n      <circle fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"8\" cy=\"32\" r=\"6\"\n        stroke-linejoin=\"miter\" style=\"opacity:0.6834712000010768;\" transform=\"translate(2.532230399991386 10.128921599965544) scale(0.6834712000010768)\"></circle>\n      <circle fill=\"none\" stroke=\"#444444\" stroke-width=\"2\" stroke-linecap=\"square\" stroke-miterlimit=\"10\" cx=\"56\" cy=\"32\" r=\"6\"\n        transform=\"translate(33.6 19.2) scale(0.4)\" style=\"opacity:0.4;\" stroke-linejoin=\"miter\"></circle>\n    </g>\n    <script>\n      ! function () {\n        function t(t) {\n          this.element = t, this.dots = [this.element.getElementsByTagName(\"circle\")[1], this.element.getElementsByTagName(\n              \"circle\")[0], this.element.getElementsByTagName(\"circle\")[2]], this.animationId, this.start = null,\n            this.init()\n        }\n        if (!window.requestAnimationFrame) {\n          var e = null;\n          window.requestAnimationFrame = function (t, i) {\n            var n = (new Date).getTime();\n            e || (e = n);\n            var a = Math.max(0, 16 - (n - e)),\n              s = window.setTimeout(function () {\n                t(n + a)\n              }, a);\n            return e = n + a, s\n          }\n        }\n        t.prototype.init = function () {\n          var t = this;\n          this.animationId = window.requestAnimationFrame(t.triggerAnimation.bind(t))\n        }, t.prototype.reset = function () {\n          var t = this;\n          window.cancelAnimationFrame(t.animationId)\n        }, t.prototype.triggerAnimation = function (t) {\n          var e = this;\n          this.start || (this.start = t);\n          var i = t - this.start,\n            n = Math.min(i / 250, 4),\n            a = (n = 4 == n ? 0 : n) % 1,\n            s = Math.ceil(n);\n          1e3 > i || (this.start = this.start + 1e3);\n          var r = [],\n            o = [8, 32, 56],\n            m = [32, 32, 32];\n          switch (r[0] = r[1] = r[2] = .4, s) {\n            case 1:\n              r[0] = 1 - 3 * a / 5, r[1] = .4 + 3 * a / 5;\n              break;\n            case 2:\n              r[1] = 1 - 3 * a / 5, r[2] = .4 + 3 * a / 5;\n              break;\n            case 3:\n              r[1] = .4 + 3 * a / 5, r[2] = 1 - 3 * a / 5;\n              break;\n            case 4:\n              r[0] = .4 + 3 * a / 5, r[1] = 1 - 3 * a / 5;\n              break;\n            default:\n              r[0] = 1\n          }\n          for (var c = 0; 3 > c; c++) this.dots[c].setAttribute(\"style\", \"opacity:\" + r[c] + \";\"), this.dots[c].setAttribute(\n            \"transform\", \"translate(\" + (1 - r[c]) * o[c] + \" \" + (1 - r[c]) * m[c] + \") scale(\" + r[c] + \")\");\n          if (document.documentElement.contains(this.element)) window.requestAnimationFrame(e.triggerAnimation.bind(\n            e))\n        };\n        var i = document.getElementsByClassName(\"nc-loop_dots-07-64\"),\n          n = [];\n        if (i)\n          for (var a = 0; i.length > a; a++) ! function (e) {\n            n.push(new t(i[e]))\n          }(a);\n        document.addEventListener(\"visibilitychange\", function () {\n          \"hidden\" == document.visibilityState ? n.forEach(function (t) {\n            t.reset()\n          }) : n.forEach(function (t) {\n            t.init()\n          })\n        })\n      }();\n\n    </script>\n  </g>\n</svg>\n\n"
            }]
    }], function () { return []; }, { notificationToggle: [{
            type: Input
        }] }); })();

class NotificationService {
    constructor() {
        this.pendingMessage = '';
        this.messageSubject = new BehaviorSubject({ msg: '' });
        this.messageObservable = this.messageSubject.asObservable();
        this.alertSubject = new Subject();
        this.alertObservable = this.alertSubject.asObservable();
    }
    setMessage(message, delay, politeness = 'assertive') {
        if (delay) {
            this.messageSubject.next({ msg: message, delay: delay, politeness: politeness });
        }
        else {
            this.messageSubject.next({ msg: message, politeness: politeness });
        }
    }
    setAlert(message, delay) {
        if (delay) {
            this.alertSubject.next({ msg: message, delay: delay });
        }
        else {
            this.alertSubject.next({ msg: message });
        }
    }
    get message() {
        return this.messageObservable;
    }
    get alert() {
        return this.alertObservable;
    }
    ngOnDestroy() {
        if (this.messageSubject) {
            this.messageSubject.complete();
        }
        if (this.alertSubject) {
            this.alertSubject.complete();
        }
    }
}
NotificationService.ɵfac = function NotificationService_Factory(t) { return new (t || NotificationService)(); };
NotificationService.ɵprov = i0.ɵɵdefineInjectable({ factory: function NotificationService_Factory() { return new NotificationService(); }, token: NotificationService, providedIn: "root" });
NotificationService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class LoadingComponent {
    constructor(loadingService, notification) {
        this.notification = notification;
        this.loadingDebounceTime = 2000;
        this.loadingStartMessage = 'ui.loading.label';
        this.loadingEndMessage = 'ui.loading.complete_label';
        loadingService.status.subscribe(status => {
            this.active = status;
        });
        loadingService.status.pipe(throttle(() => interval(this.loadingDebounceTime), { leading: true, trailing: true })).subscribe(status => {
            if (status) {
                this.notification.setMessage(this.loadingStartMessage);
            }
            else {
                this.notification.setMessage(this.loadingEndMessage);
            }
        });
    }
}
LoadingComponent.ɵfac = function LoadingComponent_Factory(t) { return new (t || LoadingComponent)(ɵngcc0.ɵɵdirectiveInject(LoadingService), ɵngcc0.ɵɵdirectiveInject(NotificationService)); };
LoadingComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: LoadingComponent, selectors: [["ui-loading"]], inputs: { loadingDebounceTime: "loadingDebounceTime", loadingStartMessage: "loadingStartMessage", loadingEndMessage: "loadingEndMessage", active: "active" }, decls: 3, vars: 7, consts: [["id", "overlay", 1, "overlay", 3, "ngClass"], ["id", "loader", 1, "loader", 3, "ngClass"], [4, "ngIf"]], template: function LoadingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵtemplate(2, LoadingComponent_ui_loading_spinner_2_Template, 1, 0, "ui-loading-spinner", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(3, _c6, ctx.active));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(5, _c6, ctx.active));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.active);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgIf, LoadingSpinnerComponent], encapsulation: 2 });
LoadingComponent.ctorParameters = () => [
    { type: LoadingService },
    { type: NotificationService }
];
LoadingComponent.propDecorators = {
    active: [{ type: Input }],
    loadingDebounceTime: [{ type: Input }],
    loadingStartMessage: [{ type: Input }],
    loadingEndMessage: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LoadingComponent, [{
        type: Component,
        args: [{
                selector: 'ui-loading',
                template: "<div id=\"overlay\" class=\"overlay\" [ngClass]=\"{'active': active}\"></div>\n<div id=\"loader\" class=\"loader\" [ngClass]=\"{'active': active}\">\n  <ui-loading-spinner *ngIf=\"active\"></ui-loading-spinner>\n</div>\n"
            }]
    }], function () { return [{ type: LoadingService }, { type: NotificationService }]; }, { loadingDebounceTime: [{
            type: Input
        }], loadingStartMessage: [{
            type: Input
        }], loadingEndMessage: [{
            type: Input
        }], active: [{
            type: Input
        }] }); })();

class ErrorComponent {
    constructor(activatedRoute, router, lastResponseService) {
        this.activatedRoute = activatedRoute;
        this.router = router;
        this.lastResponseService = lastResponseService;
        this.errorType = 'general'; // default
        this.hideGoHome = false;
    }
    ngOnInit() {
        var _a, _b, _c, _d;
        this.routeDataSubscription = this.activatedRoute.data.subscribe(routeData => {
            if (routeData.errorType) {
                this.errorType = routeData.errorType;
                this.hideGoHome = routeData.hideGoHome;
            }
        });
        if ((_d = (_c = (_b = (_a = this.lastResponseService) === null || _a === void 0 ? void 0 : _a.ifResponse) === null || _b === void 0 ? void 0 : _b.Results) === null || _c === void 0 ? void 0 : _c.data) === null || _d === void 0 ? void 0 : _d.native) {
            this.error = this.lastResponseService.ifResponse.Results.data.native;
        }
        this.setErrorContent(this.errorType);
    }
    ngOnChanges(changes) {
        if (changes['error']) {
            let errorDetails = [];
            if (this.error) {
                if (this.error.header) {
                    errorDetails.push(`<head>${this.error.header}</head>`);
                }
                if (this.error.body) {
                    errorDetails.push(`<body>${this.error.body}</body>`);
                }
                if (errorDetails.length > 0) {
                    errorDetails = ['<html>', ...errorDetails, '</html>'];
                }
                if (this.error.details) {
                    errorDetails.push(this.error.details);
                }
            }
            this.errorDetails = errorDetails.join('');
        }
    }
    setErrorContent(errorType) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
        switch (errorType) {
            case 'network':
                this.errorIcon = (_a = this.errorIcon) !== null && _a !== void 0 ? _a : 'ifc-planet';
                this.errorHeader = (_b = this.errorHeader) !== null && _b !== void 0 ? _b : 'ui.error.network_header';
                this.errorText = (_c = this.errorText) !== null && _c !== void 0 ? _c : 'ui.error.network_text';
                break;
            case 'sso':
                this.errorIcon = (_d = this.errorIcon) !== null && _d !== void 0 ? _d : 'ifc-alert-circle-exc';
                this.errorHeader = (_e = this.errorHeader) !== null && _e !== void 0 ? _e : 'ui.error.sso_header';
                this.errorText = (_f = this.errorText) !== null && _f !== void 0 ? _f : 'ui.error.sso_text';
                break;
            case 'not-found':
                this.errorIcon = (_g = this.errorIcon) !== null && _g !== void 0 ? _g : 'ifc-search';
                this.errorHeader = (_h = this.errorHeader) !== null && _h !== void 0 ? _h : 'ui.error.not_found_header';
                this.errorText = (_j = this.errorText) !== null && _j !== void 0 ? _j : 'ui.error.not_found_text';
                break;
            case 'forbidden':
                this.errorIcon = (_k = this.errorIcon) !== null && _k !== void 0 ? _k : 'ifc-alert-circle-exc';
                this.errorHeader = (_l = this.errorHeader) !== null && _l !== void 0 ? _l : 'ui.error.forbidden_header';
                this.errorText = (_m = this.errorText) !== null && _m !== void 0 ? _m : 'ui.error.forbidden_text';
                break;
            default:
                this.errorIcon = (_o = this.errorIcon) !== null && _o !== void 0 ? _o : 'ifc-alert-circle-exc';
                this.errorHeader = (_p = this.errorHeader) !== null && _p !== void 0 ? _p : 'ui.error.general_header';
                this.errorText = (_q = this.errorText) !== null && _q !== void 0 ? _q : 'ui.error.general_text';
                break;
        }
    }
    ngOnDestroy() {
        if (this.routeDataSubscription) {
            this.routeDataSubscription.unsubscribe();
        }
    }
    goHome() {
        this.router.navigateByUrl('');
    }
}
ErrorComponent.ɵfac = function ErrorComponent_Factory(t) { return new (t || ErrorComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.ActivatedRoute), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LastResponseService)); };
ErrorComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ErrorComponent, selectors: [["ui-error"]], inputs: { errorType: "errorType", hideGoHome: "hideGoHome", error: "error", errorIcon: "errorIcon", errorHeader: "errorHeader", errorText: "errorText" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], ngContentSelectors: _c7, decls: 14, vars: 12, consts: [[1, "row"], [1, "col-sm-10", "offset-sm-1", "col-xl-8", "offset-xl-2", "card", "p-4", "p-sm-5", "text-center"], [1, "h2"], [1, "lead", "my-4"], [4, "ngIf"], ["id", "result", "class", "collapse col", 4, "ngIf"], ["class", "btn btn-outline-primary mt-4", 3, "click", 4, "ngIf"], ["href", "#", "role", "button", "data-toggle", "collapse", "data-target", "#result"], ["id", "result", 1, "collapse", "col"], ["readonly", "", "rows", "20", "id", "resultPage", 1, "form-control"], [1, "btn", "btn-outline-primary", "mt-4", 3, "click"]], template: function ErrorComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "article", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "i");
        ɵngcc0.ɵɵelementStart(3, "h1", 2);
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "p", 3);
        ɵngcc0.ɵɵtext(7);
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, ErrorComponent_span_9_Template, 4, 3, "span", 4);
        ɵngcc0.ɵɵelementStart(10, "div", 0);
        ɵngcc0.ɵɵtemplate(11, ErrorComponent_div_11_Template, 3, 1, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵprojection(12);
        ɵngcc0.ɵɵtemplate(13, ErrorComponent_button_13_Template, 3, 3, "button", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵclassMapInterpolate1("ifc-icon ", ctx.errorIcon, " ifc-icon-3 mb-2");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(5, 8, ctx.errorHeader));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(8, 10, ctx.errorText));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorDetails);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.errorDetails);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideGoHome);
    } }, directives: [ɵngcc1.NgIf], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
ErrorComponent.ctorParameters = () => [
    { type: ActivatedRoute },
    { type: Router },
    { type: LastResponseService }
];
ErrorComponent.propDecorators = {
    errorType: [{ type: Input }],
    error: [{ type: Input }],
    hideGoHome: [{ type: Input }],
    errorHeader: [{ type: Input }],
    errorText: [{ type: Input }],
    errorIcon: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ErrorComponent, [{
        type: Component,
        args: [{
                selector: 'ui-error',
                template: "<article class=\"row\">\n    <div class=\"col-sm-10 offset-sm-1 col-xl-8 offset-xl-2 card p-4 p-sm-5 text-center\">\n      <i class=\"ifc-icon {{errorIcon}} ifc-icon-3 mb-2\"></i>\n      <h1 class=\"h2\">{{errorHeader | translate}}</h1>\n      <p class=\"lead my-4\">{{errorText | translate}}</p><span *ngIf=\"errorDetails\"><a href=\"#\" role=\"button\" data-toggle=\"collapse\" data-target=\"#result\">{{ 'ui.error.more_details' | translate }}</a> </span>\n\n      <div class=\"row\">\n        <div id=\"result\" class=\"collapse col\" *ngIf=\"errorDetails\">\n          <textarea readonly class=\"form-control\" rows=\"20\" id=\"resultPage\">{{errorDetails}}</textarea>\n        </div>\n      </div>\n\n      <ng-content></ng-content>\n\n      <button class=\"btn btn-outline-primary mt-4\" (click)=\"goHome()\" *ngIf=\"!hideGoHome\">{{'ui.error.return_home' | translate}}</button>\n    </div>\n  </article>\n"
            }]
    }], function () { return [{ type: ɵngcc5.ActivatedRoute }, { type: ɵngcc5.Router }, { type: ɵngcc2.LastResponseService }]; }, { errorType: [{
            type: Input
        }], hideGoHome: [{
            type: Input
        }], error: [{
            type: Input
        }], errorIcon: [{
            type: Input
        }], errorHeader: [{
            type: Input
        }], errorText: [{
            type: Input
        }] }); })();

class CopyrightComponent {
    constructor() { }
    ngOnInit() {
        this.year = new Date().getFullYear();
    }
}
CopyrightComponent.ɵfac = function CopyrightComponent_Factory(t) { return new (t || CopyrightComponent)(); };
CopyrightComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CopyrightComponent, selectors: [["ui-copyright"]], inputs: { company: "company" }, decls: 3, vars: 7, template: function CopyrightComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "span");
        ɵngcc0.ɵɵtext(1);
        ɵngcc0.ɵɵpipe(2, "translate");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind2(2, 1, "ui.copyright", ɵngcc0.ɵɵpureFunction2(4, _c8, ctx.year, ctx.company)));
    } }, pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
CopyrightComponent.ctorParameters = () => [];
CopyrightComponent.propDecorators = {
    company: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CopyrightComponent, [{
        type: Component,
        args: [{
                selector: 'ui-copyright',
                template: "<span>{{ 'ui.copyright' | translate:{'year':year, 'company': company} }}</span>"
            }]
    }], function () { return []; }, { company: [{
            type: Input
        }] }); })();

class AttachmentsComponent {
    constructor(settings) {
        this.done = new EventEmitter();
        this.urlPrefix = settings.defaultSystemSettings.IFURLPrefix;
    }
    ngOnChanges(changes) {
        if (changes) {
            this._attachments = this.attachments;
        }
    }
    updateAttachmentList(attachment) {
        this._attachments = this._attachments.filter(attach => attach !== attachment);
        if (this._attachments.length === 0) {
            this.done.emit();
        }
    }
    toAttachmentUrl(url) {
        const hasHostRegex = /https?:\/\/[^/]+\/.*/i;
        if (!hasHostRegex.test(url)) {
            url = `${this.urlPrefix}${url}`;
        }
        return url.replace('/NLX3/', '/').replace('/NLX7/', '/');
    }
    ngOnDestroy() {
        this.done.complete();
    }
}
AttachmentsComponent.ɵfac = function AttachmentsComponent_Factory(t) { return new (t || AttachmentsComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc2.SettingsService)); };
AttachmentsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: AttachmentsComponent, selectors: [["ui-attachments"]], inputs: { attachments: "attachments", forceDownloadOption: "forceDownloadOption" }, outputs: { done: "done" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngFor", "ngForOf"], [1, "card", "w-100"], [1, "d-flex", "flex-row"], [1, "card-body", "d-flex", "justify-content-around"], [1, "h5", "mb-0", "pt-1", "mr-2"], ["target", "_blank", 1, "btn", "btn-primary", "mr-2", 3, "title", "href", "click"], [4, "ngIf"]], template: function AttachmentsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, AttachmentsComponent_div_0_Template, 11, 10, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngForOf", ctx._attachments);
    } }, directives: [ɵngcc1.NgForOf, ɵngcc1.NgIf], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
AttachmentsComponent.ctorParameters = () => [
    { type: SettingsService }
];
AttachmentsComponent.propDecorators = {
    attachments: [{ type: Input }],
    forceDownloadOption: [{ type: Input }],
    done: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(AttachmentsComponent, [{
        type: Component,
        args: [{
                selector: 'ui-attachments',
                template: "<div *ngFor=\"let attachment of _attachments\">\n  <div class=\"card w-100\">\n    <div class=\"d-flex flex-row\">\n      <div class=\"card-body d-flex justify-content-around\">\n        <div class=\"h5 mb-0 pt-1 mr-2\">\n          {{ 'ui.attachments.information' | translate }}\n        </div>\n        <a\n          class=\"btn btn-primary mr-2\"\n          [title]=\"'ui.attachments.title' | translate\"\n          href=\"{{toAttachmentUrl(attachment.url)}}\"\n          target=\"_blank\"\n          [attr.download]=\"forceDownloadOption ? '' : null\"\n          (click)=\"updateAttachmentList(attachment)\"\n        >\n          <ng-container *ngIf=\"forceDownloadOption\">{{\n            'ui.attachments.download' | translate\n          }}</ng-container>\n          <ng-container *ngIf=\"!forceDownloadOption\">{{\n            'ui.attachments.view_attachment' | translate\n          }}</ng-container>\n        </a>\n      </div>\n    </div>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc2.SettingsService }]; }, { done: [{
            type: Output
        }], attachments: [{
            type: Input
        }], forceDownloadOption: [{
            type: Input
        }] }); })();

class ResponsiveImgComponent {
    constructor() { }
    ngOnInit() {
        const img = {};
        if (this.src && typeof (this.src) !== 'string') {
            const rimg = this.src;
            if (rimg.path) {
                img.src = `${rimg.path}${rimg.src}`;
            }
            else {
                img.src = rimg.src;
            }
            if (rimg.srcset) {
                const imageName = rimg.src.substring(0, rimg.src.lastIndexOf(','));
                const regex = new RegExp(`${imageName}`, 'g');
                img.srcset = rimg.srcset.replace(regex, `${rimg.path}${imageName}`);
            }
            img.sizes = rimg.sizes;
            img.alt = rimg.alt;
        }
        else {
            img.src = this.src;
        }
        this.img = img.src ? img : undefined;
    }
}
ResponsiveImgComponent.ɵfac = function ResponsiveImgComponent_Factory(t) { return new (t || ResponsiveImgComponent)(); };
ResponsiveImgComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ResponsiveImgComponent, selectors: [["ui-responsive-img"]], inputs: { src: "src", alt: "alt" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "img-fluid", 3, "src"]], template: function ResponsiveImgComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ResponsiveImgComponent_picture_0_Template, 2, 5, "picture", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.img);
    } }, directives: [ɵngcc1.NgIf], encapsulation: 2 });
ResponsiveImgComponent.ctorParameters = () => [];
ResponsiveImgComponent.propDecorators = {
    src: [{ type: Input }],
    alt: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResponsiveImgComponent, [{
        type: Component,
        args: [{
                selector: 'ui-responsive-img',
                template: "<picture *ngIf=\"img\">\n  <img\n    class=\"img-fluid\"\n    [src]=\"img.src\"\n    [attr.sizes]=\"img.sizes\"\n    [attr.srcset]=\"img.srcset\"\n    [attr.alt]= \"alt || img.alt\"\n    [attr.role]=\"!alt && !img.alt? 'presentation': ''\"\n    >\n</picture>\n"
            }]
    }], function () { return []; }, { src: [{
            type: Input
        }], alt: [{
            type: Input
        }] }); })();

class FormHelper {
    static validateForm(form) {
        form.markAsTouched();
        form.markAsDirty();
        this.markDirtyandTouched(form);
        form.updateValueAndValidity();
    }
    static markDirtyandTouched(form) {
        Object.keys(form.controls).forEach(ctrl => {
            if (form.controls[ctrl].controls) {
                this.markDirtyandTouched(form.controls[ctrl]);
            }
            form.controls[ctrl].markAsTouched();
            form.controls[ctrl].markAsDirty();
            form.controls[ctrl].updateValueAndValidity();
        });
    }
}

class ModalService {
    constructor() {
        this.showModal = {
            selected: '',
            disableDismiss: true
        };
        this.modalSource = new Subject();
        this.modalObservable = this.modalSource.asObservable();
    }
    show(disableDismiss = false, id = 'default') {
        this.showModal = {
            selected: id,
            disableDismiss: disableDismiss
        };
        this.modalSource.next(this.showModal);
    }
    hide() {
        this.showModal.selected = '';
        this.modalSource.next(this.showModal);
    }
}
ModalService.ɵfac = function ModalService_Factory(t) { return new (t || ModalService)(); };
ModalService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ModalService, factory: ModalService.ɵfac });
ModalService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class ModalComponent {
    constructor(modalService, render, changesRef) {
        this.modalService = modalService;
        this.render = render;
        this.changesRef = changesRef;
        this.id = 'default';
        this.focusedElementSelector = 'input:not([disabled]):not([type="hidden"]),select:not([disabled]), button:not([disabled]), a';
        this.isAlertDialog = false;
        this.closed = new EventEmitter();
        this.showModal = false;
    }
    ngOnInit() {
        this.subscription = new Subscription();
        this.subscription.add(this.modalService.modalObservable.subscribe(show => {
            this.currentShowModal = show;
            if (show && show.selected === this.id) {
                this.disableDismiss = show.disableDismiss;
                this.showModal = true;
                this.changesRef.detectChanges();
            }
            else if (this.showModal) {
                this.closed.emit(this.id);
                this.showModal = false;
                this.changesRef.detectChanges();
            }
            this.updateModalOpenClass();
        }));
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this.closed.complete();
        this.updateModalOpenClass(true);
    }
    // updating the modal-open class for the body
    updateModalOpenClass(destroying = false) {
        var _a, _b;
        if (((_a = this.currentShowModal) === null || _a === void 0 ? void 0 : _a.selected) === this.id && !destroying) {
            // add the class if this component is the current one being shown, and it's not being destroyed
            this.render.addClass(document.body, 'modal-open');
        }
        else if (!((_b = this.currentShowModal) === null || _b === void 0 ? void 0 : _b.selected) || (destroying && this.currentShowModal.selected === this.id)) {
            // remove the class if there's no currently opened modal, or if the current modal is open and being destroyed
            this.render.removeClass(document.body, 'modal-open');
        }
    }
    closeModal($event) {
        var _a, _b;
        if (!this.disableDismiss && (!$event || ((_b = (_a = $event.className) === null || _a === void 0 ? void 0 : _a.indexOf) === null || _b === void 0 ? void 0 : _b.call(_a, "modal")) !== -1)) {
            this.modalService.hide();
        }
    }
}
ModalComponent.ɵfac = function ModalComponent_Factory(t) { return new (t || ModalComponent)(ɵngcc0.ɵɵdirectiveInject(ModalService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ModalComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ModalComponent, selectors: [["ui-modal"]], contentQueries: function ModalComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c9, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c10, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c11, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.bodyTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
    } }, inputs: { id: "id", focusedElementSelector: "focusedElementSelector", isAlertDialog: "isAlertDialog", label: "label", lastFocusableElementId: "lastFocusableElementId", scrollable: "scrollable" }, outputs: { closed: "closed" }, decls: 4, vars: 11, consts: [[1, "modal", "fade", 3, "ngClass", "keyup.esc", "click"], [4, "ngIf"], ["uiModalDialog", "", 1, "modal-dialog", 3, "ngClass", "focusedElementSelector", "lastFocusableElementId", "isAlertDialog"], [1, "modal-content"], ["class", "modal-header", "tabindex", "-1", 4, "ngIf"], ["class", "modal-body", 4, "ngIf"], ["class", "modal-footer", 4, "ngIf"], ["tabindex", "-1", 1, "modal-header"], [3, "ngTemplateOutlet"], [1, "modal-body"], [1, "modal-footer"], [1, "modal-backdrop", "fade", "show"]], template: function ModalComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵlistener("keyup.esc", function ModalComponent_Template_div_keyup_esc_0_listener() { return ctx.closeModal(); })("click", function ModalComponent_Template_div_click_0_listener($event) { return ctx.closeModal($event.target); });
        ɵngcc0.ɵɵpipe(1, "translate");
        ɵngcc0.ɵɵtemplate(2, ModalComponent_ng_container_2_Template, 6, 9, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, ModalComponent_ng_container_3_Template, 2, 0, "ng-container", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction3(7, _c13, ctx.showModal, ctx.showModal, !ctx.showModal));
        ɵngcc0.ɵɵattribute("aria-label", ɵngcc0.ɵɵpipeBind1(1, 5, ctx.label))("aria-modal", true);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showModal);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showModal);
    } }, directives: function () { return [ɵngcc1.NgClass, ɵngcc1.NgIf, ModalDialogDirective, ɵngcc1.NgTemplateOutlet]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, encapsulation: 2 });
ModalComponent.ctorParameters = () => [
    { type: ModalService },
    { type: Renderer2 },
    { type: ChangeDetectorRef }
];
ModalComponent.propDecorators = {
    headerTemplate: [{ type: ContentChild, args: ['headerTemplate',] }],
    bodyTemplate: [{ type: ContentChild, args: ['bodyTemplate',] }],
    footerTemplate: [{ type: ContentChild, args: ['footerTemplate',] }],
    label: [{ type: Input }],
    id: [{ type: Input }],
    focusedElementSelector: [{ type: Input }],
    lastFocusableElementId: [{ type: Input }],
    scrollable: [{ type: Input }],
    isAlertDialog: [{ type: Input }],
    closed: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalComponent, [{
        type: Component,
        args: [{
                selector: 'ui-modal',
                template: "<div \n  class=\"modal fade\" \n  [ngClass]=\"{'show': showModal, 'd-block':showModal, 'd-none':!showModal}\"\n  [attr.aria-label]=\"label | translate\" \n  [attr.aria-modal]='true'\n  (keyup.esc)=\"closeModal()\" \n  (click)=\"closeModal($event.target)\"  >\n  <ng-container *ngIf=\"showModal\">\n    <div class=\"modal-dialog\" [ngClass]=\"{'modal-dialog-scrollable': scrollable }\" uiModalDialog [focusedElementSelector]=\"focusedElementSelector\"\n      [lastFocusableElementId]=\"lastFocusableElementId\" [isAlertDialog]=\"isAlertDialog\">\n      <div class=\"modal-content\">\n        <div class=\"modal-header\" *ngIf=\"headerTemplate\" tabindex=\"-1\">\n          <ng-container [ngTemplateOutlet]=\"headerTemplate\">\n          </ng-container>\n        </div>\n        <div class=\"modal-body\" *ngIf=\"bodyTemplate\">\n          <ng-container [ngTemplateOutlet]=\"bodyTemplate\">\n          </ng-container>\n        </div>\n        <div class=\"modal-footer\" *ngIf=\"footerTemplate\">\n          <ng-container [ngTemplateOutlet]=\"footerTemplate\">\n          </ng-container>\n        </div>\n      </div>\n    </div>\n  </ng-container>\n</div>\n\n<ng-container *ngIf=\"showModal\">\n  <div class=\"modal-backdrop fade show\"> </div>\n</ng-container>\n"
            }]
    }], function () { return [{ type: ModalService }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ChangeDetectorRef }]; }, { id: [{
            type: Input
        }], focusedElementSelector: [{
            type: Input
        }], isAlertDialog: [{
            type: Input
        }], closed: [{
            type: Output
        }], headerTemplate: [{
            type: ContentChild,
            args: ['headerTemplate']
        }], bodyTemplate: [{
            type: ContentChild,
            args: ['bodyTemplate']
        }], footerTemplate: [{
            type: ContentChild,
            args: ['footerTemplate']
        }], label: [{
            type: Input
        }], lastFocusableElementId: [{
            type: Input
        }], scrollable: [{
            type: Input
        }] }); })();

const UI_PROXY_KEY = '__PROXY_DO_NOT_PROMPT__';
class ProxyUrlService {
    constructor(lastResponse, settings) {
        this.lastResponse = lastResponse;
        this.settings = settings;
        this.subject = new Subject();
        this.observable = this.subject.asObservable();
        this.lastResponse.ifResponseObservable.subscribe((ifResponse) => {
            if (this.isProxyRoute(ifResponse)) {
                const responseData = ifResponse.Results.data;
                let url;
                if (responseData && responseData.url) {
                    url = responseData.url;
                }
                else {
                    url = this.lastResponse.getReferringTarget();
                }
                this.subject.next({
                    proxyUrl: this.processProxyUrl(url),
                    title: responseData.title
                });
            }
        });
    }
    ngOnDestroy() {
        this.removeDoNotPromptSetting();
    }
    isProxyRoute(ifResponse) {
        return (ifResponse &&
            ifResponse.ProposedTemplate &&
            ifResponse.ProposedTemplate.indexOf('/proxy-page') === 0);
    }
    get proxyUrl() {
        return this.observable;
    }
    getDoNotPromptState() {
        return sessionStorage.getItem(UI_PROXY_KEY);
    }
    setDoNotPromptForSession() {
        sessionStorage.setItem(UI_PROXY_KEY, 'true');
    }
    removeDoNotPromptSetting() {
        sessionStorage.removeItem(UI_PROXY_KEY);
    }
    processProxyUrl(url) {
        if (!url) {
            return;
        }
        if (url && url.indexOf('http') !== 0) {
            url = this.settings.IFURLPrefix + url;
        }
        return url
            .replace('/NLX3/', '/')
            .replace('/NLX7/', '/');
    }
}
ProxyUrlService.ɵfac = function ProxyUrlService_Factory(t) { return new (t || ProxyUrlService)(ɵngcc0.ɵɵinject(ɵngcc2.LastResponseService), ɵngcc0.ɵɵinject(ɵngcc2.SettingsService)); };
ProxyUrlService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ProxyUrlService_Factory() { return new ProxyUrlService(i0.ɵɵinject(i1$1.LastResponseService), i0.ɵɵinject(i1$1.SettingsService)); }, token: ProxyUrlService, providedIn: "root" });
ProxyUrlService.ctorParameters = () => [
    { type: LastResponseService },
    { type: SettingsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProxyUrlService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.LastResponseService }, { type: ɵngcc2.SettingsService }]; }, null); })();

class ProxyUrlComponent {
    constructor(proxyService) {
        this.proxyService = proxyService;
        this.done = new EventEmitter();
    }
    promptChanged(e) {
        if (e) {
            const target = e.target;
            this.doNotPrompt = target.checked;
        }
    }
    ngOnDestroy() {
        this.done.complete();
    }
    open() {
        if (this.doNotPrompt) {
            this.proxyService.setDoNotPromptForSession();
        }
        this.done.emit();
    }
}
ProxyUrlComponent.ɵfac = function ProxyUrlComponent_Factory(t) { return new (t || ProxyUrlComponent)(ɵngcc0.ɵɵdirectiveInject(ProxyUrlService)); };
ProxyUrlComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ProxyUrlComponent, selectors: [["ui-proxy-url"]], inputs: { data: "data" }, outputs: { done: "done" }, decls: 1, vars: 1, consts: [["class", "card w-100", 4, "ngIf"], [1, "card", "w-100"], [1, "d-flex", "flex-row"], [1, "card-body"], [1, "mb-4"], [1, "custom-control", "custom-checkbox"], ["name", "doNotPromptAgain", "id", "doNotPromptAgain", "type", "checkbox", 1, "custom-control-input", 3, "change"], ["for", "doNotPromptAgain", 1, "custom-control-label"], ["class", "mt-3 alert alert-warning", 4, "ngIf"], [1, "d-flex", "justify-content-around"], ["target", "_blank", 1, "btn", "btn-primary", "btn-block", 3, "title", "href", "click"], [1, "sr-only"], [1, "mt-3", "alert", "alert-warning"]], template: function ProxyUrlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ProxyUrlComponent_div_0_Template, 20, 16, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.data);
    } }, directives: [ɵngcc1.NgIf], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
ProxyUrlComponent.ctorParameters = () => [
    { type: ProxyUrlService }
];
ProxyUrlComponent.propDecorators = {
    data: [{ type: Input }],
    done: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProxyUrlComponent, [{
        type: Component,
        args: [{
                selector: 'ui-proxy-url',
                template: "<div class=\"card w-100\" *ngIf=\"data\">\n\t<div class=\"d-flex flex-row\">\n\t\t<div class=\"card-body\">\n\t\t\t<p>{{'ui.proxy_url.description' | translate}} </p>\n\t\t\t<div class=\"mb-4\">\n\t\t\t\t<div class=\"custom-control custom-checkbox\">\n\t\t\t\t\t<input class=\"custom-control-input\"\n\t\t\t\t\t name=\"doNotPromptAgain\" id=\"doNotPromptAgain\" type=\"checkbox\" (change)=\"promptChanged($event)\">\n\t\t\t\t\t <label class=\"custom-control-label\" for=\"doNotPromptAgain\">{{'ui.proxy_url.do_not_prompt_text' | translate}}</label>\n\t\t\t\t</div>\n\t\t\t\t<div *ngIf=\"doNotPrompt\" class=\"mt-3 alert alert-warning\">{{'ui.proxy_url.popup_blocker_text' | translate}}</div>\n\t\t\t</div>\n\t\t\t<div class=\"d-flex justify-content-around\">\n\t\t\t\t<a class=\"btn btn-primary btn-block\" [title]=\"data.title\" [href]=\"data.proxyUrl\" target=\"_blank\" (click)=\"open()\">\n\t\t\t\t\t{{'ui.proxy_url.open' | translate}} {{data.title}} <span class=\"sr-only\">{{'ui.proxy_url.new_window_text' |\n\t\t\t\t\t\ttranslate}}</span>\n\t\t\t\t</a>\n\t\t\t</div>\n\t\t</div>\n\t</div>\n</div>"
            }]
    }], function () { return [{ type: ProxyUrlService }]; }, { done: [{
            type: Output
        }], data: [{
            type: Input
        }] }); })();

class TrackingPixelsService {
    constructor(lastResponse, settings) {
        this.lastResponse = lastResponse;
        this.settings = settings;
        this.pixelsSubject = new Subject();
        this.pixels = this.pixelsSubject.asObservable();
        this.lastResponse.ifResponseObservable.subscribe(ifr => {
            if (ifr && ifr.Results && ifr.Results.data && ifr.Results.data.trackingPixels) {
                const pixels = ifr.Results.data.trackingPixels;
                this.setPixels(pixels.map(pixel => {
                    if (UrlUtils.isInFlightUrl(pixel.src) && pixel.src.indexOf('http') === -1) {
                        return {
                            src: `${this.settings.IFURLPrefix}${pixel.src}`
                        };
                    }
                    else {
                        return pixel;
                    }
                }));
            }
        });
    }
    setPixels(pixels) {
        this.pixelsSubject.next(pixels);
    }
}
TrackingPixelsService.ɵfac = function TrackingPixelsService_Factory(t) { return new (t || TrackingPixelsService)(ɵngcc0.ɵɵinject(ɵngcc2.LastResponseService), ɵngcc0.ɵɵinject(ɵngcc2.SettingsService)); };
TrackingPixelsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: TrackingPixelsService, factory: TrackingPixelsService.ɵfac });
TrackingPixelsService.ctorParameters = () => [
    { type: LastResponseService },
    { type: SettingsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TrackingPixelsService, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc2.LastResponseService }, { type: ɵngcc2.SettingsService }]; }, null); })();

class TrackingPixelsComponent {
    constructor(service) {
        this.service = service;
    }
    ngOnInit() {
        this.pixelSubscription = this.service.pixels.subscribe(pixels => {
            this.pixels = pixels;
        });
    }
    ngOnDestroy() {
        if (this.pixelSubscription) {
            this.pixelSubscription.unsubscribe();
        }
    }
}
TrackingPixelsComponent.ɵfac = function TrackingPixelsComponent_Factory(t) { return new (t || TrackingPixelsComponent)(ɵngcc0.ɵɵdirectiveInject(TrackingPixelsService)); };
TrackingPixelsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TrackingPixelsComponent, selectors: [["ui-tracking-pixels"]], decls: 1, vars: 1, consts: [[4, "ngIf"], ["width", "1px", "height", "1px", "style", "display:none;", "aria-hidden", "true", 3, "src", 4, "ngFor", "ngForOf"], ["width", "1px", "height", "1px", "aria-hidden", "true", 2, "display", "none", 3, "src"]], template: function TrackingPixelsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TrackingPixelsComponent_div_0_Template, 2, 1, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.pixels);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf], encapsulation: 2 });
TrackingPixelsComponent.ctorParameters = () => [
    { type: TrackingPixelsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TrackingPixelsComponent, [{
        type: Component,
        args: [{
                selector: 'ui-tracking-pixels',
                template: `<div *ngIf="pixels">
              <img *ngFor="let pixel of pixels" [src]="pixel.src" width="1px" height="1px" style="display:none;" aria-hidden="true">
             </div>`
            }]
    }], function () { return [{ type: TrackingPixelsService }]; }, null); })();

class ImageContentComponent {
    constructor() { }
}
ImageContentComponent.ɵfac = function ImageContentComponent_Factory(t) { return new (t || ImageContentComponent)(); };
ImageContentComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ImageContentComponent, selectors: [["ui-image-content"]], inputs: { img: "img", title: "title", description: "description", imgLeft: "imgLeft" }, decls: 9, vars: 16, consts: [[1, "row"], [1, "col-lg-6", "col-xl-7", "order-2", 3, "ngClass"], [3, "src", "alt"], [1, "col-lg-5", "col-xl-4", "order-1", 3, "ngClass"], [3, "headingLevel"], [3, "innerHtml"]], template: function ImageContentComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelement(2, "ui-responsive-img", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 3);
        ɵngcc0.ɵɵelementStart(4, "ui-dynamic-heading", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵpipe(6, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(7, "div", 5);
        ɵngcc0.ɵɵpipe(8, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction1(11, _c14, ctx.imgLeft));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("src", ctx.img)("alt", ctx.img.alt);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(13, _c15, ctx.imgLeft, !ctx.imgLeft));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("headingLevel", 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(6, 7, ctx.title));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("innerHtml", ɵngcc0.ɵɵpipeBind1(8, 9, ctx.description), ɵngcc0.ɵɵsanitizeHtml);
    } }, directives: function () { return [ɵngcc1.NgClass, ResponsiveImgComponent, DynamicHeadingComponent]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, encapsulation: 2 });
ImageContentComponent.ctorParameters = () => [];
ImageContentComponent.propDecorators = {
    img: [{ type: Input }],
    title: [{ type: Input }],
    description: [{ type: Input }],
    imgLeft: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ImageContentComponent, [{
        type: Component,
        args: [{
                selector: 'ui-image-content',
                template: "<div class=\"row\">\n  <div class=\"col-lg-6 col-xl-7 order-2\" [ngClass]=\"{'order-lg-1': imgLeft}\">\n    <ui-responsive-img [src]=\"img\" [alt]=\"img.alt\"></ui-responsive-img>\n  </div>\n  <div class=\"col-lg-5 col-xl-4 order-1\" [ngClass]=\"{'order-lg-2 ml-lg-auto': imgLeft, 'mr-lg-auto': !imgLeft}\">\n    <ui-dynamic-heading [headingLevel]=\"1\">{{ title | translate }}</ui-dynamic-heading>\n    <div [innerHtml]=\"description | translate\"></div>\n  </div>\n</div>\n"
            }]
    }], function () { return []; }, { img: [{
            type: Input
        }], title: [{
            type: Input
        }], description: [{
            type: Input
        }], imgLeft: [{
            type: Input
        }] }); })();

var Direction;
(function (Direction) {
    Direction["Up"] = "Up";
    Direction["Down"] = "Down";
})(Direction || (Direction = {}));
class ScrollService {
    constructor() {
        this.scroll$ = fromEvent(window, 'scroll').pipe(map(() => window.pageYOffset), pairwise(), map(([y1, y2]) => (y2 < y1 ? Direction.Up : Direction.Down)), share());
        this.goingUp$ = this.scroll$.pipe(filter(direction => direction === Direction.Up));
        this.goingDown$ = this.scroll$.pipe(filter(direction => direction === Direction.Down));
    }
    scrollToTop() {
        setTimeout(() => {
            window.scroll(0, 0);
        });
    }
    scrollToElement(selector) {
        setTimeout(() => {
            const element = document.querySelector(selector);
            if (element) {
                window.scroll(0, element.getBoundingClientRect().y);
            }
        });
    }
}
ScrollService.ɵfac = function ScrollService_Factory(t) { return new (t || ScrollService)(); };
ScrollService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ScrollService_Factory() { return new ScrollService(); }, token: ScrollService, providedIn: "root" });
ScrollService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ScrollService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class Element$1 {
    static getElementSize(selector) {
        const el = document.querySelector(selector);
        return el ? el.getBoundingClientRect().bottom : 0;
    }
}

class StickyNavbarComponent {
    constructor(scroll, renderer) {
        this.scroll = scroll;
        this.renderer = renderer;
        this.YThreshold = 60;
        this.isVisible = true;
    }
    get toggle() {
        return this.isVisible ? 'visible' : 'hidden';
    }
    ngOnInit() {
        this.showInternal = false;
        this.isActive = false;
        this.isTop = true;
        this.scroll.goingUp$.subscribe(() => {
            this.isVisible = true;
            this.isTop = window.pageYOffset < this.YThreshold;
        });
        this.scroll.goingDown$.subscribe(() => {
            this.isVisible = true;
            this.isTop = window.pageYOffset < this.YThreshold;
        });
        this.scroll.scroll$.subscribe(() => {
            const pos = Element$1.getElementSize('ui-sticky-navbar');
            if (pos !== this.stickpos) {
                this.stickpos = pos;
                this.setSticky(pos);
            }
        });
    }
    ngAfterViewInit() {
    }
    setSticky(pos) {
        const sticky = document.querySelectorAll(`.sticky-top`);
        if (sticky) {
            Array.from(sticky).forEach((element) => {
                this.renderer.setStyle(element, 'top', `${this.stickpos}px`);
            });
        }
    }
}
StickyNavbarComponent.ɵfac = function StickyNavbarComponent_Factory(t) { return new (t || StickyNavbarComponent)(ɵngcc0.ɵɵdirectiveInject(ScrollService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
StickyNavbarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: StickyNavbarComponent, selectors: [["ui-sticky-navbar"]], hostVars: 1, hostBindings: function StickyNavbarComponent_HostBindings(rf, ctx) { if (rf & 2) {
        ɵngcc0.ɵɵsyntheticHostProperty("@toggle", ctx.toggle);
    } }, inputs: { YThreshold: "YThreshold" }, ngContentSelectors: _c7, decls: 2, vars: 2, template: function StickyNavbarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵprojection(1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("active", !ctx.isTop);
    } }, encapsulation: 2, data: { animation: [
            trigger('toggle', [
                state('hidden', style({ opacity: 0, transform: 'translateY(-100%)' })),
                state('visible', style({ opacity: 1, transform: 'translateY(0)' })),
                transition('* => *', animate('200ms ease-in'))
            ])
        ] } });
StickyNavbarComponent.ctorParameters = () => [
    { type: ScrollService },
    { type: Renderer2 }
];
StickyNavbarComponent.propDecorators = {
    YThreshold: [{ type: Input }],
    toggle: [{ type: HostBinding, args: ['@toggle',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StickyNavbarComponent, [{
        type: Component,
        args: [{
                selector: 'ui-sticky-navbar',
                template: `<div [class.active]="!isTop"><ng-content></ng-content></div>`,
                animations: [
                    trigger('toggle', [
                        state('hidden', style({ opacity: 0, transform: 'translateY(-100%)' })),
                        state('visible', style({ opacity: 1, transform: 'translateY(0)' })),
                        transition('* => *', animate('200ms ease-in'))
                    ])
                ]
            }]
    }], function () { return [{ type: ScrollService }, { type: ɵngcc0.Renderer2 }]; }, { YThreshold: [{
            type: Input
        }], toggle: [{
            type: HostBinding,
            args: ['@toggle']
        }] }); })();

var StorageMethod;
(function (StorageMethod) {
    StorageMethod["Cookie"] = "cookie";
    StorageMethod["SessionStorage"] = "session";
    StorageMethod["LocalStorage"] = "local";
})(StorageMethod || (StorageMethod = {}));

class StorageService {
    constructor() {
        this.defaultStorageMethod = StorageMethod.Cookie;
    }
    set(key, value, storageMethod = this.defaultStorageMethod, expires) {
        switch (storageMethod) {
            case StorageMethod.SessionStorage:
                this.setSessionStorage(key, value);
                break;
            case StorageMethod.LocalStorage:
                this.setLocalStorage(key, value);
                break;
            default:
                this.setCookie(key, value, expires);
        }
    }
    get(key, storageMethod = this.defaultStorageMethod) {
        switch (storageMethod) {
            case StorageMethod.SessionStorage:
                return this.getSessionStorage(key);
            case StorageMethod.LocalStorage:
                return this.getLocalStorage(key);
            default:
                return this.getCookie(key);
        }
    }
    check(key, storageMethod = this.defaultStorageMethod) {
        switch (storageMethod) {
            case StorageMethod.SessionStorage:
                return this.checkSessionStorage(key);
            case StorageMethod.LocalStorage:
                return this.checkLocalStorage(key);
            default:
                return this.checkCookie(key);
        }
    }
    /*
    * Cookie
    */
    setCookie(key, value, expires) {
        if (this.checkCookieEnabled()) {
            try {
                let cookieValue = `${key}=${value}`;
                if (expires) {
                    cookieValue += `;expires='${expires.toUTCString()}'`;
                }
                document.cookie = cookieValue;
                return true;
            }
            catch (e) {
                return false;
            }
        }
    }
    getCookie(key) {
        if (this.checkCookieEnabled()) {
            try {
                const decodedCookie = decodeURIComponent(document.cookie);
                const pairs = decodedCookie.split(/;\s*/);
                const prefix = `${key}=`;
                for (const pair of pairs) {
                    if (pair.indexOf(prefix) === 0) {
                        return pair.substring(prefix.length);
                    }
                }
            }
            catch (e) { }
        }
    }
    checkCookie(key) {
        try {
            return this.checkCookieEnabled() && document.cookie.split(';').filter((item) => item.trim().startsWith(key)).length > 0;
        }
        catch (e) {
            return false;
        }
    }
    checkCookieEnabled() {
        if (navigator.cookieEnabled) {
            return true;
        }
        else {
            console.warn('Request to access cookies was blocked because of custom cookie permission.');
            return false;
        }
    }
    /*
    * SessionStorage
    */
    setSessionStorage(key, value) {
        if (sessionStorage) {
            sessionStorage.setItem(key, value);
        }
    }
    getSessionStorage(key) {
        if (sessionStorage) {
            try {
                return sessionStorage.getItem(key);
            }
            catch (e) { }
        }
    }
    checkSessionStorage(key) {
        if (sessionStorage) {
            try {
                return sessionStorage.getItem(key) !== null;
            }
            catch (e) {
                return false;
            }
        }
    }
    /*
    * LocalStorage
    */
    setLocalStorage(key, value) {
        if (localStorage) {
            try {
                localStorage.setItem(key, value);
                return true;
            }
            catch (e) {
                return false;
            }
        }
    }
    getLocalStorage(key) {
        if (localStorage) {
            return localStorage.getItem(key);
        }
    }
    checkLocalStorage(key) {
        if (localStorage) {
            return localStorage.getItem(key) !== null;
        }
    }
}
StorageService.ɵfac = function StorageService_Factory(t) { return new (t || StorageService)(); };
StorageService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StorageService_Factory() { return new StorageService(); }, token: StorageService, providedIn: "root" });
StorageService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StorageService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class CookieAdvisoryBannerComponent {
    constructor(service) {
        this.service = service;
        this.accept = new EventEmitter();
    }
    ngOnInit() {
        if (!this.service.check('userCookieConsent', this.storageMethod)) {
            this.isVisible = true;
        }
    }
    ngOnDestroy() {
        this.accept.complete();
    }
    ngOnChanges(changes) {
        if (changes.disclaimerRoute &&
            changes.disclaimerRoute.currentValue &&
            changes.disclaimerRoute.currentValue.indexOf('http') === 0) {
            this.isExternal = true;
        }
    }
    closeBanner() {
        this.isVisible = false;
        this.accept.emit();
        this.service.set('userCookieConsent', 'true', this.storageMethod);
    }
}
CookieAdvisoryBannerComponent.ɵfac = function CookieAdvisoryBannerComponent_Factory(t) { return new (t || CookieAdvisoryBannerComponent)(ɵngcc0.ɵɵdirectiveInject(StorageService)); };
CookieAdvisoryBannerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CookieAdvisoryBannerComponent, selectors: [["ui-cookie-advisory-banner"]], inputs: { storageMethod: "storageMethod", disclaimerRoute: "disclaimerRoute" }, outputs: { accept: "accept" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "routerLink", 4, "ngIf", "ngIfElse"], ["external", ""], ["type", "button", 1, "btn", "btn-primary", "btn-sm", 3, "click"], [3, "routerLink"], ["target", "_blank", 3, "href"]], template: function CookieAdvisoryBannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CookieAdvisoryBannerComponent_div_0_Template, 14, 8, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isVisible);
    } }, directives: [ɵngcc1.NgIf, ɵngcc5.RouterLinkWithHref], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
CookieAdvisoryBannerComponent.ctorParameters = () => [
    { type: StorageService }
];
CookieAdvisoryBannerComponent.propDecorators = {
    storageMethod: [{ type: Input }],
    disclaimerRoute: [{ type: Input }],
    accept: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CookieAdvisoryBannerComponent, [{
        type: Component,
        args: [{
                selector: 'ui-cookie-advisory-banner',
                template: "<div *ngIf=\"isVisible\">\n  <div>\n    <p>{{ 'ui.cookie.cookie_message' | translate }}\n      <span>\n        <a *ngIf=\"!isExternal; else external\" [routerLink]=\"[disclaimerRoute]\">{{ 'ui.cookie.learn_more' | translate }}</a>\n        <ng-template #external>\n          <a [href]=\"disclaimerRoute\" target=\"_blank\">{{ 'ui.cookie.learn_more' | translate }}</a>\n        </ng-template>\n      </span>.\n    </p>\n  </div>\n  <div>\n    <button type=\"button\" class=\"btn btn-primary btn-sm\" (click)=\"closeBanner()\">\n      {{ 'ui.cookie_banner.accept' | translate }}\n    </button>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: StorageService }]; }, { accept: [{
            type: Output
        }], storageMethod: [{
            type: Input
        }], disclaimerRoute: [{
            type: Input
        }] }); })();

class CookieExplicitBannerComponent {
    constructor(consentService, router) {
        this.consentService = consentService;
        this.router = router;
        this.storageMethod = StorageMethod.Cookie;
        this.action = new EventEmitter();
    }
    ngOnInit() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd && this.consentService.get('userCookieConsent') !== 'true') {
                this.isVisible = true;
            }
        });
        if (!this.consentService.check('userCookieConsent', this.storageMethod)) {
            this.consentService.set('userCookieConsent', 'false', this.storageMethod);
        }
        this.isVisible = this.consentService.get('userCookieConsent', this.storageMethod) !== 'true';
    }
    ngOnDestroy() {
        this.action.complete();
    }
    accept() {
        this.isVisible = false;
        this.action.emit(true);
        this.consentService.set('userCookieConsent', 'true', this.storageMethod);
    }
    decline() {
        this.isVisible = false;
        this.action.emit(false);
        this.consentService.set('userCookieConsent', 'false', this.storageMethod);
    }
}
CookieExplicitBannerComponent.ɵfac = function CookieExplicitBannerComponent_Factory(t) { return new (t || CookieExplicitBannerComponent)(ɵngcc0.ɵɵdirectiveInject(StorageService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.Router)); };
CookieExplicitBannerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CookieExplicitBannerComponent, selectors: [["ui-cookie-explicit-banner"]], inputs: { storageMethod: "storageMethod", disclaimerRoute: "disclaimerRoute" }, outputs: { action: "action" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "routerLink"], ["type", "button", 1, "btn", "btn-primary", "btn-sm", 3, "click"]], template: function CookieExplicitBannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CookieExplicitBannerComponent_div_0_Template, 17, 15, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.isVisible);
    } }, directives: [ɵngcc1.NgIf, ɵngcc5.RouterLinkWithHref], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
CookieExplicitBannerComponent.ctorParameters = () => [
    { type: StorageService },
    { type: Router }
];
CookieExplicitBannerComponent.propDecorators = {
    storageMethod: [{ type: Input }],
    disclaimerRoute: [{ type: Input }],
    action: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CookieExplicitBannerComponent, [{
        type: Component,
        args: [{
                selector: 'ui-cookie-explicit-banner',
                template: "<div *ngIf=\"isVisible\">\n  <div>\n    <p>{{ 'ui.cookie.cookie_message' | translate }}\n      <span><a [routerLink]=\"[disclaimerRoute]\">{{ 'ui.cookie.learn_more' | translate }}</a></span>.\n    </p>\n  </div>\n  <div>\n    <button type=\"button\" class=\"btn btn-primary btn-sm\" (click)=\"accept()\">\n      {{ 'ui.cookie_banner.accept' | translate }}\n    </button>\n    <button type=\"button\" class=\"btn btn-primary btn-sm\" (click)=\"decline()\">\n      {{ 'ui.cookie_banner.decline' | translate }}\n    </button>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: StorageService }, { type: ɵngcc5.Router }]; }, { storageMethod: [{
            type: Input
        }], action: [{
            type: Output
        }], disclaimerRoute: [{
            type: Input
        }] }); })();

class CookieStatementComponent {
    constructor() { }
    ngOnInit() {
    }
}
CookieStatementComponent.ɵfac = function CookieStatementComponent_Factory(t) { return new (t || CookieStatementComponent)(); };
CookieStatementComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CookieStatementComponent, selectors: [["ui-cookie-statement"]], decls: 6, vars: 6, consts: [[1, "container"], [3, "innerHTML"]], template: function CookieStatementComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "h1");
        ɵngcc0.ɵɵtext(2);
        ɵngcc0.ɵɵpipe(3, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(4, "p", 1);
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(3, 2, "ui.cookie_statement.title"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(5, 4, "ui.cookie_statement.statement"), ɵngcc0.ɵɵsanitizeHtml);
    } }, pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
CookieStatementComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CookieStatementComponent, [{
        type: Component,
        args: [{
                selector: 'ui-cookie-statement',
                template: "<div class=\"container\">\n  <h1>{{ 'ui.cookie_statement.title' | translate }}</h1>\n  <p [innerHTML]=\"'ui.cookie_statement.statement' | translate\"></p>\n</div>"
            }]
    }], function () { return []; }, null); })();

class PopoverDirective {
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
        this.showToggle = false;
    }
    onClick() {
        this.showToggle = !this.showToggle;
        if (this.showToggle) {
            this.showPopover();
        }
        else {
            this.hidePopover();
        }
    }
    onBlur(evt) {
        if (evt.relatedTarget && this.popover && this.popover.contains(evt.relatedTarget)) {
            return;
        }
        if (this.showToggle) {
            this.showToggle = !this.showToggle;
            this.hidePopover();
        }
    }
    showPopover() {
        this.createPopover();
        setTimeout(() => {
            if (!this.popper) {
                this.popper = new Popper(this.el.nativeElement, this.popover, {
                    placement: this.placement ? this.placement : 'top',
                    modifiers: {
                        arrow: {
                            element: '.arrow'
                        }
                    }
                });
                this.renderer.removeClass(this.popover, 'fade');
                this.renderer.addClass(this.popover, 'show');
            }
            else {
                this.renderer.removeClass(this.popover, 'fade');
                this.renderer.addClass(this.popover, 'show');
            }
        });
    }
    hidePopover() {
        if (this.popper) {
            this.renderer.removeClass(this.popover, 'show');
            this.renderer.addClass(this.popover, 'fade');
        }
        setTimeout(() => {
            this.destroyPopover();
        });
    }
    destroyPopover() {
        if (this.popper) {
            this.popper.destroy();
            this.popper = undefined;
            const container = this.container && this.container.nativeElement ? this.container.nativeElement : this.container;
            this.renderer.removeChild(container ? container : document.body, this.popover);
        }
    }
    createPopover() {
        const container = this.container && this.container.nativeElement ? this.container.nativeElement : this.container;
        this.popover = this.renderer.createElement('div');
        this.popover.classList.add('if-popover-container');
        this.popover.classList.add('popover');
        this.popover.classList.add('fade');
        this.popover.classList.add(`bs-popover-${this.placement ? this.placement : 'top'}`);
        this.updateDescription();
        this.renderer.appendChild(container ? container : document.body, this.popover);
        if (!this.el.nativeElement.getAttribute('tabindex')) {
            this.renderer.setAttribute(this.el.nativeElement, 'tabindex', '-1');
        }
        this.renderer.setAttribute(this.popover, 'tabindex', '-1');
        this.popover.addEventListener('focusout', (evt) => { this.onBlur(evt); });
    }
    ngOnDestroy() {
        this.destroyPopover();
    }
    updateDescription() {
        const t = this.title ? `<div class="popover-header">${this.title}</div>` : '';
        const d = this.description ? `<div class="popover-body">${this.description}</div>` : '';
        this.popover.innerHTML = `<div class="arrow"></div>${t}${d}`;
    }
}
PopoverDirective.ɵfac = function PopoverDirective_Factory(t) { return new (t || PopoverDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
PopoverDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: PopoverDirective, selectors: [["", "uiPopover", ""]], hostBindings: function PopoverDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("click", function PopoverDirective_click_HostBindingHandler() { return ctx.onClick(); })("blur", function PopoverDirective_blur_HostBindingHandler($event) { return ctx.onBlur($event); });
    } }, inputs: { title: ["popoverTitle", "title"], description: ["popoverDescription", "description"], placement: "placement", container: ["popoverContainer", "container"] } });
PopoverDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
PopoverDirective.propDecorators = {
    title: [{ type: Input, args: ['popoverTitle',] }],
    description: [{ type: Input, args: ['popoverDescription',] }],
    placement: [{ type: Input }],
    container: [{ type: Input, args: ['popoverContainer',] }],
    onClick: [{ type: HostListener, args: ['click',] }],
    onBlur: [{ type: HostListener, args: ['blur', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PopoverDirective, [{
        type: Directive,
        args: [{
                selector: '[uiPopover]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { onClick: [{
            type: HostListener,
            args: ['click']
        }], onBlur: [{
            type: HostListener,
            args: ['blur', ['$event']]
        }], title: [{
            type: Input,
            args: ['popoverTitle']
        }], description: [{
            type: Input,
            args: ['popoverDescription']
        }], placement: [{
            type: Input
        }], container: [{
            type: Input,
            args: ['popoverContainer']
        }] }); })();

class FooterComponent {
    constructor() {
        this.year = (new Date()).getFullYear().toString();
        this.footerParams = {
            year: this.year,
            copyrightHolder: this.copyrightHolder
        };
    }
    ngOnChanges(changes) {
        this.footerParams = {
            year: changes.year ? changes.year.currentValue : this.year,
            copyrightHolder: changes.copyrightHolder ? changes.copyrightHolder.currentValue : this.copyrightHolder
        };
    }
}
FooterComponent.ɵfac = function FooterComponent_Factory(t) { return new (t || FooterComponent)(); };
FooterComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FooterComponent, selectors: [["ui-footer"]], contentQueries: function FooterComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c17, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.customFooterContent = _t.first);
    } }, inputs: { year: "year", copyrightHolder: "copyrightHolder" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 8, vars: 3, consts: [[1, "logo"], [4, "ngIf"], ["role", "region", "aria-label", "copyright", 1, "p-5"], [4, "ngIf", "ngIfElse"], ["noCompany", ""], [4, "ngTemplateOutlet"]], template: function FooterComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "footer");
        ɵngcc0.ɵɵelementStart(1, "section");
        ɵngcc0.ɵɵelement(2, "div", 0);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(3, FooterComponent_ng_container_3_Template, 2, 1, "ng-container", 1);
        ɵngcc0.ɵɵelementStart(4, "div", 2);
        ɵngcc0.ɵɵtemplate(5, FooterComponent_ng_container_5_Template, 3, 4, "ng-container", 3);
        ɵngcc0.ɵɵtemplate(6, FooterComponent_ng_template_6_Template, 2, 4, "ng-template", null, 4, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r2 = ɵngcc0.ɵɵreference(7);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.customFooterContent);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.copyrightHolder)("ngIfElse", _r2);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
FooterComponent.ctorParameters = () => [];
FooterComponent.propDecorators = {
    customFooterContent: [{ type: ContentChild, args: ['customFooterContent',] }],
    year: [{ type: Input }],
    copyrightHolder: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FooterComponent, [{
        type: Component,
        args: [{
                selector: 'ui-footer',
                template: `<footer>
                    <section>
                        <div class="logo"></div>
                    </section>
                    <ng-container *ngIf="customFooterContent">
                      <ng-container *ngTemplateOutlet="customFooterContent"> </ng-container>
                    </ng-container>
                    <div role="region" aria-label="copyright" class="p-5">
                        <ng-container *ngIf="copyrightHolder; else noCompany">{{'ui.footer.copyright'| translate: footerParams}}</ng-container>
                        <ng-template #noCompany>{{'ui.copyright_no_company' | translate: footerParams}}</ng-template>
                    </div>
                </footer>`
            }]
    }], function () { return []; }, { year: [{
            type: Input
        }], customFooterContent: [{
            type: ContentChild,
            args: ['customFooterContent']
        }], copyrightHolder: [{
            type: Input
        }] }); })();

class SelectComponent extends FieldComponent {
    constructor() {
        super(...arguments);
        this.change = new EventEmitter();
        this.defaultUpdateOnOptions = {
            updateOnType: "change" /* Change */,
            fieldType: "select" /* Select */
        };
    }
    changeOccurred($event, field) {
        field.value = $event.currentTarget.value;
        if (field.options) {
            field.options.forEach((opt) => {
                opt.selected = field.value === opt.value;
            });
        }
        $event.preventDefault();
        $event.stopPropagation();
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(field);
    }
    ngOnInit() {
        if (this.field) {
            this.setup();
        }
    }
    ngOnChanges(changes) {
        if (changes['field']) {
            super.updateOriginalValue();
        }
        if (changes['field'] && !changes['field'].firstChange) {
            this.setup();
        }
    }
    setup() {
        if (this.field.nodeType === 'select') {
            let isSelected = false;
            if (this.field.options && this.field.options.length) {
                this.field.options.forEach((option, index) => {
                    option.ifId = this.field.extraAttributes && this.field.extraAttributes.ifId ? this.field.extraAttributes.ifId + '-option-' + index : 'option-' + index;
                    if (option.selected) {
                        this.field.value = option.value;
                        isSelected = true;
                    }
                });
                if (!isSelected) {
                    this.field.value = this.field.options[0].value;
                    this.field.options[0].selected = true;
                }
            }
        }
        if (this.field.value && this.field.value !== '-1' && this.field.value !== '-1000') {
            this.FormCtrl.setValue(this.field.value);
        }
        else {
            this.FormCtrl.setValue('');
        }
        this.checkForError();
    }
    trackByFn(index, option) {
        return option.value;
    }
    ngOnDestroy() {
        this.change.complete();
    }
}
SelectComponent.ɵfac = /*@__PURE__*/ function () { let ɵSelectComponent_BaseFactory; return function SelectComponent_Factory(t) { return (ɵSelectComponent_BaseFactory || (ɵSelectComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(SelectComponent)))(t || SelectComponent); }; }();
SelectComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SelectComponent, selectors: [["ui-select"]], inputs: { field: "field" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[3, "field", "formGroup", "form", "formCtrl", "hasError", "updateOn", 4, "ngIf"], [3, "field", "formGroup", "form", "formCtrl", "hasError", "updateOn"], ["template", ""], ["ifPII", "", "class", "form-control", 3, "id", "required", "formControlName", "ngClass", "change", "blur", 4, "ngIf"], ["ifPII", "", 1, "form-control", 3, "id", "required", "formControlName", "ngClass", "change", "blur"], [3, "value", "selected", "disabled", 4, "ngFor", "ngForOf", "ngForTrackBy"], [3, "value", "selected", "disabled"]], template: function SelectComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, SelectComponent_ui_form_field_0_Template, 3, 6, "ui-form-field", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.field);
    } }, directives: function () { return [ɵngcc1.NgIf, FormFieldComponent, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.SelectControlValueAccessor, ɵngcc2.IfPersonallyIdentifiableInformationDirective, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc4.NgSelectOption, ɵngcc4.ɵNgSelectMultipleOption]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, encapsulation: 2 });
SelectComponent.propDecorators = {
    field: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectComponent, [{
        type: Component,
        args: [{
                selector: 'ui-select',
                template: "<ui-form-field *ngIf=\"field\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\" [hasError]=\"hasError\" [updateOn]=\"updateOn\">\n  <ng-template #template let-field=\"field\">\n    <select ifPII *ngIf=\"field && field.nodeType === 'select'\" [attr.aria-invalid]=\"hasError\" [id]=\"field.id\" class=\"form-control\" [required]=\"field.required\"\n    [formControlName]=\"field.name\" (change)=\"changeOccurred($event, field)\" (blur)=\"checkForError()\"\n      [attr.data-if-id]=\"field.extraAttributes? field.extraAttributes.ifId: undefined\"\n       [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\" [attr.aria-describedby]=\"ariaDescribedBy\" [attr.aria-errormessage]=\"ariaErrorMessage\">\n      <option *ngFor=\"let option of field.options; trackBy: trackByFn\" [value]=\"option.value | translate\" [selected]=\"option.selected\" [attr.data-if-id]=\"option.ifId \" [disabled]=\"option.disabled\">{{option.text | translate}}</option>\n    </select>\n  </ng-template>\n</ui-form-field>\n"
            }]
    }], null, { change: [{
            type: Output
        }], field: [{
            type: Input
        }] }); })();

class HiddensComponent {
    constructor() { }
    ngOnInit() {
        this.setupHiddens(this.fields);
    }
    ngOnDestroy() {
        if (this.fields) {
            this.fields.forEach((field) => {
                if (this.form.contains(field.name)) {
                    this.form.removeControl(field.name);
                }
            });
        }
    }
    ngOnChanges(changes) {
        if (changes.fields) {
            if (changes.fields.previousValue && Array.isArray(changes.fields.previousValue)) {
                changes.fields.previousValue.forEach((field) => {
                    if (this.form.contains(field.name)) {
                        this.form.removeControl(field.name);
                    }
                });
            }
            this.setupHiddens(changes.fields.currentValue);
        }
    }
    setupHiddens(fields) {
        if (fields) {
            fields.forEach((field) => {
                if (!this.form.contains(field.name)) {
                    this.form.addControl(field.name, new FormControl());
                }
                const control = this.form.controls[field.name];
                if (field.required) {
                    control.setValidators(Validators.required);
                }
                control.setValue(field.value ? field.value : '');
                if (field.disabled) {
                    control.disable();
                }
            });
        }
    }
}
HiddensComponent.ɵfac = function HiddensComponent_Factory(t) { return new (t || HiddensComponent)(); };
HiddensComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HiddensComponent, selectors: [["ui-hiddens"]], inputs: { fields: "fields", form: "form" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 2, consts: [[3, "formGroup"], ["ifPII", "", "type", "hidden", 3, "id", "formControlName", 4, "ngFor", "ngForOf"], ["ifPII", "", "type", "hidden", 3, "id", "formControlName"]], template: function HiddensComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, HiddensComponent_input_1_Template, 1, 2, "input", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.fields);
    } }, directives: [ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc1.NgForOf, ɵngcc4.DefaultValueAccessor, ɵngcc2.IfPersonallyIdentifiableInformationDirective, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName], encapsulation: 2 });
HiddensComponent.ctorParameters = () => [];
HiddensComponent.propDecorators = {
    fields: [{ type: Input }],
    form: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HiddensComponent, [{
        type: Component,
        args: [{
                selector: 'ui-hiddens',
                template: "<div [formGroup]=\"form\">\n  <input ifPII type=\"hidden\" *ngFor=\"let field of fields\" [id]=\"field.id\" [formControlName]=\"field.name\" />\n</div>\n"
            }]
    }], function () { return []; }, { fields: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();

class RadioComponent extends FieldComponent {
    constructor() {
        super(...arguments);
        this.change = new EventEmitter();
        this.defaultUpdateOnOptions = {
            updateOnType: "change" /* Change */,
            fieldType: "radio" /* Radio */
        };
    }
    ngOnDestroy() {
        this.change.complete();
    }
    changeOccurred($event, field) {
        $event.preventDefault();
        $event.stopPropagation();
        field.checked = $event.target.checked;
        if (field.checked) {
            // bugfix: Edge is not automatically updating the state of the form
            this.FormCtrl.setValue($event.target.value);
        }
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(field);
    }
    syncFieldToForm() {
        if (this.field.checked) {
            this.FormCtrl.setValue(this.field.value);
        }
    }
}
RadioComponent.ɵfac = /*@__PURE__*/ function () { let ɵRadioComponent_BaseFactory; return function RadioComponent_Factory(t) { return (ɵRadioComponent_BaseFactory || (ɵRadioComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(RadioComponent)))(t || RadioComponent); }; }();
RadioComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioComponent, selectors: [["ui-radio"]], inputs: { field: "field" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "custom-control custom-radio", 3, "formGroup", 4, "ngIf"], [1, "custom-control", "custom-radio", 3, "formGroup"], ["ifPII", "", 1, "custom-control-input", 3, "formControlName", "type", "name", "id", "value", "checked", "change"], [1, "custom-control-label", 3, "for", "ngClass", "innerHTML"], ["class", "badge badge-danger", 4, "ngIf"], [1, "badge", "badge-danger"]], template: function RadioComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, RadioComponent_div_0_Template, 5, 17, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", (ctx.field == null ? null : ctx.field.type) === "radio");
    } }, directives: [ɵngcc1.NgIf, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.DefaultValueAccessor, ɵngcc2.IfPersonallyIdentifiableInformationDirective, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, ɵngcc1.NgClass], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
RadioComponent.propDecorators = {
    field: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioComponent, [{
        type: Component,
        args: [{
                selector: 'ui-radio',
                template: `
  <div class="custom-control custom-radio" *ngIf="field?.type === 'radio'" [formGroup]="form">
  <input
    class="custom-control-input"
    (change)="changeOccurred($event, field)"
    [formControlName]="field.name"
    [type]="field.type"
    [name]="field.name"
    [id]="field.id"
    [value]="field?.value"
    [checked]="field.checked"
    [attr.data-if-id]="field.extraAttributes?.ifId"
    ifPII />
  <label [for]="field.id" class="custom-control-label"
    [ngClass]="{error: hasError, required : field.required}" [innerHTML]="field.label | translate"></label>
  <div *ngIf="hasError" class="badge badge-danger">{{errorMessage}}</div>
</div>
  `
            }]
    }], null, { change: [{
            type: Output
        }], field: [{
            type: Input
        }] }); })();

class CheckRadioComponent {
    constructor() {
        this.change = new EventEmitter();
    }
    changeOccurred($event) {
        this.change.emit($event);
    }
}
CheckRadioComponent.ɵfac = function CheckRadioComponent_Factory(t) { return new (t || CheckRadioComponent)(); };
CheckRadioComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CheckRadioComponent, selectors: [["ui-checkbox-radio"]], inputs: { form: "form", field: "field", validators: "validators", asyncValidators: "asyncValidators" }, outputs: { change: "change" }, decls: 2, vars: 2, consts: [[4, "ngIf"], [3, "field", "form", "validators", "asyncValidators", "change"]], template: function CheckRadioComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CheckRadioComponent_ng_container_0_Template, 2, 4, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, CheckRadioComponent_ng_container_1_Template, 2, 4, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", (ctx.field == null ? null : ctx.field.type) === "checkbox");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.field == null ? null : ctx.field.type) === "radio");
    } }, directives: function () { return [ɵngcc1.NgIf, CheckboxComponent, RadioComponent]; }, encapsulation: 2 });
CheckRadioComponent.propDecorators = {
    form: [{ type: Input }],
    field: [{ type: Input }],
    validators: [{ type: Input }],
    asyncValidators: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckRadioComponent, [{
        type: Component,
        args: [{
                selector: 'ui-checkbox-radio',
                template: "<ng-container *ngIf=\"field?.type === 'checkbox'\">\n  <ui-checkbox [field]=\"field\" [form]=\"form\" (change)=\"changeOccurred($event)\" [validators]=\"validators\" [asyncValidators]=\"asyncValidators\"></ui-checkbox>\n</ng-container>\n\n<ng-container *ngIf=\"field?.type === 'radio'\">\n  <ui-radio [field]=\"field\" [form]=\"form\" (change)=\"changeOccurred($event)\" [validators]=\"validators\" [asyncValidators]=\"asyncValidators\"></ui-radio>\n</ng-container>"
            }]
    }], function () { return []; }, { change: [{
            type: Output
        }], form: [{
            type: Input
        }], field: [{
            type: Input
        }], validators: [{
            type: Input
        }], asyncValidators: [{
            type: Input
        }] }); })();

class TextAreaComponent extends FieldComponent {
    constructor() {
        super(...arguments);
        this.change = new EventEmitter();
    }
    ngOnInit() {
        this.syncFieldToForm();
        this.checkForError();
        if (this.field.disabled) {
            this.FormCtrl.disable();
        }
    }
    ngOnDestroy() {
        this.change.complete();
    }
    syncFieldToForm() {
        const val = this.field.html || this.field.value; // for backwards compatibility
        if (val) {
            this.FormCtrl.setValue(val);
        }
        else {
            this.FormCtrl.setValue('');
        }
    }
    changeOccurred($event, field) {
        field.value = $event.currentTarget.value;
        field.html = field.value;
        this.syncFieldToForm();
        $event.preventDefault();
        $event.stopPropagation();
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(field);
    }
}
TextAreaComponent.ɵfac = /*@__PURE__*/ function () { let ɵTextAreaComponent_BaseFactory; return function TextAreaComponent_Factory(t) { return (ɵTextAreaComponent_BaseFactory || (ɵTextAreaComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(TextAreaComponent)))(t || TextAreaComponent); }; }();
TextAreaComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TextAreaComponent, selectors: [["ui-textarea"]], inputs: { field: "field" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "field", "formGroup", "form", "formCtrl", "hasError", "updateOn", 4, "ngIf"], [3, "field", "formGroup", "form", "formCtrl", "hasError", "updateOn"], ["template", ""], ["ifPII", "", 1, "form-control", 3, "id", "formControlName", "name", "required", "ngClass", "maxlength", "readonly", "input", "blur"]], template: function TextAreaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TextAreaComponent_ui_form_field_0_Template, 3, 6, "ui-form-field", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.field);
    } }, directives: function () { return [ɵngcc1.NgIf, FormFieldComponent, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.DefaultValueAccessor, ɵngcc2.IfPersonallyIdentifiableInformationDirective, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, ɵngcc4.RequiredValidator, ɵngcc1.NgClass, ɵngcc4.MaxLengthValidator]; }, encapsulation: 2 });
TextAreaComponent.propDecorators = {
    field: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TextAreaComponent, [{
        type: Component,
        args: [{
                selector: 'ui-textarea',
                template: "<ui-form-field *ngIf=\"field\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\" [hasError]=\"hasError\" [updateOn]=\"updateOn\">\n  <ng-template #template let-field=\"field\">\n    <textarea ifPII class=\"form-control\" [id]=\"field.id\" [formControlName]=\"field.name\" [name]=\"field.name\" (input)=\"changeOccurred($event, field)\" [required]=\"field.required\"\n      [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\" (blur)=\"checkForError()\" [maxlength]=\"field.maxlength\" [attr.data-if-id]=\"field.extraAttributes?.ifId\"\n      [attr.aria-describedby]=\"ariaDescribedBy\" [attr.aria-errormessage]=\"ariaErrorMessage\" [attr.aria-invalid]=\"hasError\" [readonly]=\"field.readonly\">\n          </textarea>\n  </ng-template>\n</ui-form-field>\n"
            }]
    }], null, { change: [{
            type: Output
        }], field: [{
            type: Input
        }] }); })();

class SelectButtonsComponent extends FieldComponent {
    constructor() {
        super(...arguments);
        this.change = new EventEmitter();
    }
    ngAfterViewInit() {
        setTimeout(() => {
            var _a, _b;
            const label = (_b = (_a = this.selectFieldset) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.querySelector('label');
            if (label) {
                label.setAttribute('aria-hidden', 'true');
            }
        });
    }
    ngOnDestroy() {
        this.change.complete();
        if (this.form.contains(this.field.name)) {
            this.form.removeControl(this.field.name);
        }
    }
    ngOnInit() {
        if (this.field) {
            let isSelected = false;
            this.field.options.forEach((option, index) => {
                option.ifId = this.field.extraAttributes && this.field.extraAttributes.ifId ? this.field.extraAttributes.ifId + '-option-' + index : 'option-' + index;
                if (option.selected) {
                    this.field.value = option.value;
                    isSelected = true;
                }
            });
            if (!isSelected) {
                this.FormCtrl.setValue('');
            }
            if (this.field.disabled) {
                this.FormCtrl.disable();
            }
            this.FormCtrl.setValue(this.field.value);
            this.checkForError();
        }
    }
    updateNextChange(update) {
        this.updateOnNextChange = update;
    }
    updateResponseField(value) {
        if (this.updateOnNextChange) {
            this.FormCtrl.setValue(value);
            this.field.value = value;
            super.onChangePreProcessor({ src: this.field, args: { form: this.form } });
            this.change.emit(this.field);
        }
        this.checkForError();
        this.updateOnNextChange = true;
    }
    checkRequired($event) {
        if ($event.currentTarget.contains($event.relatedTarget)) {
            return;
        }
        if (this.field.required && !this.field.value) {
            this.hasError = true;
        }
    }
}
SelectButtonsComponent.ɵfac = /*@__PURE__*/ function () { let ɵSelectButtonsComponent_BaseFactory; return function SelectButtonsComponent_Factory(t) { return (ɵSelectButtonsComponent_BaseFactory || (ɵSelectButtonsComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(SelectButtonsComponent)))(t || SelectButtonsComponent); }; }();
SelectButtonsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SelectButtonsComponent, selectors: [["ui-select-buttons"]], contentQueries: function SelectButtonsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c19, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.customButtonLabel = _t.first);
    } }, viewQuery: function SelectButtonsComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c20, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.selectFieldset = _t.first);
    } }, inputs: { field: "field", style: "style" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 6, vars: 2, consts: [["selectFieldset", ""], [1, "sr-only", 3, "innerHTML"], [3, "field", "formGroup", "form", "formCtrl", "hasError", "updateOn", 4, "ngIf"], ["defaultButtonLabel", ""], [3, "field", "formGroup", "form", "formCtrl", "hasError", "updateOn"], ["template", ""], ["role", "radio-group", "uiArrowModalDialog", "", "tabindex", "-1", 1, "d-flex", 3, "focusout"], [4, "ngFor", "ngForOf"], [3, "id", "name", "active", "label", "value", "updateField", "updateOnNextChange"], ["fieldLabel", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function SelectButtonsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "fieldset", null, 0);
        ɵngcc0.ɵɵelement(2, "legend", 1);
        ɵngcc0.ɵɵtemplate(3, SelectButtonsComponent_ui_form_field_3_Template, 3, 6, "ui-form-field", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, SelectButtonsComponent_ng_template_4_Template, 3, 3, "ng-template", null, 3, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("innerHTML", ctx.field.label, ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.field);
    } }, directives: function () { return [ɵngcc1.NgIf, FormFieldComponent, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ArrowModalDialogDirective, ɵngcc1.NgForOf, RadioButtonComponent, ɵngcc1.NgTemplateOutlet]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, encapsulation: 2 });
SelectButtonsComponent.propDecorators = {
    customButtonLabel: [{ type: ContentChild, args: ['customButtonLabel',] }],
    field: [{ type: Input }],
    change: [{ type: Output }],
    style: [{ type: Input }],
    selectFieldset: [{ type: ViewChild, args: ['selectFieldset',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SelectButtonsComponent, [{
        type: Component,
        args: [{
                selector: 'ui-select-buttons',
                template: "<fieldset #selectFieldset>\n  <legend class=\"sr-only\" [innerHTML]=\"field.label\"></legend> \n  <ui-form-field *ngIf=\"field\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\"\n    [hasError]=\"hasError\" [updateOn]=\"updateOn\">\n\n    <ng-template #template let-field=\"field\">\n\n      <div class=\"d-flex\" role=\"radio-group\" uiArrowModalDialog [class.ng-invalid]=\"!field.value\" tabindex=\"-1\"\n        (focusout)=\"checkRequired($event)\">\n\n        <ng-container *ngFor=\"let option of field.options; index as idx\">\n          <ui-radio-button (updateField)=\"updateResponseField($event)\" (updateOnNextChange)=\"updateNextChange($event)\"\n            [id]=\"field.id + option.index\" [name]=\"field.name\" [active]=\"option.value === field.value\"\n            [label]=\"option.text\" [value]=\"option.value\" [style]='style && style[idx]? style[idx] : \"\"'>\n            <ng-template #fieldLabel>\n              <ng-container\n                *ngTemplateOutlet=\"customButtonLabel? customButtonLabel : defaultButtonLabel; context: {'message': option.text, 'idx': idx}\">\n              </ng-container>\n            </ng-template>\n          </ui-radio-button>\n        </ng-container>\n\n      </div>\n    </ng-template>\n  </ui-form-field>\n</fieldset>\n\n<ng-template #defaultButtonLabel let-message=\"message\">\n  <span>{{ message | translate }}</span>\n</ng-template>\n"
            }]
    }], null, { change: [{
            type: Output
        }], customButtonLabel: [{
            type: ContentChild,
            args: ['customButtonLabel']
        }], field: [{
            type: Input
        }], style: [{
            type: Input
        }], selectFieldset: [{
            type: ViewChild,
            args: ['selectFieldset']
        }] }); })();

class BreadcrumbsService {
    constructor() {
        this.breadCrumbSubject = new BehaviorSubject([]);
        this.crumbs = this.breadCrumbSubject.asObservable();
    }
    set(crumbs) {
        this.breadCrumbSubject.next(crumbs);
    }
    clear() {
        this.breadCrumbSubject.next(null);
    }
}
BreadcrumbsService.ɵfac = function BreadcrumbsService_Factory(t) { return new (t || BreadcrumbsService)(); };
BreadcrumbsService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BreadcrumbsService, factory: BreadcrumbsService.ɵfac });
BreadcrumbsService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadcrumbsService, [{
        type: Injectable
    }], function () { return []; }, null); })();
class BreadcrumbItem {
    constructor() {
        this.isActive = false;
        this.queryParamsHandling = null;
    }
}

class BreadcrumbsComponent {
    constructor(breadcrumbsService) {
        this.breadcrumbsService = breadcrumbsService;
    }
    ngOnInit() {
        this.breadcrumbSubscription = this.breadcrumbsService.crumbs.subscribe(crumbs => {
            this.breadcrumbs = crumbs;
        });
    }
    ngOnDestroy() {
        if (this.breadcrumbSubscription) {
            this.breadcrumbSubscription.unsubscribe();
        }
    }
}
BreadcrumbsComponent.ɵfac = function BreadcrumbsComponent_Factory(t) { return new (t || BreadcrumbsComponent)(ɵngcc0.ɵɵdirectiveInject(BreadcrumbsService)); };
BreadcrumbsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BreadcrumbsComponent, selectors: [["ui-breadcrumbs"]], decls: 1, vars: 1, consts: [[4, "ngIf"], ["class", "breadcrumb container py-2 mb-0", 4, "ngIf"], [1, "breadcrumb", "container", "py-2", "mb-0"], ["class", "breadcrumb-item", 3, "active", 4, "ngFor", "ngForOf"], [1, "breadcrumb-item"], [3, "routerLink", "queryParamsHandling", "queryParams", 4, "ngIf"], [3, "routerLink", "queryParamsHandling", "queryParams"], ["aria-hidden", "true", 3, "class", 4, "ngIf"], ["class", "sr-only", 4, "ngIf"], ["aria-hidden", "true"], [1, "sr-only"]], template: function BreadcrumbsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BreadcrumbsComponent_ng_container_0_Template, 4, 4, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.breadcrumbs == null ? null : ctx.breadcrumbs.length);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc5.RouterLinkWithHref], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
BreadcrumbsComponent.ctorParameters = () => [
    { type: BreadcrumbsService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BreadcrumbsComponent, [{
        type: Component,
        args: [{
                selector: 'ui-breadcrumbs',
                template: "<ng-container *ngIf=\"breadcrumbs?.length\">\n  <nav [attr.aria-label]=\"'ui.breadcrumbs.label' | translate\">\n    <div class=\"breadcrumb container py-2 mb-0\" *ngIf=\"breadcrumbs\">\n      <div *ngFor=\"let crumb of breadcrumbs\" class=\"breadcrumb-item\" [class.active]=\"crumb.isActive\">\n        <a *ngIf=\"!crumb.isActive\" [routerLink]=\"crumb.route\" [queryParamsHandling]=\"crumb.queryParamsHandling\" [queryParams]=\"crumb.queryParams\"><i *ngIf=\"crumb?.icon\" aria-hidden=\"true\" class=\"{{crumb.icon}}\" ></i>{{crumb.text | translate}} <span *ngIf=\"crumb?.screenReaderOnlyText\" class=\"sr-only\">{{crumb.screenReaderOnlyText | translate}}</span></a>\n        <span *ngIf=\"crumb.isActive\"><i class=\"{{crumb.icon}}\"></i>{{crumb.text | translate}}<span *ngIf=\"crumb?.screenReaderOnlyText\" class=\"sr-only\">{{crumb.screenReaderOnlyText | translate}}</span></span>\n      </div>\n    </div>\n  </nav>\n</ng-container>\n"
            }]
    }], function () { return [{ type: BreadcrumbsService }]; }, null); })();

class ButtonDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    ngDoCheck() {
        if (this.field) {
            if (!this.field.type) {
                this.field.type = 'button';
            }
            const btn = this.el.nativeElement;
            if (btn) {
                const changes = new Map();
                ButtonDirective.Properties.forEach(k => {
                    if (this.field[k] !== btn[k] && (this.field[k] || btn[k])) {
                        changes.set(k, this.field[k]);
                    }
                });
                if (changes.size) {
                    changes.forEach((value, key) => {
                        this.renderer.setProperty(btn, key, value);
                    });
                }
            }
        }
    }
}
ButtonDirective.ɵfac = function ButtonDirective_Factory(t) { return new (t || ButtonDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ButtonDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ButtonDirective, selectors: [["", "base-button", ""]], inputs: { field: "field" } });
ButtonDirective.Properties = ['id', 'name', 'required', 'disabled', 'type'];
ButtonDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
ButtonDirective.propDecorators = {
    field: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ButtonDirective, [{
        type: Directive,
        args: [{ selector: '[base-button]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { field: [{
            type: Input
        }] }); })();

class InputDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    ngDoCheck() {
        if (this.field) {
            if (!this.field.type) {
                this.field.type = 'text';
            }
            const input = this.el.nativeElement;
            if (input) {
                const propertyChanges = new Map();
                const attributeChanges = new Map();
                InputDirective.Properties.forEach(k => {
                    if (this.field[k] !== input[k] && (this.field[k] || input[k])) {
                        propertyChanges.set(k, this.field[k]);
                    }
                });
                InputDirective.Attributes.forEach(k => {
                    // type equality on purpose so maxlength of 255 equals "255"
                    // tslint:disable-next-line: triple-equals
                    if (this.field[k] != input.getAttribute(k) && (this.field[k] || input.getAttribute(k))) {
                        attributeChanges.set(k, this.field[k]);
                    }
                });
                if (propertyChanges.size) {
                    propertyChanges.forEach((value, key) => {
                        if (value === false || value === 'false') {
                            this.renderer.setProperty(input, key, null);
                        }
                        else {
                            this.renderer.setProperty(input, key, value || value === 0 ? value.toString() : '');
                        }
                    });
                }
                if (attributeChanges.size) {
                    attributeChanges.forEach((value, key) => {
                        if (value === false || value === 'false') {
                            this.renderer.removeAttribute(input, key);
                        }
                        else {
                            this.renderer.setAttribute(input, key, value || value === 0 ? value : '');
                        }
                    });
                }
            }
        }
    }
    ngOnChanges() {
        var _a;
        const input = this.el.nativeElement;
        if (((_a = this.field) === null || _a === void 0 ? void 0 : _a.type) !== 'file') {
            this.renderer.setProperty(input, 'value', this.field.value);
        }
    }
}
InputDirective.ɵfac = function InputDirective_Factory(t) { return new (t || InputDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
InputDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: InputDirective, selectors: [["", "base-input", ""]], inputs: { field: "field" }, features: [ɵngcc0.ɵɵNgOnChangesFeature] });
InputDirective.Attributes = ['id', 'name', 'type', 'maxlength', 'minlength',
    'autocomplete', 'autocapitalize', 'autocorrect', 'min', 'max'];
InputDirective.Properties = ['disabled', 'required', 'checked'];
InputDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
InputDirective.propDecorators = {
    field: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputDirective, [{
        type: Directive,
        args: [{ selector: '[base-input]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { field: [{
            type: Input
        }] }); })();

class FormControlComponent {
    constructor() {
        this.change = new EventEmitter();
    }
    ngOnChanges() {
        this.input = undefined;
        this.select = undefined;
        this.labelValue = undefined;
        const inputField = this.field;
        if (!inputField.nodeType) {
            this.labelValue = this.field;
            return;
        }
        if (inputField.nodeType === 'input') {
            this.input = this.field;
        }
        if (inputField.nodeType === 'select') {
            this.select = this.field;
        }
        if (inputField.nodeType === 'textarea') {
            this.textarea = this.field;
        }
    }
    ngOnDestroy() {
        this.change.complete();
    }
    changeOccurred(field) {
        this.change.emit(field);
    }
}
FormControlComponent.ɵfac = function FormControlComponent_Factory(t) { return new (t || FormControlComponent)(); };
FormControlComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormControlComponent, selectors: [["ui-form-control"]], inputs: { field: "field", form: "form" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "field", "form", "change", 4, "ngIf"], [3, "field", "form", 4, "ngIf"], [1, "form-field"], [1, "label"], [3, "field", "form", "change"], [3, "field", "form"]], template: function FormControlComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, FormControlComponent_ng_container_0_Template, 6, 5, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.field);
    } }, directives: function () { return [ɵngcc1.NgIf, InputComponent, InputDateComponent, CheckRadioComponent, SelectComponent, TextAreaComponent]; }, encapsulation: 2 });
FormControlComponent.ctorParameters = () => [];
FormControlComponent.propDecorators = {
    field: [{ type: Input }],
    form: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormControlComponent, [{
        type: Component,
        args: [{
                selector: 'ui-form-control',
                template: "<ng-container *ngIf=\"field\">\n  <span *ngIf=\"labelValue\">\n    <div class=\"form-field\">\n      <div class=\"label\">{{labelValue.label}}</div>\n      <div>{{labelValue.value}}</div>\n    </div>\n  </span>\n  <ng-container *ngIf=\"input && (input.type === 'text' || input.type === 'date')\">\n    <ui-input *ngIf=\"!input.dateFormat\" [field]=\"input\" [form]=\"form\" (change)=\"changeOccurred($event)\">\n    </ui-input>\n    <ui-input-date *ngIf=\"input.dateFormat\" [field]=\"input\" [form]=\"form\" (change)=\"changeOccurred($event)\"></ui-input-date>\n  </ng-container>\n  <ui-checkbox-radio *ngIf=\"input?.nodeType === 'input' && (input.type === 'checkbox' || input.type === 'radio')\"\n    [field]=\"input\" [form]=\"form\" (change)=\"changeOccurred($event)\"></ui-checkbox-radio>\n  <ui-select *ngIf=\"select\" [field]=\"select\" [form]=\"form\">\n  </ui-select>\n  <ui-textarea *ngIf=\"textarea\" [field]=\"textarea\" [form]=\"form\"></ui-textarea>\n</ng-container>"
            }]
    }], function () { return []; }, { change: [{
            type: Output
        }], field: [{
            type: Input
        }], form: [{
            type: Input
        }] }); })();

class ErrorBoxComponent {
    constructor(el) {
        this.el = el;
        this.invalidFieldSelector = 'app-root form .form-control.ng-invalid';
    }
    ngOnChanges(changes) {
        this.showError = changes.error && changes.error.currentValue && ((changes.error.currentValue.message && changes.error.currentValue.message.trim()) ||
            (changes.error.currentValue.title && changes.error.currentValue.title.trim()));
        if (this.showError) {
            setTimeout(() => {
                const nodes = document.querySelectorAll(this.invalidFieldSelector);
                if (nodes) {
                    this.firstInvalidField = nodes.item(0);
                }
                this.el.nativeElement.querySelector('[id="errorBody"]').focus();
            });
        }
    }
    focusFirstInvalid() {
        if (this.firstInvalidField) {
            this.firstInvalidField.focus();
        }
    }
}
ErrorBoxComponent.ɵfac = function ErrorBoxComponent_Factory(t) { return new (t || ErrorBoxComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ErrorBoxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ErrorBoxComponent, selectors: [["ui-error-box"]], inputs: { invalidFieldSelector: "invalidFieldSelector", error: "error" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 2, vars: 1, consts: [["role", "region", "aria-live", "assertive"], ["class", "row", 4, "ngIf"], [1, "row"], [1, "col-lg-12"], [1, "alert", "alert-danger"], ["id", "errorBody", "aria-atomic", "true", "tabindex", "-1"], ["class", "h5", 4, "ngIf"], [3, "innerHtml", 4, "ngIf"], ["class", "pt-3", 4, "ngIf"], [1, "h5"], [1, "fa", "fa-lg", "fa-warning"], [3, "innerHtml"], [1, "pt-3"], ["href", "javascript:void(0);", 3, "click"]], template: function ErrorBoxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, ErrorBoxComponent_div_1_Template, 7, 3, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showError);
    } }, directives: [ɵngcc1.NgIf], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
ErrorBoxComponent.ctorParameters = () => [
    { type: ElementRef }
];
ErrorBoxComponent.propDecorators = {
    error: [{ type: Input }],
    invalidFieldSelector: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ErrorBoxComponent, [{
        type: Component,
        args: [{
                selector: 'ui-error-box',
                template: `<div role="region" aria-live="assertive">
                <div class="row" *ngIf="showError">
                  <div class="col-lg-12">
                    <div class="alert alert-danger">
                      <div id="errorBody" aria-atomic="true" tabindex="-1">
                        <div class="h5" *ngIf="error?.title">
                          <i class="fa fa-lg fa-warning"></i>
                          <span [innerHtml]="error.title | translate"></span>
                        </div>
                        <p *ngIf="error?.message" [innerHtml]="error.message | translate"></p>
                      </div>
                      <div *ngIf="firstInvalidField" class="pt-3">
                      <a href="javascript:void(0);" (click)="focusFirstInvalid()">
                        {{'ui.error-box.go_to_label' | translate}}
                      </a>
                    </div>
                  </div>
                </div>
              </div>`
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { invalidFieldSelector: [{
            type: Input
        }], error: [{
            type: Input
        }] }); })();

class SROnlyLabelDirective {
    constructor(el) {
        this.el = el;
    }
    ngAfterViewInit() {
        const field = this.el.nativeElement;
        const labels = field.querySelectorAll('label, .label');
        for (let i = 0; i < labels.length; i++) {
            labels[i].classList.add('sr-only');
        }
    }
}
SROnlyLabelDirective.ɵfac = function SROnlyLabelDirective_Factory(t) { return new (t || SROnlyLabelDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
SROnlyLabelDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: SROnlyLabelDirective, selectors: [["", "sr-only-label", ""]] });
SROnlyLabelDirective.ctorParameters = () => [
    { type: ElementRef }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SROnlyLabelDirective, [{
        type: Directive,
        args: [{ selector: '[sr-only-label]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, null); })();

class FormFieldComponent {
    constructor() {
        this.updateOn = 'blur';
        this.busy = false;
    }
    ngAfterViewInit() {
        if (this.updateOn === 'blur') {
            const control = document.querySelector(`[id="${this.field.id}"]`);
            control === null || control === void 0 ? void 0 : control.addEventListener('focus', () => {
                if (this.formCtrl.invalid) { // avoid SR re-announcing error during edit
                    this.busy = true;
                }
            });
            control === null || control === void 0 ? void 0 : control.addEventListener('focusout', () => {
                this.busy = false;
            });
        }
    }
}
FormFieldComponent.ɵfac = function FormFieldComponent_Factory(t) { return new (t || FormFieldComponent)(); };
FormFieldComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: FormFieldComponent, selectors: [["ui-form-field"]], contentQueries: function FormFieldComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, TemplateRef, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.template = _t.first);
    } }, inputs: { updateOn: "updateOn", field: "field", formCtrl: "formCtrl", form: "form", hasError: "hasError" }, decls: 9, vars: 7, consts: [[1, "form-group", 3, "formGroup"], ["class", "form-group-inner", 4, "ngIf"], [1, "small", "form-control-feedback", "text-danger"], [3, "id", "innerHTML", 4, "ngIf"], ["class", "d-block small", "class", "form-text text-muted", 3, "id", "innerHTML", 4, "ngIf"], [1, "form-group-inner"], ["class", "form-control-label", 3, "for", "required", "innerHTML", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "form-control-label", 3, "for", "innerHTML"], [3, "id", "innerHTML"], [1, "form-text", "text-muted", 3, "id", "innerHTML"]], template: function FormFieldComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, FormFieldComponent_div_1_Template, 3, 5, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div");
        ɵngcc0.ɵɵelementStart(3, "div", 2);
        ɵngcc0.ɵɵtemplate(4, FormFieldComponent_span_4_Template, 2, 6, "span", 3);
        ɵngcc0.ɵɵtemplate(5, FormFieldComponent_span_5_Template, 2, 6, "span", 3);
        ɵngcc0.ɵɵtemplate(6, FormFieldComponent_span_6_Template, 2, 9, "span", 3);
        ɵngcc0.ɵɵtemplate(7, FormFieldComponent_span_7_Template, 2, 6, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(8, FormFieldComponent_span_8_Template, 2, 4, "span", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("formGroup", ctx.form);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.field);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasError && !(ctx.formCtrl == null ? null : ctx.formCtrl.errors == null ? null : ctx.formCtrl.errors.customErrorMsg) && ctx.field.required && !ctx.formCtrl.value);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasError && (ctx.formCtrl == null ? null : ctx.formCtrl.errors == null ? null : ctx.formCtrl.errors.customErrorMsg) && ctx.formCtrl.value);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasError && (ctx.formCtrl == null ? null : ctx.formCtrl.errors == null ? null : ctx.formCtrl.errors.minlength));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasError && (ctx.formCtrl == null ? null : ctx.formCtrl.errors == null ? null : ctx.formCtrl.errors.email));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.field.helperText);
    } }, directives: [ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
FormFieldComponent.ctorParameters = () => [];
FormFieldComponent.propDecorators = {
    template: [{ type: ContentChild, args: [TemplateRef,] }],
    field: [{ type: Input }],
    formCtrl: [{ type: Input }],
    form: [{ type: Input }],
    hasError: [{ type: Input }],
    updateOn: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormFieldComponent, [{
        type: Component,
        args: [{
                selector: 'ui-form-field',
                template: "<div class=\"form-group\" [formGroup]=\"form\">\n  <div class=\"form-group-inner\" *ngIf=\"field\">\n    <label class=\"form-control-label\" *ngIf=\"field.label\" [for]=\"field.id\" [class.required]=\"field.required\"\n      [innerHTML]=\"field.label | translate\"></label>\n    <ng-container [ngTemplateOutlet]=\"template\" [ngTemplateOutletContext]=\"{'field': field}\"></ng-container>\n  </div>\n  <div>\n      <div class=\"small form-control-feedback text-danger\">\n        <span *ngIf=\"hasError && !formCtrl?.errors?.customErrorMsg && field.required && !formCtrl.value\" [attr.role]=\"!busy ? 'alert' : null\" [attr.aria-live]=\"busy ? 'off' : 'rude'\"\n          [id]=\"field.id + '_error_req'\"  [innerHTML]=\"'ui.form_field.required_text' | translate\"></span>\n        <span *ngIf=\"hasError && formCtrl?.errors?.customErrorMsg && formCtrl.value\" [id]=\"field.id + '_error_custom'\" [attr.role]=\"!busy ? 'alert' : null\" [attr.aria-live]=\"busy ? 'off' : 'rude'\" [innerHTML]=\"form.controls[this.field.name].errors.customErrorMsg | translate\"></span>\n        <span *ngIf=\"hasError && formCtrl?.errors?.minlength\" [attr.role]=\"!busy ? 'alert' : null\" [attr.aria-live]=\"busy ? 'off' : 'rude'\"\n          [id]=\"field.id + '_error_minlength'\" [innerHTML]=\"'ui.form_field.min_length_required_text'| translate:{length: formCtrl?.errors?.minlength?.requiredLength}\"></span>\n        <span *ngIf=\"hasError && formCtrl?.errors?.email\"\n          [id]=\"field.id + '_error_email'\"  [innerHTML]=\"'ui.form_field.invalid_email_text'| translate\" [attr.role]=\"!busy ? 'alert' : null\" [attr.aria-live]=\"busy ? 'off' : 'rude'\"></span>\n      </div>\n      <span class=\"d-block small\" *ngIf=\"field.helperText\" class=\"form-text text-muted\" [id]=\"field.id + '_help'\"\n        [innerHTML]=\"field.helperText | translate\">\n      </span>\n    </div>\n</div>\n"
            }]
    }], function () { return []; }, { updateOn: [{
            type: Input
        }], template: [{
            type: ContentChild,
            args: [TemplateRef]
        }], field: [{
            type: Input
        }], formCtrl: [{
            type: Input
        }], form: [{
            type: Input
        }], hasError: [{
            type: Input
        }] }); })();

class InputDateComponent extends FieldComponent {
    constructor(elRef, zone, translate, cd, settings) {
        super(settings);
        this.elRef = elRef;
        this.zone = zone;
        this.translate = translate;
        this.cd = cd;
        this.change = new EventEmitter();
        this.dateFormat = 'yyyy-MM-dd';
        this.defaultMinView = 'days';
        this.defaultMaxView = 3;
        this.minDate = new Date(1950, 0, 1);
        this.maxDate = addYears((new Date()).setHours(23, 59, 59), 10);
    }
    ngOnChanges(changes) {
        if (changes.field) {
            super.updateOriginalValue();
        }
        if (changes.field && changes.field.currentValue && !changes.field.isFirstChange()) {
            this.FormCtrl.setValue(changes.field.currentValue.value);
            this.changeAvailableRange(changes.field.currentValue.min, changes.field.currentValue.max);
        }
        this.cd.detectChanges();
    }
    ngOnDestroy() {
        this.change.complete();
        const node = this.getDatePickerElement();
        if (node) {
            $(node).datepicker('destroy');
        }
    }
    ngOnInit() {
        if (this.field) {
            this.setDateFormat();
            if (!this.field.placeholder) {
                this.field.placeholder = this.dateFormat.toUpperCase();
            }
            const formatExample = this.dateFormat
                .replace('MM', '01')
                .replace('dd', '31')
                .replace('yyyy', '2018');
            this.translate.get([
                'ui.input-date.expected_format_example',
                'ui.input-date.invalid_format_error',
                'ui.input-date.invalid_range_error'
            ], {
                example: formatExample,
                format: this.dateFormat
            }).pipe(take(1)).subscribe(text => {
                this.dateFormatDesc = text['ui.input-date.expected_format_example'];
                this.invalidFormatError = text['ui.input-date.invalid_format_error'];
                this.invalidRangeError = text['ui.input-date.invalid_range_error'];
            });
            this.setMinMaxDate(this.field);
            this.validators = this.validators || [];
            if (!Array.isArray(this.validators)) {
                this.validators = [this.validators];
            }
            this.validators.push(this.dateFormatValidator());
            super.ngOnInit();
        }
    }
    ngAfterViewInit() {
        const node = this.getDatePickerElement();
        if (node) {
            this.zone.runOutsideAngular(() => {
                const datepickerSettings = {
                    autoclose: false,
                    endDate: format(this.maxDate, this.dateFormat),
                    // bootstrap date picker expects the format to be lower case where month we expect to be upper in date-fns https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
                    format: this.dateFormat.toLowerCase(),
                    maxViewMode: this.config && this.config.maxView ? this.config.maxView : this.defaultMaxView,
                    minViewMode: this.config && this.config.minView ? this.config.minView : this.defaultMinView,
                    startView: this.config ? this.config.startView : undefined,
                    startDate: format(this.minDate, this.dateFormat),
                    showOnFocus: false,
                    container: this.config && this.config.container ? this.config.container : 'body',
                    keyboardNavigation: false
                };
                $(node)
                    .datepicker(datepickerSettings)
                    .on('show', () => {
                    this.timeSinceClose = null;
                    this.datepickerShowing = true;
                })
                    .on('hide', (evt) => {
                    this.datepickerShowing = false;
                    this.timeSinceClose = Date.now();
                })
                    .on('changeDate', () => {
                    this.zone.run(() => {
                        this.dateChanged();
                        if (this.datepickerShowing) {
                            this.toggle();
                        }
                    });
                });
            });
        }
    }
    changeAvailableRange(startDate, endDate) {
        const node = this.getDatePickerElement();
        if (!node) {
            return;
        }
        $(node).datepicker('setStartDate', startDate)
            .datepicker('setEndDate', endDate);
    }
    dateFormatValidator() {
        return (control) => {
            const value = control.value;
            if (!value) {
                return null;
            }
            const oldErrs = control.errors;
            const valResult = this.validateDate(value, this.dateFormat, this.minDate, this.maxDate);
            if (!valResult) {
                return null;
            }
            // ensure the new error is announced across NVDA/FF, NVDA/Chrome, JAWS/Chrome, JAWS/Edge
            if (this.updateOn === 'change' && (oldErrs === null || oldErrs === void 0 ? void 0 : oldErrs.customErrorMsg) !== valResult.customErrorMsg) {
                control.setErrors(null);
            }
            return valResult;
        };
    }
    validateDate(value, formatString, minRange, maxRange) {
        const minDate = new Date(1867, 6, 1);
        const date = parse(value, formatString, minDate);
        if (!isValid(date) || compareAsc(date, minDate) < 1) {
            return {
                inValidDate: value,
                customErrorMsg: this.invalidFormatError
            };
        }
        if (!(compareAsc(date, minRange) >= 0 && compareAsc(date, maxRange) <= 0)) {
            return {
                inValidDate: value,
                customErrorMsg: this.invalidRangeError
                    .replace('{{date}}', format(date, formatString))
                    .replace('{{start}}', format(minRange, formatString))
                    .replace('{{end}}', format(maxRange, formatString))
            };
        }
        return null;
    }
    toggle() {
        if (this.timeSinceClose && Date.now() - this.timeSinceClose < 250) {
            return;
        }
        const node = this.getDatePickerElement();
        if (node) {
            if (this.datepickerShowing) {
                $(node).datepicker('hide');
            }
            else {
                $(node).datepicker('show')
                    .focus();
            }
            this.timeSinceClose = null;
        }
    }
    dateChanged() {
        const dp = this.getDatePickerElement();
        if (dp && this.field && (this.updateOn !== 'change' || dp.value !== this.field.value)) {
            this.field.value = dp.value;
            this.FormCtrl.setValue(this.field.value);
            this.checkForError();
            this.hasError = false;
            this.cd.detectChanges();
            this.change.emit(this.field);
        }
    }
    changeOccurred($event, field) {
        $event.preventDefault();
        $event.stopPropagation();
        field.value = $event.currentTarget.value;
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(this.field);
    }
    getDatePickerElement() {
        if (this.datepickerChild) {
            return this.datepickerChild.nativeElement;
        }
    }
    setMinMaxDate(field) {
        if (field.min) {
            if (field.min === 'today') {
                const now = new Date();
                this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
            }
            else {
                this.minDate = this.tryGetDate(field.min);
            }
        }
        else if (this.config && this.config.minDate) {
            if (this.config.minDate === 'today') {
                const now = new Date();
                this.minDate = new Date(now.getFullYear(), now.getMonth(), now.getDate(), 0, 0, 0, 0);
            }
            else {
                this.minDate = this.tryGetDate(this.config.minDate);
            }
        }
        if (field.max) {
            if (field.max === 'today') {
                this.maxDate = new Date();
            }
            else {
                this.maxDate = this.tryGetDate(field.max);
            }
        }
        else if (this.config && this.config.maxDate) {
            if (this.config.maxDate === 'today') {
                this.maxDate = new Date();
            }
            else {
                this.maxDate = this.tryGetDate(this.config.maxDate);
            }
        }
    }
    tryGetDate(possibleDate) {
        if (typeof (possibleDate) === 'string') {
            return parse(possibleDate, this.dateFormat, new Date());
        }
        else if (typeof (possibleDate) === 'number') {
            return new Date(possibleDate);
        }
        else {
            return possibleDate;
        }
    }
    setDateFormat() {
        if (this.field && this.field.dateFormat) {
            this.dateFormat = this.field.dateFormat.replace('YYYY', 'yyyy').replace('DD', 'dd').replace('YY', 'yy').replace('D', 'd');
        }
        else if (this.config && this.config.dateFormat) {
            this.dateFormat = this.config.dateFormat.replace('YYYY', 'yyyy').replace('DD', 'dd').replace('YY', 'yy').replace('D', 'd');
        }
    }
    updateAriaDescribedBy() {
        super.updateAriaDescribedBy();
        this.ariaDescribedBy += ` ${this.field.id}_desc`;
        this.cd.detectChanges();
    }
}
InputDateComponent.ɵfac = function InputDateComponent_Factory(t) { return new (t || InputDateComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.NgZone), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.TranslateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.SettingsService)); };
InputDateComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputDateComponent, selectors: [["ui-input-date"]], viewQuery: function InputDateComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c3, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.datepickerChild = _t.first);
    } }, inputs: { validators: "validators", field: "field", form: "form", config: "config", asyncValidators: "asyncValidators" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[3, "field", "formGroup", "form", "formCtrl", "hasError", "updateOn", 4, "ngIf"], [3, "field", "formGroup", "form", "formCtrl", "hasError", "updateOn"], ["template", ""], [1, "input-group", "input-date"], [1, "sr-only", 3, "id", "innerText"], ["ifPII", "", "type", "text", 1, "form-control", 3, "formControlName", "ngClass", "required", "readonly", "input", "change", "focus", "blur", "keydown.arrowdown"], ["datepicker", ""], ["type", "button", "tabindex", "-1", "aria-hidden", "true", 1, "btn", "btn-primary", "input-group-addon", 3, "click"], [1, "sr-only"], [1, "ifc-icon", "ifc-calendar-grid"]], template: function InputDateComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, InputDateComponent_ui_form_field_0_Template, 3, 6, "ui-form-field", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.field && ctx.validators);
    } }, directives: [ɵngcc1.NgIf, FormFieldComponent, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.DefaultValueAccessor, ɵngcc2.IfPersonallyIdentifiableInformationDirective, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, ɵngcc1.NgClass, ɵngcc4.RequiredValidator], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
InputDateComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: NgZone },
    { type: TranslateService },
    { type: ChangeDetectorRef },
    { type: SettingsService }
];
InputDateComponent.propDecorators = {
    datepickerChild: [{ type: ViewChild, args: ['datepicker',] }],
    field: [{ type: Input }],
    form: [{ type: Input }],
    config: [{ type: Input }],
    validators: [{ type: Input }],
    asyncValidators: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputDateComponent, [{
        type: Component,
        args: [{
                selector: 'ui-input-date',
                template: "\n  <ui-form-field *ngIf=\"field && validators\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\" [hasError]=\"hasError\" [updateOn]=\"updateOn\">\n    <ng-template #template let-field=\"field\">\n      <div class=\"input-group input-date\">\n        <span class=\"sr-only\" [id]=\"field.id + '_desc'\" [innerText]=\"dateFormatDesc\"></span>\n        <input ifPII #datepicker type=\"text\" class=\"form-control\" [attr.aria-invalid]=\"hasError\"\n          [attr.aria-describedby]=\"ariaDescribedBy\" [attr.aria-errormessage]=\"ariaErrorMessage\" (input)=\"changeOccurred($event, field)\" (change)=\"$event.stopPropagation(); dateChanged()\"\n          (focus)=\"$event.target.select()\" (blur)=\"checkForError()\" [formControlName]=\"field.name\"\n          [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\"\n          [attr.data-if-id]=\"field.extraAttributes?.ifId\" [attr.name]=\"field.name\" [attr.id]=\"field.id\"\n          [required]=\"field.required && field.required !== 'false'\" [attr.disabled]=\"field.disabled? '': null\"\n          [attr.placeholder]=\"field.placeholder ? field.placeholder: ''\"\n          (keydown.arrowdown)=\"$event.stopImmediatePropagation()\" [readonly]=\"field.readonly\">\n        <button type=\"button\" tabindex=\"-1\" aria-hidden=\"true\" class=\"btn btn-primary input-group-addon\"\n          (click)=\"!field.disabled && toggle();\" [attr.data-if-id]=\"field.extraAttributes?.ifId\">\n          <span class=\"sr-only\">{{ 'ui.input-date.toggle_datepicker' | translate }}</span>\n          <i class=\"ifc-icon ifc-calendar-grid\"></i>\n        </button>\n      </div>\n    </ng-template>\n  </ui-form-field>\n\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.NgZone }, { type: ɵngcc3.TranslateService }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc2.SettingsService }]; }, { change: [{
            type: Output
        }], validators: [{
            type: Input
        }], datepickerChild: [{
            type: ViewChild,
            args: ['datepicker']
        }], field: [{
            type: Input
        }], form: [{
            type: Input
        }], config: [{
            type: Input
        }], asyncValidators: [{
            type: Input
        }] }); })();

class ValidationCheckerComponent {
    constructor(changesRef) {
        this.changesRef = changesRef;
        this.focusedNode = new EventEmitter();
        this.standardCountFilter = `app-root form .form-control.ng-invalid, app-root [role='radiogroup'].ng-invalid`;
    }
    static getCountOfInvalid(countFilter) {
        const nodes = document.querySelectorAll(countFilter);
        if (!nodes) {
            return 0;
        }
        else {
            return nodes.length;
        }
    }
    ngOnInit() {
        this.formSubscription = this.form.statusChanges.subscribe(status => this.validateStatus(status));
    }
    ngAfterViewInit() {
        this.validateStatus(this.form.status);
    }
    ngOnDestroy() {
        this.formSubscription.unsubscribe();
    }
    focusFirstInvalid() {
        const nodes = document.querySelectorAll(this.countFilter ? this.countFilter : this.standardCountFilter);
        let node;
        if (this.restrictFocus) {
            for (let i = 0; i < nodes.length; i++) {
                const n = nodes[i];
                if (n.tagName === "input" &&
                    n["type"] &&
                    n["type"].toLowerCase() !== "hidden") {
                    node = n;
                    break;
                }
                else if (n.tagName === "select" || n.tagName === "textarea") {
                    node = n;
                    break;
                }
                else {
                    const tmpNode = n.querySelector(`input:not([type=hidden])[required], select[required], textarea[required]`);
                    if (tmpNode) {
                        node = tmpNode;
                        break;
                    }
                }
            }
        }
        else {
            node = nodes[0];
        }
        if (node) {
            this.focusedNode.emit(node);
            node["focus"]();
            const header = document.querySelector("header");
            const headerHeight = header ? header.getBoundingClientRect().height : 0;
            const ypos = node.getBoundingClientRect().top +
                window.pageYOffset -
                (headerHeight + 35);
            window.scrollTo(0, ypos);
        }
    }
    validateStatus(status) {
        if (status === "VALID") {
            setTimeout(() => {
                this.showChecker = false;
                this.changesRef.markForCheck();
            });
        }
        else if (status === "INVALID") {
            setTimeout(() => {
                this.showChecker = true;
                const nodes = document.querySelectorAll(this.countFilter ? this.countFilter : this.standardCountFilter);
                this.setErrorStatus(nodes);
                if (nodes) {
                    this.countOfInvalid = nodes.length;
                }
                if (!nodes || nodes.length === 0) {
                    this.showChecker = false;
                }
                this.changesRef.markForCheck();
            }, 0);
        }
    }
    setErrorStatus(nodes) {
        if (nodes) {
            for (let i = 0; nodes && i < nodes.length; i++) {
                if (nodes[i].value) {
                    this.errorType = "invalid";
                    return;
                }
            }
        }
        this.errorType = "required";
    }
}
ValidationCheckerComponent.ɵfac = function ValidationCheckerComponent_Factory(t) { return new (t || ValidationCheckerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
ValidationCheckerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ValidationCheckerComponent, selectors: [["ui-validation-checker"]], inputs: { form: "form", countFilter: "countFilter", restrictFocus: "restrictFocus" }, outputs: { focusedNode: "focusedNode" }, decls: 1, vars: 1, consts: [["role", "alertdialog", "class", "alert alert-info bg-white", "aria-describedby", "alertMsg", "tabindex", "-1", 4, "ngIf"], ["role", "alertdialog", "aria-describedby", "alertMsg", "tabindex", "-1", 1, "alert", "alert-info", "bg-white"], ["id", "alertMsg"], ["href", "javascript:void(0);", 3, "click"]], template: function ValidationCheckerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ValidationCheckerComponent_div_0_Template, 7, 6, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.showChecker);
    } }, directives: [ɵngcc1.NgIf], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
ValidationCheckerComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
ValidationCheckerComponent.propDecorators = {
    form: [{ type: Input }],
    countFilter: [{ type: Input }],
    restrictFocus: [{ type: Input }],
    focusedNode: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ValidationCheckerComponent, [{
        type: Component,
        args: [{
                selector: "ui-validation-checker",
                template: `
  <div *ngIf="showChecker" role="alertdialog" class="alert alert-info bg-white" aria-describedby="alertMsg" tabindex="-1">
    <span id="alertMsg">{{'ui.validation.invalid_field_text' | translate}}</span>
    <a href="javascript:void(0);" (click)="focusFirstInvalid()">
    {{'ui.validation.go_to_label' | translate}}
    </a>
  </div>
  `
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { focusedNode: [{
            type: Output
        }], form: [{
            type: Input
        }], countFilter: [{
            type: Input
        }], restrictFocus: [{
            type: Input
        }] }); })();

class HooksService {
    get onChange() {
        return FieldComponent.onChangePreProcessorObservable;
    }
}
HooksService.ɵfac = function HooksService_Factory(t) { return new (t || HooksService)(); };
HooksService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: HooksService, factory: HooksService.ɵfac });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HooksService, [{
        type: Injectable
    }], null, null); })();

class CheckboxComponent extends FieldComponent {
    constructor() {
        super(...arguments);
        this.change = new EventEmitter();
        this.defaultUpdateOnOptions = {
            updateOnType: "change" /* Change */,
            fieldType: "checkbox" /* Checkbox */
        };
    }
    ngOnDestroy() {
        this.change.complete();
    }
    changeOccurred($event, field) {
        $event.preventDefault();
        $event.stopPropagation();
        field.checked = $event.target.checked;
        this.syncFieldToForm();
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(field);
    }
    syncFieldToForm() {
        const field = this.field;
        if (!field.checked && field.type === 'checkbox') {
            this.FormCtrl.setValue(null);
        }
        else if (field.checked) {
            const onVal = field.onValue || field.value || 'on';
            this.FormCtrl.setValue(onVal);
        }
    }
}
CheckboxComponent.ɵfac = /*@__PURE__*/ function () { let ɵCheckboxComponent_BaseFactory; return function CheckboxComponent_Factory(t) { return (ɵCheckboxComponent_BaseFactory || (ɵCheckboxComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(CheckboxComponent)))(t || CheckboxComponent); }; }();
CheckboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CheckboxComponent, selectors: [["ui-checkbox"]], inputs: { field: "field", srText: "srText" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [["class", "custom-control custom-checkbox", 3, "formGroup", 4, "ngIf"], [1, "custom-control", "custom-checkbox", 3, "formGroup"], ["ifPII", "", 1, "custom-control-input", 3, "formControlName", "name", "id", "type", "checked", "change"], [1, "custom-control-label", 3, "for", "ngClass", "innerHTML"], ["class", "badge badge-danger", 4, "ngIf"], [1, "badge", "badge-danger"]], template: function CheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CheckboxComponent_div_0_Template, 5, 19, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", (ctx.field == null ? null : ctx.field.type) === "checkbox");
    } }, directives: [ɵngcc1.NgIf, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.DefaultValueAccessor, ɵngcc2.IfPersonallyIdentifiableInformationDirective, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, ɵngcc1.NgClass], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
CheckboxComponent.propDecorators = {
    field: [{ type: Input }],
    srText: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'ui-checkbox',
                template: `
  <div class="custom-control custom-checkbox" *ngIf="field?.type === 'checkbox'" [formGroup]="form">
    <input
      class="custom-control-input"
      (change)="changeOccurred($event, field)"
      [formControlName]="field.name"
      [name]="field.name"
      [id]="field.id"
      [type]="field.type"
      [checked]="field.checked"
      [attr.data-if-id]="field.extraAttributes?.ifId"
      ifPII />
    <label [for]="field.id" class="custom-control-label" [ngClass]="{error: hasError, required: field.required}"
      [innerHTML]="field.label | translate:{'srText': srText}">
    </label>
    <div *ngIf="hasError" class="badge badge-danger">{{errorMessage}}</div>
  </div>`
            }]
    }], null, { change: [{
            type: Output
        }], field: [{
            type: Input
        }], srText: [{
            type: Input
        }] }); })();

class SkipToMainComponent {
    constructor() { }
    ngOnInit() { }
    skipToMain($event) {
        $event.preventDefault();
        $event.stopPropagation();
        const node = document.querySelector(`[uiSkipToMainAnchor]`);
        if (node) {
            const rect = node.getBoundingClientRect();
            window.scrollTo(0, rect.top);
            const heading = document.querySelector('h1,h2,h3,h4,h5,h6');
            if (heading) {
                heading.setAttribute('tabindex', '-1');
                heading.focus();
            }
            else {
                node.setAttribute('tabindex', '-1');
                node.focus();
            }
        }
    }
}
SkipToMainComponent.ɵfac = function SkipToMainComponent_Factory(t) { return new (t || SkipToMainComponent)(); };
SkipToMainComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SkipToMainComponent, selectors: [["ui-skip-to-main"]], decls: 6, vars: 7, consts: [[1, "list-unstyled"], ["href", "javascript:void(0);", 3, "click", "focus", "blur"]], template: function SkipToMainComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵelementStart(1, "ul", 0);
        ɵngcc0.ɵɵelementStart(2, "li");
        ɵngcc0.ɵɵelementStart(3, "a", 1);
        ɵngcc0.ɵɵlistener("click", function SkipToMainComponent_Template_a_click_3_listener($event) { return ctx.skipToMain($event); })("focus", function SkipToMainComponent_Template_a_focus_3_listener() { return ctx.showSkip = true; })("blur", function SkipToMainComponent_Template_a_blur_3_listener() { return ctx.showSkip = false; });
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵpipe(5, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("card", ctx.showSkip)("sr-only", !ctx.showSkip);
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵtextInterpolate1(" ", ɵngcc0.ɵɵpipeBind1(5, 5, "ui.skip-to-main.link"), " ");
    } }, pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
SkipToMainComponent.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SkipToMainComponent, [{
        type: Component,
        args: [{
                selector: 'ui-skip-to-main',
                template: "<div [class.card]=\"showSkip\" [class.sr-only]=\"!showSkip\">\n    <ul class=\"list-unstyled\">\n        <li>        \n            <a href=\"javascript:void(0);\" (click)=\"skipToMain($event)\" (focus)=\"showSkip=true\" (blur)=\"showSkip=false\">\n                {{ 'ui.skip-to-main.link' | translate }}\n            </a>\n        </li>\n    </ul>\n</div>"
            }]
    }], function () { return []; }, null); })();

class ContainerLayoutComponent {
}
ContainerLayoutComponent.ɵfac = function ContainerLayoutComponent_Factory(t) { return new (t || ContainerLayoutComponent)(); };
ContainerLayoutComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ContainerLayoutComponent, selectors: [["ui-container-layout"]], decls: 3, vars: 0, consts: [[1, "container"], ["role", "main"]], template: function ContainerLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "main", 1);
        ɵngcc0.ɵɵelement(2, "router-outlet");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } }, directives: [ɵngcc5.RouterOutlet], encapsulation: 2 });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ContainerLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'ui-container-layout',
                template: "<div class=\"container\">\n  <!-- role=\"main\" included for IE11 compat -->\n  <main role=\"main\">\n    <router-outlet></router-outlet>\n  </main>\n</div>\n"
            }]
    }], null, null); })();

class PageLayoutComponent {
}
PageLayoutComponent.ɵfac = function PageLayoutComponent_Factory(t) { return new (t || PageLayoutComponent)(); };
PageLayoutComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PageLayoutComponent, selectors: [["ui-page-layout"]], contentQueries: function PageLayoutComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c9, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c11, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.footerTemplate = _t.first);
    } }, inputs: { header: "header", footer: "footer" }, decls: 6, vars: 3, consts: [[4, "ngIf"], ["role", "main", "uiSkipToMainAnchor", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function PageLayoutComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div");
        ɵngcc0.ɵɵtemplate(1, PageLayoutComponent_header_1_Template, 3, 4, "header", 0);
        ɵngcc0.ɵɵelementStart(2, "main", 1);
        ɵngcc0.ɵɵelement(3, "router-outlet");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(4, PageLayoutComponent_ui_footer_4_Template, 1, 0, "ui-footer", 0);
        ɵngcc0.ɵɵtemplate(5, PageLayoutComponent_footer_5_Template, 2, 4, "footer", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.headerTemplate);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.footerTemplate);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.footerTemplate);
    } }, directives: [ɵngcc1.NgIf, ɵngcc5.RouterOutlet, SkipToMainComponent, ɵngcc1.NgTemplateOutlet, FooterComponent], encapsulation: 2 });
PageLayoutComponent.propDecorators = {
    headerTemplate: [{ type: ContentChild, args: ['headerTemplate',] }],
    footerTemplate: [{ type: ContentChild, args: ['footerTemplate',] }],
    header: [{ type: Input }],
    footer: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PageLayoutComponent, [{
        type: Component,
        args: [{
                selector: 'ui-page-layout',
                template: "<div>\n  <header *ngIf=\"headerTemplate\">\n    <ui-skip-to-main></ui-skip-to-main>\n    <ng-container [ngTemplateOutlet]=\"headerTemplate\" [ngTemplateOutletContext]=\"{'header': header}\">\n    </ng-container>\n  </header>\n  <!-- role=\"main\" included for IE11 compat -->\n  <main role=\"main\" uiSkipToMainAnchor>\n    <router-outlet></router-outlet>\n  </main>\n</div>\n<ui-footer *ngIf=\"!footerTemplate\"></ui-footer>\n<footer *ngIf=\"footerTemplate\">\n  <ng-container [ngTemplateOutlet]=\"footerTemplate\" [ngTemplateOutletContext]=\"{'footer': footer}\">\n  </ng-container>\n</footer>\n"
            }]
    }], null, { headerTemplate: [{
            type: ContentChild,
            args: ['headerTemplate']
        }], footerTemplate: [{
            type: ContentChild,
            args: ['footerTemplate']
        }], header: [{
            type: Input
        }], footer: [{
            type: Input
        }] }); })();

class NavBarComponent {
    constructor(renderer) {
        this.renderer = renderer;
        this.showNotifications = false;
        this.signout = new EventEmitter;
        this.signin = new EventEmitter;
    }
    handleResize(event) {
        var _a;
        if (!this.isActive) {
            return;
        }
        // only toggle on width resize, height resize can be triggered by mobile device keyboard opening
        if (this.windowWidth === ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.innerWidth)) {
            return;
        }
        this.toggleNavbar();
    }
    toggleNavbar(active) {
        if (active !== undefined) {
            this.isActive = active;
        }
        else {
            this.isActive = !this.isActive;
        }
        this.windowWidth = window.innerWidth;
        const action = this.isActive ? 'addClass' : 'removeClass';
        this.renderer[action](document.body, 'nav-mode');
    }
}
NavBarComponent.ɵfac = function NavBarComponent_Factory(t) { return new (t || NavBarComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
NavBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NavBarComponent, selectors: [["ui-navbar"]], contentQueries: function NavBarComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c27, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.custom = _t.first);
    } }, hostBindings: function NavBarComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("resize", function NavBarComponent_resize_HostBindingHandler($event) { return ctx.handleResize($event); }, false, ɵngcc0.ɵɵresolveWindow);
    } }, inputs: { showNotifications: "showNotifications", isLoggedIn: "isLoggedIn", navLinks: "navLinks", header: "header" }, outputs: { signout: "signout", signin: "signin" }, decls: 8, vars: 6, consts: [["id", "navbar", 1, "container", "px-0"], [1, "navbar", "navbar-expand-lg"], [1, "d-flex", "flex-row"], ["class", "navbar-brand header", 3, "routerLink", "click", 4, "ngIf"], [1, "d-flex", "align-items-center"], ["class", "mobile-notifications d-lg-none", 4, "ngIf"], ["id", "navbar-toggler", "class", "navbar-toggler", "type", "button", "aria-controls", "siteMenu", "aria-label", "Toggle navigation", 3, "click", 4, "ngIf"], ["class", "navbar-collapse collapse", "id", "siteMenu", 3, "ngClass", 4, "ngIf"], [1, "navbar-brand", "header", 3, "routerLink", "click"], ["class", "img-fluid mh-100", 3, "src", "alt", 4, "ngIf"], ["class", "logo", 4, "ngIf"], [1, "img-fluid", "mh-100", 3, "src", "alt"], [1, "logo"], [1, "sr-only"], [1, "mobile-notifications", "d-lg-none"], ["id", "navbar-toggler", "type", "button", "aria-controls", "siteMenu", "aria-label", "Toggle navigation", 1, "navbar-toggler", 3, "click"], [1, "ifc-icon", "ifc-menu", "ifc-icon-2"], ["id", "siteMenu", 1, "navbar-collapse", "collapse", 3, "ngClass"], [1, "nav", "navbar-nav", "w-100"], ["class", "nav-item", 4, "ngFor", "ngForOf"], ["class", "ml-auto d-none d-lg-flex", 4, "ngIf"], [4, "ngIf"], [1, "nav-item"], ["routerLinkActive", "active", 1, "mx-xl-3", "nav-link", 3, "routerLink", "queryParams", "routerLinkActiveOptions", "click"], [3, "class", 4, "ngIf"], [1, "align-middle"], [1, "ml-auto", "d-none", "d-lg-flex"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["class", "nav-item ml-lg-auto", 4, "ngIf"], [1, "nav-item", "ml-lg-auto"], ["href", "javascript:void(0)", 1, "mx-xl-3", "nav-link", 3, "click"], [1, "ifc-icon", "ifc-logout", "mr-2", "align-middle", "d-none", "d-lg-inline-block"], [1, "ifc-icon", "ifc-log-in", "mr-2", "align-middle", "d-none", "d-lg-inline-block"]], template: function NavBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "nav", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, NavBarComponent_a_3_Template, 3, 4, "a", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, NavBarComponent_ui_panel_alerts_5_Template, 1, 0, "ui-panel-alerts", 5);
        ɵngcc0.ɵɵtemplate(6, NavBarComponent_button_6_Template, 2, 1, "button", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(7, NavBarComponent_div_7_Template, 6, 7, "div", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.header);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("d-lg-none", !ctx.showNotifications);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showNotifications && ctx.isLoggedIn);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.navLinks);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.navLinks);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc5.RouterLinkWithHref, PanelAlertsComponent, ɵngcc1.NgClass, ɵngcc1.NgForOf, ɵngcc5.RouterLinkActive, ɵngcc1.NgTemplateOutlet]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, encapsulation: 2 });
NavBarComponent.ctorParameters = () => [
    { type: Renderer2 }
];
NavBarComponent.propDecorators = {
    custom: [{ type: ContentChild, args: ['custom',] }],
    showNotifications: [{ type: Input }],
    isLoggedIn: [{ type: Input }],
    navLinks: [{ type: Input }],
    header: [{ type: Input }],
    signout: [{ type: Output }],
    signin: [{ type: Output }],
    handleResize: [{ type: HostListener, args: ['window:resize', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NavBarComponent, [{
        type: Component,
        args: [{
                selector: 'ui-navbar',
                template: "<div id=\"navbar\" class=\"container px-0\">\n  <nav class=\"navbar navbar-expand-lg\">\n    <div class=\"d-flex flex-row\">\n      <a class=\"navbar-brand header\" [routerLink]=\"['/']\" *ngIf=\"header\" (click)=\"toggleNavbar(false)\">\n        <img *ngIf=\"header.logoSrc\" [src]=\"header.logoSrc | translate\" class=\"img-fluid mh-100\"\n          [alt]=\"header.siteName | translate\">\n        <div *ngIf=\"!header.logoSrc\" class=\"logo\"><span class=\"sr-only\">{{header.siteName | translate }}</span></div>\n      </a>\n      <div class=\"d-flex align-items-center\" [class.d-lg-none]=\"!showNotifications\">\n        <ui-panel-alerts *ngIf=\"showNotifications && isLoggedIn\" class=\"mobile-notifications d-lg-none\">\n        </ui-panel-alerts>\n        <button (click)=\"toggleNavbar()\" id=\"navbar-toggler\" *ngIf=\"navLinks\" class=\"navbar-toggler\" type=\"button\"\n          aria-controls=\"siteMenu\" [attr.aria-expanded]=\"isActive\" aria-label=\"Toggle navigation\">\n          <i class=\"ifc-icon ifc-menu ifc-icon-2\"></i>\n        </button>\n      </div>\n    </div>\n    <div class=\"navbar-collapse collapse\" [ngClass]=\"{'show': isActive}\" id=\"siteMenu\" *ngIf=\"navLinks\">\n      <ul class=\"nav navbar-nav w-100\">\n        <li class=\"nav-item\" *ngFor=\"let navLink of navLinks\">\n          <a class=\"mx-xl-3 nav-link\" [routerLink]=\"navLink.routerLink\" [queryParams]=\"navLink.queryParams\"\n            routerLinkActive=\"active\" [routerLinkActiveOptions]=\"{ exact: true }\" (click)=\"toggleNavbar(false)\"><i\n              *ngIf=\"navLink.icon\" class=\"ifc-icon {{navLink.icon}} mr-2 align-middle\"></i><span\n              class=\"align-middle\">{{navLink.text\n              | translate }}</span></a>\n        </li>\n        <li class=\"ml-auto d-none d-lg-flex\" *ngIf=\"showNotifications && isLoggedIn\">\n          <ui-panel-alerts></ui-panel-alerts>\n        </li>\n        <ng-container *ngIf=\"custom\">\n          <ng-container *ngTemplateOutlet=\"custom; context: {'toggleNavbar':toggleNavbar.bind(this)}\"> </ng-container>\n        </ng-container>\n        <ng-container *ngIf=\"isLoggedIn !== undefined\">\n          <li class=\"nav-item ml-lg-auto\" *ngIf=\"isLoggedIn\">\n            <a class=\"mx-xl-3 nav-link\" href=\"javascript:void(0)\" (click)=\"signout.emit(); toggleNavbar(false)\"><i\n                class=\"ifc-icon ifc-logout mr-2 align-middle d-none d-lg-inline-block\"></i><span class=\"align-middle\">{{\n                'ui.navbar.signout' | translate }}</span></a>\n          </li>\n          <li class=\"nav-item ml-lg-auto\" *ngIf=\"!isLoggedIn\">\n            <a class=\"mx-xl-3 nav-link\" href=\"javascript:void(0)\" (click)=\"signin.emit(); toggleNavbar(false)\"><i\n                class=\"ifc-icon ifc-log-in mr-2 align-middle d-none d-lg-inline-block\"></i><span class=\"align-middle\">{{\n                'ui.navbar.signin' | translate }}</span></a>\n          </li>\n        </ng-container>\n      </ul>\n    </div>\n  </nav>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }]; }, { showNotifications: [{
            type: Input
        }], signout: [{
            type: Output
        }], signin: [{
            type: Output
        }], handleResize: [{
            type: HostListener,
            args: ['window:resize', ['$event']]
        }], custom: [{
            type: ContentChild,
            args: ['custom']
        }], isLoggedIn: [{
            type: Input
        }], navLinks: [{
            type: Input
        }], header: [{
            type: Input
        }] }); })();

class HeaderComponent {
    ngOnChanges(changes) {
        if (changes.header.currentValue) {
            if (changes.header.currentValue.header && typeof (changes.header.currentValue.img) !== 'string') {
                if (this.headerSubscription) {
                    this.headerSubscription.unsubscribe();
                }
                this.headerSubscription = changes.header.currentValue.img.subscribe(img => this.bannerImg = img);
            }
            else {
                this.bannerImg = changes.header.currentValue.img;
            }
        }
    }
    ngOnDestroy() {
        if (this.headerSubscription) {
            this.headerSubscription.unsubscribe();
        }
    }
}
HeaderComponent.ɵfac = function HeaderComponent_Factory(t) { return new (t || HeaderComponent)(); };
HeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: HeaderComponent, selectors: [["ui-header"]], contentQueries: function HeaderComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c9, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c32, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.headerTitleTemplate = _t.first);
    } }, inputs: { header: "header", headerContext: "headerContext" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[3, "darken", "bg-header", "ngStyle", 4, "ngIf"], [3, "ngStyle"], ["class", "v-bg", "id", "bgvid", "playsinline", "", "autoplay", "", "loop", "", 3, "muted", 4, "ngIf"], [1, "container"], [3, "headingLevel", 4, "ngIf"], ["class", "h4", 3, "innerHTML", 4, "ngIf"], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf"], ["id", "bgvid", "playsinline", "", "autoplay", "", "loop", "", 1, "v-bg", 3, "muted"], ["type", "video/mp4", 3, "src"], [3, "headingLevel"], [3, "innerHTML"], [1, "h4", 3, "innerHTML"], [3, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function HeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, HeaderComponent_div_0_Template, 8, 12, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.header || ctx.headerTitleTemplate || ctx.headerTemplate);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgStyle, DynamicHeadingComponent, ɵngcc1.NgTemplateOutlet]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, encapsulation: 2 });
HeaderComponent.propDecorators = {
    header: [{ type: Input }],
    headerContext: [{ type: Input }],
    headerTemplate: [{ type: ContentChild, args: ['headerTemplate',] }],
    headerTitleTemplate: [{ type: ContentChild, args: ['headerTitleTemplate',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HeaderComponent, [{
        type: Component,
        args: [{
                selector: 'ui-header',
                template: "<div *ngIf=\"header || headerTitleTemplate || headerTemplate\" [class.darken]=\"header?.video\"\n  [class.bg-header]=\"!header?.video\"\n  [ngStyle]=\"{ 'background': bannerImg ? 'linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.7)), url(' + bannerImg + ')' : '','background-size': 'cover'}\">\n  <video *ngIf=\"header?.video\" class=\"v-bg\" id=\"bgvid\" playsinline autoplay [muted]=\"true\" loop>\n    <source src=\"{{header?.video}}\" type=\"video/mp4\">\n  </video>\n  <div class=\"container\">\n    <header>\n      <ui-dynamic-heading [headingLevel]=\"1\" *ngIf=\"header?.title\"><span [innerHTML]=\"header?.title | translate\"></span>\n      </ui-dynamic-heading>\n      <div class=\"h4\" *ngIf=\"header?.description\" [innerHTML]=\"header?.description | translate\"></div>\n      <ng-container *ngIf=\"headerTitleTemplate\" [ngTemplateOutlet]=\"headerTitleTemplate\"\n        [ngTemplateOutletContext]=\"{'headerContext': headerContext}\"></ng-container>\n    </header>\n  </div>\n  <ng-container *ngIf=\"headerTemplate\" [ngTemplateOutlet]=\"headerTemplate\"\n    [ngTemplateOutletContext]=\"{'headerContext': headerContext}\"></ng-container>\n</div>\n"
            }]
    }], null, { header: [{
            type: Input
        }], headerContext: [{
            type: Input
        }], headerTemplate: [{
            type: ContentChild,
            args: ['headerTemplate']
        }], headerTitleTemplate: [{
            type: ContentChild,
            args: ['headerTitleTemplate']
        }] }); })();

class ResponsiveTableComponent {
    constructor() {
        this.style = "table-striped border-0";
        this.captionStyle = "";
        this.headerClicked = new EventEmitter();
    }
    colHeaderClicked(header) {
        this.headerClicked.emit(header);
    }
    ngOnChanges() {
        if (this.table.nativeOrdering) {
            this.headings = this.table.nativeOrdering;
        }
        else {
            this.headings = Object.keys(this.table.headings);
        }
    }
}
ResponsiveTableComponent.ɵfac = function ResponsiveTableComponent_Factory(t) { return new (t || ResponsiveTableComponent)(); };
ResponsiveTableComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ResponsiveTableComponent, selectors: [["ui-responsive-table"]], contentQueries: function ResponsiveTableComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c35, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c36, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.customTableRowTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.customTableHeadingTemplate = _t.first);
    } }, inputs: { style: "style", captionStyle: "captionStyle", table: "table", caption: "caption" }, outputs: { headerClicked: "headerClicked" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[3, "class", 4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["defaultTableHeadingTemplate", ""], [4, "ngFor", "ngForOf"], ["scope", "col", 4, "ngFor", "ngForOf"], ["scope", "col"], [4, "ngIf"], ["href", "javascript:void(0)", 3, "click", 4, "ngIf", "ngIfElse"], ["textTemplate", ""], ["href", "javascript:void(0)", 3, "click"], ["defaultTableRowTemplate", ""]], template: function ResponsiveTableComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ResponsiveTableComponent_table_0_Template, 9, 9, "table", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.table);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgForOf], encapsulation: 2 });
ResponsiveTableComponent.propDecorators = {
    customTableRowTemplate: [{ type: ContentChild, args: ['customTableRowTemplate',] }],
    customTableHeadingTemplate: [{ type: ContentChild, args: ['customTableHeadingTemplate',] }],
    table: [{ type: Input }],
    caption: [{ type: Input }],
    style: [{ type: Input }],
    captionStyle: [{ type: Input }],
    headerClicked: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ResponsiveTableComponent, [{
        type: Component,
        args: [{
                selector: 'ui-responsive-table',
                template: "<table *ngIf=\"table\" class=\"table table-responsive {{style}}\">\n  <caption *ngIf=\"caption\" [class]=\"captionStyle\">{{ caption }}</caption>\n  <thead>\n    <tr>\n      <ng-container\n        *ngTemplateOutlet=\"customTableHeadingTemplate? customTableHeadingTemplate : defaultTableHeadingTemplate; context: {'headings': headings}\">\n      </ng-container>\n      <ng-template #defaultTableHeadingTemplate>\n        <th *ngFor=\"let headingKey of headings\" scope=\"col\">\n          <ng-container *ngIf=\"table.headings[headingKey]; let heading\">\n            <a *ngIf=\"heading.nodeType === 'a'; else textTemplate\" href=\"javascript:void(0)\"\n              (click)=\"colHeaderClicked(heading)\">\n              {{heading.text}}\n            </a>\n            <ng-template #textTemplate>\n              <span>\n                {{heading}}\n              </span>\n            </ng-template>\n          </ng-container>\n        </th>\n      </ng-template>\n    </tr>\n  </thead>\n  <tbody>\n    <ng-container *ngFor=\"let row of table.rows; index as i\">\n      <ng-container\n        *ngTemplateOutlet=\"customTableRowTemplate? customTableRowTemplate : defaultTableRowTemplate; context: {'row': row, 'rowIndex': i, 'headings': headings}\">\n      </ng-container>\n      <ng-template #defaultTableRowTemplate>\n        <tr>\n          <td *ngFor=\"let key of headings\" [attr.data-label]=\"table.headings[key]?.text || table.headings[key]\">\n            {{row[key] }}</td>\n        </tr>\n      </ng-template>\n    </ng-container>\n  </tbody>\n</table>\n"
            }]
    }], function () { return []; }, { style: [{
            type: Input
        }], captionStyle: [{
            type: Input
        }], headerClicked: [{
            type: Output
        }], customTableRowTemplate: [{
            type: ContentChild,
            args: ['customTableRowTemplate']
        }], customTableHeadingTemplate: [{
            type: ContentChild,
            args: ['customTableHeadingTemplate']
        }], table: [{
            type: Input
        }], caption: [{
            type: Input
        }] }); })();

class InputTypeaheadComponent extends FieldComponent {
    constructor(el, cd, settings) {
        super(settings);
        this.el = el;
        this.cd = cd;
        this.queryEntered = new EventEmitter();
        this.selectionMade = new EventEmitter();
        this.isLoading = false;
        this.selectedMatchIdx = -1;
        this.filterParams = {
            minSearchLength: 3,
            caseSensitive: false
        };
        // Chrome ignores off if as you type it starts matching an existing value, using a unique value prevents this
        this.autocomplete = `off-${Math.random()}`;
    }
    ngOnInit() {
        if (this.optionsObservable) {
            this.resultsSubscription = this.optionsObservable.subscribe(matches => {
                var _a;
                this.matches = matches;
                if (!((_a = this.matches) === null || _a === void 0 ? void 0 : _a.length) && this.filterParams.closeWhenNoResults) {
                    this.matches = undefined;
                    this.isLoading = false;
                }
            });
        }
        this.setDefaultUpdateStrategy();
        this.syncFieldToForm();
    }
    checkSelectionInOptionSet(currentControl) {
        let value = currentControl.value;
        if (!this.params.caseSensitive) {
            value = value.toLowerCase();
        }
        if (!value || !this.options || !this.options.length) {
            return null;
        }
        if (typeof this.options[0] === 'string' &&
            this.options.map(op => this.params.caseSensitive ? op : op.toLowerCase()).indexOf(value) === -1) {
            return {
                customErrorMsg: `ui.input-typeahead.invalid_selection_error`
            };
        }
        if (this.options[0].id
            && !this.options
                .some(option => {
                const id = this.params.caseSensitive ? option.id : option.id.toLowerCase();
                const text = this.params.caseSensitive ? option.text : option.text.toLowerCase();
                return id === value || (option.useText && text === value);
            })) {
            return {
                customErrorMsg: `ui.input-typeahead.invalid_selection_error`
            };
        }
    }
    ngOnDestroy() {
        if (this.resultsSubscription) {
            this.resultsSubscription.unsubscribe();
        }
    }
    ngOnChanges(changes) {
        Object.assign(this.filterParams, this.params);
        super.ngOnChanges(changes);
    }
    onChange(event) {
        event.preventDefault();
        event.stopPropagation();
        const newValue = event.target.value.trim();
        this.field.value = event.target.value;
        super.onChangePreProcessor({ src: this.field, args: { form: this.form } });
        this.selectedMatchIdx = -1;
        this.isLoading = newValue.length > 0 || newValue.length === this.filterParams.minSearchLength;
        if (newValue.length < this.filterParams.minSearchLength) {
            this.matches = undefined;
            this.cd.detectChanges();
            return;
        }
        if (!this.resultsSubscription) {
            this.matches = this.search(newValue, this.options);
            if (this.matches.length === 0 && this.filterParams.closeWhenNoResults) {
                this.matches = undefined;
                this.isLoading = false;
            }
            this.cd.detectChanges();
            return;
        }
        this.selectedMatchIdx = -1;
        this.queryEntered.emit(event);
    }
    setMatch(match, close = false) {
        if (typeof match === 'string') {
            this.field.value = match;
        }
        else if (match && match.id) {
            this.field.value = match.useText ? match.text : match.id;
        }
        this.syncFieldToForm();
        if (close) {
            this.isLoading = false;
            this.matches = undefined;
            this.selectionMade.emit(match);
        }
    }
    handleKeypress(event) {
        const key = event.keyCode;
        if (!this.matches) {
            return;
        }
        if (key !== 38 && key !== 40 && key !== 13) {
            return;
        }
        event.preventDefault();
        event.stopPropagation();
        if (key === 38) {
            this.selectedMatchIdx--;
            if (this.selectedMatchIdx < 0) {
                this.selectedMatchIdx = this.matches.length - 1;
            }
            this.scrollItemIntoView(this.listitems.toArray()[this.selectedMatchIdx]);
        }
        else if (key === 40) {
            this.selectedMatchIdx++;
            if (this.selectedMatchIdx === this.matches.length) {
                this.selectedMatchIdx = 0;
            }
            this.scrollItemIntoView(this.listitems.toArray()[this.selectedMatchIdx]);
        }
        const close = key === 13;
        if (this.selectedMatchIdx < 0) {
            this.selectedMatchIdx = 0;
        }
        this.setMatch(this.matches[this.selectedMatchIdx], close);
    }
    search(search, options) {
        if (search.length < this.filterParams.minSearchLength) {
            return undefined;
        }
        if (this.customSearch) {
            return this.customSearch(search, options);
        }
        const searchValue = !this.filterParams.caseSensitive ? search.toLowerCase() : search;
        if (typeof options[0] === 'string') {
            return options.filter(option => this.matchText(searchValue, option, this.filterParams.caseSensitive));
        }
        else {
            return options.filter(option => this.matchText(searchValue, option.text, this.filterParams.caseSensitive) || this.matchId(searchValue, option.id));
        }
    }
    /**
     * onFocus - if min search length 0, trigger lookup
     * @param $event : FocusEvent
     */
    onFocus($event) {
        var _a;
        if (this.params.minSearchLength === 0 && !this.FormCtrl.value) {
            $event.preventDefault();
            $event.stopPropagation();
            super.onChangePreProcessor({ src: this.field, args: { form: this.form } });
            this.selectedMatchIdx = -1;
            this.isLoading = true;
            if (!this.resultsSubscription) {
                this.matches = this.search('', this.options);
                if (!((_a = this.matches) === null || _a === void 0 ? void 0 : _a.length) && this.filterParams.closeWhenNoResults) {
                    this.matches = undefined;
                    this.isLoading = false;
                }
                this.cd.detectChanges();
                return;
            }
            this.queryEntered.emit($event);
        }
    }
    scrollItemIntoView(item) {
        const element = item.nativeElement;
        const container = this.el.nativeElement.querySelector('.autocomplete-matches');
        container.scrollTop = element.offsetTop;
    }
    matchText(search, option, caseSensitive) {
        const text = !caseSensitive ? option.toLowerCase() : option;
        if (search.indexOf(' ') === -1) {
            const words = text.split(' ');
            return words.some(word => word.indexOf(search) === 0);
        }
        return text.indexOf(search) !== -1;
    }
    matchId(search, id) {
        return id.toLowerCase().indexOf(search) === 0;
    }
}
InputTypeaheadComponent.ɵfac = function InputTypeaheadComponent_Factory(t) { return new (t || InputTypeaheadComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.SettingsService)); };
InputTypeaheadComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputTypeaheadComponent, selectors: [["ui-input-typeahead"]], contentQueries: function InputTypeaheadComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c39, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.customOption = _t.first);
    } }, viewQuery: function InputTypeaheadComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c40, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.listitems = _t);
    } }, inputs: { field: "field", options: "options", optionsObservable: "optionsObservable", params: "params", customOptionContext: "customOptionContext", validators: ["selectionValidators", "validators"], customSearch: "customSearch" }, outputs: { queryEntered: "queryEntered", selectionMade: "selectionMade" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [["class", "d-flex flex-column mb-3", 4, "ngIf"], [1, "d-flex", "flex-column", "mb-3"], [1, "form-group", "mb-0", 3, "formGroup"], ["class", "form-control-label", 3, "for", "required", "innerHTML", 4, "ngIf"], ["type", "search", "aria-autocomplete", "both", 1, "form-control", 3, "id", "value", "required", "formControlName", "keydown", "input", "blur", "focus"], ["aria-live", "assertive", 1, "autocomplete-matches-container", 3, "id"], ["class", "autocomplete-matches w-100", 4, "ngIf"], ["aria-live", "assertive", 1, "d-block", "small", "form-control-feedback", "text-danger"], [3, "id", 4, "ngIf"], ["class", "d-block small", "class", "form-text text-muted", 3, "id", "innerHTML", 4, "ngIf"], [1, "form-control-label", 3, "for", "innerHTML"], [1, "autocomplete-matches", "w-100"], ["class", "sr-only", "role", "status", 4, "ngIf"], ["role", "listbox", 1, "list-group"], [4, "ngIf"], ["role", "status", 1, "sr-only"], ["role", "option", 1, "list-group-item", "align-items-center", "d-flex"], ["role", "alert", 1, "font-italic"], ["class", "list-group-item py-0", "role", "option", "tabindex", "-1", 3, "mousedown", 4, "ngFor", "ngForOf"], ["role", "option", "tabindex", "-1", 1, "list-group-item", "py-0", 3, "mousedown"], ["listitems", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext", 4, "ngIf", "ngIfElse"], ["defaultOption", ""], [3, "ngTemplateOutlet", "ngTemplateOutletContext"], [4, "ngIf", "ngIfElse"], ["textResult", ""], [1, "row", "py-3"], [1, "col-4", "mr-2", "font-weight-bold", "border-right", "result-id"], [1, "col", "ml-2"], [1, "py-3"], ["role", "option", 1, "list-group-item", "small", "text-muted"], ["role", "alert"], [3, "id"], [1, "form-text", "text-muted", 3, "id", "innerHTML"]], template: function InputTypeaheadComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, InputTypeaheadComponent_div_0_Template, 11, 26, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.field);
    } }, directives: [ɵngcc1.NgIf, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.DefaultValueAccessor, ɵngcc4.RequiredValidator, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, LoadingSpinnerComponent, ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
InputTypeaheadComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: ChangeDetectorRef },
    { type: SettingsService }
];
InputTypeaheadComponent.propDecorators = {
    field: [{ type: Input }],
    options: [{ type: Input }],
    optionsObservable: [{ type: Input }],
    params: [{ type: Input }],
    customOptionContext: [{ type: Input }],
    validators: [{ type: Input, args: ['selectionValidators',] }],
    customSearch: [{ type: Input }],
    queryEntered: [{ type: Output }],
    selectionMade: [{ type: Output }],
    customOption: [{ type: ContentChild, args: ['customOption',] }],
    listitems: [{ type: ViewChildren, args: ['listitems',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputTypeaheadComponent, [{
        type: Component,
        args: [{
                selector: 'ui-input-typeahead',
                template: "<div class=\"d-flex flex-column mb-3\" *ngIf=\"field\">\n  <div class=\"form-group mb-0\" [formGroup]=\"form\">\n    <label class=\"form-control-label\" *ngIf=\"field.label\" [for]=\"field.id\" [class.required]=\"field.required\"\n      [innerHTML]=\"field.label | translate\"></label>\n\n    <input\n      type=\"search\"\n      class=\"form-control\"\n      [class.results-visible]=\"matches\"\n      [class.is-invalid]=\"hasError\"\n      [attr.autocomplete]=\"autocomplete\"\n      [id]=\"field.id\"\n      [attr.name]=\"field.name\"\n      [value]=\"field.value\"\n      [attr.placeholder]=\"field.placeholder ? (field.placeholder | translate) : ''\"\n      [required]=\"field.required\"\n      [formControlName]=\"field.name\"\n      [attr.aria-expanded]=\"matches?.length\"\n      aria-autocomplete=\"both\"\n      [attr.aria-owns]=\"field.id + '-resultsList'\"\n      [attr.data-if-id]=\"field.extraAttributes?.ifId\"\n      [attr.aria-invalid]=\"hasError\"\n      [attr.aria-describedby]=\"ariaDescribedBy\"\n      [attr.aria-errormessage]=\"ariaErrorMessage\"\n      (keydown)=\"handleKeypress($event)\"\n      (input)=\"onChange($event)\"\n      (blur)=\"setMatch(field.value,true)\"\n      (focus)=\"onFocus($event)\">\n\n    <div [id]=\"field.id + '-resultsList'\" aria-live=\"assertive\" class=\"autocomplete-matches-container\">\n      <div class=\"autocomplete-matches w-100\" *ngIf=\"isLoading\">\n        <span class=\"sr-only\" role=\"status\" *ngIf=\"matches?.length\">{{'ui.input-typeahead.results' | translate}}</span>\n        <ul class=\"list-group\" role=\"listbox\">\n          <ng-container *ngIf=\"!matches\">\n            <li class=\"list-group-item align-items-center d-flex\" role=\"option\">\n              <ui-loading-spinner></ui-loading-spinner>\n              <div class=\"font-italic\"\n                role=\"alert\">{{'ui.input-typeahead.search' | translate:filterParams}}</div>\n            </li>\n          </ng-container>\n          <ng-container *ngIf=\"matches?.length > 0\">\n            <li #listitems class=\"list-group-item py-0\" [attr.aria-selected]=\"i === selectedMatchIdx\"\n              *ngFor=\"let match of matches; let i = index\" role=\"option\" (mousedown)=\"setMatch(match, true)\"\n              tabindex=\"-1\">\n              <ng-container *ngIf=\"customOption; else defaultOption\" [ngTemplateOutlet]=\"customOption\"\n                [ngTemplateOutletContext]=\"{'customOptionContext': customOptionContext, 'matchContext': match}\">\n              </ng-container>\n              <ng-template #defaultOption>\n                <ng-container *ngIf=\"match.id; else textResult\">\n                  <div class=\"row py-3\">\n                    <div class=\"col-4 mr-2 font-weight-bold border-right result-id\">\n                      {{match.id}}</div>\n                    <div class=\"col ml-2\">{{match.text}}</div>\n                  </div>\n                </ng-container>\n                <ng-template #textResult>\n                  <div class=\"py-3\">{{match}}</div>\n                </ng-template>\n              </ng-template>\n            </li>\n          </ng-container>\n          <ng-container *ngIf=\"matches?.length === 0\">\n            <li class=\"list-group-item small text-muted\" role=\"option\">\n              <span role=\"alert\">{{'ui.input-typeahead.empty' | translate}}</span>\n            </li>\n          </ng-container>\n        </ul>\n      </div>\n    </div>\n  </div>\n  <div class=\"d-block small form-control-feedback text-danger\" aria-live=\"assertive\">\n    <span *ngIf=\"hasError && !FormCtrl?.errors?.customErrorMsg && field.required && !FormCtrl.value\"\n      [id]=\"field.id + '_error_req'\">{{'ui.form_field.required_text' | translate}}</span>\n    <span *ngIf=\"hasError && FormCtrl?.errors?.customErrorMsg\"\n      [id]=\"field.id + '_error_custom'\">{{form.controls[this.field.name].errors.customErrorMsg | translate:FormCtrl}}</span>\n  </div>\n  <span class=\"d-block small\" *ngIf=\"field.helperText\" [id]=\"field.id + '_help'\" class=\"form-text text-muted\"\n    [innerHTML]=\"field.helperText | translate\">\n  </span>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc2.SettingsService }]; }, { queryEntered: [{
            type: Output
        }], selectionMade: [{
            type: Output
        }], field: [{
            type: Input
        }], options: [{
            type: Input
        }], optionsObservable: [{
            type: Input
        }], params: [{
            type: Input
        }], customOptionContext: [{
            type: Input
        }], validators: [{
            type: Input,
            args: ['selectionValidators']
        }], customSearch: [{
            type: Input
        }], customOption: [{
            type: ContentChild,
            args: ['customOption']
        }], listitems: [{
            type: ViewChildren,
            args: ['listitems']
        }] }); })();

class SearchComponent {
    constructor() {
        this.search = new EventEmitter();
        this.showAdvancedFilters = false;
    }
    ngOnDestroy() {
        this.search.complete();
    }
}
SearchComponent.ɵfac = function SearchComponent_Factory(t) { return new (t || SearchComponent)(); };
SearchComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: SearchComponent, selectors: [["ui-search"]], inputs: { title: "title", primarySearch: "primarySearch", form: "form", filters: "filters" }, outputs: { search: "search" }, decls: 16, vars: 13, consts: [[1, "card"], [1, "card-body"], [3, "headingLevel"], [1, "row"], [1, "col", "pr-0"], ["sr-only-label", "", 3, "field", "form", "keyup.enter"], [1, "mr-3", "ml-0"], ["type", "button", 1, "btn", "btn-primary", 3, "click"], [1, "ifc-icon", "ifc-search", "mx-2", "align-middle"], [1, "sr-only"], [4, "ngIf"], ["class", "collapse in show", "id", "advancedSearch", 4, "ngIf"], ["role", "button", "href", "javascript:void(0)", 1, "small", 3, "click"], [1, "align-middle"], [1, "ifc-icon", "align-middle", "ml-2"], ["id", "advancedSearch", 1, "collapse", "in", "show"], [1, "row", "pt-3"], ["class", "col-12 col-sm-6 col-md-3", 4, "ngFor", "ngForOf"], [1, "col-12", "col-sm-6", "col-md-3"], [3, "field", "form", 4, "ngIf"], [3, "field", "form"]], template: function SearchComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "ui-dynamic-heading", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "div", 3);
        ɵngcc0.ɵɵelementStart(6, "div", 4);
        ɵngcc0.ɵɵelementStart(7, "ui-input", 5);
        ɵngcc0.ɵɵlistener("keyup.enter", function SearchComponent_Template_ui_input_keyup_enter_7_listener() { return ctx.search.emit(); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(8, "div", 6);
        ɵngcc0.ɵɵelementStart(9, "button", 7);
        ɵngcc0.ɵɵlistener("click", function SearchComponent_Template_button_click_9_listener() { return ctx.search.emit(); });
        ɵngcc0.ɵɵelement(10, "i", 8);
        ɵngcc0.ɵɵelementStart(11, "span", 9);
        ɵngcc0.ɵɵtext(12);
        ɵngcc0.ɵɵpipe(13, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(14, SearchComponent_div_14_Template, 6, 8, "div", 10);
        ɵngcc0.ɵɵtemplate(15, SearchComponent_div_15_Template, 3, 2, "div", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵstyleMap("mb-3");
        ɵngcc0.ɵɵproperty("headingLevel", 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 9, ctx.title));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("field", ctx.primarySearch)("form", ctx.form);
        ɵngcc0.ɵɵadvance(5);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(13, 11, "ui.search.search_btn_label"));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.filters == null ? null : ctx.filters.length);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showAdvancedFilters);
    } }, directives: function () { return [DynamicHeadingComponent, InputComponent, SROnlyLabelDirective, ɵngcc1.NgIf, ɵngcc1.NgForOf, FormControlComponent]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, encapsulation: 2 });
SearchComponent.propDecorators = {
    title: [{ type: Input }],
    primarySearch: [{ type: Input }],
    form: [{ type: Input }],
    filters: [{ type: Input }],
    search: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(SearchComponent, [{
        type: Component,
        args: [{
                selector: 'ui-search',
                template: "<div class=\"card\">\n    <div class=\"card-body\">\n        <ui-dynamic-heading [headingLevel]=\"1\" [style]=\"'mb-3'\">{{title | translate}}</ui-dynamic-heading>\n        <div class=\"row\">\n            <div class=\"col pr-0\">\n                <ui-input sr-only-label [field]=\"primarySearch\" [form]=\"form\" (keyup.enter)=\"search.emit()\"></ui-input>\n            </div>\n            <div class=\"mr-3 ml-0\">\n                <button class=\"btn btn-primary\" type=\"button\" (click)=\"search.emit()\">\n                    <i class=\"ifc-icon ifc-search mx-2 align-middle\"></i> <span\n                        class=\"sr-only\">{{'ui.search.search_btn_label' | translate}}</span>\n                </button>\n            </div>\n        </div>\n        <div *ngIf=\"filters?.length\">\n            <a role=\"button\" (click)=\"showAdvancedFilters = !showAdvancedFilters\" href=\"javascript:void(0)\"\n                [attr.aria-expanded]=\"showAdvancedFilters\" class=\"small\">\n                <span class=\"align-middle\">{{'ui.search.advanced_filters_label' | translate}}</span>\n                <i class=\"ifc-icon align-middle ml-2\" [class.ifc-chevron-down]=\"showAdvancedFilters\"\n                    [class.ifc-chevron-right]=\"!showAdvancedFilters\"></i>\n            </a>\n        </div>\n        <div class=\"collapse in show\" id=\"advancedSearch\" *ngIf=\"showAdvancedFilters\"\n            [attr.aria-expanded]=\"showAdvancedFilters\">\n            <div class=\"row pt-3\">\n                <div class=\"col-12 col-sm-6 col-md-3\" *ngFor=\"let filter of filters\">\n                    <ui-form-control *ngIf=\"filter\" [field]=\"filter\" [form]=\"form\"></ui-form-control>\n                </div>\n            </div>\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return []; }, { search: [{
            type: Output
        }], title: [{
            type: Input
        }], primarySearch: [{
            type: Input
        }], form: [{
            type: Input
        }], filters: [{
            type: Input
        }] }); })();

function AtleastOneCheckboxRequiredValidator(required) {
    const isRequired = required;
    return (controls) => {
        if (!isRequired) {
            return null;
        }
        const hasValue = controls.value.some(val => !!val);
        return hasValue ? null : { type: 'required' };
    };
}

class CheckradioGroupComponent {
    constructor(changesRef) {
        this.changesRef = changesRef;
    }
    ngOnInit() {
        if (this.fieldset) {
            this.isRadioGroup = !!this.fieldset.elements.find((f) => f.type === 'radio');
            if (!this.fieldset.name) {
                this.fieldset.name = this.fieldset.elements[0].name;
            }
            if (!this.fieldset.required) {
                this.fieldset.required = this.fieldset.elements[0].required;
            }
            if (!this.isRadioGroup) {
                this.setupCheckboxFormControls();
            }
            else {
                this.setupRadioFormControl();
            }
            this.changesRef.detectChanges();
        }
    }
    ngOnDestroy() {
        this.form.removeControl(this.fieldset.name);
    }
    checkboxChangeOccurred($event, field, idx) {
        if (this.isRadioGroup) {
            this.form.controls[this.fieldset.name].setValue($event.target.checked ? field.value : '');
        }
        else {
            const formArray = this.form.controls[this.fieldset.name];
            formArray.controls[idx].setValue($event.target.checked ? field.value : '');
        }
        this.changesRef.markForCheck();
    }
    setupRadioFormControl() {
        let checkedRadio = (this.fieldset.elements.find((el) => el.checked) || this.fieldset.elements[0]);
        if (checkedRadio) {
            const ctrl = new FormControl(checkedRadio.checked ? checkedRadio.value : '', { validators: (this.fieldset.required) ? Validators.required : undefined });
            this.form.addControl(checkedRadio.name, ctrl);
            this.fields = this.fieldset.elements.map((f) => {
                return Object.assign({ control: ctrl }, f);
            });
        }
    }
    setupCheckboxFormControls() {
        this.fields = this.fieldset.elements.map((el, idx) => {
            el.ifId = this.fieldset.extraAttributes && this.fieldset.extraAttributes.ifId ? this.fieldset.extraAttributes.ifId + '-option-' + idx : 'option-' + idx;
            const e = Object.assign({}, el);
            e.control = new FormControl(e.checked ? e.value : '');
            return e;
        });
        if (this.fields.length) {
            this.form.addControl(this.fieldset.name, new FormArray([]));
            const formArray = this.form.controls[this.fieldset.name];
            this.fields.forEach(el => formArray.push(el.control));
            formArray.setValidators(AtleastOneCheckboxRequiredValidator(this.fieldset.required));
        }
    }
}
CheckradioGroupComponent.ɵfac = function CheckradioGroupComponent_Factory(t) { return new (t || CheckradioGroupComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
CheckradioGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CheckradioGroupComponent, selectors: [["ui-checkradio-group"]], inputs: { form: "form", fieldset: "fieldset" }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["tabindex", "-1", 1, "form-group", 3, "formGroup"], [1, "form-control-label", 3, "innerHTML"], ["class", "custom-control custom-checkbox", 3, "custom-checkbox", "custom-radio", 4, "ngFor", "ngForOf"], ["class", "d-block form-control-feedback mt-1 text-danger", 4, "ngIf"], [1, "custom-control", "custom-checkbox"], ["ifPII", "", 1, "custom-control-input", 3, "formControl", "name", "id", "type", "checked", "change"], [1, "custom-control-label", 3, "for", "innerHTML"], [1, "d-block", "form-control-feedback", "mt-1", "text-danger"], ["role", "alert", 4, "ngIf"], ["role", "alert"]], template: function CheckradioGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CheckradioGroupComponent_ng_container_0_Template, 6, 10, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.fieldset);
    } }, directives: [ɵngcc1.NgIf, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc1.NgForOf, ɵngcc4.DefaultValueAccessor, ɵngcc2.IfPersonallyIdentifiableInformationDirective, ɵngcc4.NgControlStatus, ɵngcc4.FormControlDirective], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
CheckradioGroupComponent.ctorParameters = () => [
    { type: ChangeDetectorRef }
];
CheckradioGroupComponent.propDecorators = {
    form: [{ type: Input }],
    fieldset: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CheckradioGroupComponent, [{
        type: Component,
        args: [{
                selector: 'ui-checkradio-group',
                template: "<ng-container *ngIf=\"fieldset\">\n  <fieldset class=\"form-group\" tabindex=\"-1\" [class.error]=\"form.controls[fieldset.name]?.errors && fieldset?.required\" [formGroup]=\"form\">\n    <legend class=\"form-control-label\" [class.required]=\"fieldset.required\" [innerHTML]=\"fieldset.legend | translate\"></legend>\n\n      <div class=\"custom-control custom-checkbox\"\n        [class.custom-checkbox]=\"!isRadioGroup\"\n        [class.custom-radio]=\"isRadioGroup\"\n        *ngFor=\"let field of fields; let idx = index\">\n        <input\n          ifPII\n          class=\"custom-control-input\"\n          (change)=\"checkboxChangeOccurred($event, field, idx)\"\n          [formControl]=\"field.control\"\n          [name]=\"field.name\"\n          [id]=\"field.id\"\n          [type]=\"field.type\"\n          [checked]=\"field.checked\"\n          [attr.data-if-id]=\"field.ifId\"/>\n        <label\n          [for]=\"field.id\"\n          class=\"custom-control-label\"\n          [innerHTML]=\"field.label\"></label>\n      </div>\n    <small class=\"d-block form-control-feedback mt-1 text-danger\" *ngIf=\"fieldset?.name\">\n      <span role=\"alert\" *ngIf=\"form.controls[fieldset.name] && form.controls[fieldset.name].touched && form.controls[fieldset.name].errors\">{{'ui.form_field.required_text' | translate}}</span>\n    </small>\n  </fieldset>\n</ng-container>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }]; }, { form: [{
            type: Input
        }], fieldset: [{
            type: Input
        }] }); })();

class NotificationComponent {
    constructor(notificationService) {
        this.notificationService = notificationService;
        this.messageExpireInterval = 1000; // ms
        this.messagePoliteness = 'assertive';
        this.alertExpireInterval = 1000; // ms
    }
    ngOnInit() {
        this.messageSubscription = this.notificationService.message.subscribe((message) => {
            this.setMessageTimeOut(message);
        });
        this.alertSubscription = this.notificationService.alert.subscribe((alert) => {
            if (alert) {
                this.setAlertTimeOut(alert);
            }
        });
    }
    setMessageTimeOut(message) {
        if (message.msg || !this.message) {
            this.message = message.msg;
            this.messagePoliteness = message.politeness;
            setTimeout(() => {
                this.message = '';
            }, message.delay ? message.delay : this.messageExpireInterval);
        }
    }
    setAlertTimeOut(alert) {
        this.alert = alert.msg;
        setTimeout(() => {
            this.alert = '';
        }, alert.delay ? alert.delay : this.alertExpireInterval);
    }
    ngOnDestroy() {
        if (this.messageSubscription) {
            this.messageSubscription.unsubscribe();
        }
        if (this.alertSubscription) {
            this.alertSubscription.unsubscribe();
        }
    }
}
NotificationComponent.ɵfac = function NotificationComponent_Factory(t) { return new (t || NotificationComponent)(ɵngcc0.ɵɵdirectiveInject(NotificationService)); };
NotificationComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: NotificationComponent, selectors: [["ui-notification"]], inputs: { messageExpireInterval: "messageExpireInterval", messagePoliteness: "messagePoliteness", alertExpireInterval: "alertExpireInterval", message: "message", alert: "alert" }, decls: 3, vars: 5, consts: [["role", "status", 1, "sr-only", 3, "innerHTML"], ["class", "sr-only", "role", "alert", 3, "innerHTML", 4, "ngIf"], ["role", "alert", 1, "sr-only", 3, "innerHTML"]], template: function NotificationComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", 0);
        ɵngcc0.ɵɵpipe(1, "translate");
        ɵngcc0.ɵɵtemplate(2, NotificationComponent_div_2_Template, 2, 3, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("innerHTML", ɵngcc0.ɵɵpipeBind1(1, 3, ctx.message), ɵngcc0.ɵɵsanitizeHtml);
        ɵngcc0.ɵɵattribute("aria-live", ctx.messagePoliteness);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.alert);
    } }, directives: [ɵngcc1.NgIf], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
NotificationComponent.ctorParameters = () => [
    { type: NotificationService }
];
NotificationComponent.propDecorators = {
    message: [{ type: Input }],
    messageExpireInterval: [{ type: Input }],
    messagePoliteness: [{ type: Input }],
    alert: [{ type: Input }],
    alertExpireInterval: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationComponent, [{
        type: Component,
        args: [{
                selector: 'ui-notification',
                template: "<div class=\"sr-only\" role=\"status\" [attr.aria-live]=\"messagePoliteness\" [innerHTML]=\"message | translate\"></div>\n<div *ngIf=\"alert\" class=\"sr-only\" role=\"alert\" [innerHTML]=\"alert | translate\"></div>\n"
            }]
    }], function () { return [{ type: NotificationService }]; }, { messageExpireInterval: [{
            type: Input
        }], messagePoliteness: [{
            type: Input
        }], alertExpireInterval: [{
            type: Input
        }], message: [{
            type: Input
        }], alert: [{
            type: Input
        }] }); })();

/*
 * Filters a list of controls based on property
 * Usage:
 *   value | controlsFilter:{property: string, value: any}
 * Example:
 *   *ngFor=" let field of (formFields | controlsFilter:{'property': 'required', 'value': true})"
 */
class ControlsFilterPipe {
    transform(arr, filter) {
        if (!arr || arr.length === 0) {
            return [];
        }
        return arr.filter(f => f[filter.property] === filter.value);
    }
}
ControlsFilterPipe.ɵfac = function ControlsFilterPipe_Factory(t) { return new (t || ControlsFilterPipe)(); };
ControlsFilterPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "controlsFilter", type: ControlsFilterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ControlsFilterPipe, [{
        type: Pipe,
        args: [{ name: 'controlsFilter' }]
    }], null, null); })();

class MaintenanceComponent {
    constructor(translate, titleService, lastResponseService) {
        this.translate = translate;
        this.titleService = titleService;
        this.lastResponseService = lastResponseService;
        this.page = {};
        this.translate.get([
            'ui.maintenance.default_title',
            'ui.maintenance.default_message'
        ]).subscribe(maintenanceTexts => {
            this.page.title = maintenanceTexts['ui.maintenance.default_title'];
            this.page.message = maintenanceTexts['ui.maintenance.default_message'];
            this.page.homeRoute = '/';
            if (this.lastResponseService.ifResponse) {
                const response = this.lastResponseService.ifResponse;
                const lastResponseData = response.Results.data;
                if (lastResponseData) {
                    Object.keys(lastResponseData).some(key => {
                        if (lastResponseData[key].maintenanceMessage) {
                            this.page.message = lastResponseData[key].maintenanceMessage;
                            return true;
                        }
                    });
                }
            }
        });
    }
    ngOnInit() {
        this.titleService.setTitle(this.page.title);
    }
}
MaintenanceComponent.ɵfac = function MaintenanceComponent_Factory(t) { return new (t || MaintenanceComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc3.TranslateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc6.Title), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.LastResponseService)); };
MaintenanceComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MaintenanceComponent, selectors: [["ui-maintenance"]], decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "card", "text-center", "p-4"], [1, "card-body"], [3, "innerHTML"], [1, "btn", "btn-primary", "btn-block", 3, "routerLink"]], template: function MaintenanceComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MaintenanceComponent_div_0_Template, 8, 8, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.page);
    } }, directives: [ɵngcc1.NgIf, ɵngcc5.RouterLinkWithHref], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
MaintenanceComponent.ctorParameters = () => [
    { type: TranslateService },
    { type: Title },
    { type: LastResponseService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MaintenanceComponent, [{
        type: Component,
        args: [{
                selector: 'ui-maintenance',
                template: "<div *ngIf=\"page\">\n    <div class=\"card text-center p-4\">\n        <div class=\"card-body\">\n            <h1 [innerHTML]=\"page.title\"></h1>\n            <p [innerHTML]=\"page.message\"></p>\n            <a class=\"btn btn-primary btn-block\"\n                [routerLink]=\"[page.homeRoute]\">{{'ui.maintenance.home' | translate}}</a>\n        </div>\n    </div>\n</div>"
            }]
    }], function () { return [{ type: ɵngcc3.TranslateService }, { type: ɵngcc6.Title }, { type: ɵngcc2.LastResponseService }]; }, null); })();

class YesNoComponent extends FieldComponent {
    constructor() {
        super(...arguments);
        this.change = new EventEmitter();
    }
    ngOnInit() {
        if (this.field) {
            this.checkForError();
            if (this.field.value) {
                this.FormCtrl.setValue(this.field.value);
            }
            else {
                this.FormCtrl.setValue('');
            }
            if (this.field.disabled) {
                this.FormCtrl.disable();
            }
        }
    }
    ngOnDestroy() {
        this.change.complete();
    }
    updateResponseField($event, yesNo) {
        this.field.value = yesNo.value;
        this.FormCtrl.setValue(yesNo.value);
        super.onChangePreProcessor({ src: this.field, args: { form: this.form } });
        this.change.emit(this.field);
    }
    checkRequired($event) {
        if ($event.currentTarget.contains($event.relatedTarget)) {
            return;
        }
        if (this.field.required && !this.field.value) {
            this.hasError = true;
        }
    }
}
YesNoComponent.ɵfac = /*@__PURE__*/ function () { let ɵYesNoComponent_BaseFactory; return function YesNoComponent_Factory(t) { return (ɵYesNoComponent_BaseFactory || (ɵYesNoComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(YesNoComponent)))(t || YesNoComponent); }; }();
YesNoComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: YesNoComponent, selectors: [["ui-yes-no"]], inputs: { field: "field" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "field", "formGroup", "form", "formCtrl", "updateOn", "hasError", 4, "ngIf"], [3, "field", "formGroup", "form", "formCtrl", "updateOn", "hasError"], ["template", ""], ["role", "radiogroup", "tabindex", "-1", 1, "btn-group", 3, "focusout"], ["type", "button", "role", "radio", 1, "btn", "btn-outline-secondary", "px-5", 3, "click"], ["type", "button", "role", "radio", 1, "btn", "btn-outline-primary", "px-5", 3, "click"], ["type", "hidden", 3, "formControlName"]], template: function YesNoComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, YesNoComponent_ui_form_field_0_Template, 3, 6, "ui-form-field", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.field);
    } }, directives: [ɵngcc1.NgIf, FormFieldComponent, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
YesNoComponent.propDecorators = {
    field: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(YesNoComponent, [{
        type: Component,
        args: [{
                selector: 'ui-yes-no',
                template: "<ui-form-field *ngIf=\"field\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\" [updateOn]=\"updateOn\"\n  [hasError]=\"hasError\">\n  <ng-template #template let-field=\"field\">\n    <div class=\"btn-group\" role=\"radiogroup\" [class.ng-invalid]=\"!field.value\" tabindex=\"-1\"\n      (focusout)=\"checkRequired($event)\">\n      <button type=\"button\" role=\"radio\" class=\"btn btn-outline-secondary px-5\" [attr.aria-describedby]=\"ariaDescribedBy\" [attr.aria-errormessage]=\"ariaErrorMessage\"\n        (click)=\"updateResponseField($event, field.no)\"  [attr.data-if-id]=\"field.extraAttributes?.ifId? field.extraAttributes.ifId + '-no' : 'no'\"\n        [class.active]=\"field?.value === field?.no?.value\">{{ field?.no?.label | translate }}</button>\n      <button type=\"button\" role=\"radio\" class=\"btn btn-outline-primary px-5\" [attr.aria-describedby]=\"ariaDescribedBy\" [attr.aria-errormessage]=\"ariaErrorMessage\"\n        (click)=\"updateResponseField($event, field.yes)\" [attr.data-if-id]=\"field.extraAttributes?.ifId? field.extraAttributes.ifId + '-yes' : 'yes'\"\n        [class.active]=\"field?.value === field?.yes?.value\">{{ field?.yes?.label | translate }}</button>\n    </div>\n    <input type=\"hidden\" [formControlName]=\"field.name\">\n  </ng-template>\n</ui-form-field>\n"
            }]
    }], null, { change: [{
            type: Output
        }], field: [{
            type: Input
        }] }); })();

class CarouselComponent {
    constructor() {
        this.slideChange = new EventEmitter();
        this.defaultOptions = {
            interval: 2000,
            keyboard: true,
            pause: 'hover',
            ride: false,
            wrap: true
        };
    }
    ngOnInit() {
        this.active = 0;
        this.carouselOptions = Object.assign(this.defaultOptions, this.carouselOptions);
    }
    ngAfterViewInit() {
        if (this.carousel && this.carousel.nativeElement) {
            this.$carousel = $(this.carousel.nativeElement).carousel(this.carouselOptions);
        }
    }
    next() {
        if (this.$carousel) {
            if (!this.items[this.active + 1]) {
                this.active = 0;
            }
            else {
                this.active++;
            }
            this.$carousel.carousel('pause');
            this.$carousel.carousel('next');
            this.slideChange.emit(this.items[this.active]);
        }
    }
    prev() {
        if (this.$carousel) {
            if (!this.items[this.active - 1]) {
                this.active = this.items.length - 1;
            }
            else {
                this.active--;
            }
            this.$carousel.carousel('pause');
            this.$carousel.carousel('prev');
            this.slideChange.emit(this.items[this.active]);
        }
    }
    goToSlide(idx) {
        if (this.$carousel) {
            this.active = idx;
            this.$carousel.carousel('pause');
            this.$carousel.carousel(idx);
            this.slideChange.emit(this.items[this.active]);
        }
    }
    ngOnDestroy() {
        if (this.$carousel) {
            this.$carousel.carousel('dispose');
        }
    }
    keydownClick($event, index) {
        if ($event.which === 13 || $event.which === 32) {
            let event;
            if (typeof (MouseEvent) === 'function') {
                event = new MouseEvent('click', { bubbles: true });
            }
            else {
                event = document.createEvent('MouseEvent');
                event.initEvent('click', true, true);
            }
            $event.target.dispatchEvent(event);
        }
    }
}
CarouselComponent.ɵfac = function CarouselComponent_Factory(t) { return new (t || CarouselComponent)(); };
CarouselComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: CarouselComponent, selectors: [["ui-carousel"]], contentQueries: function CarouselComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c42, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c43, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.carouselItemTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.carouselTitle = _t.first);
    } }, viewQuery: function CarouselComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c44, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.carousel = _t.first);
    } }, inputs: { carouselOptions: "carouselOptions", items: "items", hideIndicators: "hideIndicators" }, outputs: { slideChange: "slideChange" }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["role", "region", 1, "carousel", "slide"], ["carousel", ""], [4, "ngTemplateOutlet"], ["aria-live", "polite", 1, "carousel-inner", "container"], [4, "ngFor", "ngForOf"], ["type", "button", 1, "btn", "btn-link", "carousel-control-prev", 3, "click"], ["aria-hidden", "true", 1, "ifc-icon", "ifc-chevron-left", "ifc-icon-3", "pl-3"], [1, "sr-only"], ["type", "button", 1, "btn", "btn-link", "carousel-control-next", 3, "click"], ["aria-hidden", "true", 1, "ifc-icon", "ifc-chevron-right", "ifc-icon-3", "pr-3"], [1, "carousel-item"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], [1, "carousel-indicators"], [3, "active", 4, "ngFor", "ngForOf"], ["type", "button", 3, "click"]], template: function CarouselComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, CarouselComponent_ng_container_0_Template, 17, 9, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.items);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgForOf], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
CarouselComponent.TYPE = 'carousel';
CarouselComponent.ctorParameters = () => [];
CarouselComponent.propDecorators = {
    carousel: [{ type: ViewChild, args: ['carousel',] }],
    carouselItemTemplate: [{ type: ContentChild, args: ['carouselItemTemplate',] }],
    carouselTitle: [{ type: ContentChild, args: ['carouselTitle',] }],
    items: [{ type: Input }],
    carouselOptions: [{ type: Input }],
    hideIndicators: [{ type: Input }],
    slideChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CarouselComponent, [{
        type: Component,
        args: [{
                selector: 'ui-carousel',
                template: "<ng-container *ngIf=\"items\">\n  <div class=\"carousel slide\" role=\"region\" #carousel>\n    <ng-container *ngTemplateOutlet=\"carouselTitle\"></ng-container>\n    <div class=\"carousel-inner container\" aria-live=\"polite\">\n      <ng-container *ngFor=\"let item of items; index as idx\">\n        <div class=\"carousel-item\" [class.active]=\"idx === 0\">\n          <ng-container\n            *ngTemplateOutlet=\"carouselItemTemplate; context: { item: item, next: next.bind(this), prev: prev.bind(this), goToSlide: goToSlide.bind(this), index: idx }\">\n          </ng-container>\n        </div>\n      </ng-container>\n    </div>\n\n    <ng-container *ngIf=\"!hideIndicators\">\n      <ol class=\"carousel-indicators\">\n        <li *ngFor=\"let item of items; index as idx\" [class.active]=\"idx === 0\">\n          <button type=\"button\" (click)=\"goToSlide(idx)\">\n            <span class=\"sr-only\">{{ 'ui.carousel.go-to-slide' | translate:{num: (idx+1)} }}</span>\n          </button>\n        </li>\n      </ol>\n    </ng-container>\n\n    <button class=\"btn btn-link carousel-control-prev\" type=\"button\" (click)=\"prev()\">\n      <i class=\"ifc-icon ifc-chevron-left ifc-icon-3 pl-3\" aria-hidden=\"true\"></i>\n      <span class=\"sr-only\">{{ 'ui.carousel.previous' | translate }}</span>\n    </button>\n    <button class=\"btn btn-link carousel-control-next\" type=\"button\" (click)=\"next()\">\n      <i class=\"ifc-icon ifc-chevron-right ifc-icon-3 pr-3\" aria-hidden=\"true\"></i>\n      <span class=\"sr-only\">{{ 'ui.carousel.next' | translate }}</span>\n    </button>\n  </div>\n</ng-container>\n"
            }]
    }], function () { return []; }, { slideChange: [{
            type: Output
        }], carouselOptions: [{
            type: Input
        }], carousel: [{
            type: ViewChild,
            args: ['carousel']
        }], carouselItemTemplate: [{
            type: ContentChild,
            args: ['carouselItemTemplate']
        }], carouselTitle: [{
            type: ContentChild,
            args: ['carouselTitle']
        }], items: [{
            type: Input
        }], hideIndicators: [{
            type: Input
        }] }); })();

class ToggleSwitchDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
    }
    onChange(evt) {
        if (evt.checked) {
            const checkbox = evt.setAttribute ? evt : this.el.nativeElement.querySelector(`input[type="checkbox"][id="${evt.id}"]`);
            this.renderer.setAttribute(checkbox, 'aria-checked', evt.checked);
        }
        else if (evt.target) {
            this.renderer.setAttribute(evt.target, 'aria-checked', evt.target.checked);
        }
    }
    ngAfterViewInit() {
        const field = this.el.nativeElement;
        const checkboxes = field.querySelectorAll('input[type="checkbox"]');
        checkboxes.forEach(checkbox => {
            this.renderer.setAttribute(checkbox, 'role', 'switch');
            this.renderer.setAttribute(checkbox, 'aria-checked', checkbox['checked']);
        });
    }
}
ToggleSwitchDirective.ɵfac = function ToggleSwitchDirective_Factory(t) { return new (t || ToggleSwitchDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ToggleSwitchDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ToggleSwitchDirective, selectors: [["", "toggle-switch", ""]], hostBindings: function ToggleSwitchDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("change", function ToggleSwitchDirective_change_HostBindingHandler($event) { return ctx.onChange($event); });
    } } });
ToggleSwitchDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
ToggleSwitchDirective.propDecorators = {
    onChange: [{ type: HostListener, args: ['change', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToggleSwitchDirective, [{
        type: Directive,
        args: [{ selector: '[toggle-switch]' }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { onChange: [{
            type: HostListener,
            args: ['change', ['$event']]
        }] }); })();

class MessageLoaderComponent {
    constructor() { }
}
MessageLoaderComponent.ɵfac = function MessageLoaderComponent_Factory(t) { return new (t || MessageLoaderComponent)(); };
MessageLoaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MessageLoaderComponent, selectors: [["ui-loading-message-spinner"]], inputs: { loadingMessage: "loadingMessage" }, decls: 3, vars: 1, consts: [[1, "text-center"], ["class", "font-weight-bold", 4, "ngIf"], [1, "font-weight-bold"]], template: function MessageLoaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelement(1, "ui-loading-spinner");
        ɵngcc0.ɵɵtemplate(2, MessageLoaderComponent_div_2_Template, 3, 4, "div", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.loadingMessage);
    } }, directives: [LoadingSpinnerComponent, ɵngcc1.NgIf], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2, data: { animation: [
            trigger('fadeIn', [
                transition(':enter', [
                    style({ opacity: 0 }),
                    animate('1s', style({ opacity: 1 }))
                ])
            ])
        ] } });
MessageLoaderComponent.ctorParameters = () => [];
MessageLoaderComponent.propDecorators = {
    loadingMessage: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MessageLoaderComponent, [{
        type: Component,
        args: [{
                selector: 'ui-loading-message-spinner',
                template: `
  <div class="text-center">
    <ui-loading-spinner></ui-loading-spinner>
    <div *ngIf="loadingMessage" class="font-weight-bold" [@fadeIn]>{{loadingMessage | translate}}</div>
  </div>
  `,
                animations: [
                    trigger('fadeIn', [
                        transition(':enter', [
                            style({ opacity: 0 }),
                            animate('1s', style({ opacity: 1 }))
                        ])
                    ])
                ]
            }]
    }], function () { return []; }, { loadingMessage: [{
            type: Input
        }] }); })();

class MultiSelectToCheckboxComponent {
    constructor() {
        this.change = new EventEmitter();
    }
    ngOnInit() {
        if (this.field && this.field.extraAttributes && this.field.extraAttributes.multiple) {
            this.form.addControl(this.field.name, new FormArray([]));
            this.formArray = this.form.controls[this.field.name];
            const elements = this.field.options.filter(option => option.value).map((option, idx) => {
                if (option.selected) {
                    this.hasValue = true;
                }
                const ctrl = new FormControl(option.selected ? option.value : '');
                return {
                    id: this.field.id + idx,
                    name: this.field.name,
                    ifId: this.field.extraAttributes ? `${this.field.extraAttributes.ifId}-option-${idx}` : undefined,
                    nodeType: 'input',
                    type: 'checkbox',
                    checked: option.selected,
                    required: false,
                    label: option.text,
                    value: option.value,
                    control: ctrl
                };
            });
            elements.forEach(el => this.formArray.push(el.control));
            this.formArray.setValidators(AtleastOneCheckboxRequiredValidator(this.field.required));
            this.fieldset = {
                legend: this.field.label,
                elements: elements,
                nodeType: 'fieldset',
                required: this.field.required,
                name: this.field.name,
                extraAttributes: {
                    ifId: this.field.extraAttributes ? this.field.extraAttributes.ifId : undefined
                }
            };
        }
    }
    changeOccurred($event, field, idx) {
        this.form.controls[this.field.name].controls[idx].setValue($event.target.checked ? field.value : '');
        $event.preventDefault();
        $event.stopPropagation();
        this.change.emit($event);
    }
    checkTouchedStatus() {
        return this.formArray.status === 'INVALID' && this.formArray.controls.some(ctrl => ctrl.touched);
    }
}
MultiSelectToCheckboxComponent.ɵfac = function MultiSelectToCheckboxComponent_Factory(t) { return new (t || MultiSelectToCheckboxComponent)(); };
MultiSelectToCheckboxComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MultiSelectToCheckboxComponent, selectors: [["ui-multi-select-to-checkbox"]], inputs: { form: "form", field: "field" }, outputs: { change: "change" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [3, "formGroup"], ["tabindex", "-1", 1, "form-group"], [1, "form-control-label", 3, "innerHTML"], ["class", "custom-control custom-checkbox", 4, "ngFor", "ngForOf"], ["class", "d-block form-control-feedback mt-1 text-danger", "role", "alert", 4, "ngIf"], [1, "custom-control", "custom-checkbox"], ["ifPII", "", 1, "custom-control-input", 3, "name", "id", "type", "checked", "formControl", "change"], [1, "custom-control-label", 3, "for", "ngClass"], ["role", "alert", 1, "d-block", "form-control-feedback", "mt-1", "text-danger"]], template: function MultiSelectToCheckboxComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MultiSelectToCheckboxComponent_ng_container_0_Template, 8, 10, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.fieldset);
    } }, directives: [ɵngcc1.NgIf, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc1.NgForOf, ɵngcc4.DefaultValueAccessor, ɵngcc2.IfPersonallyIdentifiableInformationDirective, ɵngcc4.NgControlStatus, ɵngcc4.FormControlDirective, ɵngcc1.NgClass], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
MultiSelectToCheckboxComponent.ctorParameters = () => [];
MultiSelectToCheckboxComponent.propDecorators = {
    form: [{ type: Input }],
    field: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultiSelectToCheckboxComponent, [{
        type: Component,
        args: [{
                selector: 'ui-multi-select-to-checkbox',
                template: "<ng-container *ngIf=\"fieldset\">\n  <div [formGroup]=\"form\">\n  <fieldset\n    class=\"form-group\"\n    tabindex=\"-1\"\n    [class.error]=\"fieldset.required && (hasError || checkTouchedStatus())\">\n    <legend class=\"form-control-label\" [class.required]=\"fieldset.required\" [innerHTML]=\"fieldset.legend | translate\"></legend>\n    <div>\n      <div class=\"custom-control custom-checkbox\" *ngFor=\"let f of fieldset.elements; let idx = index\">\n        <input\n          ifPII\n          class=\"custom-control-input\"\n          (change)=\"changeOccurred($event, f, idx)\"\n          [name]=\"f.name\"\n          [id]=\"f.id\"\n          [type]=\"f.type\"\n          [checked]=\"f.checked\"\n          [formControl]=\"f.control\"\n          [attr.data-if-id]=\"f.ifId\"/>\n\n        <label\n          [for]=\"f.id\"\n          class=\"custom-control-label\"\n          [ngClass]=\"{error: hasError, required : f.required}\">\n          {{f.label | translate}}</label>\n        </div>\n    </div>\n    <small class=\"d-block form-control-feedback mt-1 text-danger\" role=\"alert\" *ngIf=\"fieldset.required && checkTouchedStatus()\">\n        {{'ui.form_field.required_text' | translate}}\n    </small>\n  </fieldset>\n</div>\n</ng-container>\n"
            }]
    }], function () { return []; }, { change: [{
            type: Output
        }], form: [{
            type: Input
        }], field: [{
            type: Input
        }] }); })();

const selectUIStepsData = (state) => state.uiSteps;

const setSteps = createAction('[UI Steps] Set steps data', props());
const resetSteps = createAction('[UI Steps] Reset steps progress');
const clearSteps = createAction('[UI Steps] Clear steps data');
const nextStep = createAction('[UI Steps] Set next step active');
const previousStep = createAction('[UI Steps] Set previous step active');
const setActiveStep = createAction('[UI Steps] Set step as active', props());
const updateStepStatus = createAction('[UI Steps] Update current step status', props());

class StepsService {
    constructor(store) {
        this.store = store;
        this.stepClickedSubject = new Subject();
        this.stepsToggle = new Subject();
        this.stepClickedEvent = this.stepClickedSubject.asObservable();
        this.watchToggle = this.stepsToggle.asObservable();
        this.steps = this.store.select(selectUIStepsData);
    }
    updateStepList(steps) {
        this.store.dispatch(setSteps({ steps: steps }));
    }
    clear() {
        this.store.dispatch(clearSteps());
    }
    reset() {
        this.store.dispatch(resetSteps());
    }
    next() {
        this.store.dispatch(nextStep());
    }
    previous() {
        this.store.dispatch(previousStep());
    }
    updateStatus(status) {
        this.store.dispatch(updateStepStatus({ status: status }));
    }
    setActiveStep(step) {
        if (typeof step === 'number') {
            this.store.dispatch(setActiveStep({ idx: step }));
        }
        else {
            this.store.dispatch(setActiveStep({ linkId: step.link.id, linkName: step.link.name }));
        }
    }
    stepClicked(e) {
        this.stepClickedSubject.next(e);
    }
    stepToggle(isShown) {
        this.stepsToggle.next(isShown);
    }
}
StepsService.ɵfac = function StepsService_Factory(t) { return new (t || StepsService)(ɵngcc0.ɵɵinject(ɵngcc7.Store)); };
StepsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function StepsService_Factory() { return new StepsService(i0.ɵɵinject(i1$2.Store)); }, token: StepsService, providedIn: "root" });
StepsService.ctorParameters = () => [
    { type: Store }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StepsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc7.Store }]; }, null); })();

class StepsComponent {
    constructor(stepsService) {
        this.stepsService = stepsService;
        this.stepClick = new EventEmitter();
        this.hasStepData = new EventEmitter();
        this.completed = StepStatus.completed;
    }
    ngOnInit() {
        this.subscription = this.stepsService.steps.subscribe(steps => {
            this.stepList = steps;
            this.hasStepData.emit(!!steps && steps.length > 0);
        });
        this.stepsService.updateStepList(this.stepList);
    }
    ngOnChanges(changes) {
        if (changes.stepList && changes.stepList.currentValue) {
            const change = changes.stepList.currentValue;
            this.hasStepData.emit(!!change && change.length > 0);
        }
    }
    ngOnDestroy() {
        this.stepClick.complete();
        this.hasStepData.complete();
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    stepClicked($event, step) {
        $event.stopPropagation();
        $event.preventDefault();
        if (step.link && (step.link.id || step.link.name)) {
            const e = Object.assign({}, step);
            e.originalEvent = $event;
            this.stepsService.setActiveStep(step);
            this.stepClick.emit(e);
            this.stepsService.stepClicked(e);
            this.stepsService.stepToggle(false);
        }
    }
    checkOverdue(step) {
        if (!step) {
            return;
        }
        if (step.status && step.status === StepStatus.pending && step.dueDate) {
            const today = Date.now();
            const dueDate = Date.parse(step.dueDate);
            return dueDate < today;
        }
        return false;
    }
    keydownSwitchToStep($event) {
        if ($event.which === 13 || $event.which === 32) {
            let event;
            if (typeof (MouseEvent) === 'function') {
                event = new MouseEvent('click', { bubbles: true });
            }
            else {
                event = document.createEvent('MouseEvent');
                event.initEvent('click', true, true);
            }
            $event.target.dispatchEvent(event);
        }
    }
}
StepsComponent.ɵfac = function StepsComponent_Factory(t) { return new (t || StepsComponent)(ɵngcc0.ɵɵdirectiveInject(StepsService)); };
StepsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: StepsComponent, selectors: [["ui-steps"]], contentQueries: function StepsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c47, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.stepListTemplate = _t.first);
    } }, inputs: { stepList: "stepList", readOnly: "readOnly" }, outputs: { stepClick: "stepClick", hasStepData: "hasStepData" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 4, consts: [[1, "sticky-top"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["defaultStepList", ""], ["class", "list-group steps", 4, "ngIf"], [1, "list-group", "steps"], [4, "ngIf", "ngIfElse"], ["notReadOnly", ""], ["tabindex", "-1", "class", "list-group-item list-group-item-action disabled", 3, "active", "overdue", "completed", "d-none", "d-flex", 4, "ngFor", "ngForOf"], ["tabindex", "-1", 1, "list-group-item", "list-group-item-action", "disabled"], [1, "h4", "m-0", 3, "innerHTML"], ["class", "list-group-item list-group-item-action", 3, "active", "disabled", "overdue", "completed", "d-none", "d-flex", "click", "keydown", 4, "ngFor", "ngForOf"], [1, "list-group-item", "list-group-item-action", 3, "click", "keydown"]], template: function StepsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "section", 0);
        ɵngcc0.ɵɵtemplate(1, StepsComponent_ng_container_1_Template, 1, 0, "ng-container", 1);
        ɵngcc0.ɵɵtemplate(2, StepsComponent_ng_template_2_Template, 1, 1, "ng-template", null, 2, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.stepListTemplate ? ctx.stepListTemplate : _r1)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction1(2, _c48, ctx.stepList));
    } }, directives: [ɵngcc1.NgTemplateOutlet, ɵngcc1.NgIf, ɵngcc1.NgForOf], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
StepsComponent.ctorParameters = () => [
    { type: StepsService }
];
StepsComponent.propDecorators = {
    stepListTemplate: [{ type: ContentChild, args: ['stepList',] }],
    stepList: [{ type: Input }],
    readOnly: [{ type: Input }],
    stepClick: [{ type: Output }],
    hasStepData: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StepsComponent, [{
        type: Component,
        args: [{
                selector: 'ui-steps',
                template: "<section class=\"sticky-top\">\n  <ng-container *ngTemplateOutlet=\" stepListTemplate? stepListTemplate: defaultStepList;context{steps:stepList}\"></ng-container>\n  <ng-template #defaultStepList let-steps=\"steps\">\n    <ul class=\"list-group steps\" *ngIf=\"steps\">\n      <ng-container *ngIf=\"readOnly; else notReadOnly\">\n        <li\n          tabindex=\"-1\"\n          [class.active]=\"step.active\"\n          [class.overdue]=\"checkOverdue(step)\"\n          [class.completed]=\"step.status === completed\"\n          [class.d-none]=\"step.hidden\"\n          [class.d-flex]=\"!step.hidden\"\n          class=\"list-group-item list-group-item-action disabled\"\n          *ngFor=\"let step of steps\">\n        <span class=\"h4 m-0\" [innerHTML]=\"step.text | translate\"></span>\n      </li>\n      </ng-container>\n      <ng-template #notReadOnly>\n        <li\n          [attr.tabindex]=\"step.status === completed? '0': '-1'\"\n          [class.active]=\"step.active\"\n          [class.disabled]=\"step.disabled\"\n          [class.overdue]=\"checkOverdue(step)\"\n          [class.completed]=\"step.status === completed\"\n          [class.d-none]=\"step.hidden\"\n          [class.d-flex]=\"!step.hidden\"\n          class=\"list-group-item list-group-item-action\"\n          *ngFor=\"let step of steps\"\n          (click)=\"stepClicked($event, step)\"\n          (keydown)=\"keydownSwitchToStep($event)\">\n        <span class=\"h4 m-0\" [innerHTML]=\"step.text | translate\"></span>\n      </li>\n      </ng-template>\n    </ul>\n  </ng-template>\n</section>\n"
            }]
    }], function () { return [{ type: StepsService }]; }, { stepClick: [{
            type: Output
        }], hasStepData: [{
            type: Output
        }], stepList: [{
            type: Input
        }], stepListTemplate: [{
            type: ContentChild,
            args: ['stepList']
        }], readOnly: [{
            type: Input
        }] }); })();

class StepsHeaderComponent {
    constructor(stepsService) {
        this.stepsService = stepsService;
        this.isShown = false;
    }
    ngOnInit() {
        this.stepsService.updateStepList(this.stepList);
        this.subscription = this.stepsService.steps.subscribe(steps => {
            this.shownStepList = steps === null || steps === void 0 ? void 0 : steps.filter(s => !s.hidden);
        });
        this.stepsService.watchToggle.subscribe((state) => this.isShown = state);
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    getPercentageWidth() {
        if (this.shownStepList) {
            const p = this.getPercentage() * 100;
            return `${p}%`;
        }
        else {
            return '0';
        }
    }
    getPercentage() {
        const total = this.shownStepList.length;
        const currIndex = this.getActive();
        return currIndex / total;
    }
    getActive() {
        if (!this.shownStepList || !this.shownStepList.length) {
            return;
        }
        const curr = this.shownStepList.findIndex((step) => step.active) + 1;
        return curr;
    }
    toggleSteps() {
        this.stepsService.stepToggle(!this.isShown);
    }
}
StepsHeaderComponent.ɵfac = function StepsHeaderComponent_Factory(t) { return new (t || StepsHeaderComponent)(ɵngcc0.ɵɵdirectiveInject(StepsService)); };
StepsHeaderComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: StepsHeaderComponent, selectors: [["ui-steps-header"]], inputs: { stepList: "stepList" }, decls: 2, vars: 2, consts: [["class", "breadcrumb p-0 d-md-none mb-0", 4, "ngIf"], ["class", "progress d-md-none", 4, "ngIf"], [1, "breadcrumb", "p-0", "d-md-none", "mb-0"], ["id", "steps-toggle", "href", "javascript:void(0);", 1, "breadcrumb-item", "p-3", 3, "click"], [1, "ifc-icon", "align-middle", "mr-1", 3, "ngClass"], [1, "counter", "align-middle"], [1, "progress", "d-md-none"], ["role", "progressbar", "aria-valuemin", "0", "aria-valuemax", "100", 1, "progress-bar"]], template: function StepsHeaderComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, StepsHeaderComponent_nav_0_Template, 6, 11, "nav", 0);
        ɵngcc0.ɵɵtemplate(1, StepsHeaderComponent_div_1_Template, 2, 3, "div", 1);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.shownStepList);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.shownStepList);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
StepsHeaderComponent.ctorParameters = () => [
    { type: StepsService }
];
StepsHeaderComponent.propDecorators = {
    stepList: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StepsHeaderComponent, [{
        type: Component,
        args: [{
                selector: 'ui-steps-header',
                template: "<nav class=\"breadcrumb p-0 d-md-none mb-0\" *ngIf=\"shownStepList\">\n  <a id=\"steps-toggle\" href=\"javascript:void(0);\" (click)=\"toggleSteps()\" class=\"breadcrumb-item p-3\">\n    <i class=\"ifc-icon align-middle mr-1\" [ngClass]=\"{'ifc-circle-add': !isShown, 'ifc-circle-remove': isShown}\"></i>\n    <span class=\"counter align-middle\">\n      {{'ui.steps.step_num_of_total' | translate: { 'current': getActive(), 'total': shownStepList.length } }}\n    </span>\n  </a>\n</nav>\n<div class=\"progress d-md-none\" *ngIf=\"shownStepList\">\n  <div class=\"progress-bar\" role=\"progressbar\" [style.width]=\"getPercentageWidth()\"  [attr.aria-valuenow]=\"getPercentage()\" aria-valuemin=\"0\" aria-valuemax=\"100\"></div>\n</div>\n"
            }]
    }], function () { return [{ type: StepsService }]; }, { stepList: [{
            type: Input
        }] }); })();

class InputTimePipe {
    transform(input) {
        input.type = 'time';
        input.value = this.convertTo24HourFormat(input.value);
        return input;
    }
    convertTo24HourFormat(time) {
        if (!time) {
            return;
        }
        const timePattern = /([0-9]+:[0-9]+)(AM|PM)/;
        const timeParts = time.match(timePattern);
        if (!timeParts) {
            return time;
        }
        const hourMinuteString = timeParts[1];
        const AMPM = timeParts[2];
        if (AMPM === 'AM') {
            return hourMinuteString.length === 5 ? hourMinuteString : `0${hourMinuteString}`;
        }
        const hourString = hourMinuteString.substring(0, hourMinuteString.indexOf(':'));
        const hour = parseInt(hourString, 10) + 12;
        const minute = hourMinuteString.substring(hourMinuteString.indexOf(':'));
        return `${hour}${minute}`;
    }
}
InputTimePipe.ɵfac = function InputTimePipe_Factory(t) { return new (t || InputTimePipe)(); };
InputTimePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "inputTime", type: InputTimePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputTimePipe, [{
        type: Pipe,
        args: [{
                name: 'inputTime'
            }]
    }], null, null); })();

class InputTimeComponent {
    constructor(renderer, inputTimePipe) {
        this.renderer = renderer;
        this.inputTimePipe = inputTimePipe;
        this.change = new EventEmitter();
    }
    ngOnInit() {
        if (this.isTimeInputSupported()) {
            this.inputTimePipe.transform(this.field);
        }
    }
    isTimeInputSupported() {
        const testInput = this.renderer.createElement('input');
        const invalidValue = 'testvalue';
        this.renderer.setAttribute(testInput, 'type', 'time');
        this.renderer.setAttribute(testInput, 'value', invalidValue);
        const timeSupported = testInput.value !== invalidValue && testInput.getAttribute('type') === 'time';
        return timeSupported;
    }
    onChange($event) {
        this.change.emit($event);
    }
}
InputTimeComponent.ɵfac = function InputTimeComponent_Factory(t) { return new (t || InputTimeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(InputTimePipe)); };
InputTimeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputTimeComponent, selectors: [["ui-input-time"]], inputs: { field: "field", form: "form", updateOn: "updateOn" }, outputs: { change: "change" }, features: [ɵngcc0.ɵɵProvidersFeature([InputTimePipe])], decls: 1, vars: 3, consts: [[3, "field", "form", "updateOn", "change"]], template: function InputTimeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ui-input", 0);
        ɵngcc0.ɵɵlistener("change", function InputTimeComponent_Template_ui_input_change_0_listener($event) { return ctx.onChange($event); });
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("field", ctx.field)("form", ctx.form)("updateOn", ctx.updateOn);
    } }, directives: [InputComponent], encapsulation: 2 });
InputTimeComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: InputTimePipe }
];
InputTimeComponent.propDecorators = {
    field: [{ type: Input }],
    form: [{ type: Input }],
    updateOn: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputTimeComponent, [{
        type: Component,
        args: [{
                selector: 'ui-input-time',
                template: `<ui-input [field]="field" [form]="form" [updateOn]="updateOn" (change)="onChange($event)"></ui-input>`,
                providers: [InputTimePipe]
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: InputTimePipe }]; }, { change: [{
            type: Output
        }], field: [{
            type: Input
        }], form: [{
            type: Input
        }], updateOn: [{
            type: Input
        }] }); })();

class InputGroupComponent extends FieldComponent {
    constructor() {
        super(...arguments);
        this.change = new EventEmitter();
        this.blur = new EventEmitter();
        this.enter = new EventEmitter();
        this.btnClick = new EventEmitter();
    }
    ngOnDestroy() {
        this.change.complete();
        this.blur.complete();
    }
    changeOccurred($event, field) {
        $event.preventDefault();
        $event.stopPropagation();
        field.value = $event.currentTarget.value;
        this.form.value[field.name] = field.value;
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(field);
    }
    handleBlur(field) {
        this.blur.emit(field);
    }
    handleEnter($event, field) {
        if (this.preventDefaultOnEnter) {
            $event.preventDefault();
        }
        this.enter.emit(field);
    }
    handleClick(event, btn, field) {
        this.btnClick.emit({ field, button: btn });
        event.stopPropagation();
    }
}
InputGroupComponent.ɵfac = /*@__PURE__*/ function () { let ɵInputGroupComponent_BaseFactory; return function InputGroupComponent_Factory(t) { return (ɵInputGroupComponent_BaseFactory || (ɵInputGroupComponent_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(InputGroupComponent)))(t || InputGroupComponent); }; }();
InputGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputGroupComponent, selectors: [["ui-input-group"]], inputs: { icon: "icon", button: "button", field: "field", preventDefaultOnEnter: "preventDefaultOnEnter" }, outputs: { change: "change", blur: "blur", enter: "enter", btnClick: "btnClick" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[3, "field", "formGroup", "form", "formCtrl", "hasError", "updateOn", 4, "ngIf"], [3, "field", "formGroup", "form", "formCtrl", "hasError", "updateOn"], ["template", ""], [1, "input-group"], ["ifPII", "", "base-input", "", 1, "form-control", 3, "formControlName", "field", "ngClass", "input", "blur", "keydown.enter"], ["base-button", "", 1, "input-group-addon", 3, "field", "click"], [3, "class", 4, "ngIf"]], template: function InputGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, InputGroupComponent_ui_form_field_0_Template, 3, 6, "ui-form-field", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.field);
    } }, directives: [ɵngcc1.NgIf, FormFieldComponent, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.DefaultValueAccessor, ɵngcc2.IfPersonallyIdentifiableInformationDirective, InputDirective, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, ɵngcc1.NgClass, ButtonDirective], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
InputGroupComponent.propDecorators = {
    icon: [{ type: Input }],
    button: [{ type: Input }],
    field: [{ type: Input }],
    preventDefaultOnEnter: [{ type: Input }],
    change: [{ type: Output }],
    blur: [{ type: Output }],
    enter: [{ type: Output }],
    btnClick: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputGroupComponent, [{
        type: Component,
        args: [{
                selector: 'ui-input-group',
                template: "<ui-form-field *ngIf=\"field\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\"\n  [hasError]=\"hasError\" [updateOn]=\"updateOn\">\n  <ng-template #template let-field=\"field\">\n    <div class=\"input-group\">\n      <input ifPII base-input class=\"form-control\" [formControlName]=\"field?.name\"\n        (input)=\"changeOccurred($event, field)\" [field]=\"field\" (blur)=\"handleBlur(field)\"\n        [attr.data-if-id]=\"field?.extraAttributes?.ifId\" (keydown.enter)=\"handleEnter($event, field)\"\n        [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\" />\n      <button base-button class=\"input-group-addon\" [field]=\"button\"\n        (click)=\"handleClick($event, button, field)\">\n        <i *ngIf=\"icon\" class=\"{{icon}} p-2\"></i>\n        <span [class.sr-only]=\"icon\">{{button.text | translate}}</span>\n      </button>\n    </div>\n  </ng-template>\n</ui-form-field>\n"
            }]
    }], null, { change: [{
            type: Output
        }], blur: [{
            type: Output
        }], enter: [{
            type: Output
        }], btnClick: [{
            type: Output
        }], icon: [{
            type: Input
        }], button: [{
            type: Input
        }], field: [{
            type: Input
        }], preventDefaultOnEnter: [{
            type: Input
        }] }); })();

class BrowserDetectionService {
    constructor() {
        this.defaultBrowserConstraints = {
            mobile: {
                safari: '>=13'
            },
            chrome: '>=90',
            edge: '>=90',
            firefox: '>=70',
            safari: '>=13',
        };
        this.browser = Bowser.getParser(window.navigator.userAgent);
    }
    getBrowserName() {
        return this.browser.getBrowserName();
    }
    getBrowserVersion() {
        return this.browser.getBrowserVersion();
    }
    getOSName() {
        return this.browser.getOSName();
    }
    getBrowserDetails() {
        return this.browser.getBrowser();
    }
    isSupported(browserConstraints) {
        let isSupported;
        if (browserConstraints) {
            isSupported = this.browser.satisfies(browserConstraints);
            if (!isSupported) {
                if (this.browser.getBrowserVersion() === undefined && this.browser.getBrowserName() === 'Safari' && this.browser.getOSName() === 'iOS' && parseInt(this.browser.getOSVersion(), 10) > 10) {
                    isSupported = true; // fix iOS webview version gets reported as undefined
                }
                if (this.browser.getUA().indexOf('Teams/') > -1) {
                    isSupported = true; // fix for MS Teams
                }
            }
        }
        else {
            isSupported = this.browser.satisfies(this.defaultBrowserConstraints);
        }
        return isSupported;
    }
    isMobile() {
        const platformType = this.browser.getPlatformType(true);
        return platformType === 'mobile';
    }
}
BrowserDetectionService.ɵfac = function BrowserDetectionService_Factory(t) { return new (t || BrowserDetectionService)(); };
BrowserDetectionService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: BrowserDetectionService, factory: BrowserDetectionService.ɵfac });
BrowserDetectionService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BrowserDetectionService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class BrowserDetectionComponent {
    constructor(service, browserService, changesRef) {
        this.service = service;
        this.browserService = browserService;
        this.changesRef = changesRef;
        this.notSatisfied = true;
        this.showDialog = false;
        this.storageMethod = StorageMethod.Cookie;
        this.browserInfo = [
            {
                key: 'firefox',
                name: 'ui.browser-detection.firefox',
                os: 'ui.browser-detection.os.macwin',
                link: 'https://www.mozilla.org/en-US/firefox/new/?redirect_source=firefox-com',
                icon: 'https://media-img.demo.inflightcloud.com/ifc/svg/browsers/browser-firefox.svg',
                modern: true
            },
            {
                key: 'chrome',
                name: 'ui.browser-detection.chrome',
                os: 'ui.browser-detection.os.macwin',
                link: 'https://www.google.com/chrome/',
                icon: 'https://media-img.demo.inflightcloud.com/ifc/svg/browsers/browser-chrome.svg',
                modern: true
            },
            {
                key: 'safari',
                name: 'ui.browser-detection.safari',
                os: 'ui.browser-detection.os.mac',
                link: 'https://www.apple.com/safari/',
                icon: 'https://media-img.demo.inflightcloud.com/ifc/svg/browsers/browser-safari.svg',
                modern: true
            },
            {
                key: 'edge',
                name: 'ui.browser-detection.edge',
                os: 'ui.browser-detection.os.win',
                link: 'https://www.microsoft.com/en-us/windows/microsoft-edge',
                icon: 'https://media-img.demo.inflightcloud.com/ifc/svg/browsers/browser-edge.svg',
                modern: true
            },
            {
                key: 'internet explorer',
                name: 'ui.browser-detection.ie',
                os: 'ui.browser-detection.os.win',
                link: 'https://support.microsoft.com/en-us/help/17621/internet-explorer-downloads',
                icon: 'https://media-img.demo.inflightcloud.com/ifc/svg/browsers/browser-ie.svg',
                modern: false
            }
        ];
        this.defaultBrowserConstraints = {
            windows: {
                ie: '>=11'
            },
            mobile: {
                safari: '>=11'
            },
            chrome: '>=70',
            edge: '>=17',
            firefox: '>=70',
            safari: '>=11',
        };
    }
    ngOnInit() {
        this.details = this.browserService.getBrowserDetails();
        if (!this.service.check(BrowserDetectionComponent.BROWSER_DETECTION_KEY, this.storageMethod)) {
            if (this.browserConstraints) {
                this.notSatisfied = !this.browserService.isSupported(this.browserConstraints);
                this.supportedBrowserInfo = this.browserInfo.filter(bi => {
                    return this.browserConstraints[bi.key] ||
                        (this.browserConstraints.windows && this.browserConstraints.windows[bi.key]) ||
                        (this.browserConstraints.mobile && this.browserConstraints.mobile[bi.key]);
                });
            }
            else {
                this.notSatisfied = !this.browserService.isSupported();
                this.supportedBrowserInfo = this.browserInfo;
            }
            this.browserInfo.some(b => {
                if (this.details.name.toLowerCase() === b.key) {
                    this.currentBrowserInfo = b;
                    return true;
                }
            });
            this.isSupported = this.currentBrowserInfo && this.supportedBrowserInfo.find(sbi => sbi.key === this.currentBrowserInfo.key);
            this.showDialog = this.notSatisfied;
        }
    }
    dismiss() {
        this.showDialog = false;
        this.service.set(BrowserDetectionComponent.BROWSER_DETECTION_KEY, 'dismiss', this.storageMethod);
        setTimeout(() => {
            this.notSatisfied = false;
            this.changesRef.markForCheck();
        }, 700);
    }
}
BrowserDetectionComponent.ɵfac = function BrowserDetectionComponent_Factory(t) { return new (t || BrowserDetectionComponent)(ɵngcc0.ɵɵdirectiveInject(StorageService), ɵngcc0.ɵɵdirectiveInject(BrowserDetectionService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
BrowserDetectionComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BrowserDetectionComponent, selectors: [["ui-browser-detection"]], inputs: { storageMethod: "storageMethod", browserConstraints: "browserConstraints" }, decls: 1, vars: 1, consts: [[4, "ngIf"], [1, "d-flex", "flex-column", "justify-content-between"], [1, "card-body", "p-4", "pt-5", "text-center", "position-relative"], [4, "ngIf", "ngIfElse"], ["unsupportedTitle", ""], ["type", "button", 1, "m-2", "btn", "btn-outline-primary", "border-0", 3, "title", "click"], [1, "ifc-icon", "ifc-remove"], ["unsupportedDescription", ""], [1, "text-center", "px-4"], ["target", "_blank", 3, "href", 4, "ngIf"], [1, "card-footer", "text-center", "px-1", "py-3"], [1, "mb-4"], ["upgrade", ""], ["class", "d-flex flex-row justify-content-center align-items-center", 4, "ngIf"], ["target", "_blank", 3, "href"], ["width", "60", 3, "src", "title"], [1, "pt-2"], [1, "d-flex", "flex-row", "justify-content-center", "align-items-center"], [4, "ngFor", "ngForOf"], [1, "text-center", "px-1", "px-md-4"], ["width", "40", 3, "src", "title"]], template: function BrowserDetectionComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BrowserDetectionComponent_ng_container_0_Template, 22, 12, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.notSatisfied);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2, data: { animation: [
            trigger('toggle', [
                state('*', style({ opacity: 0, transform: 'translateY(-100%)' })),
                state('hidden', style({ opacity: 0, transform: 'translateY(100%)' })),
                state('visible', style({ opacity: 1, transform: 'translateY(0)' })),
                transition('* => visible', animate('0.2s ease-in')),
                transition('* => hidden', animate('0.3s ease-in'))
            ])
        ] } });
BrowserDetectionComponent.BROWSER_DETECTION_KEY = 'uiBrowserDialog';
BrowserDetectionComponent.ctorParameters = () => [
    { type: StorageService },
    { type: BrowserDetectionService },
    { type: ChangeDetectorRef }
];
BrowserDetectionComponent.propDecorators = {
    browserConstraints: [{ type: Input }],
    storageMethod: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BrowserDetectionComponent, [{
        type: Component,
        args: [{
                selector: 'ui-browser-detection',
                template: "<ng-container *ngIf=\"notSatisfied\">\n  <section class=\"d-flex flex-column justify-content-between\" [@toggle]=\"showDialog?  'visible': 'hidden'\">\n    <div class=\"card-body p-4 pt-5 text-center position-relative\">\n      <h1>\n        <span *ngIf=\"isSupported; else unsupportedTitle\">\n          {{ 'ui.browser-detection.title' | translate }}\n        </span>\n        <ng-template #unsupportedTitle>\n          <span>\n            {{ 'ui.browser-detection.unsupported_title' | translate }}\n          </span>\n        </ng-template>\n      </h1>\n      <button type=\"button\" class=\"m-2 btn btn-outline-primary border-0\"\n        (click)=\"dismiss()\" [title]=\"'ui.browser-detection.dismiss' | translate\"><i class=\"ifc-icon ifc-remove\"></i></button>\n      <p>\n        <span *ngIf=\"isSupported; else unsupportedDescription\">\n          {{ 'ui.browser-detection.description' | translate:{'browser': details?.name, version: details?.version} }}\n        </span>\n        <ng-template #unsupportedDescription>\n          <span>\n            {{ 'ui.browser-detection.unsupported_description' | translate:{'browser': details?.name, version: details?.version} }}\n          </span>\n        </ng-template>\n      </p>\n      <div class=\"text-center px-4\">\n        <a *ngIf=\"currentBrowserInfo?.modern && isSupported\" [href]=\"currentBrowserInfo?.link\" target=\"_blank\">\n          <img width=\"60\" [src]=\"currentBrowserInfo.icon\" [title]=\"currentBrowserInfo.name | translate\">\n          <div class=\"pt-2\">{{'ui.browser-detection.update'|translate:{'browser': details?.name} }}</div>\n        </a>\n      </div>\n\n\n    </div>\n    <div class=\"card-footer text-center px-1 py-3\">\n      <h2 class=\"mb-4\">\n        <span *ngIf=\"currentBrowserInfo?.modern && isSupported; else upgrade\">\n          {{'ui.browser-detection.optional'| translate }}\n        </span>\n        <ng-template #upgrade>\n          <span>\n            {{ 'ui.browser-detection.try'| translate }}\n          </span>\n        </ng-template>\n      </h2>\n\n      <div *ngIf=\"supportedBrowserInfo\" class=\"d-flex flex-row justify-content-center align-items-center\">\n\n        <ng-container *ngFor=\"let bi of supportedBrowserInfo\">\n          <ng-container *ngIf=\"bi.modern && (!currentBrowserInfo || bi.key !== currentBrowserInfo.key)\">\n            <div class=\"text-center px-1 px-md-4\">\n              <a [href]=\"bi.link\" target=\"_blank\">\n                <img width=\"40\" [src]=\"bi.icon\" [title]=\"bi.name | translate\">\n                <div class=\"pt-2\">{{ 'ui.browser-detection.install' | translate: { browser: bi.name | translate } }}</div>\n              </a>\n            </div>\n          </ng-container>\n        </ng-container>\n      </div>\n\n    </div>\n  </section>\n</ng-container>\n",
                animations: [
                    trigger('toggle', [
                        state('*', style({ opacity: 0, transform: 'translateY(-100%)' })),
                        state('hidden', style({ opacity: 0, transform: 'translateY(100%)' })),
                        state('visible', style({ opacity: 1, transform: 'translateY(0)' })),
                        transition('* => visible', animate('0.2s ease-in')),
                        transition('* => hidden', animate('0.3s ease-in'))
                    ])
                ]
            }]
    }], function () { return [{ type: StorageService }, { type: BrowserDetectionService }, { type: ɵngcc0.ChangeDetectorRef }]; }, { storageMethod: [{
            type: Input
        }], browserConstraints: [{
            type: Input
        }] }); })();

class ProgressBarComponent {
    constructor() {
        this.valueFormat = '1.0-2';
        this.variant = 'success';
    }
    ngOnChanges() {
        this.updatePercentComplete();
    }
    updatePercentComplete() {
        this.percentComplete = (this.complete / this.total) * 100;
    }
}
ProgressBarComponent.ɵfac = function ProgressBarComponent_Factory(t) { return new (t || ProgressBarComponent)(); };
ProgressBarComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ProgressBarComponent, selectors: [["ui-progress-bar"]], inputs: { valueFormat: "valueFormat", variant: "variant", total: "total", complete: "complete", showProgressLabel: "showProgressLabel" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 4, vars: 11, consts: [[1, "progress"], ["role", "progressbar", "aria-valuemin", "0", "aria-valuemax", "100", 3, "ngStyle"], ["class", "progressBarLabel", 4, "ngIf"], [1, "progressBarLabel"]], template: function ProgressBarComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵpipe(2, "number");
        ɵngcc0.ɵɵtemplate(3, ProgressBarComponent_div_3_Template, 3, 4, "div", 2);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("progress-bar bg-", ctx.variant, "");
        ɵngcc0.ɵɵproperty("ngStyle", ɵngcc0.ɵɵpureFunction1(9, _c54, ctx.percentComplete + "%"));
        ɵngcc0.ɵɵattribute("aria-valuenow", ɵngcc0.ɵɵpipeBind2(2, 6, ctx.percentComplete, ctx.valueFormat));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showProgressLabel);
    } }, directives: [ɵngcc1.NgStyle, ɵngcc1.NgIf], pipes: [ɵngcc1.DecimalPipe], encapsulation: 2 });
ProgressBarComponent.ctorParameters = () => [];
ProgressBarComponent.propDecorators = {
    total: [{ type: Input }],
    complete: [{ type: Input }],
    valueFormat: [{ type: Input }],
    showProgressLabel: [{ type: Input }],
    variant: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProgressBarComponent, [{
        type: Component,
        args: [{
                selector: 'ui-progress-bar',
                template: "<div class=\"progress\">\n    <div class=\"progress-bar bg-{{variant}}\" role=\"progressbar\"\n        [attr.aria-valuenow]=\"percentComplete | number:valueFormat\"\n        [ngStyle]=\"{'width': percentComplete + '%'}\"\n        aria-valuemin=\"0\" aria-valuemax=\"100\">\n        <div *ngIf=\"showProgressLabel\" class=\"progressBarLabel\">\n            {{this.percentComplete | number:valueFormat}}%\n        </div>\n    </div>\n</div>\n"
            }]
    }], function () { return []; }, { valueFormat: [{
            type: Input
        }], variant: [{
            type: Input
        }], total: [{
            type: Input
        }], complete: [{
            type: Input
        }], showProgressLabel: [{
            type: Input
        }] }); })();

class MultiSelectDropdownComponent extends FieldComponent {
    constructor(changesRef, translate, settings) {
        super(settings);
        this.changesRef = changesRef;
        this.translate = translate;
        this.change = new EventEmitter();
        this.unselected = new EventEmitter();
        this.btnClick = new EventEmitter();
        this.selected = new EventEmitter();
        this.listToggle = false;
        this.dropdownActiveIndex = -1;
    }
    ngOnInit() {
        super.ngOnInit();
        this.updateLists();
    }
    updateLists() {
        this.dropdownSet = this.field.options.filter(op => op.value && !op.selected).map(op => Object.assign({}, op));
        this.selectedSet = this.field.options.filter(op => op.value && op.selected).map(op => Object.assign({}, op));
        if (this.FormCtrl) {
            const value = [];
            this.selectedSet.forEach(op => {
                value.push(op.value);
            });
            value.length ? this.FormCtrl.setValue(value) : this.FormCtrl.setValue('');
        }
    }
    addSelected(selected) {
        this.field.options.some(op => {
            if (op.value === selected.value) {
                op.selected = true;
                return true;
            }
        });
        this.updateLists();
    }
    removeSelected(selected) {
        this.field.options.some(op => {
            if (op.value === selected.value) {
                op.selected = false;
                this.unselected.emit(op);
                return true;
            }
        });
        this.updateLists();
    }
    removeAllSelected() {
        this.field.options.forEach(op => {
            if (op.selected) {
                this.unselected.emit(op);
                op.selected = false;
            }
        });
        this.updateLists();
    }
    ngOnDestroy() { }
    closeList($event) {
        if ($event && $event.currentTarget && $event.currentTarget.contains($event.relatedTarget)) {
            return true;
        }
        if (this.input.nativeElement) {
            this.input.nativeElement.value = '';
        }
        this.listToggle = false;
        this.filterBy = '';
        this.dropdownActiveIndex = -1;
        if (this.selectedSet.length === 0) {
            setTimeout(() => {
                this.hasError = true;
            });
        }
        this.changesRef.markForCheck();
    }
    iterateList($event, input) {
        if ($event.which === 27 || $event.which === 9) { // escape or tab keys
            this.closeList();
            return;
        }
        if ($event.which !== 9 && $event.which !== 13) {
            this.listToggle = true;
        }
        let dropdownSet = this.dropdownSet;
        if (this.filterBy) {
            dropdownSet = this.dropdownSet.filter(op => op.text.toLowerCase().indexOf(this.filterBy.toLowerCase()) > -1);
        }
        if (dropdownSet.length > 0 && this.dropdownActiveIndex !== undefined) {
            if ($event.which === 38) {
                // up
                $event.preventDefault();
                $event.stopPropagation();
                this.dropdownActiveIndex = this.dropdownActiveIndex - 1 < 0 ? dropdownSet.length - 1 : this.dropdownActiveIndex - 1;
                if (this.listitems && this.listitems.toArray()[this.dropdownActiveIndex]) {
                    this.listitems.toArray()[this.dropdownActiveIndex].nativeElement.scrollIntoView(false);
                }
                if (this.dropdownActiveIndex >= 0 && this.dropdownActiveIndex < dropdownSet.length) {
                    this.input.nativeElement.value = dropdownSet[this.dropdownActiveIndex].text;
                }
                this.changesRef.markForCheck();
                return true;
            }
            else if ($event.which === 40) {
                // down
                $event.preventDefault();
                $event.stopPropagation();
                this.dropdownActiveIndex = this.dropdownActiveIndex + 1 > dropdownSet.length ? 0 : this.dropdownActiveIndex + 1;
                if (this.listitems && this.listitems.toArray()[this.dropdownActiveIndex]) {
                    this.listitems.toArray()[this.dropdownActiveIndex].nativeElement.scrollIntoView(false);
                }
                if (this.dropdownActiveIndex >= 0 && this.dropdownActiveIndex < dropdownSet.length) {
                    this.input.nativeElement.value = dropdownSet[this.dropdownActiveIndex].text;
                }
                this.changesRef.markForCheck();
                return true;
            }
            else if ($event.which === 13) {
                // enter
                $event.preventDefault();
                $event.stopPropagation();
                if (this.listToggle && dropdownSet && this.dropdownActiveIndex !== undefined && dropdownSet[this.dropdownActiveIndex]) {
                    this.addSelected(dropdownSet[this.dropdownActiveIndex]);
                    this.dropdownActiveIndex = 0;
                    this.filterBy = '';
                    input.value = '';
                    this.listToggle = false;
                }
                return true;
            }
            else {
                this.dropdownActiveIndex = 0;
            }
        }
    }
    updateInput(selected, input, idx) {
        this.addSelected(selected);
        this.dropdownActiveIndex = idx ? idx : -1;
        this.listToggle = false;
        this.filterBy = '';
        input.value = '';
        this.change.emit(selected);
        this.selected.emit(input);
    }
    btnClickAction($event, input) {
        this.btnClick.emit({
            event: UIEvent,
            value: input.value,
            input: input
        });
        this.closeList(undefined);
    }
    trackBySelected(index, selected) {
        return selected.value;
    }
}
MultiSelectDropdownComponent.ɵfac = function MultiSelectDropdownComponent_Factory(t) { return new (t || MultiSelectDropdownComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.TranslateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.SettingsService)); };
MultiSelectDropdownComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MultiSelectDropdownComponent, selectors: [["ui-multi-select-dropdown"]], viewQuery: function MultiSelectDropdownComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c55, 5);
        ɵngcc0.ɵɵviewQuery(_c40, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.input = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.listitems = _t);
    } }, inputs: { field: "field", showBtn: "showBtn", btnTitle: "btnTitle", btnIconCss: "btnIconCss", placeholder: "placeholder" }, outputs: { change: "change", unselected: "unselected", btnClick: "btnClick", selected: "selected" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature], decls: 1, vars: 1, consts: [[4, "ngIf"], ["tabindex", "-1", 1, "form-group", 3, "focusout"], [3, "field", "formGroup", "form", "formCtrl", "updateOn", "hasError", 4, "ngIf"], ["role", "region", 1, "d-flex", "flex-row", "align-items-center"], [1, "mr-3", "sr-only"], ["class", "d-flex flex-row align-items-center mr-3", 4, "ngFor", "ngForOf", "ngForTrackBy"], ["class", "ml-auto pr-2", 4, "ngIf"], [1, "d-flex", "flex-row", "align-items-center", "mr-3"], ["href", "javascript:void(0);", "role", "button", 1, "ml-2", 3, "title", "click"], [1, "ifc-icon", "ifc-remove", "align-middle"], [1, "sr-only"], [1, "ml-auto", "pr-2"], ["type", "button", 1, "btn", "btn-outline-primary", "btn-sm", 3, "title", "click"], [3, "field", "formGroup", "form", "formCtrl", "updateOn", "hasError"], ["template", ""], [1, "input-group", 3, "ngClass"], ["ifPII", "", "type", "text", "autocomplete", "off", "aria-autocomplete", "list", "role", "combobox", 1, "form-control", 3, "id", "placeholder", "value", "keydown", "focus", "input"], ["dropdownInput", ""], [1, "input-group-append"], [1, "ifc-icon", "ifc-triangle-down"], ["class", "btn btn-primary", "type", "button", "base-button", "", 3, "title", "click", 4, "ngIf"], [3, "class", 4, "ngIf"], ["type", "hidden", 3, "formControlName"], [1, "dropdown-list-container"], [1, "dropdown-list"], [1, "dropdown-up-list"], ["class", "list-group", "role", "listbox", 3, "id", 4, "ngIf"], ["type", "button", "base-button", "", 1, "btn", "btn-primary", 3, "title", "click"], ["role", "listbox", 1, "list-group", 3, "id"], ["role", "option", "class", "list-group-item list-group-item-action", "tabindex", "-1", 3, "active", "click", 4, "ngFor", "ngForOf"], ["role", "option", "tabindex", "-1", 1, "list-group-item", "list-group-item-action", 3, "click"], ["listitems", ""], ["role", "option", 1, "list-group-item", "small", "text-muted"]], template: function MultiSelectDropdownComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, MultiSelectDropdownComponent_ng_container_0_Template, 4, 2, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.field);
    } }, directives: function () { return [ɵngcc1.NgIf, ɵngcc1.NgForOf, FormFieldComponent, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc1.NgClass, ɵngcc2.IfPersonallyIdentifiableInformationDirective, ɵngcc4.DefaultValueAccessor, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, ButtonDirective]; }, pipes: function () { return [ɵngcc3.TranslatePipe, OptionFilterPipe]; }, encapsulation: 2 });
MultiSelectDropdownComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: TranslateService },
    { type: SettingsService }
];
MultiSelectDropdownComponent.propDecorators = {
    input: [{ type: ViewChild, args: ['dropdownInput',] }],
    field: [{ type: Input }],
    showBtn: [{ type: Input }],
    btnTitle: [{ type: Input }],
    btnIconCss: [{ type: Input }],
    placeholder: [{ type: Input }],
    change: [{ type: Output }],
    unselected: [{ type: Output }],
    btnClick: [{ type: Output }],
    selected: [{ type: Output }],
    listitems: [{ type: ViewChildren, args: ['listitems',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MultiSelectDropdownComponent, [{
        type: Component,
        args: [{
                selector: 'ui-multi-select-dropdown',
                template: "<ng-container *ngIf=\"field\">\n\n  <div class=\"form-group\" tabindex=\"-1\" (focusout)=\"closeList($event);\">\n    <ng-container *ngIf=\"selectedSet && selectedSet.length>0\">\n      <div class=\"d-flex flex-row align-items-center\" role=\"region\">\n        <span class=\"mr-3 sr-only\">{{ 'ui.controls.multi-select-dropdown.selected_options' | translate }}</span>\n        <span class=\"d-flex flex-row align-items-center mr-3\"\n          *ngFor=\"let selected of selectedSet; trackBy: trackBySelected\">\n          <span>{{selected.text | translate }}</span>\n          <a href=\"javascript:void(0);\" class=\"ml-2\" role=\"button\" (click)=\"removeSelected(selected);\"\n            title=\"{{'ui.controls.multi-select-dropdown.remove_option' | translate: {'optionName': selected.text} }}\">\n            <i class=\"ifc-icon ifc-remove align-middle\"></i>\n            <span\n              class=\"sr-only\">{{'ui.controls.multi-select-dropdown.remove_option' | translate: {'optionName': selected.text } }}</span>\n          </a>\n        </span>\n        <span class=\"ml-auto pr-2\" *ngIf=\"selectedSet!.length>0\">\n          <button type=\"button\" class=\"btn btn-outline-primary btn-sm\" (click)=\"removeAllSelected();\"\n            [title]=\"'ui.controls.multi-select-dropdown.clear_all' | translate\">\n            <span>{{'ui.controls.multi-select-dropdown.clear_all' | translate}}</span>\n          </button>\n        </span>\n      </div>\n    </ng-container>\n    <ui-form-field *ngIf=\"field\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\" [updateOn]=\"updateOn\"\n      [hasError]=\"hasError\">\n      <ng-template #template let-field=\"field\">\n        <div class=\"input-group\" [ngClass]=\"{'input-group-lg': showBtn }\">\n          <input #dropdownInput ifPII\n            [id]=\"field.id\"\n            class=\"form-control\"\n            type=\"text\"\n            (keydown)=\"iterateList($event, dropdownInput)\"\n            (focus)=\"listToggle=true;dropdownActiveIndex=0;\"\n            (input)=\"filterBy=$event.currentTarget.value;\"\n            autocomplete=\"off\"\n            placeholder=\"{{'ui.controls.multi-select-dropdown.placeholder' | translate}}\"\n            aria-autocomplete=\"list\"\n            [attr.aria-owns]=\"field.id + '_list'\"\n            [attr.aria-expanded]=\"!!dropdownSet && !!dropdownSet?.length\"\n            role=\"combobox\"\n            [value]=\"selectedQuery?.text\" />\n\n          <div class=\"input-group-append\">\n            <i class=\"ifc-icon ifc-triangle-down\"></i>\n            <button *ngIf=\"showBtn\" class=\"btn btn-primary\" type=\"button\" base-button [title]=\"btnTitle | translate\"\n              (click)=\"btnClickAction($event, dropdownInput)\">\n              <i *ngIf=\"btnIconCss\" class=\"{{btnIconCss}}\"></i>\n            </button>\n            <i *ngIf=\"!showBtn && btnIconCss\" class=\"{{btnIconCss}}\"></i>\n          </div>\n\n        </div>\n        <input type=\"hidden\" [formControlName]=\"field.name\">\n        <div class=\"dropdown-list-container\">\n          <div class=\"dropdown-list\">\n            <div class=\"dropdown-up-list\">\n              <ul class=\"list-group\" [id]=\"field.id + '_list'\" role=\"listbox\" *ngIf=\"listToggle && dropdownSet\">\n\n                <ng-container *ngIf=\"dropdownSet?.length > 0\">\n                  <li #listitems *ngFor=\"let item of dropdownSet | optionFilter:{filter: filterBy}; let idx=index\"\n                    role=\"option\" class=\"list-group-item list-group-item-action\"\n                    [class.active]=\"dropdownActiveIndex === idx\" (click)=\"updateInput(item, dropdownInput, idx)\"\n                    tabindex=\"-1\">\n                    {{item.text | translate}}\n                  </li>\n                </ng-container>\n                <ng-container *ngIf=\"dropdownSet?.length === 0\">\n                  <li class=\"list-group-item small text-muted\" role=\"option\">\n                    {{'ui.controls.multi-select-dropdown.empty' | translate}}</li>\n                </ng-container>\n\n                <ng-container\n                  *ngIf=\"dropdownSet?.length > 0 && (dropdownSet | optionFilter:{filter: filterBy}).length === 0\">\n                  <li class=\"list-group-item small text-muted\" role=\"option\">\n                    {{'ui.controls.multi-select-dropdown.no_match' | translate}}</li>\n                </ng-container>\n              </ul>\n            </div>\n          </div>\n        </div>\n      </ng-template>\n\n    </ui-form-field>\n\n  </div>\n\n</ng-container>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc3.TranslateService }, { type: ɵngcc2.SettingsService }]; }, { change: [{
            type: Output
        }], unselected: [{
            type: Output
        }], btnClick: [{
            type: Output
        }], selected: [{
            type: Output
        }], input: [{
            type: ViewChild,
            args: ['dropdownInput']
        }], field: [{
            type: Input
        }], showBtn: [{
            type: Input
        }], btnTitle: [{
            type: Input
        }], btnIconCss: [{
            type: Input
        }], placeholder: [{
            type: Input
        }], listitems: [{
            type: ViewChildren,
            args: ['listitems']
        }] }); })();

class OptionFilterPipe {
    transform(options, filterBy) {
        if (!filterBy.filter) {
            return options;
        }
        else {
            return options.filter(op => op.text.toLowerCase().indexOf(filterBy.filter.toLowerCase()) > -1);
        }
    }
}
OptionFilterPipe.ɵfac = function OptionFilterPipe_Factory(t) { return new (t || OptionFilterPipe)(); };
OptionFilterPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "optionFilter", type: OptionFilterPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OptionFilterPipe, [{
        type: Pipe,
        args: [{ name: 'optionFilter' }]
    }], null, null); })();

class ModalDialogDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.defaultFocusableElementSelector = 'input:not([disabled]):not([type="hidden"]),select:not([disabled]), button:not([disabled]), a';
        this.isAlertDialog = false;
        this.focusedElementSelector = this.defaultFocusableElementSelector;
    }
    ngAfterViewInit() {
        const host = this.el.nativeElement;
        this.renderer.setAttribute(host, 'aria-modal', 'true');
        this.renderer.setAttribute(host, 'role', this.isAlertDialog ? 'alertdialog' : 'dialog');
        const firstFocusableElement = this.el.nativeElement.querySelector(this.focusedElementSelector);
        if (firstFocusableElement) {
            this.unlistenFirstFocusable = this.renderer.listen(firstFocusableElement, 'keydown.shift.tab', () => {
                event.preventDefault();
                this.returnFocusToEnd();
            });
        }
        this.setupLastFocusableElement();
        this.returnFocusToStart();
    }
    ngOnDestroy() {
        if (this.unlistenFirstFocusable) {
            this.unlistenFirstFocusable();
        }
        if (this.unlistenLastFocusable) {
            this.unlistenLastFocusable();
        }
    }
    ngAfterContentChecked() {
        // redetermining last focused element in modal in case the content changed
        this.setupLastFocusableElement();
    }
    returnFocusToStart() {
        setTimeout(() => {
            const focusElement = this.el.nativeElement.querySelector(this.focusedElementSelector);
            if (focusElement) {
                focusElement.focus();
            }
        });
    }
    returnFocusToEnd() {
        setTimeout(() => {
            // ensures accuracy
            if (!this.lastFocusableElementId) {
                const elemList = this.el.nativeElement.querySelectorAll(this.defaultFocusableElementSelector);
                this.lastFocusableElement = elemList.item(elemList.length - 1);
            }
            if (this.lastFocusableElement) {
                this.lastFocusableElement.focus();
            }
        });
    }
    setupLastFocusableElement() {
        if (!this.lastFocusableElementId) {
            const elemList = this.el.nativeElement.querySelectorAll(this.defaultFocusableElementSelector);
            this.lastFocusableElement = elemList.item(elemList.length - 1);
        }
        else {
            this.lastFocusableElement = this.el.nativeElement.querySelector(`[id="${this.lastFocusableElementId}"]`);
        }
        if (this.lastFocusableElement) {
            if (this.unlistenLastFocusable) {
                this.unlistenLastFocusable();
            }
            this.unlistenLastFocusable = this.renderer.listen(this.lastFocusableElement, 'keydown.tab', () => {
                event.preventDefault();
                this.returnFocusToStart();
            });
        }
    }
}
ModalDialogDirective.ɵfac = function ModalDialogDirective_Factory(t) { return new (t || ModalDialogDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ModalDialogDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ModalDialogDirective, selectors: [["", "uiModalDialog", ""]], inputs: { isAlertDialog: "isAlertDialog", focusedElementSelector: "focusedElementSelector", lastFocusableElementId: "lastFocusableElementId" } });
ModalDialogDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
ModalDialogDirective.propDecorators = {
    isAlertDialog: [{ type: Input }],
    focusedElementSelector: [{ type: Input }],
    lastFocusableElementId: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalDialogDirective, [{
        type: Directive,
        args: [{
                selector: '[uiModalDialog]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { isAlertDialog: [{
            type: Input
        }], focusedElementSelector: [{
            type: Input
        }], lastFocusableElementId: [{
            type: Input
        }] }); })();

var KeyCode;
(function (KeyCode) {
    KeyCode[KeyCode["ARROWLEFT"] = 37] = "ARROWLEFT";
    KeyCode[KeyCode["ARROWRIGHT"] = 39] = "ARROWRIGHT";
    KeyCode[KeyCode["TAB"] = 9] = "TAB";
    KeyCode[KeyCode["SPACE"] = 13] = "SPACE";
    KeyCode[KeyCode["ENTER"] = 32] = "ENTER";
})(KeyCode || (KeyCode = {}));
;
class TabGroupComponent {
    constructor(elementRef) {
        this.elementRef = elementRef;
        this.tabChanged = new EventEmitter();
        this.activeTabIndex = 0;
        this.focusTabIndex = 0;
    }
    ngOnInit() {
        this.random = Math.random().toString(36).substring(4);
    }
    keyPress(e) {
        const key = e.key || e.keyCode;
        if (key) {
            e.preventDefault();
            //arrow right
            if (key === KeyCode.ARROWRIGHT || key === "ArrowRight") {
                this.activeTabIndex++;
                if (this.activeTabIndex >= this.tabHeadings.length) {
                    this.activeTabIndex = 0;
                }
                this.elementRef.nativeElement.querySelector(`[id="tab_${this.activeTabIndex}_${this.random}"]`).focus();
                //arrow left
            }
            else if (key === KeyCode.ARROWLEFT || key === "ArrowLeft") {
                this.activeTabIndex--;
                if (this.activeTabIndex < 0) {
                    this.activeTabIndex = this.tabHeadings.length - 1;
                }
                this.elementRef.nativeElement.querySelector(`[id="tab_${this.activeTabIndex}_${this.random}"]`).focus();
            }
            //tab
            else if (key === KeyCode.TAB || key === "Tab") {
                if (e.shiftKey) {
                    this.elementRef.nativeElement.querySelector(`[id="tab_${this.focusTabIndex}_${this.random}"]`).focus();
                }
                else {
                    this.activeTabIndex = this.focusTabIndex;
                    this.elementRef.nativeElement.querySelector(`[id="tabpanel_${this.focusTabIndex}_${this.random}"]`).focus();
                }
            }
            //enter && space
            else if (key === KeyCode.ENTER || key === KeyCode.SPACE || key === "Enter" || key === "Space") {
                this.focusTabIndex = this.activeTabIndex;
                this.emitTabChange();
            }
        }
    }
    emitTabChange() {
        this.tabChanged.emit(this.focusTabIndex);
    }
}
TabGroupComponent.ɵfac = function TabGroupComponent_Factory(t) { return new (t || TabGroupComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
TabGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TabGroupComponent, selectors: [["ui-tab-group"]], contentQueries: function TabGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c59, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.tabPanelTemplate = _t.first);
    } }, inputs: { tabHeadings: "tabHeadings" }, outputs: { tabChanged: "tabChanged" }, decls: 1, vars: 1, consts: [[4, "ngIf"], ["role", "tablist", 1, "nav", "nav-tabs"], ["class", "nav-item", 4, "ngFor", "ngForOf"], ["class", "tab-content", "role", "tabpanel", 3, "id", 4, "ngIf"], [1, "nav-item"], ["href", "javascript:void(0)", "role", "tab", 1, "nav-link", 3, "id", "keydown", "click"], [1, "font-weight-bold"], ["role", "tabpanel", 1, "tab-content", 3, "id"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"]], template: function TabGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TabGroupComponent_ng_container_0_Template, 4, 2, "ng-container", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.tabHeadings);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgForOf, ɵngcc1.NgTemplateOutlet], encapsulation: 2 });
TabGroupComponent.ctorParameters = () => [
    { type: ElementRef }
];
TabGroupComponent.propDecorators = {
    tabPanelTemplate: [{ type: ContentChild, args: ["tabPanelTemplate", { static: false },] }],
    tabHeadings: [{ type: Input }],
    tabChanged: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TabGroupComponent, [{
        type: Component,
        args: [{
                selector: "ui-tab-group",
                template: "<ng-container *ngIf=\"tabHeadings\">\n  <ul class=\"nav nav-tabs\" role=\"tablist\">\n    <li class=\"nav-item\" *ngFor=\"let tab of tabHeadings; let i = index\">\n      <a href=\"javascript:void(0)\" class=\"nav-link\" role=\"tab\" id=\"tab_{{ i }}_{{ random }}\"\n        [attr.aria-selected]=\"focusTabIndex === i\" (keydown)=\"keyPress($event)\"\n        (click)=\"activeTabIndex = i; focusTabIndex = i; emitTabChange()\" attr.aria-controls=\"tabpanel_{{ i }}_{{ random }}\"\n        [attr.tabindex]=\"focusTabIndex == i ? 0:-1\">\n        <div class=\"font-weight-bold\">{{ tab }}</div>\n      </a>\n    </li>\n  </ul>\n  <div class=\"tab-content\" id=\"tabpanel_{{ focusTabIndex }}_{{ random }}\" role=\"tabpanel\" *ngIf=\"tabPanelTemplate\"\n    [attr.tabindex]=\"focusTabIndex == activeTabIndex ? 0 :-1\"\n    [attr.aria-labelledby]=\"'tab_' + activeTabIndex + '_' + random\">\n    <ng-container *ngTemplateOutlet=\"\n        tabPanelTemplate\n        context: { activeTabIndex: focusTabIndex }\n      \"></ng-container>\n  </div>\n</ng-container>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { tabChanged: [{
            type: Output
        }], tabPanelTemplate: [{
            type: ContentChild,
            args: ["tabPanelTemplate", { static: false }]
        }], tabHeadings: [{
            type: Input
        }] }); })();

class ArrowModalDialogDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.defaultFocusableElementSelector = 'input:not([disabled]):not([type="hidden"]),select:not([disabled]), button:not([disabled]), a';
        this.unlistens = [];
    }
    ngAfterViewInit() {
        this.elements = this.el.nativeElement.querySelectorAll(this.defaultFocusableElementSelector);
        this.unlistens.push(this.renderer.listen(this.el.nativeElement, 'keydown.arrowright', () => {
            this.focusNext();
        }));
        this.unlistens.push(this.renderer.listen(this.el.nativeElement, 'keydown.arrowdown', () => {
            this.focusNext();
        }));
        this.unlistens.push(this.renderer.listen(this.el.nativeElement, 'keydown.arrowup', () => {
            this.focusPrevious();
        }));
        this.unlistens.push(this.renderer.listen(this.el.nativeElement, 'keydown.arrowleft', () => {
            this.focusPrevious();
        }));
    }
    focusNext() {
        event.preventDefault();
        for (let i = 0; i < this.elements.length; ++i) {
            if (document.activeElement == this.elements[i]) {
                if (i == this.elements.length - 1) {
                    this.elements[0].focus();
                }
                else {
                    this.elements[i + 1].focus();
                }
                break;
            }
        }
    }
    focusPrevious() {
        event.preventDefault();
        for (let i = 0; i < this.elements.length; ++i) {
            if (document.activeElement == this.elements[i]) {
                if (i == 0) {
                    this.elements[this.elements.length - 1].focus();
                }
                else {
                    this.elements[i - 1].focus();
                }
                break;
            }
        }
    }
    ngOnDestroy() {
        if (this.unlistens && this.unlistens.length) {
            this.unlistens.forEach(unlisten => unlisten());
        }
    }
}
ArrowModalDialogDirective.ɵfac = function ArrowModalDialogDirective_Factory(t) { return new (t || ArrowModalDialogDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
ArrowModalDialogDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ArrowModalDialogDirective, selectors: [["", "uiArrowModalDialog", ""]] });
ArrowModalDialogDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ArrowModalDialogDirective, [{
        type: Directive,
        args: [{
                selector: '[uiArrowModalDialog]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, null); })();

class ToggletipDirective {
    constructor(renderer, el) {
        this.renderer = renderer;
        this.el = el;
        this.showOnHover = false;
        this.showToggle = false;
        this.mouseoutUnlisten = this.onMouseLeave.bind(this);
    }
    onHover() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.showOnHover) {
                this.show(false);
                this.el.nativeElement.addEventListener('mouseleave', this.mouseoutUnlisten, { only: true });
            }
        });
    }
    onFocus() {
        if (this.showOnHover) {
            this.show(false);
        }
    }
    onClick() {
        this.el.nativeElement.removeEventListener('mouseleave', this.mouseoutUnlisten);
        this.show();
    }
    onBlur(evt) {
        if (evt.relatedTarget && this.toggletip && this.toggletip.contains(evt.relatedTarget)) {
            return;
        }
        if (this.showToggle) {
            this.showToggle = !this.showToggle;
            this.hideToggletip();
        }
    }
    onMouseLeave(evt) {
        this.onBlur({ relatedTarget: evt.relatedTarget });
    }
    show(autoFocus = true) {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.showToggle) {
                return;
            }
            this.showToggle = true;
            if (this.exceptionHandler) {
                yield this.exceptionHandler.passToHandleException();
            }
            setTimeout(() => {
                this.showToggletip(autoFocus);
            });
        });
    }
    createToggletip() {
        if (this.toggletip) {
            return;
        }
        this.toggletip = this.renderer.createElement('div');
        if (this.tooltipId) {
            this.toggletip.setAttribute('id', `toggletip_${this.tooltipId}`);
        }
        else {
            this.random = Math.random().toString(36).substring(4);
            this.toggletip.setAttribute('id', `toggletip_${this.random}`);
        }
        this.toggletip.classList.add('if-popover-container');
        this.toggletip.classList.add('popover');
        this.toggletip.classList.add('fade');
        this.toggletip.classList.add(`bs-popover-${this.placement ? this.placement : 'top'}`);
        this.updateToggletipInfo();
        if (this.tooltipId) {
            const parent = document.querySelector(`[id="${this.tooltipId}"]`);
            this.renderer.appendChild(parent, this.toggletip);
        }
        else {
            const nextSibling = this.renderer.nextSibling(this.el.nativeElement);
            const parent = this.renderer.parentNode(this.el.nativeElement);
            if (nextSibling) {
                this.renderer.insertBefore(parent, this.toggletip, nextSibling);
            }
            else {
                this.renderer.appendChild(parent, this.toggletip);
            }
        }
        this.renderer.setAttribute(this.toggletip, 'tabindex', '-1');
        this.renderer.setStyle(this.toggletip, 'display', 'none');
    }
    updateToggletipInfo() {
        const content = this.description ? `<div class="popover-body">${this.description}</div>` : '';
        this.toggletip.innerHTML = `<div class="arrow"></div>${content}`;
    }
    showToggletip(autoFocus) {
        this.createToggletip();
        setTimeout(() => {
            if (!this.popper) {
                this.popper = new Popper(this.el.nativeElement, this.toggletip, {
                    placement: this.placement ? this.placement : 'top',
                    modifiers: {
                        arrow: {
                            element: '.arrow'
                        }
                    }
                });
                this.renderer.removeClass(this.toggletip, 'fade');
                this.renderer.addClass(this.toggletip, 'show');
            }
            else {
                this.renderer.removeClass(this.toggletip, 'fade');
                this.renderer.addClass(this.toggletip, 'show');
            }
            this.renderer.setStyle(this.toggletip, 'display', 'block');
            if (autoFocus) {
                setTimeout(() => {
                    this.toggletip.addEventListener('focusout', (evt) => { this.onBlur(evt); });
                    this.toggletip.focus();
                });
            }
        });
    }
    hideToggletip() {
        this.showToggle = false;
        if (this.popper) {
            this.renderer.removeClass(this.toggletip, 'show');
            this.renderer.addClass(this.toggletip, 'fade');
            this.renderer.setStyle(this.toggletip, 'display', 'none');
        }
        setTimeout(() => {
            this.destroyToggletip();
        });
    }
    destroyToggletip() {
        if (this.popper) {
            this.popper.destroy();
            this.popper = undefined;
            const parent = this.tooltipId ? document.querySelector(`[id="${this.tooltipId}"]`) : this.renderer.parentNode(this.el.nativeElement);
            this.renderer.removeChild(parent, this.toggletip);
            this.toggletip = undefined;
        }
    }
    ngOnDestroy() {
        this.destroyToggletip();
    }
}
ToggletipDirective.ɵfac = function ToggletipDirective_Factory(t) { return new (t || ToggletipDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
ToggletipDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: ToggletipDirective, selectors: [["", "uiToggletip", ""]], hostBindings: function ToggletipDirective_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mouseenter", function ToggletipDirective_mouseenter_HostBindingHandler() { return ctx.onHover(); })("focusin", function ToggletipDirective_focusin_HostBindingHandler() { return ctx.onFocus(); })("click", function ToggletipDirective_click_HostBindingHandler() { return ctx.onClick(); })("focusout", function ToggletipDirective_focusout_HostBindingHandler($event) { return ctx.onBlur($event); });
    } }, inputs: { showOnHover: "showOnHover", description: ["popoverDescription", "description"], placement: "placement", exceptionHandler: "exceptionHandler", tooltipId: "tooltipId" } });
ToggletipDirective.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef }
];
ToggletipDirective.propDecorators = {
    description: [{ type: Input, args: ['popoverDescription',] }],
    placement: [{ type: Input }],
    exceptionHandler: [{ type: Input }],
    tooltipId: [{ type: Input }],
    showOnHover: [{ type: Input }],
    onHover: [{ type: HostListener, args: ['mouseenter',] }],
    onFocus: [{ type: HostListener, args: ['focusin',] }],
    onClick: [{ type: HostListener, args: ['click',] }],
    onBlur: [{ type: HostListener, args: ['focusout', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToggletipDirective, [{
        type: Directive,
        args: [{
                selector: '[uiToggletip]'
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }]; }, { showOnHover: [{
            type: Input
        }], onHover: [{
            type: HostListener,
            args: ['mouseenter']
        }], onFocus: [{
            type: HostListener,
            args: ['focusin']
        }], onClick: [{
            type: HostListener,
            args: ['click']
        }], onBlur: [{
            type: HostListener,
            args: ['focusout', ['$event']]
        }], description: [{
            type: Input,
            args: ['popoverDescription']
        }], placement: [{
            type: Input
        }], exceptionHandler: [{
            type: Input
        }], tooltipId: [{
            type: Input
        }] }); })();

class TooltipComponent {
    constructor() {
        this.showOnHover = false;
    }
    ngOnInit() {
        this.random = Math.random().toString(36).substring(4);
        if (!this.tooltipId) {
            this.tooltipId = `tooltip_${this.random}`;
        }
    }
}
TooltipComponent.ɵfac = function TooltipComponent_Factory(t) { return new (t || TooltipComponent)(); };
TooltipComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TooltipComponent, selectors: [["ui-tooltip"]], inputs: { showOnHover: "showOnHover", tooltipId: "tooltipId", description: "description", placement: "placement", srText: "srText", style: "style", icon: "icon" }, decls: 6, vars: 14, consts: [["uiToggletip", "", "type", "button", 3, "popoverDescription", "placement", "tooltipId", "showOnHover"], [1, "sr-only"], ["role", "tooltip", 3, "id"]], template: function TooltipComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵelement(1, "i");
        ɵngcc0.ɵɵelementStart(2, "span", 1);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelement(5, "div", 2);
    } if (rf & 2) {
        ɵngcc0.ɵɵclassMap(ctx.style ? ctx.style : "btn btn-outline-primary btn-sm rounded-circle");
        ɵngcc0.ɵɵproperty("popoverDescription", ctx.description)("placement", ctx.placement)("tooltipId", ctx.tooltipId)("showOnHover", ctx.showOnHover);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassMapInterpolate1("ifc-icon ", ctx.icon ? ctx.icon : "ifc-info", " align-middle");
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 12, ctx.srText));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("id", ctx.tooltipId);
    } }, directives: [ToggletipDirective], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
TooltipComponent.propDecorators = {
    description: [{ type: Input }],
    placement: [{ type: Input }],
    srText: [{ type: Input }],
    style: [{ type: Input }],
    icon: [{ type: Input }],
    tooltipId: [{ type: Input }],
    showOnHover: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TooltipComponent, [{
        type: Component,
        args: [{
                selector: 'ui-tooltip',
                template: "<button uiToggletip [popoverDescription]=\"description\" [placement]=\"placement\" [tooltipId]=\"tooltipId\" [showOnHover]=\"showOnHover\" type=\"button\"\n  class=\"{{ style ? style : 'btn btn-outline-primary btn-sm rounded-circle'}}\">\n  <i class=\"ifc-icon {{icon ? icon : 'ifc-info'}} align-middle\"></i>\n  <span class=\"sr-only\">{{srText | translate}}</span>\n</button>\n<div [id]=\"tooltipId\" role=\"tooltip\"></div>\n"
            }]
    }], function () { return []; }, { showOnHover: [{
            type: Input
        }], tooltipId: [{
            type: Input
        }], description: [{
            type: Input
        }], placement: [{
            type: Input
        }], srText: [{
            type: Input
        }], style: [{
            type: Input
        }], icon: [{
            type: Input
        }] }); })();

class InlineTimePickerComponent {
    constructor(renderer, el, changesRef) {
        this.renderer = renderer;
        this.el = el;
        this.changesRef = changesRef;
        this.change = new EventEmitter();
        this.close = new EventEmitter();
        this.initialized = false;
        this.defaultClockTransition = 500;
        this.defaultTransitionDelayBetweenHandClick = 250;
        this.showToggle = false;
        this.dialRadius = 80;
        this.outerRadius = 65;
        this.innerRadius = 38;
        this.tickRadius = 12;
        this.diameter = 160;
        this.duration = 1;
        this.svgSupported = 'SVGAngle' in window &&
            (() => {
                const el = document.createElement('div');
                el.innerHTML = '<svg/>';
                el.innerHTML = '';
                return true;
            })();
        this.amPmToggle = {
            disabled: false,
            required: true,
            id: 'amPmToggle',
            name: 'amPmToggle',
            options: [
                {
                    value: 'AM',
                    text: 'ui.input-timepicker.btn.am.label',
                    selected: false,
                    index: 0
                },
                {
                    value: 'PM',
                    text: 'ui.input-timepicker.btn.pm.label',
                    selected: true,
                    index: 1
                }
            ],
            nodeType: 'select',
            label: '',
        };
        this.form = new FormGroup({});
    }
    ngAfterViewInit() {
        this.initialTimeValue = this.config.default;
        this.timepicker = this.el.nativeElement;
        const touchSupported = 'ontouchstart' in window;
        this.mousedownEvent = `mousedown${touchSupported ? ' touchstart' : ''}`;
        this.mousemoveEvent = `mousemove.clockpicker${touchSupported ? ' touchmove.clockpicker' : ''}`;
        this.mouseupEvent = `mouseup.clockpicker${touchSupported ? ' touchend.clockpicker' : ''}`;
        this.showTimepicker();
        this.changesRef.detectChanges();
    }
    ngOnDestroy() {
        this.change.complete();
    }
    ngOnChanges(changes) {
        if (changes.config && !changes.config.isFirstChange()) {
            this.initialTimeValue = this.config.default;
            this.parseInputValue(this.initialTimeValue);
            this.drawClock();
        }
    }
    toggleChange(field) {
        this.setAMPM(field.value);
    }
    setAMPM(amPM) {
        this.AMorPM = amPM;
        this.changesRef.detectChanges();
        this.changeTimeEvent();
    }
    clockDesign(twelveHour) {
        const tickTpl = $('<div class="clockpicker-tick"></div>');
        //hour view
        if (twelveHour) {
            for (let i = 0; i < 12; i++) {
                const tick = tickTpl.clone();
                const radian = (i / 6) * Math.PI;
                const radius = this.outerRadius;
                tick.css('font-size', '120%');
                tick.css({
                    left: this.dialRadius + Math.sin(radian) * radius - this.tickRadius,
                    top: this.dialRadius - Math.cos(radian) * radius - this.tickRadius
                });
                $(tick).html(i === 0 ? 12 : i);
                $(this.hoursView).append(tick);
                $(tick).on(this.mousedownEvent, (e) => {
                    this.mouseDown(e, true);
                });
            }
        }
        else {
            for (let i = 0; i < 24; i++) {
                const tick = tickTpl.clone();
                const radian = (i / 6) * Math.PI;
                const inner = i > 0 && i < 13;
                const radius = inner ? this.innerRadius : this.outerRadius;
                $(tick).css({
                    left: this.dialRadius + Math.sin(radian) * radius - this.tickRadius,
                    top: this.dialRadius - Math.cos(radian) * radius - this.tickRadius
                });
                if (inner) {
                    $(tick).css('font-size', '120%');
                }
                $(tick).html(i === 0 ? '00' : i);
                $(this.hoursView).append(tick);
                $(tick).on(this.mousedownEvent, (e) => {
                    this.mouseDown(e, true);
                });
            }
        }
        //Minute View
        for (let i = 0; i < 60; i += 5) {
            const tickMinute = tickTpl.clone();
            const radian = (i / 30) * Math.PI;
            $(tickMinute).css({
                left: this.dialRadius + Math.sin(radian) * this.outerRadius - this.tickRadius,
                top: this.dialRadius - Math.cos(radian) * this.outerRadius - this.tickRadius
            });
            $(tickMinute).css('font-size', '120%');
            $(tickMinute).html(this.leadingZero(i, false));
            $(this.minutesView).append(tickMinute);
            $(tickMinute).on(this.mousedownEvent, onmousedown);
            $(tickMinute).on(this.mousedownEvent, (e) => {
                this.mouseDown(e, true);
            });
        }
        $(this.plate).on(this.mousedownEvent, (e) => {
            if ($(e.target).closest('.clockpicker-tick').length === 0) {
                this.mouseDown(e, true);
            }
        });
    }
    mouseDown(e, space) {
        const offset = $(this.plate).offset();
        const isTouch = /^touch/.test(e.type);
        const x0 = offset.left + this.dialRadius;
        const y0 = offset.top + this.dialRadius;
        const dx = (isTouch ? e.originalEvent.touches[0] : e).pageX - x0;
        const dy = (isTouch ? e.originalEvent.touches[0] : e).pageY - y0;
        const z = Math.sqrt(dx * dx + dy * dy);
        let moved = false;
        // When clicking on minutes view space, check the mouse position
        if (space &&
            (z < this.outerRadius - this.tickRadius || z > this.outerRadius + this.tickRadius)) {
            return;
        }
        e.preventDefault();
        // Set cursor style of body after 200ms
        this.movingTimer = setTimeout(function () {
            document.body.classList.add('clockpicker-moving');
        }, 200);
        // Place the canvas to top
        $(this.plate).append(this.canvas);
        // Clock
        this.setHand(dx, dy, true);
        // Mousemove on document
        $(document).off(this.mousemoveEvent).on(this.mousemoveEvent, (e) => {
            e.preventDefault();
            const isTouch = /^touch/.test(e.type), x = (isTouch ? e.originalEvent.touches[0] : e).pageX - x0, y = (isTouch ? e.originalEvent.touches[0] : e).pageY - y0;
            if (!moved && x === dx && y === dy) {
                // Clicking in chrome on windows will trigger a mousemove event
                return;
            }
            moved = true;
            this.setHand(x, y, true);
        });
        // Mouseup on document
        $(document).off(this.mouseupEvent).on(this.mouseupEvent, (e) => {
            $(document).off(this.mouseupEvent);
            e.preventDefault();
            const isTouch = /^touch/.test(e.type), x = (isTouch ? e.originalEvent.changedTouches[0] : e).pageX - x0, y = (isTouch ? e.originalEvent.changedTouches[0] : e).pageY - y0;
            if ((space || moved) && x === dx && y === dy) {
                this.setHand(x, y, false);
            }
            if (this.currentView === 'hour') {
                setTimeout(() => {
                    this.toggleView('minutes');
                }, this.defaultTransitionDelayBetweenHandClick);
            }
            $(this.plate).prepend(this.canvas);
            // Reset cursor style of body
            clearTimeout(this.movingTimer);
            document.body.classList.remove('clockpicker-moving');
            // Unbind mousemove event
            $(document).off(this.mousemoveEvent);
            this.changeTimeEvent();
        });
    }
    drawClock() {
        if (this.svgSupported) {
            const canvas = this.timepicker.querySelector('.clockpicker-canvas'), svg = this.el.nativeElement.querySelector('svg') || this.createSvgElement('svg');
            svg.setAttribute('class', 'clockpicker-svg');
            svg.setAttribute('width', this.diameter);
            svg.setAttribute('height', this.diameter);
            const g = this.el.nativeElement.querySelector('g') || this.createSvgElement('g');
            g.setAttribute('transform', `translate(${this.dialRadius},${this.dialRadius})`);
            const bearing = this.el.nativeElement.querySelector('circle.clockpicker-canvas-bearing') || this.createSvgElement('circle');
            bearing.setAttribute('class', 'clockpicker-canvas-bearing');
            bearing.setAttribute('cx', 0);
            bearing.setAttribute('cy', 0);
            bearing.setAttribute('r', 3);
            const hand = this.el.nativeElement.querySelector('line') || this.createSvgElement('line');
            hand.setAttribute('x1', 0);
            hand.setAttribute('y1', 0);
            const bg = this.el.nativeElement.querySelector('circle.clockpicker-canvas-bg') || this.createSvgElement('circle');
            bg.setAttribute('class', 'clockpicker-canvas-bg');
            bg.setAttribute('r', this.tickRadius);
            const fg = this.el.nativeElement.querySelector('circle.clockpicker-canvas-fg') || this.createSvgElement('circle');
            fg.setAttribute('class', 'clockpicker-canvas-fg');
            fg.setAttribute('r', 3.5);
            g.appendChild(hand);
            g.appendChild(bg);
            g.appendChild(fg);
            g.appendChild(bearing);
            svg.appendChild(g);
            canvas.appendChild(svg);
            this.hand = hand;
            this.bg = bg;
            this.fg = fg;
            this.bearing = bearing;
            this.g = g;
            this.canvas = canvas;
            this.toggleView('hour', 0);
        }
    }
    createSvgElement(name) {
        return this.renderer.createElement(name, 'http://www.w3.org/2000/svg');
    }
    parseInputValue(value) {
        if (value === 'now') {
            value = (this.config.is24HourFormat) ? format(Date.now(), 'HH:mm') : format(Date.now(), 'hh:mma');
        }
        if (value instanceof Date) {
            value = value.getHours() + ':' + value.getMinutes();
        }
        value = value.split(':');
        // Minutes can have AM/PM that needs to be removed
        this.hours = parseInt(value[0], 10);
        if (isNaN(this.hours)) {
            this.hours = 0;
        }
        this.minutes = parseInt(value[1], 10);
        if (isNaN(this.minutes)) {
            this.minutes = 0;
        }
        this.hours = Math.round(this.hours);
        this.minutes = Math.round(this.minutes);
        this.oldHours = this.hours;
        this.oldMinutes = this.minutes;
        if (!this.config.is24HourFormat) {
            const period = `${value[1]}`.replace(/\d+/g, '').toLowerCase();
            if (period) {
                this.AMorPM = period === 'am' ? 'AM' : 'PM';
            }
            else {
                this.AMorPM = this.hours < 12 ? 'AM' : 'PM';
            }
        }
    }
    toggleView(view, delay = this.defaultClockTransition) {
        this.isHours = view === 'hour';
        const nextView = this.isHours ? this.hoursView : this.minutesView;
        const hideView = this.isHours ? this.minutesView : this.hoursView;
        this.currentView = view;
        // Visibility
        hideView.classList.add('clockpicker-dial-out');
        nextView.classList.remove('clockpicker-dial-out');
        nextView.classList.remove('invisible');
        nextView.classList.add('visible');
        // Reset clock hand
        this.resetClock(delay); // supposed tobe delay here
        // After transitions ended
        clearTimeout(this.toggleViewTimer);
        this.toggleViewTimer = setTimeout(function () {
            hideView.classList.remove('visible');
            hideView.classList.add('invisible');
        }, delay);
    }
    resetClock(delay) {
        const view = this.currentView;
        const value = view === 'hour' ? this.hours : this.minutes;
        const isHours = view === 'hour';
        const unit = Math.PI / (isHours ? 6 : 30);
        const radian = value * unit;
        const radius = isHours && value > 0 && value < 13 ? this.innerRadius : this.outerRadius;
        const x = Math.sin(radian) * radius;
        const y = -Math.cos(radian) * radius;
        if (this.svgSupported && delay) {
            this.canvas.classList.add('clockpicker-canvas-out');
            setTimeout(() => {
                this.canvas.classList.remove('clockpicker-canvas-out');
                this.setHand(x, y, null);
            }, 0);
        }
        else {
            this.setHand(x, y, null);
        }
    }
    setHand(x, y, dragging) {
        let radian = Math.atan2(x, -y);
        const isHours = this.currentView === 'hour';
        const z = Math.sqrt(x * x + y * y);
        const inner = isHours && z < (this.outerRadius + this.innerRadius) / 2;
        let radius = inner ? this.innerRadius : this.outerRadius;
        let unit;
        let value;
        // Calculate the unit
        if (isHours) {
            unit = (1 / 6) * Math.PI;
        }
        else {
            unit = (1 / 30) * Math.PI;
        }
        if (!this.config.is24HourFormat) {
            radius = this.outerRadius;
        }
        // Radian should in range [0, 2PI]
        if (radian < 0) {
            radian = Math.PI * 2 + radian;
        }
        // Get the round value
        value = Math.round(radian / unit);
        // Get the round radian
        radian = value * unit;
        // Correct the hours or minutes
        if (isHours) {
            value *= 1;
            if (!this.config.is24HourFormat && value === 0) {
                value = 12;
            }
            if (this.config.is24HourFormat && !inner === value > 0) {
                value += 12;
            }
            if ((this.config.is24HourFormat && value === 0) || value === 24) {
                value = 0;
            }
        }
        else {
            value *= 1;
            if (value === 60) {
                value = 0;
            }
        }
        $(this[isHours ? 'spanHours' : 'spanMinutes']).html(this.leadingZero(value, isHours ? true : false));
        if (isHours) {
            this.hours = value;
        }
        if (!isHours) {
            this.minutes = value;
        }
        // If svg is not supported, just add an active class to the tick
        if (!this.svgSupported) {
            this[isHours ? 'hoursView' : 'minutesView']
                .find('.clockpicker-tick')
                .each(() => {
                const tick = $(this);
                tick.toggleClass('active', value === +tick.html());
            });
            return;
        }
        // Place clock hand at the top when dragging
        if (dragging || (!isHours && value % 5)) {
            this.g.insertBefore(this.hand, this.bearing);
            this.g.insertBefore(this.bg, this.fg);
            this.bg.setAttribute('class', 'clockpicker-canvas-bg clockpicker-canvas-bg-trans');
        }
        else {
            // Or place it at the bottom
            this.g.insertBefore(this.hand, this.bg);
            this.g.insertBefore(this.fg, this.bg);
            this.bg.setAttribute('class', 'clockpicker-canvas-bg');
        }
        // Set clock hand and others' position
        const cx = Math.sin(radian) * radius, cy = -Math.cos(radian) * radius;
        this.hand.setAttribute('x2', cx);
        this.hand.setAttribute('y2', cy);
        this.bg.setAttribute('cx', cx);
        this.bg.setAttribute('cy', cy);
        this.fg.setAttribute('cx', cx);
        this.fg.setAttribute('cy', cy);
    }
    createTimepicker() {
        this.initialTimeValue = this.initialTimeValue || this.config.default;
        if (!this.initialized) {
            this.parseInputValue(this.config.default);
            this.currentView = 'hour';
            this.plate = this.timepicker.querySelector('.clockpicker-plate'),
                this.hoursView = this.timepicker.querySelector('.clockpicker-hours');
            this.minutesView = this.timepicker.querySelector('.clockpicker-minutes');
            if (!this.config.is24HourFormat) {
                this.clockDesign(true);
            }
            else {
                this.clockDesign(false);
            }
            this.drawClock();
        }
        this.currentView = 'hour';
        this.isHours = true;
    }
    done() {
        this.hideTimepicker();
        this.close.emit();
    }
    changeTimeEvent() {
        const outHours = this.hours;
        let value = ':' + this.leadingZero(this.minutes, false);
        value = this.leadingZero(outHours, false) + value;
        if (!this.config.is24HourFormat) {
            value = value + this.AMorPM;
        }
        this.change.emit(value);
        this.changesRef.detectChanges();
    }
    showTimepicker() {
        this.createTimepicker();
        this.renderer.removeClass(this.timepicker, 'fade');
        this.renderer.addClass(this.timepicker, 'show');
        if (this.hoursView || this.minutesView) {
            this.toggleView('hour', 0);
        }
        this.initialized = true;
    }
    hideTimepicker() {
        this.renderer.removeClass(this.timepicker, 'show');
        this.renderer.addClass(this.timepicker, 'fade');
        this.currentView = 'hour';
        if (this.hoursView || this.minutesView) {
            this.toggleView('hour', 0);
        }
    }
    leadingZero(num, twelveHour) {
        if (twelveHour && num === 0) {
            return 12;
        }
        return (num < 10 ? '0' : '') + num;
    }
}
InlineTimePickerComponent.ɵfac = function InlineTimePickerComponent_Factory(t) { return new (t || InlineTimePickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef)); };
InlineTimePickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InlineTimePickerComponent, selectors: [["ui-inline-time-picker"]], inputs: { config: "config" }, outputs: { change: "change", close: "close" }, features: [ɵngcc0.ɵɵNgOnChangesFeature], decls: 17, vars: 16, consts: [[1, "clockpicker-popover-container"], [1, "clockpicker-popover", "if-popover-container", "popover"], [1, "popover-header"], [1, "clockpicker-span-hours", "text-white-50", 3, "click"], [1, "clockpicker-span-minutes", "text-white-50", 3, "click"], ["class", "d-flex font-weight-bold clockpicker-buttons-am-pm", 3, "d-none", 4, "ngIf"], [1, "popover-body"], [1, "clockpicker-plate"], [1, "clockpicker-canvas"], [1, "clockpicker-dial", "clockpicker-hours"], [1, "clockpicker-dial", "clockpicker-minutes", "clockpicker-dial-out"], ["class", "clockpicker-close-block", 4, "ngIf"], [1, "d-flex", "font-weight-bold", "clockpicker-buttons-am-pm"], [3, "field", "form", "change"], [1, "clockpicker-close-block"], ["type", "button", 1, "btn", "btn-sm", "btn-link", 3, "click"]], template: function InlineTimePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵelementStart(3, "span", 3);
        ɵngcc0.ɵɵlistener("click", function InlineTimePickerComponent_Template_span_click_3_listener() { return ctx.toggleView("hour"); });
        ɵngcc0.ɵɵtext(4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "span");
        ɵngcc0.ɵɵtext(6, ":");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(7, "span", 4);
        ɵngcc0.ɵɵlistener("click", function InlineTimePickerComponent_Template_span_click_7_listener() { return ctx.toggleView("minutes"); });
        ɵngcc0.ɵɵtext(8);
        ɵngcc0.ɵɵpipe(9, "timeLeadingZero");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(10, InlineTimePickerComponent_div_10_Template, 2, 4, "div", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(11, "div", 6);
        ɵngcc0.ɵɵelementStart(12, "div", 7);
        ɵngcc0.ɵɵelement(13, "div", 8);
        ɵngcc0.ɵɵelement(14, "div", 9);
        ɵngcc0.ɵɵelement(15, "div", 10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(16, InlineTimePickerComponent_div_16_Template, 4, 3, "div", 11);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("d-none", !ctx.initialized);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassProp("font-weight-bold", ctx.isHours)("text-white-50", !ctx.isHours);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ctx.hours);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵclassProp("font-weight-bold", !ctx.isHours)("text-white-50", ctx.isHours);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(9, 14, ctx.minutes));
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.config.is24HourFormat);
        ɵngcc0.ɵɵadvance(6);
        ɵngcc0.ɵɵproperty("ngIf", ctx.config.showDone);
    } }, directives: function () { return [ɵngcc1.NgIf, SelectComponent]; }, pipes: function () { return [TimeLeadingZeroPipe, ɵngcc3.TranslatePipe]; }, encapsulation: 2 });
InlineTimePickerComponent.ctorParameters = () => [
    { type: Renderer2 },
    { type: ElementRef },
    { type: ChangeDetectorRef }
];
InlineTimePickerComponent.propDecorators = {
    config: [{ type: Input }],
    change: [{ type: Output }],
    close: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InlineTimePickerComponent, [{
        type: Component,
        args: [{
                selector: 'ui-inline-time-picker',
                template: "<div class=\"clockpicker-popover-container\" [class.d-none]=\"!initialized\">\n  <div class=\"clockpicker-popover if-popover-container popover\">\n    <div class=\"popover-header\">\n      <span class=\"clockpicker-span-hours text-white-50 \" [class.font-weight-bold]=\"isHours\" [class.text-white-50]=\"!isHours\"\n        (click)=\"toggleView('hour');\">{{hours}}</span>\n      <span>:</span>\n      <span class=\"clockpicker-span-minutes text-white-50\" [class.font-weight-bold]=\"!isHours\" [class.text-white-50]=\"isHours\"\n        (click)=\"toggleView('minutes');\">{{minutes | timeLeadingZero}}</span>\n      <div *ngIf=\"!config.is24HourFormat\" class=\"d-flex font-weight-bold clockpicker-buttons-am-pm\"\n        [class.d-none]=\"config?.is24HourFormat\">\n        \n        <ui-select [field]=\"amPmToggle\" [form]=\"form\" (change)=\"toggleChange($event)\"></ui-select>\n      </div>\n    </div>\n    <div class=\"popover-body\">\n      <div class=\"clockpicker-plate\">\n        <div class=\"clockpicker-canvas\"></div>\n        <div class=\"clockpicker-dial clockpicker-hours\"></div>\n        <div class=\"clockpicker-dial clockpicker-minutes clockpicker-dial-out\"></div>\n      </div>\n      <div class=\"clockpicker-close-block\" *ngIf=\"config.showDone\">\n        <button type=\"button\" (click)=\"done()\"\n          class=\"btn btn-sm btn-link\">{{'ui.input-timepicker.btn.done.label' | translate}}</button>\n      </div>\n    </div>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ɵngcc0.ChangeDetectorRef }]; }, { change: [{
            type: Output
        }], close: [{
            type: Output
        }], config: [{
            type: Input
        }] }); })();

class InputTimePickerComponent extends FieldComponent {
    constructor(elRef, translate, cd, renderer, browserService, settings) {
        super(settings);
        this.elRef = elRef;
        this.translate = translate;
        this.cd = cd;
        this.renderer = renderer;
        this.browserService = browserService;
        this.validationDelay = 300;
        this.change = new EventEmitter();
        this.keydown = new EventEmitter();
        this.orientation = 'bottom';
        this.timeFormat = 'hh:mma';
        this.oldvalue = undefined;
        this.isMobile = false;
        this.defaultHourFormat = true;
    }
    closeOnBlur($event) {
        const timepickerInputRef = this.elRef.nativeElement.querySelector('ui-form-field .input-timepicker');
        const timepickerRef = document.querySelector(`ui-inline-time-picker[id="timepicker_${this.field.id}"]`);
        if ($event.target
            && ((timepickerRef === null || timepickerRef === void 0 ? void 0 : timepickerRef.contains($event.target))
                || (timepickerInputRef === null || timepickerInputRef === void 0 ? void 0 : timepickerInputRef.contains($event.target)))) {
            return;
        }
        this.showTimePicker = false;
        this.cd.detectChanges();
    }
    ngOnInit() {
        var _a, _b, _c;
        this.showTimePicker = false;
        this.isMobile = this.browserService.isMobile();
        if (this.field) {
            this.timepickerSettings = {
                useDefaultMobileView: ((_a = this.config) === null || _a === void 0 ? void 0 : _a.useDefaultMobileView) ? this.config.useDefaultMobileView : false,
                timeFormat: this.config ? this.config.timeFormat : 'hh:mma',
                default: this.config.default || 'now',
                isRelativeToContainer: this.config.isRelativeToContainer || false,
                is24HourFormat: this.config ? this.config.is24HourFormat : this.defaultHourFormat,
                showDone: ((_b = this.config) === null || _b === void 0 ? void 0 : _b.showDone) ? this.config.showDone : true,
                targetMobileOS: ((_c = this.config) === null || _c === void 0 ? void 0 : _c.targetMobileOS) ? this.config.targetMobileOS : ['android', 'ios'],
            };
            this.setTimeFormat();
            if (!this.field.placeholder) {
                this.field.placeholder = 'HH:MM';
            }
            const formatExample = format(Date.now(), this.timeFormat);
            this.translate.get([
                'ui.input-timepicker.expected_format_example',
                'ui.input-timepicker.invalid_format_error',
                'ui.input-timepicker.input.helptext'
            ], {
                example: formatExample,
                format: this.field.placeholder
            }).pipe(take(1)).subscribe(text => {
                this.timeFormatDesc = text['ui.input-timepicker.expected_format_example'];
                this.invalidFormatError = text['ui.input-timepicker.invalid_format_error'];
                if (this.field.helperText) {
                    this.field.helperText = text['ui.input-timepicker.input.helptext'];
                }
            });
            const inputValidators = [];
            inputValidators.push(this.timeFormatValidator());
            if (this.asyncValidators) {
                if (Array.isArray(this.asyncValidators)) {
                    inputValidators.push(...this.asyncValidators);
                }
                else {
                    inputValidators.push(this.asyncValidators);
                }
            }
            this.asyncValidators = inputValidators;
            if (this.isMobile && this.timepickerSettings.targetMobileOS) {
                this.isMobile = false;
                const currentOS = this.browserService.getOSName();
                this.timepickerSettings.targetMobileOS.forEach((os) => {
                    if (os.toLowerCase() === currentOS.toLowerCase()) {
                        this.isMobile = true;
                    }
                });
            }
            super.ngOnInit();
        }
    }
    setOrientation() {
        this.orientation = 'bottom';
        const timepickerRect = this.elRef.nativeElement.getBoundingClientRect();
        const clockpickerHeight = 360;
        const windowHeight = window.innerHeight;
        const topOffset = timepickerRect.top;
        const bottomOffset = timepickerRect.bottom;
        if (windowHeight - bottomOffset >= clockpickerHeight) {
            this.orientation = 'bottom';
        }
        else if (topOffset >= clockpickerHeight) {
            this.orientation = 'top';
        }
    }
    ngOnChanges(changes) {
        if (changes.field) {
            super.updateOriginalValue();
        }
        if (changes.field && changes.field.currentValue && !changes.field.isFirstChange()) {
            this.FormCtrl.setValue(changes.field.currentValue.value);
            this.timepickerSettings.default = changes.field.currentValue.value;
        }
    }
    ngOnDestroy() {
        this.change.complete();
    }
    handleKeypress($event) {
        if ($event.key === 'Enter' || $event.key === 'Tab') {
            this.showTimePicker = false;
            $event.stopPropagation();
            this.keydown.emit($event);
            return;
        }
        if (!this.timepickerSettings.is24HourFormat && !this.field.value && $event.code.indexOf('Digit') > -1) {
            this.field.value = `${$event.key}:00${format(Date.now(), 'a')}`;
            this.FormCtrl.setValue(this.field.value);
            $event.target.setSelectionRange(1, 1);
            $event.preventDefault();
            $event.stopPropagation();
            this.keydown.emit($event);
            return false;
        }
    }
    timeFormatValidator() {
        return (control) => {
            this.ariaDescribedBy = ''; // prevent JAWS+IE11 from reading outdated aria-describedby during validation
            this.cd.detectChanges();
            return timer(this.validationDelay).pipe(map(() => {
                const value = control.value;
                if (!value) {
                    return null;
                }
                return this.validateTime(value, this.timeFormat);
            }));
        };
    }
    validateTime(value, format) {
        setTimeout(() => {
            this.updateAriaDescribedBy();
        });
        const m = parse(value.replace(/\s*/g, ''), format, new Date());
        if (!isValid(m)) {
            return {
                inValidTime: value,
                customErrorMsg: this.invalidFormatError
            };
        }
        return null;
    }
    toggle() {
        if (!this.showTimePicker) {
            this.setOrientation();
            this.timeValueChanged();
        }
        this.showTimePicker = !this.showTimePicker;
        this.cd.detectChanges();
        if (!this.showTimePicker) {
            this.FormCtrl.markAsTouched();
            this.FormCtrl.updateValueAndValidity();
            return;
        }
        setTimeout(() => {
            const timepickerInput = this.elRef.nativeElement.querySelector('.input-group.input-timepicker');
            const timepicker = this.elRef.nativeElement.querySelector('ui-inline-time-picker');
            const timepickerRect = timepickerInput.getBoundingClientRect();
            if (!this.timepickerSettings.isRelativeToContainer) {
                this.renderer.setStyle(timepicker, 'top', timepickerRect.bottom + window.scrollY + 'px');
                this.renderer.setStyle(timepicker, 'left', timepickerRect.left + window.scrollX + 'px');
                this.renderer.appendChild(document.querySelector('body'), timepicker);
            }
        });
    }
    timeValueChanged(event) {
        var _a, _b;
        const newSettings = Object.assign({}, this.timepickerSettings);
        newSettings.default = ((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) || ((_b = this.field) === null || _b === void 0 ? void 0 : _b.value);
        this.timepickerSettings = newSettings;
        this.field.value = newSettings.default;
        if (event) {
            this.setFormat();
            this.timeChanged(this.field.value);
        }
    }
    timeChanged(value) {
        if (this.field && value !== this.oldvalue) {
            this.oldvalue = value;
            this.field.value = value;
            this.FormCtrl.setValue(this.field.value);
            this.checkForError();
            this.cd.detectChanges();
            this.change.emit(this.field);
        }
    }
    timeValueChangedMobile(event) {
        var _a, _b;
        this.timeChanged(((_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value) || ((_b = this.field) === null || _b === void 0 ? void 0 : _b.value));
    }
    setFormat() {
        let isFieldEmpty = true;
        if (this.FormCtrl.value) {
            const hourMatch = this.FormCtrl.value.match(/^(\d+)/);
            if (hourMatch && hourMatch[1]) {
                isFieldEmpty = false;
                const inputHour = parseInt(hourMatch[1], 10);
                let inputMinute;
                let AMPM;
                const matches = this.FormCtrl.value.match(/:(\d+)/);
                inputMinute = matches && matches[1] ? parseInt(matches[1], 10) : 0;
                if (!inputMinute) {
                    inputMinute = 0;
                }
                AMPM = this.FormCtrl.value.match(/([AaPp][Mm])$/);
                AMPM = AMPM && AMPM[1] ? AMPM[1] : null;
                if (!AMPM) {
                    AMPM = format(Date.now(), 'a');
                }
                else {
                    AMPM = AMPM.toString().toUpperCase();
                }
                const hour = (inputHour < 10) ? '0' + inputHour.toString() : inputHour.toString();
                const minute = (inputMinute < 10) ? '0' + inputMinute.toString() : inputMinute.toString();
                this.FormCtrl.setValue(`${hour}:${minute}`);
            }
        }
        this.checkForError();
    }
    setTimeFormat() {
        if (this.timepickerSettings && this.timepickerSettings.timeFormat) {
            this.timeFormat = this.timepickerSettings.timeFormat;
        }
    }
    updateAriaDescribedBy() {
        var _a;
        super.updateAriaDescribedBy();
        this.ariaDescribedBy = ((_a = this.ariaDescribedBy) === null || _a === void 0 ? void 0 : _a.trim()) || '';
        this.ariaDescribedBy += ` ${this.field.id}_desc`;
        this.ariaDescribedBy = this.ariaDescribedBy.trim();
    }
}
InputTimePickerComponent.ɵfac = function InputTimePickerComponent_Factory(t) { return new (t || InputTimePickerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.TranslateService), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(BrowserDetectionService), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.SettingsService)); };
InputTimePickerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputTimePickerComponent, selectors: [["ui-input-time-picker"]], hostBindings: function InputTimePickerComponent_HostBindings(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵlistener("mousedown", function InputTimePickerComponent_mousedown_HostBindingHandler($event) { return ctx.closeOnBlur($event); }, false, ɵngcc0.ɵɵresolveDocument);
    } }, inputs: { validationDelay: "validationDelay", asyncValidators: "asyncValidators", field: "field", form: "form", config: "config", mobileTimepickerUpdateOn: "mobileTimepickerUpdateOn" }, outputs: { change: "change", keydown: "keydown" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 3, vars: 2, consts: [[4, "ngIf", "ngIfElse"], ["inputtime", ""], [3, "field", "formGroup", "form", "formCtrl", "hasError", "updateOn"], ["template", ""], [3, "id", "config", "class", "change", "close", 4, "ngIf"], [1, "input-group", "input-timepicker"], [1, "sr-only", 3, "id", "innerText"], ["ifPII", "", "type", "text", "autocomplete", "off", 1, "form-control", 3, "id", "formControlName", "ngClass", "required", "readonly", "keydown", "change", "blur"], ["timepicker", ""], ["type", "button", "tabindex", "-1", "aria-hidden", "true", 1, "btn", "btn-primary", "input-group-addon", 3, "click"], [1, "ifc-icon", "ifc-time-clock"], [3, "id", "config", "change", "close"], ["inlineTimePicker", ""], [3, "field", "form", "updateOn", "change"]], template: function InputTimePickerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, InputTimePickerComponent_ng_container_0_Template, 6, 7, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, InputTimePickerComponent_ng_template_1_Template, 1, 3, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.timepickerSettings.useDefaultMobileView && !ctx.isMobile)("ngIfElse", _r1);
    } }, directives: [ɵngcc1.NgIf, FormFieldComponent, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.DefaultValueAccessor, ɵngcc2.IfPersonallyIdentifiableInformationDirective, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, ɵngcc1.NgClass, ɵngcc4.RequiredValidator, InlineTimePickerComponent, InputTimeComponent], encapsulation: 2 });
InputTimePickerComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: TranslateService },
    { type: ChangeDetectorRef },
    { type: Renderer2 },
    { type: BrowserDetectionService },
    { type: SettingsService }
];
InputTimePickerComponent.propDecorators = {
    field: [{ type: Input }],
    form: [{ type: Input }],
    config: [{ type: Input }],
    validationDelay: [{ type: Input }],
    asyncValidators: [{ type: Input }],
    mobileTimepickerUpdateOn: [{ type: Input }],
    change: [{ type: Output }],
    keydown: [{ type: Output }],
    closeOnBlur: [{ type: HostListener, args: ['document:mousedown', ['$event'],] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputTimePickerComponent, [{
        type: Component,
        args: [{
                selector: 'ui-input-time-picker',
                template: "<ng-container *ngIf=\"!timepickerSettings.useDefaultMobileView && !isMobile; else inputtime\">\n  <div>\n    <ui-form-field [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\" [hasError]=\"hasError\" [updateOn]=\"updateOn\">\n      <ng-template #template let-field=\"field\">\n        <div class=\"input-group input-timepicker\">\n          <span class=\"sr-only\" [id]=\"field.id + '_desc'\" [innerText]=\"timeFormatDesc\"></span>\n          <input [id]=\"field.id\" (keydown)=\"handleKeypress($event)\" (change)=\"$event.stopPropagation(); timeValueChanged($event)\"\n            ifPII #timepicker type=\"text\" class=\"form-control\" autocomplete=\"off\" (blur)=\"checkForError()\" [attr.aria-invalid]=\"hasError\"\n            [attr.aria-describedby]=\"ariaDescribedBy ? ariaDescribedBy : ''\"\n            [attr.aria-errormessage]=\"ariaErrorMessage\"\n            [formControlName]=\"field.name\" [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\"\n            [attr.data-if-id]=\"field.extraAttributes?.ifId\" [attr.name]=\"field.name\" [attr.id]=\"field.id\"\n            [required]=\"field.required && field.required !== 'false'\" [attr.disabled]=\"field.disabled? '': null\" [readonly]=\"field.readonly\"\n            [attr.placeholder]=\"field.placeholder ? field.placeholder: ''\">\n          <button type=\"button\" tabindex=\"-1\" aria-hidden=\"true\" class=\"btn btn-primary input-group-addon\"\n            (click)=\"!field.disabled && toggle();\" [attr.data-if-id]=\"field.extraAttributes?.ifId\">\n            <i class=\"ifc-icon ifc-time-clock\"></i>\n          </button>\n        </div>\n      </ng-template>\n    </ui-form-field>\n    <ui-inline-time-picker #inlineTimePicker id=\"timepicker_{{field.id}}\" *ngIf=\"showTimePicker\" (change)=\"timeChanged($event)\" [config]=\"timepickerSettings\"\n      (close)=\"toggle()\" class=\"input-timepicker timepicker-{{orientation}}\"></ui-inline-time-picker>\n  </div>\n</ng-container>\n<ng-template #inputtime>\n  <ui-input-time [field]=\"field\" [form]=\"form\" [updateOn]=\"mobileTimepickerUpdateOn || updateOn\" (change)=\"timeValueChangedMobile($event)\"></ui-input-time>\n</ng-template>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc3.TranslateService }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.Renderer2 }, { type: BrowserDetectionService }, { type: ɵngcc2.SettingsService }]; }, { validationDelay: [{
            type: Input
        }], change: [{
            type: Output
        }], keydown: [{
            type: Output
        }], closeOnBlur: [{
            type: HostListener,
            args: ['document:mousedown', ['$event']]
        }], asyncValidators: [{
            type: Input
        }], field: [{
            type: Input
        }], form: [{
            type: Input
        }], config: [{
            type: Input
        }], mobileTimepickerUpdateOn: [{
            type: Input
        }] }); })();

class TimeLeadingZeroPipe {
    transform(time) {
        if (time < 10) {
            return `0${time}`;
        }
        return time;
    }
}
TimeLeadingZeroPipe.ɵfac = function TimeLeadingZeroPipe_Factory(t) { return new (t || TimeLeadingZeroPipe)(); };
TimeLeadingZeroPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "timeLeadingZero", type: TimeLeadingZeroPipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TimeLeadingZeroPipe, [{
        type: Pipe,
        args: [{
                name: 'timeLeadingZero'
            }]
    }], null, null); })();

class DateReformatPipeParams {
}
/* Pipe for reformating date strings.
 * Replaces ifdate
 */
class DateReformatPipe {
    constructor() { }
    transform(value, params) {
        try {
            let inputFormat = 'MM/dd/yyyy';
            if (params && params.locale && params.locale.dateFormat) {
                inputFormat = params.locale.dateFormat.replace('DD', 'dd').replace('YYYY', 'yyyy').replace('D', 'd').replace('YY', 'yy');
            }
            let outputFormat = 'MMM d, yyyy';
            if (params && params.format) {
                outputFormat = params.format;
            }
            const date = parse(value, inputFormat, new Date());
            if (isValid(date)) {
                return format(date, outputFormat);
            }
            return value;
        }
        catch (e) {
            console.error(`Error parsing date value '${value}'.`, e);
            return value;
        }
    }
}
DateReformatPipe.ɵfac = function DateReformatPipe_Factory(t) { return new (t || DateReformatPipe)(); };
DateReformatPipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "uiDateReformat", type: DateReformatPipe, pure: true });
DateReformatPipe.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DateReformatPipe, [{
        type: Pipe,
        args: [{ name: 'uiDateReformat' }]
    }], function () { return []; }, null); })();

class InputDateRangeComponent {
    constructor(cd, translate) {
        this.cd = cd;
        this.translate = translate;
        this.validationDelay = 300;
        this.change = new EventEmitter();
    }
    ngOnInit() {
        if (!this.updateOn) {
            this.updateOn = "change" /* Change */;
        }
        this.asyncDateRangeValidators = [this.dateRangeValidator()];
        this.translate.get('ui.input-date-range.invalid-end-date').subscribe(text => {
            this.invalidEndDateMsg = text;
        });
        this.dateFormat = this.config ? this.config.dateFormat : 'yyyy-MM-dd';
    }
    ngOnDestroy() {
        this.change.complete();
    }
    dateRangeValidator() {
        return (control) => {
            this.cd.detectChanges();
            return timer(this.validationDelay).pipe(map(() => {
                const value = control.value;
                if (!value) {
                    return null;
                }
                const endDate = parse(this.endDate.value, this.endDate.dateFormat ? this.endDate.dateFormat : this.dateFormat, new Date());
                const startDate = parse(this.startDate.value, this.startDate.dateFormat ? this.startDate.dateFormat : this.dateFormat, new Date());
                const compareDates = compareAsc(endDate, startDate);
                if (compareDates < 0) {
                    return {
                        invalidDateRange: value,
                        customErrorMsg: this.invalidEndDateMsg
                    };
                }
            }));
        };
    }
    handleChange(event, isStartDate, dateField) {
        if (isStartDate) {
            if (!this.form.controls[this.endDate.name].touched) {
                this.form.controls[this.endDate.name].markAsTouched();
            }
            this.form.controls[this.endDate.name].updateValueAndValidity();
        }
        this.form.controls[dateField.name].markAsDirty();
        this.form.controls[dateField.name].markAsTouched();
        this.form.controls[dateField.name].updateValueAndValidity();
        this.change.emit({ start: this.startDate, end: this.endDate });
    }
}
InputDateRangeComponent.ɵfac = function InputDateRangeComponent_Factory(t) { return new (t || InputDateRangeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.TranslateService)); };
InputDateRangeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputDateRangeComponent, selectors: [["ui-input-date-range"]], inputs: { validationDelay: "validationDelay", updateOn: "updateOn", startDate: "startDate", endDate: "endDate", form: "form", config: "config" }, outputs: { change: "change" }, decls: 5, vars: 9, consts: [[1, "row"], [1, "col-md-6"], [3, "field", "form", "config", "updateOn", "change"], [3, "field", "form", "config", "asyncValidators", "updateOn", "change"]], template: function InputDateRangeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "ui-input-date", 2);
        ɵngcc0.ɵɵlistener("change", function InputDateRangeComponent_Template_ui_input_date_change_2_listener($event) { return ctx.handleChange($event, true, ctx.startDate); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(3, "div", 1);
        ɵngcc0.ɵɵelementStart(4, "ui-input-date", 3);
        ɵngcc0.ɵɵlistener("change", function InputDateRangeComponent_Template_ui_input_date_change_4_listener($event) { return ctx.handleChange($event, false, ctx.endDate); });
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("field", ctx.startDate)("form", ctx.form)("config", ctx.config)("updateOn", ctx.updateOn);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("field", ctx.endDate)("form", ctx.form)("config", ctx.config)("asyncValidators", ctx.asyncDateRangeValidators)("updateOn", ctx.updateOn);
    } }, directives: [InputDateComponent], encapsulation: 2 });
InputDateRangeComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: TranslateService }
];
InputDateRangeComponent.propDecorators = {
    startDate: [{ type: Input }],
    endDate: [{ type: Input }],
    form: [{ type: Input }],
    config: [{ type: Input }],
    validationDelay: [{ type: Input }],
    updateOn: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputDateRangeComponent, [{
        type: Component,
        args: [{
                selector: 'ui-input-date-range',
                template: "<div class=\"row\">\n  <div class=\"col-md-6\">\n    <ui-input-date\n      [field]=\"startDate\"\n      [form]=\"form\"\n      [config]=\"config\"\n      [updateOn]=\"updateOn\"\n      (change)=\"handleChange($event, true, startDate)\">\n    </ui-input-date>\n  </div>\n  <div class=\"col-md-6\">\n    <ui-input-date\n      [field]=\"endDate\"\n      [form]=\"form\"\n      [config]=\"config\"\n      [asyncValidators]=\"asyncDateRangeValidators\"\n      [updateOn]=\"updateOn\"\n      (change)=\"handleChange($event, false, endDate)\">\n    </ui-input-date>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc3.TranslateService }]; }, { validationDelay: [{
            type: Input
        }], change: [{
            type: Output
        }], updateOn: [{
            type: Input
        }], startDate: [{
            type: Input
        }], endDate: [{
            type: Input
        }], form: [{
            type: Input
        }], config: [{
            type: Input
        }] }); })();

class InputTimeRangeComponent {
    constructor(cd, translate) {
        this.cd = cd;
        this.translate = translate;
        this.validationDelay = 300;
        this.change = new EventEmitter();
    }
    ngOnInit() {
        this.asyncTimeRangeValidators = [this.timeRangeValidator()];
        this.translate.get('ui.input-time-range.invalid-end-time').subscribe(text => {
            this.invalidEndTimeMsg = text;
        });
        this.timeFormat = this.config ? this.config.timeFormat : 'hh:mma';
    }
    ngOnDestroy() {
        this.change.complete();
    }
    timeRangeValidator() {
        return (control) => {
            this.cd.detectChanges();
            return timer(this.validationDelay).pipe(map(() => {
                const value = control.value;
                if (!value) {
                    return null;
                }
                const endTimeValue = this.form.controls[this.endTime.name].value;
                const startTimeValue = this.form.controls[this.startTime.name].value;
                const endTime = parse(endTimeValue, this.timeFormat, new Date());
                const startTime = parse(startTimeValue, this.timeFormat, new Date());
                const compareTimes = compareAsc(endTime, startTime);
                if (compareTimes <= 0) {
                    return {
                        invalidTimeRange: value,
                        customErrorMsg: this.invalidEndTimeMsg
                    };
                }
            }));
        };
    }
    handleChange(event, isStartTime) {
        this.change.emit({ start: this.startTime, end: this.endTime });
        if (isStartTime) {
            if (!this.form.controls[this.endTime.name].touched) {
                this.form.controls[this.endTime.name].markAsTouched();
            }
            this.form.controls[this.endTime.name].updateValueAndValidity();
        }
    }
}
InputTimeRangeComponent.ɵfac = function InputTimeRangeComponent_Factory(t) { return new (t || InputTimeRangeComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc3.TranslateService)); };
InputTimeRangeComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputTimeRangeComponent, selectors: [["ui-input-time-range"]], inputs: { validationDelay: "validationDelay", startTime: "startTime", endTime: "endTime", config: "config", form: "form", startTimeValidator: "startTimeValidator", endTimeValidator: "endTimeValidator" }, outputs: { change: "change" }, decls: 7, vars: 15, consts: [[1, "row"], [1, "col-md-6"], [3, "config", "field", "form", "validationDelay", "validators", "change"], [3, "config", "field", "form", "asyncValidators", "validationDelay", "validators", "change"]], template: function InputTimeRangeComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "ui-input-time-picker", 2);
        ɵngcc0.ɵɵlistener("change", function InputTimeRangeComponent_Template_ui_input_time_picker_change_2_listener($event) { return ctx.handleChange($event, true); });
        ɵngcc0.ɵɵpipe(3, "formatTimeFieldValue");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(4, "div", 1);
        ɵngcc0.ɵɵelementStart(5, "ui-input-time-picker", 3);
        ɵngcc0.ɵɵlistener("change", function InputTimeRangeComponent_Template_ui_input_time_picker_change_5_listener($event) { return ctx.handleChange($event, false); });
        ɵngcc0.ɵɵpipe(6, "formatTimeFieldValue");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("config", ctx.config)("field", ɵngcc0.ɵɵpipeBind1(3, 11, ctx.startTime))("form", ctx.form)("validationDelay", ctx.validationDelay)("validators", ctx.startTimeValidator);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("config", ctx.config)("field", ɵngcc0.ɵɵpipeBind1(6, 13, ctx.endTime))("form", ctx.form)("asyncValidators", ctx.asyncTimeRangeValidators)("validationDelay", ctx.validationDelay)("validators", ctx.endTimeValidator);
    } }, directives: function () { return [InputTimePickerComponent]; }, pipes: function () { return [FormatTimeFieldValuePipe]; }, encapsulation: 2 });
InputTimeRangeComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: TranslateService }
];
InputTimeRangeComponent.propDecorators = {
    startTime: [{ type: Input }],
    endTime: [{ type: Input }],
    config: [{ type: Input }],
    form: [{ type: Input }],
    validationDelay: [{ type: Input }],
    startTimeValidator: [{ type: Input }],
    endTimeValidator: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputTimeRangeComponent, [{
        type: Component,
        args: [{
                selector: 'ui-input-time-range',
                template: "<div class=\"row\">\n  <div class=\"col-md-6\">\n    <ui-input-time-picker [config]=\"config\" [field]=\"startTime | formatTimeFieldValue\" [form]=\"form\"\n      [validationDelay]=\"validationDelay\" (change)=\"handleChange($event, true)\"\n      [validators]=\"startTimeValidator\">\n    </ui-input-time-picker>\n  </div>\n  <div class=\"col-md-6\">\n    <ui-input-time-picker [config]=\"config\" [field]=\"endTime | formatTimeFieldValue\" [form]=\"form\"\n      [asyncValidators]=\"asyncTimeRangeValidators\" [validationDelay]=\"validationDelay\"\n      (change)=\"handleChange($event, false)\" [validators]=\"endTimeValidator\">\n    </ui-input-time-picker>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc3.TranslateService }]; }, { validationDelay: [{
            type: Input
        }], change: [{
            type: Output
        }], startTime: [{
            type: Input
        }], endTime: [{
            type: Input
        }], config: [{
            type: Input
        }], form: [{
            type: Input
        }], startTimeValidator: [{
            type: Input
        }], endTimeValidator: [{
            type: Input
        }] }); })();

class FormatTimeFieldValuePipe {
    transform(field) {
        if (field && field.value) {
            const timeValue = parse(field.value, 'hh:mm:ssa', new Date());
            if (isValid(timeValue)) {
                field.value = format(timeValue, 'hh:mma');
            }
        }
        return field;
    }
}
FormatTimeFieldValuePipe.ɵfac = function FormatTimeFieldValuePipe_Factory(t) { return new (t || FormatTimeFieldValuePipe)(); };
FormatTimeFieldValuePipe.ɵpipe = /*@__PURE__*/ ɵngcc0.ɵɵdefinePipe({ name: "formatTimeFieldValue", type: FormatTimeFieldValuePipe, pure: true });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FormatTimeFieldValuePipe, [{
        type: Pipe,
        args: [{ name: 'formatTimeFieldValue' }]
    }], null, null); })();

class ToastService {
    constructor() {
        this.subject = new BehaviorSubject({ status: false });
        this.observable = this.subject.asObservable();
    }
    get status() {
        return this.observable;
    }
    show(message, delay, style, id = '', position) {
        this.hide();
        this.subject.next({ message: message, status: true, style: style, id: id, position: position });
        if (delay) {
            this.timeOut = setTimeout(() => {
                this.subject.next({ status: false });
            }, delay);
        }
    }
    hide() {
        if (this.timeOut) {
            clearTimeout(this.timeOut);
        }
        this.subject.next({ status: false });
    }
}
ToastService.ɵfac = function ToastService_Factory(t) { return new (t || ToastService)(); };
ToastService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ToastService_Factory() { return new ToastService(); }, token: ToastService, providedIn: "root" });
ToastService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ToastComponent {
    constructor(toastService) {
        this.toastService = toastService;
        this.id = '';
        this.closed = new EventEmitter();
    }
    ngOnInit() {
        this.subscription = new Subscription();
        this.subscription.add(this.toastService.status.subscribe((toastModel) => {
            if (this.id === toastModel.id || !toastModel.status) {
                if (this.active && !toastModel.status) {
                    this.closed.emit(this.id);
                }
                this.message = toastModel.message;
                this.active = toastModel.status;
                this.style = toastModel.style;
                this.position = toastModel.position ? toastModel.position : 'center top';
            }
        }));
    }
    hideToast() {
        this.toastService.hide();
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
        this.closed.complete();
    }
}
ToastComponent.ɵfac = function ToastComponent_Factory(t) { return new (t || ToastComponent)(ɵngcc0.ɵɵdirectiveInject(ToastService)); };
ToastComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ToastComponent, selectors: [["ui-toast"]], contentQueries: function ToastComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c61, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.customToastBodyTemplate = _t.first);
    } }, inputs: { id: "id" }, outputs: { closed: "closed" }, decls: 3, vars: 1, consts: [[4, "ngIf"], ["defaultToastBodyTemplate", ""], ["role", "alert", 1, "container", "justify-content-between", "align-items-center", 3, "ngClass"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["type", "button", 1, "btn", "btn-sm", "default", 3, "click"], [1, "sr-only"], [1, "ifc-icon", "ifc-remove"]], template: function ToastComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, ToastComponent_ng_container_0_Template, 4, 12, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, ToastComponent_ng_template_1_Template, 8, 6, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.active);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc1.NgTemplateOutlet], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
ToastComponent.ctorParameters = () => [
    { type: ToastService }
];
ToastComponent.propDecorators = {
    customToastBodyTemplate: [{ type: ContentChild, args: ['customToastBodyTemplate',] }],
    id: [{ type: Input }],
    closed: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ToastComponent, [{
        type: Component,
        args: [{
                selector: 'ui-toast',
                template: "<ng-container *ngIf=\"active\">\n  <div class=\"container justify-content-between align-items-center\" [class.active]=\"active\" [ngClass]=\"position\" role=\"alert\">\n    <div class=\"alert {{style ? style : '' }} {{ position }}\">\n      <ng-container\n        *ngTemplateOutlet=\"customToastBodyTemplate? customToastBodyTemplate : defaultToastBodyTemplate; context: {'message': message, 'hideToast':hideToast.bind(this)}\">\n      </ng-container>\n    </div>\n  </div>\n</ng-container>\n\n\n<ng-template #defaultToastBodyTemplate let-message=\"message\" let-hideToast=\"hideToast\">\n  <span>{{ message | translate }}</span>\n  <button type=\"button\" class=\"btn btn-sm default\" (click)=\"hideToast()\">\n    <span class=\"sr-only\">{{ 'ui.toast.close' | translate }}</span>\n    <i class=\"ifc-icon ifc-remove\"></i>\n  </button>\n</ng-template>"
            }]
    }], function () { return [{ type: ToastService }]; }, { id: [{
            type: Input
        }], closed: [{
            type: Output
        }], customToastBodyTemplate: [{
            type: ContentChild,
            args: ['customToastBodyTemplate']
        }] }); })();

class RadioButtonGroupComponent {
    constructor() {
        this.change = new EventEmitter();
    }
    ngOnInit() {
        var _a;
        if (!this.form.contains(this.field.name)) {
            const value = (_a = this.field.elements.find((el) => el.checked)) === null || _a === void 0 ? void 0 : _a.value;
            this.ctrl = new FormControl(value !== null && value !== void 0 ? value : '');
            this.form.addControl(this.field.name, this.ctrl);
        }
        else {
            this.ctrl = this.form.controls[this.field.name];
        }
        if (this.field.required) {
            this.ctrl.setValidators(Validators.required);
        }
    }
    ngOnDestroy() {
        this.change.complete();
    }
    updateNextChange(update) {
        this.updateOnNextChange = update;
    }
    updateResponseField(fieldValue) {
        if (this.updateOnNextChange) {
            this.value = fieldValue;
            this.form.controls[this.field.name].setValue(fieldValue);
            this.change.emit(fieldValue);
            this.field.elements.forEach(element => {
                element.checked = element.value === fieldValue;
            });
            this.hasError = false;
        }
        this.updateOnNextChange = true;
    }
    checkRequired($event) {
        if ($event.currentTarget.contains($event.relatedTarget)) {
            return;
        }
        if (this.field.required && !this.form.controls[this.field.name].value) {
            this.hasError = true;
        }
    }
}
RadioButtonGroupComponent.ɵfac = function RadioButtonGroupComponent_Factory(t) { return new (t || RadioButtonGroupComponent)(); };
RadioButtonGroupComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioButtonGroupComponent, selectors: [["ui-radio-button-group"]], contentQueries: function RadioButtonGroupComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c19, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.customButtonLabel = _t.first);
    } }, inputs: { field: "field", form: "form", style: "style" }, outputs: { change: "change" }, decls: 11, vars: 7, consts: [[1, "form-group"], ["class", "sr-only", 3, "id", "innerHTML", 4, "ngIf"], ["role", "radiogroup", "uiArrowModalDialog", "", "tabindex", "-1", 1, "d-flex", "flex-column", "flex-lg-row", "justify-content-between", "align-items-lg-center", 3, "focusout"], ["class", "form-control-label", "aria-hidden", "true", 3, "required", "id", "innerHTML", 4, "ngIf"], [1, "d-flex", "flex-row", "align-items-start"], [4, "ngFor", "ngForOf"], ["role", "region", "aria-live", "assertive", 1, "d-block", "small", "form-control-feedback", "text-danger"], ["aria-live", "assertive", 3, "id", "innerHTML", 4, "ngIf"], ["defaultButtonLabel", ""], [1, "sr-only", 3, "id", "innerHTML"], ["aria-hidden", "true", 1, "form-control-label", 3, "id", "innerHTML"], [3, "id", "name", "active", "label", "value", "updateField", "updateOnNextChange"], ["fieldLabel", ""], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["aria-live", "assertive", 3, "id", "innerHTML"]], template: function RadioButtonGroupComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "fieldset", 0);
        ɵngcc0.ɵɵtemplate(1, RadioButtonGroupComponent_legend_1_Template, 2, 4, "legend", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵlistener("focusout", function RadioButtonGroupComponent_Template_div_focusout_2_listener($event) { return ctx.checkRequired($event); });
        ɵngcc0.ɵɵtemplate(3, RadioButtonGroupComponent_label_3_Template, 2, 6, "label", 3);
        ɵngcc0.ɵɵelementStart(4, "div", 4);
        ɵngcc0.ɵɵtemplate(5, RadioButtonGroupComponent_ng_container_5_Template, 4, 7, "ng-container", 5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div");
        ɵngcc0.ɵɵelementStart(7, "span", 6);
        ɵngcc0.ɵɵtemplate(8, RadioButtonGroupComponent_span_8_Template, 2, 4, "span", 7);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(9, RadioButtonGroupComponent_ng_template_9_Template, 3, 3, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵattribute("aria-labelledby", ctx.field.id + "_legend");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.field.legend);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("ng-invalid", !ctx.value);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.field.legend);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.field.elements);
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.hasError);
    } }, directives: function () { return [ɵngcc1.NgIf, ArrowModalDialogDirective, ɵngcc1.NgForOf, RadioButtonComponent, ɵngcc1.NgTemplateOutlet]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, encapsulation: 2 });
RadioButtonGroupComponent.ctorParameters = () => [];
RadioButtonGroupComponent.propDecorators = {
    customButtonLabel: [{ type: ContentChild, args: ['customButtonLabel',] }],
    field: [{ type: Input }],
    form: [{ type: Input }],
    style: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioButtonGroupComponent, [{
        type: Component,
        args: [{
                selector: 'ui-radio-button-group',
                template: "<fieldset class=\"form-group\" [attr.aria-labelledby]=\"field.id + '_legend'\">\n  <legend *ngIf=\"this.field.legend\" class=\"sr-only\" [id]=\"field.id + '_legend'\" [innerHTML]=\"this.field.legend | translate\"></legend>\n  <div class=\"d-flex flex-column flex-lg-row justify-content-between align-items-lg-center\" role=\"radiogroup\" uiArrowModalDialog [class.ng-invalid]=\"!value\" tabindex=\"-1\"\n    (focusout)=\"checkRequired($event)\">\n    <label *ngIf=\"field.legend\" class=\"form-control-label\" [class.required]=\"field.required\" [id]=\"field.id + '_legend_label'\" [innerHTML]=\"this.field.legend | translate\" aria-hidden=\"true\"></label>\n    <div class=\"d-flex flex-row align-items-start\">\n      <ng-container *ngFor=\"let option of field.elements; index as idx\">\n\n        <ui-radio-button (updateField)=\"updateResponseField($event)\" (updateOnNextChange)=\"updateNextChange($event)\"\n          [id]=\"option.id\" [name]=\"option.name\" [active]=\"$any(option).checked\" [style]='style && style[idx]? style[idx] : \"\"'\n          [label]=\"$any(option).label\" [value]=\"$any(option).value\">\n\n          <ng-template #fieldLabel>\n            <ng-container\n              *ngTemplateOutlet=\"customButtonLabel? customButtonLabel : defaultButtonLabel; context: {'message': $any(option).label, 'idx': idx}\">\n            </ng-container>\n          </ng-template>\n\n        </ui-radio-button>\n      </ng-container>\n    </div>\n\n  </div>\n  <div>\n    <span role=\"region\" aria-live=\"assertive\" class=\"d-block small form-control-feedback text-danger\">\n      <span *ngIf=\"hasError\" [id]=\"field.id + '_error_req'\" aria-live=\"assertive\"\n        [innerHTML]=\"'ui.form_field.required_text' | translate\"></span>\n    </span>\n  </div>\n</fieldset>\n\n<ng-template #defaultButtonLabel let-message=\"message\">\n  <span>{{ message | translate }}</span>\n</ng-template>\n"
            }]
    }], function () { return []; }, { change: [{
            type: Output
        }], customButtonLabel: [{
            type: ContentChild,
            args: ['customButtonLabel']
        }], field: [{
            type: Input
        }], form: [{
            type: Input
        }], style: [{
            type: Input
        }] }); })();

class RadioButtonComponent {
    constructor() {
        this.updateField = new EventEmitter();
        this.updateOnNextChange = new EventEmitter();
    }
    ngOnInit() {
    }
    updateResponseField(field, $event) {
        // doesn't catch shift + tab otherwise
        if ($event) {
            switch ($event.code) {
                case "Tab":
                case "Shift":
                    this.updateOnNextChange.emit(false);
                    break;
                case "Enter":
                case "Space":
                    $event.preventDefault();
                    this.updateOnNextChange.emit(true);
                    this.updateField.emit(field);
                    break;
            }
        }
        else {
            this.updateOnNextChange.emit(true);
            this.updateField.emit(field);
        }
    }
}
RadioButtonComponent.ɵfac = function RadioButtonComponent_Factory(t) { return new (t || RadioButtonComponent)(); };
RadioButtonComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: RadioButtonComponent, selectors: [["ui-radio-button"]], contentQueries: function RadioButtonComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c63, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.fieldLabel = _t.first);
    } }, inputs: { id: "id", name: "name", active: "active", label: "label", value: "value", style: "style" }, outputs: { updateField: "updateField", updateOnNextChange: "updateOnNextChange" }, decls: 2, vars: 9, consts: [["type", "button", "role", "radio", 1, "btn", 3, "id", "name", "value", "ngClass", "keydown", "click"], [4, "ngTemplateOutlet"]], template: function RadioButtonComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "button", 0);
        ɵngcc0.ɵɵlistener("keydown", function RadioButtonComponent_Template_button_keydown_0_listener($event) { return ctx.updateResponseField(ctx.value, $event); })("click", function RadioButtonComponent_Template_button_click_0_listener() { return ctx.updateResponseField(ctx.value); });
        ɵngcc0.ɵɵtemplate(1, RadioButtonComponent_ng_container_1_Template, 1, 0, "ng-container", 1);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("id", ctx.id)("name", ctx.name)("value", ctx.value)("ngClass", ɵngcc0.ɵɵpureFunction1(7, _c6, ctx.active));
        ɵngcc0.ɵɵattribute("aria-label", ctx.label)("aria-checked", ctx.active);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.fieldLabel);
    } }, directives: [ɵngcc1.NgClass, ɵngcc1.NgTemplateOutlet], encapsulation: 2 });
RadioButtonComponent.ctorParameters = () => [];
RadioButtonComponent.propDecorators = {
    fieldLabel: [{ type: ContentChild, args: ['fieldLabel',] }],
    id: [{ type: Input }],
    name: [{ type: Input }],
    active: [{ type: Input }],
    label: [{ type: Input }],
    value: [{ type: Input }],
    style: [{ type: Input }],
    updateField: [{ type: Output }],
    updateOnNextChange: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RadioButtonComponent, [{
        type: Component,
        args: [{
                selector: 'ui-radio-button',
                template: "<button type=\"button\" role=\"radio\" [id]=\"id\" [name]=\"name\" [value]=\"value\" class=\"btn\"\n[attr.aria-label]=\"label\" [attr.aria-checked]=\"active\"\n  [ngClass]=\"{'active' : active}\" (keydown)=\"updateResponseField(value, $event)\" (click)=\"updateResponseField(value)\">\n  <ng-container *ngTemplateOutlet=\"fieldLabel\">\n  </ng-container>\n</button>\n"
            }]
    }], function () { return []; }, { updateField: [{
            type: Output
        }], updateOnNextChange: [{
            type: Output
        }], fieldLabel: [{
            type: ContentChild,
            args: ['fieldLabel']
        }], id: [{
            type: Input
        }], name: [{
            type: Input
        }], active: [{
            type: Input
        }], label: [{
            type: Input
        }], value: [{
            type: Input
        }], style: [{
            type: Input
        }] }); })();

class ExpandCollapseService {
    constructor() {
        this.expandCollapseSource = new Subject();
        this.expandCollapseObservable = this.expandCollapseSource.asObservable();
    }
    expandAll() {
        this.expandCollapseSource.next(true);
    }
    collapseAll() {
        this.expandCollapseSource.next(false);
    }
}
ExpandCollapseService.ɵfac = function ExpandCollapseService_Factory(t) { return new (t || ExpandCollapseService)(); };
ExpandCollapseService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ExpandCollapseService, factory: ExpandCollapseService.ɵfac });
ExpandCollapseService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ExpandCollapseService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class ExpandCollapseComponent {
    constructor(expandCollapse) {
        this.expandCollapse = expandCollapse;
        this.showExpand = false;
        this.displayCard = false;
        this.change = new EventEmitter();
        this.state = 'active';
    }
    ngOnInit() {
        this.subscription = new Subscription();
        this.subscription.add(this.expandCollapse.expandCollapseObservable.subscribe(expand => {
            this.showExpand = expand;
        }));
    }
    updateExpand() {
        this.showExpand = !this.showExpand;
        this.change.emit(this.id);
    }
}
ExpandCollapseComponent.ɵfac = function ExpandCollapseComponent_Factory(t) { return new (t || ExpandCollapseComponent)(ɵngcc0.ɵɵdirectiveInject(ExpandCollapseService)); };
ExpandCollapseComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ExpandCollapseComponent, selectors: [["ui-expand-collapse"]], inputs: { showExpand: "showExpand", displayCard: "displayCard", title: "title", id: "id", referenceHeading: "referenceHeading", headingClass: "headingClass" }, outputs: { change: "change" }, ngContentSelectors: _c7, decls: 8, vars: 17, consts: [[3, "uiDynamicHeadings"], ["role", "button", "href", "javascript:void(0)", 1, "d-flex", "align-items-center", 3, "click"], [3, "headingLevel", "style", 4, "ngIf"], [3, "class", 4, "ngIf"], ["aria-hidden", "true", 1, "ifc-icon", "ml-2"], ["role", "region", "aria-live", "polite", 3, "id"], [4, "ngIf"], [3, "headingLevel"]], template: function ExpandCollapseComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div");
        ɵngcc0.ɵɵelementStart(2, "a", 1);
        ɵngcc0.ɵɵlistener("click", function ExpandCollapseComponent_Template_a_click_2_listener() { return ctx.updateExpand(); });
        ɵngcc0.ɵɵtemplate(3, ExpandCollapseComponent_ui_dynamic_heading_3_Template, 3, 6, "ui-dynamic-heading", 2);
        ɵngcc0.ɵɵtemplate(4, ExpandCollapseComponent_div_4_Template, 3, 6, "div", 3);
        ɵngcc0.ɵɵelement(5, "i", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "div", 5);
        ɵngcc0.ɵɵtemplate(7, ExpandCollapseComponent_div_7_Template, 2, 1, "div", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵclassProp("card", ctx.displayCard);
        ɵngcc0.ɵɵproperty("uiDynamicHeadings", ctx.referenceHeading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("card-header", ctx.displayCard);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵattribute("aria-controls", ctx.id)("aria-expanded", ctx.showExpand);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.referenceHeading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", !ctx.referenceHeading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("ifc-chevron-right", !ctx.showExpand)("ifc-chevron-down", ctx.showExpand);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵclassProp("card-body", ctx.displayCard && ctx.showExpand);
        ɵngcc0.ɵɵproperty("id", ctx.id);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showExpand);
    } }, directives: function () { return [DynamicHeadingDirective, ɵngcc1.NgIf, DynamicHeadingComponent]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, encapsulation: 2, data: { animation: [
            trigger('animateCollapse', [
                state('void', style({
                    'max-height': 0,
                    'overflow': 'hidden',
                    'visibility': 'hidden'
                })),
                state('*', style({
                    'max-height': 'unset',
                    'overflow': 'hidden'
                })),
                transition('void => *', animate('300ms ease-in', keyframes([
                    style({ 'opacity': '0', 'max-height': '0' }),
                    style({ 'opacity': '0', 'max-height': '0.25rem' }),
                    style({ 'opacity': '0', 'max-height': '1.25rem' }),
                    style({ 'max-height': '3rem' }),
                    style({ 'max-height': '3.75rem' }),
                    style({ 'max-height': '5rem' }),
                ]))),
                transition('* => void', animate('300ms ease-in', keyframes([
                    style({ 'max-height': '5rem' }),
                    style({ 'max-height': '3.75rem' }),
                    style({ 'max-height': '3rem' }),
                    style({ 'opacity': '0', 'max-height': '1.25rem' }),
                    style({ 'opacity': '0', 'max-height': '0.25rem' }),
                    style({ 'opacity': '0', 'max-height': '0' })
                ])))
            ])
        ] } });
ExpandCollapseComponent.ctorParameters = () => [
    { type: ExpandCollapseService }
];
ExpandCollapseComponent.propDecorators = {
    title: [{ type: Input }],
    id: [{ type: Input }],
    showExpand: [{ type: Input }],
    displayCard: [{ type: Input }],
    referenceHeading: [{ type: Input }],
    headingClass: [{ type: Input }],
    change: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ExpandCollapseComponent, [{
        type: Component,
        args: [{
                selector: 'ui-expand-collapse',
                template: "<div [class.card]=\"displayCard\" [uiDynamicHeadings]=\"referenceHeading\">\n  <div [class.card-header]=\"displayCard\">\n    <a class=\"d-flex align-items-center\" [attr.aria-controls]=\"id\" role=\"button\" [attr.aria-expanded]=\"showExpand\"\n      href=\"javascript:void(0)\" (click)=\"updateExpand()\">\n      <ui-dynamic-heading [headingLevel]=\"1\" [style]=\"headingClass\" *ngIf=\"referenceHeading\"> {{ title | translate }} </ui-dynamic-heading>\n      <div class=\"{{headingClass || 'expander-heading'}}\" *ngIf=\"!referenceHeading\"> {{ title | translate }}</div> <i class=\"ifc-icon ml-2\" aria-hidden=\"true\"\n        [class.ifc-chevron-right]=\"!showExpand\" [class.ifc-chevron-down]=\"showExpand\"></i>\n    </a>\n  </div>\n  <div [id]=\"id\" [class.card-body]=\"displayCard && showExpand\" role=\"region\" aria-live=\"polite\">\n    <div *ngIf=\"showExpand\" [@animateCollapse]=\"state\">\n      <ng-content> </ng-content>\n    </div>\n  </div>\n</div>\n",
                animations: [
                    trigger('animateCollapse', [
                        state('void', style({
                            'max-height': 0,
                            'overflow': 'hidden',
                            'visibility': 'hidden'
                        })),
                        state('*', style({
                            'max-height': 'unset',
                            'overflow': 'hidden'
                        })),
                        transition('void => *', animate('300ms ease-in', keyframes([
                            style({ 'opacity': '0', 'max-height': '0' }),
                            style({ 'opacity': '0', 'max-height': '0.25rem' }),
                            style({ 'opacity': '0', 'max-height': '1.25rem' }),
                            style({ 'max-height': '3rem' }),
                            style({ 'max-height': '3.75rem' }),
                            style({ 'max-height': '5rem' }),
                        ]))),
                        transition('* => void', animate('300ms ease-in', keyframes([
                            style({ 'max-height': '5rem' }),
                            style({ 'max-height': '3.75rem' }),
                            style({ 'max-height': '3rem' }),
                            style({ 'opacity': '0', 'max-height': '1.25rem' }),
                            style({ 'opacity': '0', 'max-height': '0.25rem' }),
                            style({ 'opacity': '0', 'max-height': '0' })
                        ])))
                    ])
                ]
            }]
    }], function () { return [{ type: ExpandCollapseService }]; }, { showExpand: [{
            type: Input
        }], displayCard: [{
            type: Input
        }], change: [{
            type: Output
        }], title: [{
            type: Input
        }], id: [{
            type: Input
        }], referenceHeading: [{
            type: Input
        }], headingClass: [{
            type: Input
        }] }); })();

class InformationBannerComponent {
    constructor(router) {
        this.router = router;
        this.close = new EventEmitter();
        this.action = new EventEmitter();
    }
    ngOnInit() {
        if (!this.informationBanner.icon) {
            this.informationBanner.icon = "ifc-circle-info";
        }
    }
    handleNavigation(link) {
        if (!link) {
            return;
        }
        this.action.emit(link);
        if ((link === null || link === void 0 ? void 0 : link.indexOf('http')) === 0) {
            window.open(link, '_blank');
        }
        else {
            this.router.navigateByUrl(link);
        }
    }
    closeBanner() {
        this.close.emit();
        this.hideBanner = true;
    }
}
InformationBannerComponent.ɵfac = function InformationBannerComponent_Factory(t) { return new (t || InformationBannerComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc5.Router)); };
InformationBannerComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InformationBannerComponent, selectors: [["ui-information-banner"]], inputs: { informationBanner: "informationBanner" }, outputs: { close: "close", action: "action" }, decls: 1, vars: 1, consts: [[3, "class", 4, "ngIf"], [1, "container"], [1, "d-flex", "flex-wrap", "align-items-end"], [1, "d-flex", "flex-row", "align-items-start", "flex-nowrap"], ["aria-hidden", "true"], ["class", "ml-4 d-flex flex-row align-items-center", "href", "javascript:void(0)", 3, "title", "click", 4, "ngIf"], ["type", "button", 1, "btn", 3, "click"], ["aria-hidden", "true", 1, "ifc-icon", "ifc-remove", "font-weight-bold", "align-middle"], [1, "sr-only"], ["href", "javascript:void(0)", 1, "ml-4", "d-flex", "flex-row", "align-items-center", 3, "title", "click"], [1, "ifc-icon", "ifc-chevron-right", "ml-1"]], template: function InformationBannerComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, InformationBannerComponent_section_0_Template, 13, 11, "section", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", !ctx.hideBanner && ctx.informationBanner);
    } }, directives: [ɵngcc1.NgIf], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
InformationBannerComponent.ctorParameters = () => [
    { type: Router }
];
InformationBannerComponent.propDecorators = {
    informationBanner: [{ type: Input }],
    close: [{ type: Output }],
    action: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InformationBannerComponent, [{
        type: Component,
        args: [{
                selector: 'ui-information-banner',
                template: "<section class=\"{{informationBanner.position}}\" *ngIf=\"!hideBanner && informationBanner\">\n  <div class=\"container\">\n    <div class=\"d-flex flex-wrap align-items-end\">\n      <span class=\"d-flex flex-row align-items-start flex-nowrap\">\n        <i class=\"ifc-icon mt-1 mr-2 {{informationBanner.icon}}\" aria-hidden=\"true\"></i>\n        <span>{{informationBanner.description}}</span>\n      </span>\n      <a *ngIf=\"informationBanner.link && informationBanner.linkText\" class=\"ml-4 d-flex flex-row align-items-center\"\n        href=\"javascript:void(0)\" (click)=\"handleNavigation(informationBanner.link)\"\n        title=\"{{ 'ui.information-banner.link_title' | translate: { linkText: informationBanner.linkText | translate } }}\">{{informationBanner.linkText}}<i\n          class=\"ifc-icon ifc-chevron-right ml-1\"></i></a>\n    </div>\n  </div>\n  <button type=\"button\" class=\"btn\" (click)=\"closeBanner()\">\n    <i class=\"ifc-icon ifc-remove font-weight-bold align-middle\" aria-hidden=\"true\"></i>\n    <span class=\"sr-only\">{{ 'ui.information-banner.close_text' | translate }}</span>\n  </button>\n</section>\n"
            }]
    }], function () { return [{ type: ɵngcc5.Router }]; }, { close: [{
            type: Output
        }], action: [{
            type: Output
        }], informationBanner: [{
            type: Input
        }] }); })();

const stepsFeatureKey = 'uiSteps';
const initialState = [];
const ɵ0 = (state, props) => cloneDeep(props === null || props === void 0 ? void 0 : props.steps), ɵ1 = (state) => state.map((step, i) => {
    return {
        text: step.text,
        active: i === 0,
        link: cloneDeep(step.link),
        status: undefined,
        dueDate: step.dueDate,
        disabled: step.disabled
    };
}), ɵ2 = (state) => {
    const newState = cloneDeep(state);
    let currActiveIdx = -1;
    for (let i = 0; i < newState.length; i++) {
        if (newState[i].active) {
            currActiveIdx = i;
            newState[i].active = false;
        }
    }
    const nextActiveIdx = Math.min(currActiveIdx + 1, newState.length - 1);
    newState[nextActiveIdx].active = true;
    return newState;
}, ɵ3 = (state) => {
    const newState = cloneDeep(state);
    let currActiveIdx = -1;
    for (let i = 0; i < newState.length; i++) {
        if (newState[i].active) {
            currActiveIdx = i;
            newState[i].active = false;
        }
    }
    const nextActiveIdx = Math.max(currActiveIdx - 1, 0);
    newState[nextActiveIdx].active = true;
    return newState;
}, ɵ4 = (state, props) => state.map((step, i) => {
    const newStep = {
        text: step.text,
        active: false,
        link: cloneDeep(step.link),
        status: step.status,
        dueDate: step.dueDate,
        disabled: step.disabled
    };
    newStep.active = (i === (props === null || props === void 0 ? void 0 : props.idx)) || (newStep.link
        && ((props === null || props === void 0 ? void 0 : props.linkId) && newStep.link.id === (props === null || props === void 0 ? void 0 : props.linkId)) || ((props === null || props === void 0 ? void 0 : props.linkName) && newStep.link.name === (props === null || props === void 0 ? void 0 : props.linkName)));
    return newStep;
}), ɵ5 = (state, props) => state.map((step) => {
    return {
        text: step.text,
        active: step.active,
        link: cloneDeep(step.link),
        status: step.active ? props === null || props === void 0 ? void 0 : props.status : step.status,
        dueDate: step.dueDate,
        disabled: step.disabled
    };
}), ɵ6 = (state) => initialState;
const _uiStepsReducer = createReducer(initialState, on(setSteps, ɵ0), on(resetSteps, ɵ1), on(nextStep, ɵ2), on(previousStep, ɵ3), on(setActiveStep, ɵ4), on(updateStepStatus, ɵ5), on(clearSteps, ɵ6));
function uiStepsReducer(state, action) {
    return _uiStepsReducer(state, action);
}
const uiStepsStorageKey = '__ui_steps_data__';
function sessionStorageMetaReducer(reducer) {
    return function (state, action) {
        const nextState = reducer(state, action);
        if (action.type !== clearSteps.type && !(nextState === null || nextState === void 0 ? void 0 : nextState.length)) {
            try {
                const savedState = sessionStorage.getItem(uiStepsStorageKey);
                const parsedState = savedState ? JSON.parse(savedState) : [];
                return parsedState;
            }
            catch (e) { }
        }
        try {
            sessionStorage.setItem(uiStepsStorageKey, JSON.stringify(nextState));
        }
        catch (e) { }
        return nextState;
    };
}
const metaReducers = [sessionStorageMetaReducer];

class PasswordCriterionValidatorService {
    constructor() {
        this.criteriaArray = [];
        this.criteriaSubject = new BehaviorSubject(this.criteriaArray);
        this.criteria = this.criteriaSubject.asObservable();
        this.criteriaSuccessfulSubject = new BehaviorSubject(false);
        this.criteriaSuccessful = this.criteriaSuccessfulSubject.asObservable();
    }
    setCriteria(criteria) {
        this.criteriaArray = criteria;
        this.criteriaSubject.next(this.criteriaArray);
    }
    addCriterion(criterion) {
        this.criteriaArray.push(criterion);
        this.criteriaSubject.next(this.criteriaArray);
    }
    updateCriteriaValidationStatus(value) {
        this.setDefaultCriteriaStatus('processing');
        setTimeout(() => {
            const criteria = this.criteriaArray.map((criterion) => {
                return {
                    title: criterion.title,
                    description: criterion.description,
                    status: criterion.validator(value) ? 'success' : 'failure',
                    validator: criterion.validator
                };
            });
            this.criteriaArray = criteria;
            this.criteriaSubject.next(this.criteriaArray);
            const criteriaMet = this.criteriaMet();
            this.criteriaSuccessfulSubject.next(criteriaMet);
        }, 1000);
    }
    criteriaMet() {
        return !this.criteriaArray.some((criterion) => {
            return criterion.status !== 'success';
        });
    }
    setDefaultCriteriaStatus(state) {
        const criteria = this.criteriaArray.map((criterion) => {
            return { title: criterion.title, description: criterion.description, status: state, validator: criterion.validator };
        });
        this.criteriaArray = criteria;
        this.criteriaSubject.next(this.criteriaArray);
    }
}
PasswordCriterionValidatorService.ɵfac = function PasswordCriterionValidatorService_Factory(t) { return new (t || PasswordCriterionValidatorService)(); };
PasswordCriterionValidatorService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PasswordCriterionValidatorService, factory: PasswordCriterionValidatorService.ɵfac });
PasswordCriterionValidatorService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PasswordCriterionValidatorService, [{
        type: Injectable
    }], function () { return []; }, null); })();

class PasswordCriteriaComponent {
    constructor(cd, passwordCriteriaService) {
        this.cd = cd;
        this.passwordCriteriaService = passwordCriteriaService;
        this.criterionSubscription = new Subscription();
    }
    ngOnInit() {
        this.criterionSubscription = this.passwordCriteriaService.criteria.subscribe(criteria => {
            this.criteria = criteria;
            this.cd.detectChanges();
        });
    }
    ngOnDestroy() {
        if (this.criterionSubscription) {
            this.criterionSubscription.unsubscribe();
        }
    }
}
PasswordCriteriaComponent.ɵfac = function PasswordCriteriaComponent_Factory(t) { return new (t || PasswordCriteriaComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(PasswordCriterionValidatorService)); };
PasswordCriteriaComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PasswordCriteriaComponent, selectors: [["ui-password-criteria"]], inputs: { parentHeading: "parentHeading" }, decls: 7, vars: 8, consts: [[1, "card", "h-100", "w-100", "px-sm-4", "mt-2"], [3, "uiDynamicHeadings"], [3, "headingLevel"], [1, "list-group"], [3, "class", 4, "ngFor", "ngForOf"], [1, "ifc-icon", "pr-3"], [1, "list-group-item-heading", "small"]], template: function PasswordCriteriaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "div", 1);
        ɵngcc0.ɵɵelementStart(2, "ui-dynamic-heading", 2);
        ɵngcc0.ɵɵtext(3);
        ɵngcc0.ɵɵpipe(4, "translate");
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(5, "ul", 3);
        ɵngcc0.ɵɵtemplate(6, PasswordCriteriaComponent_li_6_Template, 5, 6, "li", 4);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("uiDynamicHeadings", ctx.parentHeading);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵstyleMap("h5 pt-3");
        ɵngcc0.ɵɵproperty("headingLevel", ctx.parentHeading ? 1 : 2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵtextInterpolate(ɵngcc0.ɵɵpipeBind1(4, 6, "ui.password-criteria.password_requirements"));
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.criteria);
    } }, directives: function () { return [DynamicHeadingDirective, DynamicHeadingComponent, ɵngcc1.NgForOf]; }, pipes: function () { return [ɵngcc3.TranslatePipe]; }, encapsulation: 2 });
PasswordCriteriaComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: PasswordCriterionValidatorService }
];
PasswordCriteriaComponent.propDecorators = {
    parentHeading: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PasswordCriteriaComponent, [{
        type: Component,
        args: [{
                selector: 'ui-password-criteria',
                template: "<div class=\"card h-100 w-100 px-sm-4 mt-2\">\n  <div [uiDynamicHeadings]=\"parentHeading\">\n    <ui-dynamic-heading [headingLevel]=\"parentHeading ? 1 : 2\" [style]=\"'h5 pt-3'\">{{'ui.password-criteria.password_requirements' | translate}}</ui-dynamic-heading>\n  </div>\n  <ul class=\"list-group\">\n    <li class=\"list-group-item {{criterion?.status}} d-flex flex-row align-items-center border-0 py-2 px-0\"\n      *ngFor=\"let criterion of criteria\">\n      <i class=\"ifc-icon pr-3\"></i>\n      <div class=\"list-group-item-heading small\">{{criterion?.title | translate}}</div>\n    </li>\n  </ul>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: PasswordCriterionValidatorService }]; }, { parentHeading: [{
            type: Input
        }] }); })();

class MobilePasswordCriteriaComponent {
    constructor(cd, passwordCriteriaService) {
        this.cd = cd;
        this.passwordCriteriaService = passwordCriteriaService;
        this.criterionSubscription = new Subscription();
    }
    ngOnInit() {
        this.showCriteria = true;
        this.criterionSubscription = new Subscription();
        this.criterionSubscription.add(this.passwordCriteriaService.criteria.subscribe(criteria => {
            this.criteria = criteria;
            this.cd.detectChanges();
        }));
        this.criterionSubscription.add(this.passwordCriteriaService.criteriaSuccessful.subscribe(successful => {
            this.criteriaSuccessful = successful;
            this.showCriteria = !this.criteriaSuccessful;
        }));
    }
    ngOnDestroy() {
        if (this.criterionSubscription) {
            this.criterionSubscription.unsubscribe();
        }
    }
}
MobilePasswordCriteriaComponent.ɵfac = function MobilePasswordCriteriaComponent_Factory(t) { return new (t || MobilePasswordCriteriaComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(PasswordCriterionValidatorService)); };
MobilePasswordCriteriaComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: MobilePasswordCriteriaComponent, selectors: [["ui-mobile-password-criteria"]], decls: 4, vars: 6, consts: [[1, "mobile-criterion", "pb-3"], [4, "ngIf"], ["id", "mobile-criterion", 3, "ngClass"], [3, "class", 4, "ngFor", "ngForOf"], ["aria-controls", "mobile-criterion", 1, "criteria", "success", "w-100", 3, "click"], [1, "ifc-icon", "mr-2"], [1, "ifc-icon", "ml-auto"], [1, "ifc-icon"]], template: function MobilePasswordCriteriaComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵtemplate(1, MobilePasswordCriteriaComponent_ng_container_1_Template, 7, 4, "ng-container", 1);
        ɵngcc0.ɵɵelementStart(2, "div", 2);
        ɵngcc0.ɵɵtemplate(3, MobilePasswordCriteriaComponent_span_3_Template, 5, 6, "span", 3);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.criteriaSuccessful);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngClass", ɵngcc0.ɵɵpureFunction2(3, _c65, ctx.criteriaSuccessful, ctx.showCriteria));
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.criteria);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc1.NgForOf], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
MobilePasswordCriteriaComponent.ctorParameters = () => [
    { type: ChangeDetectorRef },
    { type: PasswordCriterionValidatorService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MobilePasswordCriteriaComponent, [{
        type: Component,
        args: [{
                selector: 'ui-mobile-password-criteria',
                template: "<div class=\"mobile-criterion pb-3\">\n  <ng-container *ngIf=\"criteriaSuccessful\">\n    <span class=\"criteria success w-100\" (click)=\"showCriteria=!showCriteria\" [attr.aria-expanded]=\"showCriteria\"\n      aria-controls=\"mobile-criterion\">\n      <i class=\"ifc-icon mr-2\"></i>\n      <span>{{'ui.password-criteria-mobile.requirements_met' | translate}}</span>\n      <i class=\"ifc-icon ml-auto\"></i>\n    </span>\n  </ng-container>\n  <div [ngClass]=\"{'collapse': criteriaSuccessful, 'show': showCriteria}\" id=\"mobile-criterion\">\n    <span class=\"criteria {{criterion.status}}\" *ngFor=\"let criterion of criteria\">\n      <i class=\"ifc-icon\"></i>\n      <span>{{criterion.description | translate}}</span>\n    </span>\n  </div>\n</div>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ChangeDetectorRef }, { type: PasswordCriterionValidatorService }]; }, null); })();

class DynamicHeadingDirective {
    constructor(el, renderer) {
        this.el = el;
        this.renderer = renderer;
        this.headings = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
    }
    ngAfterViewInit() {
        this.renderer.setAttribute(this.el.nativeElement, 'data-heading-group', 'true');
        setTimeout(() => {
            this.initHeadings();
        });
    }
    findClosestHeadingGroup(heading) {
        if (!heading) {
            return;
        }
        if (heading.closest) {
            return heading.closest('[data-heading-group]');
        }
        // IE11 support, modified from https://developer.mozilla.org/en-US/docs/Web/API/Element/closest#polyfill
        const closest = (el, s) => {
            if (!Element.prototype.matches) {
                Element.prototype.matches =
                    Element.prototype.msMatchesSelector ||
                        Element.prototype.webkitMatchesSelector;
            }
            do {
                if (Element.prototype.matches.call(el, s))
                    return el;
                el = el.parentElement || el.parentNode;
            } while (el !== null && el.nodeType === 1);
            return null;
        };
        return closest(heading, '[data-heading-group]');
    }
    getDescendants(selector) {
        var _a;
        if ((_a = Element.prototype) === null || _a === void 0 ? void 0 : _a.closest) {
            return Array.from(this.el.nativeElement.querySelectorAll(`:scope ${selector}`));
        }
        // IE11 does not support :scope pseudo-selector
        return Array.from(this.el.nativeElement.querySelectorAll(selector)).filter((el) => this.findClosestHeadingGroup(el) !== this.el.nativeElement);
    }
    initHeadings() {
        var _a, _b, _c, _d;
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.parentHeading) {
                return;
            }
            const parentElement = ((_a = this.parentHeading.el) === null || _a === void 0 ? void 0 : _a.nativeElement) || this.parentHeading.nativeElement || this.parentHeading;
            const group = this.findClosestHeadingGroup(((_b = this.parentHeading.el) === null || _b === void 0 ? void 0 : _b.nativeElement) || this.parentHeading.nativeElement);
            let parentHeading = (_c = parentElement === null || parentElement === void 0 ? void 0 : parentElement.children[0]) === null || _c === void 0 ? void 0 : _c.tagName;
            if (group && this.parentHeading.changes && !this.parentHeading.changes.isStopped) {
                parentHeading = yield this.parentHeading.changes.pipe(take(1)).toPromise();
            }
            parentHeading = parentHeading || ((_d = parentElement) === null || _d === void 0 ? void 0 : _d.tagName);
            if (!parentHeading) {
                return;
            }
            let headingStartLevelOffset = this.headings.findIndex(heading => heading === parentHeading.toLowerCase()) + 1;
            const nestedHeadings = this.getDescendants('[data-heading-group] ui-dynamic-heading');
            const allHeadings = Array.from(this.el.nativeElement.querySelectorAll('ui-dynamic-heading'));
            const immediateHeadings = allHeadings.filter(heading => nestedHeadings.indexOf(heading) === -1);
            if (!(immediateHeadings === null || immediateHeadings === void 0 ? void 0 : immediateHeadings.length)) {
                return;
            }
            immediateHeadings.forEach((heading) => {
                setTimeout(() => {
                    var _a, _b;
                    const headingContainer = heading.querySelector('[data-heading-level]');
                    if (headingContainer) {
                        const level = parseInt(headingContainer.getAttribute('data-heading-level'), 10);
                        const levelIdx = level - 1; //convert to 0-based
                        const headingLevel = this.headings[levelIdx + headingStartLevelOffset] || 'h6';
                        const newHeading = this.renderer.createElement(headingLevel);
                        try {
                            (_a = Array.from(headingContainer === null || headingContainer === void 0 ? void 0 : headingContainer.childNodes)) === null || _a === void 0 ? void 0 : _a.forEach(node => {
                                this.renderer.appendChild(newHeading, node);
                            });
                            if ((_b = headingContainer.classList) === null || _b === void 0 ? void 0 : _b.length) {
                                headingContainer.classList.forEach(className => {
                                    this.renderer.addClass(newHeading, className);
                                });
                            }
                            const tabIndex = heading.getAttribute('tabindex');
                            if (tabIndex) {
                                this.renderer.setAttribute(newHeading, 'tabindex', tabIndex);
                            }
                            this.renderer.appendChild(heading, newHeading);
                            this.renderer.removeChild(heading, headingContainer);
                        }
                        catch (e) { }
                    }
                });
            });
        });
    }
}
DynamicHeadingDirective.ɵfac = function DynamicHeadingDirective_Factory(t) { return new (t || DynamicHeadingDirective)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2)); };
DynamicHeadingDirective.ɵdir = /*@__PURE__*/ ɵngcc0.ɵɵdefineDirective({ type: DynamicHeadingDirective, selectors: [["", "uiDynamicHeadings", ""]], inputs: { parentHeading: ["uiDynamicHeadings", "parentHeading"] } });
DynamicHeadingDirective.ctorParameters = () => [
    { type: ElementRef },
    { type: Renderer2 }
];
DynamicHeadingDirective.propDecorators = {
    parentHeading: [{ type: Input, args: ['uiDynamicHeadings',] }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicHeadingDirective, [{
        type: Directive,
        args: [{
                selector: '[uiDynamicHeadings]'
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc0.Renderer2 }]; }, { parentHeading: [{
            type: Input,
            args: ['uiDynamicHeadings']
        }] }); })();

class DynamicHeadingComponent {
    constructor(el) {
        this.el = el;
        this.headingLevel = 1;
        this.changes = new EventEmitter();
    }
    ngAfterViewInit() {
        this.nativeElement = this.el.nativeElement;
        this.observer = new MutationObserver((e) => {
            var _a, _b;
            this.changes.emit((_b = (_a = e[0]) === null || _a === void 0 ? void 0 : _a.addedNodes[0]) === null || _b === void 0 ? void 0 : _b.nodeName);
            this.observer.disconnect();
            this.changes.complete();
        });
        this.observer.observe(this.nativeElement, {
            childList: true
        });
    }
    ngOnDestroy() {
        if (this.observer) {
            this.observer.disconnect();
        }
    }
}
DynamicHeadingComponent.ɵfac = function DynamicHeadingComponent_Factory(t) { return new (t || DynamicHeadingComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef)); };
DynamicHeadingComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: DynamicHeadingComponent, selectors: [["ui-dynamic-heading"]], inputs: { headingLevel: "headingLevel", style: "style" }, outputs: { changes: "changes" }, ngContentSelectors: _c7, decls: 8, vars: 6, consts: [[3, "class", 4, "ngIf"], ["contentTemplate", ""], [4, "ngTemplateOutlet"]], template: function DynamicHeadingComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵprojectionDef();
        ɵngcc0.ɵɵtemplate(0, DynamicHeadingComponent_h1_0_Template, 2, 4, "h1", 0);
        ɵngcc0.ɵɵtemplate(1, DynamicHeadingComponent_h2_1_Template, 2, 4, "h2", 0);
        ɵngcc0.ɵɵtemplate(2, DynamicHeadingComponent_h3_2_Template, 2, 4, "h3", 0);
        ɵngcc0.ɵɵtemplate(3, DynamicHeadingComponent_h4_3_Template, 2, 4, "h4", 0);
        ɵngcc0.ɵɵtemplate(4, DynamicHeadingComponent_h5_4_Template, 2, 4, "h5", 0);
        ɵngcc0.ɵɵtemplate(5, DynamicHeadingComponent_h6_5_Template, 2, 4, "h6", 0);
        ɵngcc0.ɵɵtemplate(6, DynamicHeadingComponent_ng_template_6_Template, 1, 0, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.headingLevel === 1);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.headingLevel === 2);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.headingLevel === 3);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.headingLevel === 4);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.headingLevel === 5);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.headingLevel === 6);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], encapsulation: 2 });
DynamicHeadingComponent.ctorParameters = () => [
    { type: ElementRef }
];
DynamicHeadingComponent.propDecorators = {
    headingLevel: [{ type: Input }],
    style: [{ type: Input }],
    changes: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DynamicHeadingComponent, [{
        type: Component,
        args: [{
                selector: 'ui-dynamic-heading',
                template: "<h1 *ngIf=\"headingLevel === 1\" [attr.data-heading-level]=\"headingLevel\" [class]=\"style ? style : null\">\n  <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n</h1>\n<h2 *ngIf=\"headingLevel === 2\" [attr.data-heading-level]=\"headingLevel\" [class]=\"style ? style : null\">\n  <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n</h2>\n<h3 *ngIf=\"headingLevel === 3\" [attr.data-heading-level]=\"headingLevel\" [class]=\"style ? style : null\">\n  <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n</h3>\n<h4 *ngIf=\"headingLevel === 4\" [attr.data-heading-level]=\"headingLevel\" [class]=\"style ? style : null\">\n  <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n</h4>\n<h5 *ngIf=\"headingLevel === 5\" [attr.data-heading-level]=\"headingLevel\" [class]=\"style ? style : null\">\n  <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n</h5>\n<h6 *ngIf=\"headingLevel === 6\" [attr.data-heading-level]=\"headingLevel\" [class]=\"style ? style : null\">\n  <ng-container *ngTemplateOutlet=\"contentTemplate\"></ng-container>\n</h6>\n\n<ng-template #contentTemplate>\n  <ng-content></ng-content>\n</ng-template>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }]; }, { headingLevel: [{
            type: Input
        }], changes: [{
            type: Output
        }], style: [{
            type: Input
        }] }); })();

class InputPasswordComponent extends FieldComponent {
    constructor(elementRef, settings) {
        super(settings);
        this.elementRef = elementRef;
        this.change = new EventEmitter();
        this.blur = new EventEmitter();
        this.toggleShowPassword = new EventEmitter();
    }
    ngOnChanges(changes) {
        super.ngOnChanges(changes);
        if (changes === null || changes === void 0 ? void 0 : changes.showPassword) {
            this.toggleShowHidePassword(changes === null || changes === void 0 ? void 0 : changes.showPassword.currentValue);
        }
    }
    ngOnDestroy() {
        this.change.complete();
        this.blur.complete();
    }
    changeOccurred($event, field) {
        $event.preventDefault();
        $event.stopPropagation();
        field.value = $event.currentTarget.value;
        this.form.value[field.name] = field.value;
        super.onChangePreProcessor({ src: field, args: { form: this.form } });
        this.change.emit(field);
    }
    handleBlur(field) {
        this.blur.emit(field);
    }
    handleClick(event) {
        this.showPassword = !this.showPassword;
        this.toggleShowHidePassword(this.showPassword);
        this.toggleShowPassword.emit(this.showPassword);
        event.stopPropagation();
    }
    checkForEnter($evt) {
        if ($evt.key === 'Enter') {
            // prevent enter from toggling show password
            $evt.stopPropagation();
        }
        return true;
    }
    toggleShowHidePassword(show) {
        var _a, _b;
        const inputNode = (_b = (_a = this.elementRef) === null || _a === void 0 ? void 0 : _a.nativeElement) === null || _b === void 0 ? void 0 : _b.querySelector('input');
        if (show) {
            this.field.type = 'text';
            if (inputNode) {
                inputNode.type = 'text';
            }
        }
        else {
            this.field.type = 'password';
            if (inputNode) {
                inputNode.type = 'password';
            }
        }
    }
}
InputPasswordComponent.ɵfac = function InputPasswordComponent_Factory(t) { return new (t || InputPasswordComponent)(ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc2.SettingsService)); };
InputPasswordComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: InputPasswordComponent, selectors: [["ui-input-password"]], inputs: { showPassword: "showPassword", icon: "icon", field: "field" }, outputs: { change: "change", blur: "blur", toggleShowPassword: "toggleShowPassword" }, features: [ɵngcc0.ɵɵInheritDefinitionFeature, ɵngcc0.ɵɵNgOnChangesFeature], decls: 1, vars: 1, consts: [[3, "field", "formGroup", "form", "formCtrl", "updateOn", "hasError", 4, "ngIf"], [3, "field", "formGroup", "form", "formCtrl", "updateOn", "hasError"], ["template", ""], [1, "input-group"], ["ifPII", "", "base-input", "", 1, "form-control", 3, "formControlName", "field", "ngClass", "input", "blur", "keydown"], ["type", "button", 1, "input-group-addon", "btn", 3, "title", "click"], [4, "ngIf", "ngIfElse"], ["hidePasswordIcon", ""], ["aria-hidden", "true", 1, "ifc-icon", "ifc-eye"], [1, "sr-only"], ["aria-hidden", "true", 1, "ifc-icon", "ifc-eye-disabled"]], template: function InputPasswordComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, InputPasswordComponent_ui_form_field_0_Template, 3, 6, "ui-form-field", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.field);
    } }, directives: [ɵngcc1.NgIf, FormFieldComponent, ɵngcc4.NgControlStatusGroup, ɵngcc4.FormGroupDirective, ɵngcc4.DefaultValueAccessor, ɵngcc2.IfPersonallyIdentifiableInformationDirective, InputDirective, ɵngcc4.NgControlStatus, ɵngcc4.FormControlName, ɵngcc1.NgClass], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
InputPasswordComponent.ctorParameters = () => [
    { type: ElementRef },
    { type: SettingsService }
];
InputPasswordComponent.propDecorators = {
    icon: [{ type: Input }],
    field: [{ type: Input }],
    showPassword: [{ type: Input }],
    change: [{ type: Output }],
    blur: [{ type: Output }],
    toggleShowPassword: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(InputPasswordComponent, [{
        type: Component,
        args: [{
                selector: 'ui-input-password',
                template: "<ui-form-field *ngIf=\"field\" [field]=\"field\" [formGroup]=\"form\" [form]=\"form\" [formCtrl]=\"FormCtrl\" [updateOn]=\"updateOn\"\n  [hasError]=\"hasError\">\n  <ng-template #template let-field=\"field\">\n    <div class=\"input-group\">\n      <input\n        ifPII\n        base-input\n        class=\"form-control\"\n        [formControlName]=\"field?.name\"\n        (input)=\"changeOccurred($event, field)\"\n        [field]=\"field\"\n        (blur)=\"handleBlur(field)\"\n        [attr.data-if-id]=\"field?.extraAttributes?.ifId\"\n        [ngClass]=\"{'form-control-danger': hasError, 'is-invalid': hasError}\"\n        (keydown)=\"checkForEnter($event)\"/>\n      <button type=\"button\" class=\"input-group-addon btn\" (click)=\"handleClick($event)\" [title]=\"(showPassword ? 'ui.input-password.hide_password' : 'ui.input-password.show_password') | translate\">\n        <ng-container *ngIf=\"!showPassword; else hidePasswordIcon\">\n          <i class=\"ifc-icon ifc-eye\" aria-hidden=\"true\"></i>\n          <span class=\"sr-only\">{{ 'ui.input-password.show_password' | translate}}</span>\n        </ng-container>\n        <ng-template #hidePasswordIcon>\n          <i class=\"ifc-icon ifc-eye-disabled\" aria-hidden=\"true\"></i>\n          <span class=\"sr-only\">{{ 'ui.input-password.hide_password' | translate}}</span>\n        </ng-template>\n      </button>\n    </div>\n  </ng-template>\n</ui-form-field>\n"
            }]
    }], function () { return [{ type: ɵngcc0.ElementRef }, { type: ɵngcc2.SettingsService }]; }, { change: [{
            type: Output
        }], blur: [{
            type: Output
        }], toggleShowPassword: [{
            type: Output
        }], showPassword: [{
            type: Input
        }], icon: [{
            type: Input
        }], field: [{
            type: Input
        }] }); })();

class NotificationsAlertsService {
    constructor() {
        this.modalAlertsSubject = new BehaviorSubject([]);
        this.modalAlertsObservable = this.modalAlertsSubject.asObservable();
        this.bannerSubject = new BehaviorSubject([]);
        this.bannerObservable = this.bannerSubject.asObservable();
        this.panelNotificationSubject = new BehaviorSubject([]);
        this.panelNotificationObservable = this.panelNotificationSubject.asObservable();
    }
    pushModalAlert(alert) {
        const notifications = this.modalAlertsSubject.value || [];
        notifications.push(alert);
        this.setModalAlerts(notifications);
    }
    setModalAlerts(alerts) {
        this.modalAlertsSubject.next(alerts);
    }
    pushBanner(alert) {
        const notifications = this.bannerSubject.value || [];
        notifications.push(alert);
        this.setBanner(notifications);
    }
    setBanner(alerts) {
        this.bannerSubject.next(alerts);
    }
    pushPanelNotification(alert) {
        const notifications = this.panelNotificationSubject.value || [];
        notifications.push(alert);
        this.setPanelNotification(notifications);
    }
    setPanelNotification(alerts) {
        this.panelNotificationSubject.next(alerts);
    }
}
NotificationsAlertsService.ɵfac = function NotificationsAlertsService_Factory(t) { return new (t || NotificationsAlertsService)(); };
NotificationsAlertsService.ɵprov = i0.ɵɵdefineInjectable({ factory: function NotificationsAlertsService_Factory() { return new NotificationsAlertsService(); }, token: NotificationsAlertsService, providedIn: "root" });
NotificationsAlertsService.ctorParameters = () => [];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationsAlertsService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return []; }, null); })();

class ModalAlertsComponent {
    constructor(modalService, notificationsAlertsService, router) {
        this.modalService = modalService;
        this.notificationsAlertsService = notificationsAlertsService;
        this.router = router;
        this.closeOnAction = true;
        this.modalAlerts = [];
        this.action = new EventEmitter;
    }
    dismiss() {
        const alerts = this.modalAlerts.slice(1);
        this.notificationsAlertsService.setModalAlerts(alerts);
    }
    handleAction(action) {
        this.action.emit(action);
        if (this.closeOnAction) {
            this.modalService.hide();
        }
    }
    handleNavigation(link) {
        if ((link === null || link === void 0 ? void 0 : link.href.indexOf('http')) === 0) {
            window.open(link === null || link === void 0 ? void 0 : link.href, link === null || link === void 0 ? void 0 : link.target);
        }
        else {
            this.router.navigateByUrl(link.href);
        }
    }
    ngOnInit() {
        this.subscription = new Subscription();
        this.subscription.add(this.notificationsAlertsService.modalAlertsObservable.subscribe(data => {
            var _a;
            this.modalAlerts = data;
            if ((_a = this.modalAlerts) === null || _a === void 0 ? void 0 : _a.length) {
                this.modalService.show(true, 'modalAlerts');
            }
            else {
                this.modalService.hide();
            }
        }));
    }
    ngAfterViewInit() {
        var _a;
        if ((_a = this.modalAlerts) === null || _a === void 0 ? void 0 : _a.length) {
            this.modalService.show(true, 'modalAlerts');
        }
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
ModalAlertsComponent.ɵfac = function ModalAlertsComponent_Factory(t) { return new (t || ModalAlertsComponent)(ɵngcc0.ɵɵdirectiveInject(ModalService), ɵngcc0.ɵɵdirectiveInject(NotificationsAlertsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.Router)); };
ModalAlertsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: ModalAlertsComponent, selectors: [["ui-modal-alerts"]], contentQueries: function ModalAlertsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c66, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.modalAlertTemplate = _t.first);
    } }, inputs: { closeOnAction: "closeOnAction" }, outputs: { action: "action" }, decls: 5, vars: 4, consts: [["id", "modalAlerts", 3, "label"], ["bodyTemplate", ""], [4, "ngIf"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["defaultModalAlertTemplate", ""], [1, "p-3"], [1, "h2"], [1, "lead"], [3, "innerHtml", 4, "ngIf"], [3, "innerHtml"], ["footerTemplate", ""], [1, "row", "justify-content-end", "w-100"], ["class", "col-12 col-sm-auto pl-sm-1 order-2 mb-2", 4, "ngIf"], ["class", "col-12 col-sm-auto pr-sm-1 order-1 mb-2", 4, "ngIf"], [1, "col-12", "col-sm-auto", "pl-sm-1", "order-2", "mb-2"], ["class", "btn btn-primary btn-block", "type", "button", 3, "click", 4, "ngIf"], ["class", "btn btn-primary btn-block", 3, "click", 4, "ngIf"], ["type", "button", 1, "btn", "btn-primary", "btn-block", 3, "click"], [1, "btn", "btn-primary", "btn-block", 3, "click"], [1, "col-12", "col-sm-auto", "pr-sm-1", "order-1", "mb-2"], ["type", "button", 1, "btn", "btn-block", "btn-default", 3, "click"]], template: function ModalAlertsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "ui-modal", 0);
        ɵngcc0.ɵɵpipe(1, "translate");
        ɵngcc0.ɵɵtemplate(2, ModalAlertsComponent_ng_template_2_Template, 3, 5, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(4, ModalAlertsComponent_4_Template, 2, 0, undefined, 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("label", ɵngcc0.ɵɵpipeBind1(1, 2, ctx.modalAlerts[0] == null ? null : ctx.modalAlerts[0].title));
        ɵngcc0.ɵɵadvance(4);
        ɵngcc0.ɵɵproperty("ngIf", (ctx.modalAlerts[0] == null ? null : ctx.modalAlerts[0].dismissible) || (ctx.modalAlerts[0] == null ? null : ctx.modalAlerts[0].action));
    } }, directives: [ModalComponent, ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
ModalAlertsComponent.ctorParameters = () => [
    { type: ModalService },
    { type: NotificationsAlertsService },
    { type: Router }
];
ModalAlertsComponent.propDecorators = {
    modalAlertTemplate: [{ type: ContentChild, args: ['modalAlertTemplate',] }],
    closeOnAction: [{ type: Input }],
    action: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ModalAlertsComponent, [{
        type: Component,
        args: [{
                selector: 'ui-modal-alerts',
                template: "<ui-modal id=\"modalAlerts\" [label]=\"modalAlerts[0]?.title | translate\">\n  <ng-template #bodyTemplate>\n    <ng-container\n      *ngTemplateOutlet=\"modalAlertTemplate ? modalAlertTemplate: defaultModalAlertTemplate; context: {'alert': modalAlerts[0], 'dismiss': dismiss}\">\n    </ng-container>\n    <ng-template #defaultModalAlertTemplate>\n      <div class=\"p-3\">\n        <h1 class=\"h2\">{{ modalAlerts[0]?.title | translate }}</h1>\n        <p class=\"lead\">{{ modalAlerts[0]?.description | translate }}</p>\n        <div *ngIf=\"modalAlerts[0]?.longDesc; let longDesc\" [innerHtml]=\"longDesc | translate\">\n        </div>\n      </div>\n    </ng-template>\n  </ng-template>\n  <ng-template #footerTemplate *ngIf=\"modalAlerts[0]?.dismissible || modalAlerts[0]?.action\">\n    <div class=\"row justify-content-end w-100\">\n      <div class=\"col-12 col-sm-auto pl-sm-1 order-2 mb-2\" *ngIf=\"modalAlerts[0]?.action; let action\">\n        <button class=\"btn btn-primary btn-block\" type=\"button\" *ngIf=\"!action.href\"\n          (click)=\"handleAction(action)\">{{action.text | translate}}</button>\n        <a class=\"btn btn-primary btn-block\" *ngIf=\"action.href\" (click)=\"handleNavigation(action)\">{{action.text |\n          translate}}</a>\n      </div>\n      <div class=\"col-12 col-sm-auto pr-sm-1 order-1 mb-2\" *ngIf=\"modalAlerts[0]?.dismissible\">\n        <button class=\"btn btn-block btn-default\" type=\"button\" (click)=\"dismiss()\">{{ 'ui.modal-alerts.dismiss_label' | translate }}</button>\n      </div>\n    </div>\n  </ng-template>\n</ui-modal>\n"
            }]
    }], function () { return [{ type: ModalService }, { type: NotificationsAlertsService }, { type: ɵngcc5.Router }]; }, { closeOnAction: [{
            type: Input
        }], action: [{
            type: Output
        }], modalAlertTemplate: [{
            type: ContentChild,
            args: ['modalAlertTemplate']
        }] }); })();

class BannerAlertsComponent {
    constructor(notificationsAlertsService, router) {
        this.notificationsAlertsService = notificationsAlertsService;
        this.router = router;
        this.bannerAlerts = [];
        this.action = new EventEmitter;
    }
    dismiss() {
        const alerts = this.bannerAlerts.slice(1);
        this.notificationsAlertsService.setBanner(alerts);
    }
    handleAction(action) {
        this.action.emit(action);
    }
    handleNavigation(link) {
        if ((link === null || link === void 0 ? void 0 : link.href.indexOf('http')) === 0) {
            window.open(link === null || link === void 0 ? void 0 : link.href, (link === null || link === void 0 ? void 0 : link.target) || '_blank');
        }
        else {
            this.router.navigateByUrl(link.href);
        }
    }
    ngOnInit() {
        this.subscription = new Subscription();
        this.subscription.add(this.notificationsAlertsService.bannerObservable.subscribe(data => {
            var _a, _b, _c;
            this.bannerAlerts = data;
            this.displayedAlert = undefined;
            if ((_a = this.bannerAlerts) === null || _a === void 0 ? void 0 : _a.length) {
                const firstAlert = this.bannerAlerts[0];
                this.displayedAlert = {
                    description: firstAlert.title,
                    icon: firstAlert.icon,
                    position: 'top',
                    link: (_b = firstAlert.action) === null || _b === void 0 ? void 0 : _b.href,
                    linkText: (_c = firstAlert.action) === null || _c === void 0 ? void 0 : _c.text
                };
            }
        }));
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
}
BannerAlertsComponent.ɵfac = function BannerAlertsComponent_Factory(t) { return new (t || BannerAlertsComponent)(ɵngcc0.ɵɵdirectiveInject(NotificationsAlertsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.Router)); };
BannerAlertsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: BannerAlertsComponent, selectors: [["ui-banner-alerts"]], contentQueries: function BannerAlertsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c68, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.bannerTemplate = _t.first);
    } }, outputs: { action: "action" }, decls: 1, vars: 1, consts: [["class", "position-relative", 4, "ngIf"], [1, "position-relative"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["defaultBannerTemplate", ""], [3, "informationBanner", "close", "action"]], template: function BannerAlertsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, BannerAlertsComponent_div_0_Template, 4, 5, "div", 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵproperty("ngIf", ctx.displayedAlert);
    } }, directives: [ɵngcc1.NgIf, ɵngcc1.NgTemplateOutlet, InformationBannerComponent], encapsulation: 2 });
BannerAlertsComponent.ctorParameters = () => [
    { type: NotificationsAlertsService },
    { type: Router }
];
BannerAlertsComponent.propDecorators = {
    bannerTemplate: [{ type: ContentChild, args: ['bannerTemplate',] }],
    action: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BannerAlertsComponent, [{
        type: Component,
        args: [{
                selector: 'ui-banner-alerts',
                template: "<div class=\"position-relative\" *ngIf=\"displayedAlert\">\n  <ng-container\n    *ngTemplateOutlet=\"bannerTemplate ? bannerTemplate: defaultBannerTemplate; context: {'displayedAlert': displayedAlert, 'dismiss': dismiss}\">\n  </ng-container>\n  <ng-template #defaultBannerTemplate>\n    <ui-information-banner [informationBanner]=\"displayedAlert\" (close)=\"dismiss()\" (action)=\"handleAction(bannerAlerts[0]?.action)\"></ui-information-banner>\n  </ng-template>\n</div>\n"
            }]
    }], function () { return [{ type: NotificationsAlertsService }, { type: ɵngcc5.Router }]; }, { action: [{
            type: Output
        }], bannerTemplate: [{
            type: ContentChild,
            args: ['bannerTemplate']
        }] }); })();

class PanelAlertsComponent {
    constructor(notificationsAlertsService, router, changesRef, renderer, el, modal) {
        this.notificationsAlertsService = notificationsAlertsService;
        this.router = router;
        this.changesRef = changesRef;
        this.renderer = renderer;
        this.el = el;
        this.modal = modal;
        this.maxAlerts = 5;
        this.showPanel = false;
        this.panelAlerts = [];
        this.action = new EventEmitter;
    }
    openAllNotifications() {
        this.modal.show(true, 'allNotifications');
    }
    closeNotifications() {
        this.modal.hide();
    }
    handleAction(action) {
        this.action.emit(action);
    }
    handleNavigation(link) {
        this.handleAction(link);
        if ((link === null || link === void 0 ? void 0 : link.href.indexOf('http')) === 0) {
            window.open(link === null || link === void 0 ? void 0 : link.href, (link === null || link === void 0 ? void 0 : link.target) || '_blank');
        }
        else {
            this.router.navigateByUrl(link.href);
        }
    }
    ngOnInit() {
        this.subscription = new Subscription();
        this.subscription.add(this.notificationsAlertsService.panelNotificationObservable.subscribe(data => {
            this.panelAlerts = data;
        }));
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    togglePanel() {
        this.showPanel = !this.showPanel;
        this.changesRef.detectChanges();
        setTimeout(() => {
            if (this.showPanel) {
                const menu = this.el.nativeElement.querySelector('.panel-alerts');
                if (!menu) {
                    return;
                }
                menu.focus();
                this.showPanelListener = this.renderer.listen(menu, 'focusout', (e) => {
                    if (menu.contains(e.relatedTarget)) {
                        return;
                    }
                    this.showPanel = false;
                });
            }
            else {
                this.showPanelListener();
            }
        });
    }
}
PanelAlertsComponent.ɵfac = function PanelAlertsComponent_Factory(t) { return new (t || PanelAlertsComponent)(ɵngcc0.ɵɵdirectiveInject(NotificationsAlertsService), ɵngcc0.ɵɵdirectiveInject(ɵngcc5.Router), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ChangeDetectorRef), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.Renderer2), ɵngcc0.ɵɵdirectiveInject(ɵngcc0.ElementRef), ɵngcc0.ɵɵdirectiveInject(ModalService)); };
PanelAlertsComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PanelAlertsComponent, selectors: [["ui-panel-alerts"]], contentQueries: function PanelAlertsComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c70, 5);
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c71, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.panelAlertsTemplate = _t.first);
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.allAlertsTemplate = _t.first);
    } }, inputs: { maxAlerts: "maxAlerts" }, outputs: { action: "action" }, decls: 17, vars: 7, consts: [[1, "mx-2", "d-flex", "align-items-center", "h-100", "position-relative"], ["type", "button", 1, "btn", "btn-link", "position-relative", "align-items-center", "d-none", "d-lg-flex", 3, "click"], [1, "ifc-icon", "ifc-bell", "ifc-icon-2"], ["class", "alert-bubble rounded-circle", 4, "ngIf"], [1, "sr-only"], ["type", "button", 1, "btn", "btn-link", "position-relative", "align-items-center", "d-flex", "d-lg-none", 3, "click"], ["class", "panel-alerts card", "tabindex", "-1", 4, "ngIf"], ["id", "allNotifications", 3, "scrollable", "label"], ["bodyTemplate", ""], ["footerTemplate", ""], [1, "alert-bubble", "rounded-circle"], ["tabindex", "-1", 1, "panel-alerts", "card"], [4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["defaultAlertsTemplate", ""], ["class", "font-italic p-3 h6", 4, "ngIf"], ["class", "list-group list-group-flush border-0", 4, "ngIf"], [4, "ngIf"], [1, "font-italic", "p-3", "h6"], [1, "list-group", "list-group-flush", "border-0"], ["class", "list-group-item list-group-item-action", 4, "ngFor", "ngForOf"], [1, "list-group-item", "list-group-item-action"], ["href", "javascript:void(0)", 1, "small", 3, "click"], [1, "d-flex", "flex-row", "justify-content-lg-between", "align-items-start"], [1, "mr-2", "d-flex"], [1, "d-block"], ["class", "text-muted mt-2 d-block", 4, "ngIf"], [1, "ifc-icon", "ifc-chevron-right", "mt-1"], [1, "text-muted", "mt-2", "d-block"], ["href", "javascript:void(0)", 1, "btn", "btn-block", "btn-outline-primary", "border-0", 3, "click"], ["defaultAllAlertsTemplate", ""], [1, "p-3"], [1, "h2"], ["class", "list-group-item list-group-item-action px-0", 4, "ngFor", "ngForOf"], [1, "list-group-item", "list-group-item-action", "px-0"], ["href", "javascript:void(0)", 3, "click"], ["class", "small text-muted mt-2 d-block", 4, "ngIf"], [1, "small", "text-muted", "mt-2", "d-block"], [1, "row", "justify-content-end", "w-100"], [1, "col-12", "col-sm-auto", "mb-2"], ["type", "button", 1, "btn", "btn-block", "btn-outline-primary", 3, "click"]], template: function PanelAlertsComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0);
        ɵngcc0.ɵɵelementStart(1, "button", 1);
        ɵngcc0.ɵɵlistener("click", function PanelAlertsComponent_Template_button_click_1_listener() { return ctx.togglePanel(); });
        ɵngcc0.ɵɵelement(2, "i", 2);
        ɵngcc0.ɵɵtemplate(3, PanelAlertsComponent_span_3_Template, 2, 1, "span", 3);
        ɵngcc0.ɵɵelementStart(4, "span", 4);
        ɵngcc0.ɵɵtext(5);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(6, "button", 5);
        ɵngcc0.ɵɵlistener("click", function PanelAlertsComponent_Template_button_click_6_listener() { return ctx.openAllNotifications(); });
        ɵngcc0.ɵɵelement(7, "i", 2);
        ɵngcc0.ɵɵtemplate(8, PanelAlertsComponent_span_8_Template, 2, 1, "span", 3);
        ɵngcc0.ɵɵelementStart(9, "span", 4);
        ɵngcc0.ɵɵtext(10);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵtemplate(11, PanelAlertsComponent_div_11_Template, 4, 7, "div", 6);
        ɵngcc0.ɵɵelementEnd();
        ɵngcc0.ɵɵelementStart(12, "ui-modal", 7);
        ɵngcc0.ɵɵtemplate(13, PanelAlertsComponent_ng_template_13_Template, 3, 7, "ng-template", null, 8, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵtemplate(15, PanelAlertsComponent_ng_template_15_Template, 5, 3, "ng-template", null, 9, ɵngcc0.ɵɵtemplateRefExtractor);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.panelAlerts == null ? null : ctx.panelAlerts.length);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate("ui.panel-alerts.notifications");
        ɵngcc0.ɵɵadvance(3);
        ɵngcc0.ɵɵproperty("ngIf", ctx.panelAlerts == null ? null : ctx.panelAlerts.length);
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵtextInterpolate("ui.panel-alerts.notifications");
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("ngIf", ctx.showPanel);
        ɵngcc0.ɵɵadvance(1);
        ɵngcc0.ɵɵproperty("scrollable", true)("label", "All Notifications");
    } }, directives: [ɵngcc1.NgIf, ModalComponent, ɵngcc1.NgTemplateOutlet, ɵngcc1.NgForOf], pipes: [ɵngcc3.TranslatePipe, ɵngcc1.SlicePipe], encapsulation: 2 });
PanelAlertsComponent.ctorParameters = () => [
    { type: NotificationsAlertsService },
    { type: Router },
    { type: ChangeDetectorRef },
    { type: Renderer2 },
    { type: ElementRef },
    { type: ModalService }
];
PanelAlertsComponent.propDecorators = {
    panelAlertsTemplate: [{ type: ContentChild, args: ['panelAlertsTemplate',] }],
    allAlertsTemplate: [{ type: ContentChild, args: ['allAlertsTemplate',] }],
    maxAlerts: [{ type: Input }],
    action: [{ type: Output }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PanelAlertsComponent, [{
        type: Component,
        args: [{
                selector: 'ui-panel-alerts',
                template: "<div class=\"mx-2 d-flex align-items-center h-100 position-relative\">\n  <button class=\"btn btn-link position-relative align-items-center d-none d-lg-flex\" type=\"button\" (click)=\"togglePanel()\">\n    <i class=\"ifc-icon ifc-bell ifc-icon-2\"></i>\n    <span *ngIf=\"panelAlerts?.length\" class=\"alert-bubble rounded-circle\">{{ panelAlerts?.length }}</span>\n    <span class=\"sr-only\">{{'ui.panel-alerts.notifications'}}</span>\n  </button>\n\n  <button class=\"btn btn-link position-relative align-items-center d-flex d-lg-none\" type=\"button\" (click)=\"openAllNotifications()\">\n    <i class=\"ifc-icon ifc-bell ifc-icon-2\"></i>\n    <span *ngIf=\"panelAlerts?.length\" class=\"alert-bubble rounded-circle\">{{ panelAlerts?.length }}</span>\n    <span class=\"sr-only\">{{'ui.panel-alerts.notifications'}}</span>\n  </button>\n\n  <div class=\"panel-alerts card\" *ngIf=\"showPanel\" tabindex=\"-1\">\n    <ng-container\n      *ngTemplateOutlet=\"panelAlertsTemplate ? panelAlertsTemplate: defaultAlertsTemplate; context: {'alerts': panelAlerts, 'openAllNotifications': openAllNotifications, 'closeNotifications': closeNotifications, 'togglePanel': togglePanel}\">\n    </ng-container>\n    <ng-template #defaultAlertsTemplate>\n      <div *ngIf=\"!panelAlerts?.length\" class=\"font-italic p-3 h6\">\n        {{ 'ui.panel-alerts.empty_state' | translate }}\n      </div>\n      <ul class=\"list-group list-group-flush border-0\" *ngIf=\"panelAlerts?.length\">\n        <li class=\"list-group-item list-group-item-action\" *ngFor=\"let alert of panelAlerts | slice:0:maxAlerts\">\n          <a href=\"javascript:void(0)\" class=\"small\" (click)=\"handleNavigation(alert.action)\">\n            <span class=\"d-flex flex-row justify-content-lg-between align-items-start\">\n              <span class=\"mr-2 d-flex\">\n                <i class=\"ifc-icon {{alert.icon}} ifc-icon-2 mr-2 mt-1\"></i>\n                <span>\n                  <span class=\"d-block\">{{alert.title | translate}}</span>\n                  <span class=\"text-muted mt-2 d-block\" *ngIf=\"alert.dateTime; let dateTime\">{{alert.dateTime |\n                    translate}}</span>\n                </span>\n              </span>\n              <i class=\"ifc-icon ifc-chevron-right mt-1\"></i>\n            </span>\n          </a>\n        </li>\n      </ul>\n      <div *ngIf=\"panelAlerts.length > maxAlerts\">\n        <a href=\"javascript:void(0)\" class=\"btn btn-block btn-outline-primary border-0\"\n          (click)=\"openAllNotifications()\">{{'ui.panel-alerts.view_all' | translate}}</a>\n      </div>\n    </ng-template>\n  </div>\n</div>\n\n<ui-modal id=\"allNotifications\" [scrollable]=\"true\" [label]=\"'All Notifications'\">\n  <ng-template #bodyTemplate>\n    <ng-container\n      *ngTemplateOutlet=\"allAlertsTemplate ? allAlertsTemplate: defaultAllAlertsTemplate; context: {'alerts': panelAlerts, 'openAllNotifications': openAllNotifications, 'closeNotifications': closeNotifications, 'togglePanel': togglePanel}\">\n    </ng-container>\n    <ng-template #defaultAllAlertsTemplate>\n      <div class=\"p-3\">\n        <h1 class=\"h2\">{{ 'ui.panel-alerts.all_notifications_heading' | translate }}</h1>\n        <ul class=\"list-group list-group-flush border-0\">\n          <li class=\"list-group-item list-group-item-action px-0\" *ngFor=\"let alert of panelAlerts\">\n            <a href=\"javascript:void(0)\" (click)=\"handleNavigation(alert.action)\">\n              <span class=\"d-flex flex-row justify-content-lg-between align-items-start\">\n                <span class=\"mr-2 d-flex\">\n                  <i class=\"ifc-icon {{alert.icon}} ifc-icon-2 mr-2 mt-1\"></i>\n                  <span>\n                    <span class=\"d-block\">{{alert.title | translate}}</span>\n                    <span class=\"small text-muted mt-2 d-block\" *ngIf=\"alert.dateTime; let dateTime\">{{alert.dateTime |\n                      translate}}</span>\n                  </span>\n                </span>\n                <i class=\"ifc-icon ifc-chevron-right mt-1\"></i>\n              </span>\n            </a>\n          </li>\n        </ul>\n      </div>\n    </ng-template>\n  </ng-template>\n  <ng-template #footerTemplate>\n    <div class=\"row justify-content-end w-100\">\n      <div class=\"col-12 col-sm-auto mb-2\">\n        <button class=\"btn btn-block btn-outline-primary\" type=\"button\" (click)=\"closeNotifications()\">{{'ui.panel-alerts.close_label' | translate}}</button>\n      </div>\n    </div>\n  </ng-template>\n</ui-modal>\n"
            }]
    }], function () { return [{ type: NotificationsAlertsService }, { type: ɵngcc5.Router }, { type: ɵngcc0.ChangeDetectorRef }, { type: ɵngcc0.Renderer2 }, { type: ɵngcc0.ElementRef }, { type: ModalService }]; }, { maxAlerts: [{
            type: Input
        }], action: [{
            type: Output
        }], panelAlertsTemplate: [{
            type: ContentChild,
            args: ['panelAlertsTemplate']
        }], allAlertsTemplate: [{
            type: ContentChild,
            args: ['allAlertsTemplate']
        }] }); })();

class TrainService {
    constructor(lastResponse) {
        this.curStopIdxSubject = new BehaviorSubject(-1);
        this.curStopIdxObservable = this.curStopIdxSubject.asObservable();
        this.trainStopsSubject = new BehaviorSubject(undefined);
        this.trainStopsObservable = this.trainStopsSubject.asObservable();
        lastResponse.ifResponseObservable.subscribe((ifResponse) => {
            if (ifResponse === null || ifResponse === void 0 ? void 0 : ifResponse.ProposedTemplate) {
                this.curTemplate = ifResponse === null || ifResponse === void 0 ? void 0 : ifResponse.ProposedTemplate;
                this.setCurStopIdx();
            }
        });
    }
    setTrainStops(trainStops) {
        this.trainStops = trainStops;
        this.trainStopsSubject.next(this.trainStops);
        this.setCurStopIdx();
    }
    setCurStopIdx(curStop) {
        var _a, _b, _c, _d, _e;
        if (curStop) {
            if (typeof curStop === 'string') {
                const curStopIdx = (_b = (_a = this.trainStops) === null || _a === void 0 ? void 0 : _a.stopArray) === null || _b === void 0 ? void 0 : _b.findIndex(stop => stop.title === curStop);
                if (curStopIdx !== -1) {
                    this.curStopIdxSubject.next(curStopIdx);
                }
            }
            else {
                this.curStopIdxSubject.next(curStop);
            }
        }
        else if ((_c = this.trainStops) === null || _c === void 0 ? void 0 : _c.byRoute) {
            const curStopIdx = (_e = (_d = this.trainStops) === null || _d === void 0 ? void 0 : _d.stopArray) === null || _e === void 0 ? void 0 : _e.findIndex(stop => { var _a; return (_a = stop.nativeStepRoutes) === null || _a === void 0 ? void 0 : _a.some(sr => { var _a; return (_a = this.curTemplate) === null || _a === void 0 ? void 0 : _a.endsWith(sr); }); });
            if (curStopIdx !== -1) {
                this.curStopIdxSubject.next(curStopIdx);
            }
        }
    }
}
TrainService.ɵfac = function TrainService_Factory(t) { return new (t || TrainService)(ɵngcc0.ɵɵinject(ɵngcc2.LastResponseService)); };
TrainService.ɵprov = i0.ɵɵdefineInjectable({ factory: function TrainService_Factory() { return new TrainService(i0.ɵɵinject(i1$1.LastResponseService)); }, token: TrainService, providedIn: "root" });
TrainService.ctorParameters = () => [
    { type: LastResponseService }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TrainService, [{
        type: Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc2.LastResponseService }]; }, null); })();

class TrainComponent {
    constructor(trainService) {
        this.trainService = trainService;
        this.currentStopIdx = 0;
        this.stepListShown = false;
        this.subscription = new Subscription();
    }
    ngOnInit() {
        if (this.trainStops) {
            this.trainService.setTrainStops(this.trainStops);
        }
        this.subscription.add(this.trainService.curStopIdxObservable.subscribe((curStopIdx) => {
            this.currentStopIdx = curStopIdx;
        }));
        this.subscription.add(this.trainService.trainStopsObservable.subscribe((trainStops) => {
            this.trainStops = trainStops;
        }));
    }
    ngOnDestroy() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    }
    toggleStepListShown() {
        this.stepListShown = !this.stepListShown;
    }
}
TrainComponent.ɵfac = function TrainComponent_Factory(t) { return new (t || TrainComponent)(ɵngcc0.ɵɵdirectiveInject(TrainService)); };
TrainComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: TrainComponent, selectors: [["ui-train"]], contentQueries: function TrainComponent_ContentQueries(rf, ctx, dirIndex) { if (rf & 1) {
        ɵngcc0.ɵɵcontentQuery(dirIndex, _c73, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.trainTemplate = _t.first);
    } }, inputs: { trainStops: "trainStops" }, decls: 3, vars: 5, consts: [[4, "ngTemplateOutlet", "ngTemplateOutletContext"], ["trainDefault", ""], [4, "ngIf"], [1, "pt-3", "d-none", "d-lg-block"], ["class", "train-stops px-0 d-flex row justify-content-between m-0", 4, "ngIf"], [1, "mt-4", "d-flex", "flex-column", "d-lg-none", "mobile-view"], [1, "step-indicator", "p-3", 3, "click", "focusout"], [1, "ifc-icon", "align-middle", "mr-1", 3, "ngClass"], [1, "progress-bar"], [1, "train-stop-list", "flex-column", 3, "click"], ["class", "px-3 py-1", 3, "stop-list-active", "stop-list-inactive", 4, "ngFor", "ngForOf"], [1, "train-stops", "px-0", "d-flex", "row", "justify-content-between", "m-0"], ["role", "navigation", "class", "col d-flex flex-column align-items-center", 3, "active", "completed", "border-right-0", 4, "ngFor", "ngForOf"], ["role", "navigation", 1, "col", "d-flex", "flex-column", "align-items-center"], ["class", "badge badge-incomplete rounded-circle d-flex align-items-center justify-content-center", 4, "ngIf"], ["class", "badge badge-complete rounded-circle d-flex align-items-center justify-content-center", 4, "ngIf"], [1, "d-flex", "flex-row", "align-items-center"], [1, "badge", "badge-incomplete", "rounded-circle", "d-flex", "align-items-center", "justify-content-center"], [1, "stop-num"], [1, "badge", "badge-complete", "rounded-circle", "d-flex", "align-items-center", "justify-content-center"], [1, "ifc-icon", "ifc-check", "text-white", "font-weight-bold"], [1, "px-3", "py-1"], [1, "stop-list-num", "mr-1"]], template: function TrainComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵtemplate(0, TrainComponent_ng_container_0_Template, 1, 0, "ng-container", 0);
        ɵngcc0.ɵɵtemplate(1, TrainComponent_ng_template_1_Template, 1, 1, "ng-template", null, 1, ɵngcc0.ɵɵtemplateRefExtractor);
    } if (rf & 2) {
        const _r1 = ɵngcc0.ɵɵreference(2);
        ɵngcc0.ɵɵproperty("ngTemplateOutlet", ctx.trainTemplate ? ctx.trainTemplate : _r1)("ngTemplateOutletContext", ɵngcc0.ɵɵpureFunction2(2, _c75, ctx.trainStops == null ? null : ctx.trainStops.stopArray, ctx.currentStopIdx));
    } }, directives: [ɵngcc1.NgTemplateOutlet, ɵngcc1.NgIf, ɵngcc1.NgClass, ɵngcc1.NgForOf], pipes: [ɵngcc3.TranslatePipe], encapsulation: 2 });
TrainComponent.ctorParameters = () => [
    { type: TrainService }
];
TrainComponent.propDecorators = {
    trainTemplate: [{ type: ContentChild, args: ['trainTemplate',] }],
    trainStops: [{ type: Input }]
};
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TrainComponent, [{
        type: Component,
        args: [{
                selector: 'ui-train',
                template: "<ng-container *ngTemplateOutlet=\"trainTemplate ? trainTemplate: trainDefault; context: {'trainStops': trainStops?.stopArray, 'currentStopIdx': currentStopIdx}\">\n</ng-container>\n\n<ng-template #trainDefault let-trainStops=\"trainStops\" let-currentStopIdx=\"currentStopIdx\">\n  <ng-container *ngIf=\"trainStops\">\n    <section class=\"pt-3 d-none d-lg-block\">\n      <ul class=\"train-stops px-0 d-flex row justify-content-between m-0\"\n        *ngIf=\"trainStops\">\n        <li *ngFor=\"let stop of trainStops; let i = index\"\n            role=\"navigation\"\n            class=\"col d-flex flex-column align-items-center\"\n            [attr.tabindex]=\"currentStopIdx > i ? '0' : '-1'\"\n            [class.active]=\"currentStopIdx === i\"\n            [class.completed]=\"currentStopIdx > i\"\n            [class.border-right-0]=\"i > 0\">\n          <div *ngIf=\"currentStopIdx <= i\"\n              class=\"badge badge-incomplete rounded-circle d-flex align-items-center justify-content-center\">\n            <span class=\"stop-num\">\n              {{i+1}}\n            </span>\n          </div>\n          <div *ngIf=\"currentStopIdx > i\"\n              class=\"badge badge-complete rounded-circle d-flex align-items-center justify-content-center\">\n            <i class=\"ifc-icon ifc-check text-white font-weight-bold\">\n            </i>\n          </div>\n          <div class=\"d-flex flex-row align-items-center\">\n            {{ stop.title | translate }}\n          </div>\n        </li>\n      </ul>\n    </section>\n\n    <section class=\"mt-4 d-flex flex-column d-lg-none mobile-view\">\n      <div class=\"step-indicator p-3\" (click)=\"toggleStepListShown()\" (focusout)=\"toggleStepListShown()\">\n        <i class=\"ifc-icon align-middle mr-1\" [ngClass]=\"{'ifc-menu': !stepListShown, 'ifc-circle-remove': stepListShown}\"></i>\n        {{'ui.steps.step_num_of_total' | translate: { 'current': currentStopIdx + 1, 'total': trainStops.length } }}\n      </div>\n      <div class=\"progress-bar\">\n        <span [style.width.%]=\"(currentStopIdx + 1) / (trainStops.length + 1) * 100\">\n        </span>\n      </div>\n      <div class=\"train-stop-list flex-column\"\n          [class.d-none]=\"!stepListShown\"\n          [class.d-flex]=\"stepListShown\"\n          (click)=\"toggleStepListShown()\">\n        <div *ngFor=\"let stop of trainStops; let i = index\"\n            class=\"px-3 py-1\"\n            [class.stop-list-active]=\"currentStopIdx === i\"\n            [class.stop-list-inactive]=\"currentStopIdx !== i\">\n          <span class=\"stop-list-num mr-1\">{{i + 1}}</span>\n          <span>{{stop.title | translate}}</span>\n        </div>\n      </div>\n    </section>\n  </ng-container>\n</ng-template>\n"
            }]
    }], function () { return [{ type: TrainService }]; }, { trainStops: [{
            type: Input
        }], trainTemplate: [{
            type: ContentChild,
            args: ['trainTemplate']
        }] }); })();

class UINgModule {
    static forRoot() {
        return {
            ngModule: UINgModule,
            providers: [
                HooksService,
                TrackingPixelsService,
                ModalService,
                ScrollService,
                StorageService,
                ProxyUrlService,
                LoadingService,
                BreadcrumbsService,
                NotificationService,
                StepsService,
                ToastService,
                ExpandCollapseService,
                PasswordCriterionValidatorService,
                BrowserDetectionService,
                TrainService
            ]
        };
    }
}
UINgModule.ɵfac = function UINgModule_Factory(t) { return new (t || UINgModule)(); };
UINgModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: UINgModule });
UINgModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [[
            CommonModule,
            ReactiveFormsModule,
            StoreModule.forFeature(stepsFeatureKey, uiStepsReducer, { metaReducers: metaReducers }),
            CoreNg,
            TranslateModule,
            RouterModule
        ]] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UINgModule, [{
        type: NgModule,
        args: [{
                imports: [
                    CommonModule,
                    ReactiveFormsModule,
                    StoreModule.forFeature(stepsFeatureKey, uiStepsReducer, { metaReducers: metaReducers }),
                    CoreNg,
                    TranslateModule,
                    RouterModule
                ],
                declarations: [
                    DynamicHeadingComponent,
                    DynamicHeadingDirective,
                    InputRangeComponent,
                    InputFileComponent,
                    LoadingComponent,
                    LoadingSpinnerComponent,
                    InputSwitchComponent,
                    ListViewComponent,
                    TileViewComponent,
                    GenericEditComponent,
                    ErrorComponent,
                    CopyrightComponent,
                    ResponsiveImgComponent,
                    AttachmentsComponent,
                    ModalComponent,
                    ModalDialogDirective,
                    ArrowModalDialogDirective,
                    ProxyUrlComponent,
                    TrackingPixelsComponent,
                    ImageContentComponent,
                    FooterComponent,
                    StickyNavbarComponent,
                    CookieAdvisoryBannerComponent,
                    CookieStatementComponent,
                    CookieExplicitBannerComponent,
                    InlineDatepickerComponent,
                    PopoverDirective,
                    InputComponent,
                    SelectComponent,
                    HiddensComponent,
                    RadioComponent,
                    CheckboxComponent,
                    CheckRadioComponent,
                    TextAreaComponent,
                    SelectButtonsComponent,
                    BreadcrumbsComponent,
                    ButtonDirective,
                    InputDirective,
                    SROnlyLabelDirective,
                    ErrorBoxComponent,
                    FormFieldComponent,
                    InputDateComponent,
                    FormControlComponent,
                    ValidationCheckerComponent,
                    SkipToMainComponent,
                    PageLayoutComponent,
                    ContainerLayoutComponent,
                    NavBarComponent,
                    HeaderComponent,
                    ButtonGroupComponent,
                    InputTypeaheadComponent,
                    ResponsiveTableComponent,
                    SearchComponent,
                    CheckradioGroupComponent,
                    MaintenanceComponent,
                    NotificationComponent,
                    ControlsFilterPipe,
                    YesNoComponent,
                    CarouselComponent,
                    ToggleSwitchDirective,
                    MessageLoaderComponent,
                    MultiSelectToCheckboxComponent,
                    StepsComponent,
                    StepsHeaderComponent,
                    InputTimePipe,
                    InputTimeComponent,
                    InputGroupComponent,
                    BrowserDetectionComponent,
                    ProgressBarComponent,
                    TooltipComponent,
                    ToggletipDirective,
                    MultiSelectDropdownComponent,
                    OptionFilterPipe,
                    TabGroupComponent,
                    InlineTimePickerComponent,
                    InputTimePickerComponent,
                    TimeLeadingZeroPipe,
                    DateReformatPipe,
                    InputDateRangeComponent,
                    InputTimeRangeComponent,
                    FormatTimeFieldValuePipe,
                    ToastComponent,
                    RadioButtonGroupComponent,
                    RadioButtonComponent,
                    ExpandCollapseComponent,
                    InformationBannerComponent,
                    PasswordCriteriaComponent,
                    MobilePasswordCriteriaComponent,
                    InputPasswordComponent,
                    ModalAlertsComponent,
                    BannerAlertsComponent,
                    PanelAlertsComponent,
                    TrainComponent
                ],
                exports: [
                    DynamicHeadingComponent,
                    DynamicHeadingDirective,
                    InputRangeComponent,
                    InputFileComponent,
                    LoadingComponent,
                    LoadingSpinnerComponent,
                    InputSwitchComponent,
                    ListViewComponent,
                    TileViewComponent,
                    GenericEditComponent,
                    ErrorComponent,
                    CopyrightComponent,
                    ResponsiveImgComponent,
                    AttachmentsComponent,
                    ProxyUrlComponent,
                    TrackingPixelsComponent,
                    ImageContentComponent,
                    FooterComponent,
                    StickyNavbarComponent,
                    CookieAdvisoryBannerComponent,
                    CookieStatementComponent,
                    CookieExplicitBannerComponent,
                    InlineDatepickerComponent,
                    PopoverDirective,
                    ModalComponent,
                    ModalDialogDirective,
                    ArrowModalDialogDirective,
                    InputComponent,
                    SelectComponent,
                    HiddensComponent,
                    RadioComponent,
                    CheckboxComponent,
                    CheckRadioComponent,
                    TextAreaComponent,
                    SelectButtonsComponent,
                    BreadcrumbsComponent,
                    ButtonDirective,
                    InputDirective,
                    SROnlyLabelDirective,
                    ErrorBoxComponent,
                    FormFieldComponent,
                    InputDateComponent,
                    FormControlComponent,
                    ValidationCheckerComponent,
                    SkipToMainComponent,
                    PageLayoutComponent,
                    ContainerLayoutComponent,
                    NavBarComponent,
                    HeaderComponent,
                    ButtonGroupComponent,
                    InputTypeaheadComponent,
                    ResponsiveTableComponent,
                    SearchComponent,
                    CheckradioGroupComponent,
                    MaintenanceComponent,
                    NotificationComponent,
                    ControlsFilterPipe,
                    YesNoComponent,
                    CarouselComponent,
                    ToggleSwitchDirective,
                    MessageLoaderComponent,
                    MultiSelectToCheckboxComponent,
                    StepsComponent,
                    StepsHeaderComponent,
                    InputTimePipe,
                    InputTimeComponent,
                    InputGroupComponent,
                    BrowserDetectionComponent,
                    ProgressBarComponent,
                    TooltipComponent,
                    ToggletipDirective,
                    MultiSelectDropdownComponent,
                    OptionFilterPipe,
                    TabGroupComponent,
                    InlineTimePickerComponent,
                    InputTimePickerComponent,
                    TimeLeadingZeroPipe,
                    DateReformatPipe,
                    InputDateRangeComponent,
                    InputTimeRangeComponent,
                    FormatTimeFieldValuePipe,
                    ToastComponent,
                    RadioButtonGroupComponent,
                    ExpandCollapseComponent,
                    RadioButtonComponent,
                    InformationBannerComponent,
                    PasswordCriteriaComponent,
                    MobilePasswordCriteriaComponent,
                    InputPasswordComponent,
                    ModalAlertsComponent,
                    BannerAlertsComponent,
                    PanelAlertsComponent,
                    TrainComponent
                ]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(UINgModule, { declarations: function () { return [DynamicHeadingComponent, DynamicHeadingDirective, InputRangeComponent, InputFileComponent, LoadingComponent, LoadingSpinnerComponent, InputSwitchComponent, ListViewComponent, TileViewComponent, GenericEditComponent, ErrorComponent, CopyrightComponent, ResponsiveImgComponent, AttachmentsComponent, ModalComponent, ModalDialogDirective, ArrowModalDialogDirective, ProxyUrlComponent, TrackingPixelsComponent, ImageContentComponent, FooterComponent, StickyNavbarComponent, CookieAdvisoryBannerComponent, CookieStatementComponent, CookieExplicitBannerComponent, InlineDatepickerComponent, PopoverDirective, InputComponent, SelectComponent, HiddensComponent, RadioComponent, CheckboxComponent, CheckRadioComponent, TextAreaComponent, SelectButtonsComponent, BreadcrumbsComponent, ButtonDirective, InputDirective, SROnlyLabelDirective, ErrorBoxComponent, FormFieldComponent, InputDateComponent, FormControlComponent, ValidationCheckerComponent, SkipToMainComponent, PageLayoutComponent, ContainerLayoutComponent, NavBarComponent, HeaderComponent, ButtonGroupComponent, InputTypeaheadComponent, ResponsiveTableComponent, SearchComponent, CheckradioGroupComponent, MaintenanceComponent, NotificationComponent, ControlsFilterPipe, YesNoComponent, CarouselComponent, ToggleSwitchDirective, MessageLoaderComponent, MultiSelectToCheckboxComponent, StepsComponent, StepsHeaderComponent, InputTimePipe, InputTimeComponent, InputGroupComponent, BrowserDetectionComponent, ProgressBarComponent, TooltipComponent, ToggletipDirective, MultiSelectDropdownComponent, OptionFilterPipe, TabGroupComponent, InlineTimePickerComponent, InputTimePickerComponent, TimeLeadingZeroPipe, DateReformatPipe, InputDateRangeComponent, InputTimeRangeComponent, FormatTimeFieldValuePipe, ToastComponent, RadioButtonGroupComponent, RadioButtonComponent, ExpandCollapseComponent, InformationBannerComponent, PasswordCriteriaComponent, MobilePasswordCriteriaComponent, InputPasswordComponent, ModalAlertsComponent, BannerAlertsComponent, PanelAlertsComponent, TrainComponent]; }, imports: function () { return [CommonModule,
        ReactiveFormsModule, ɵngcc7.StoreFeatureModule, CoreNg,
        TranslateModule,
        RouterModule]; }, exports: function () { return [DynamicHeadingComponent, DynamicHeadingDirective, InputRangeComponent, InputFileComponent, LoadingComponent, LoadingSpinnerComponent, InputSwitchComponent, ListViewComponent, TileViewComponent, GenericEditComponent, ErrorComponent, CopyrightComponent, ResponsiveImgComponent, AttachmentsComponent, ProxyUrlComponent, TrackingPixelsComponent, ImageContentComponent, FooterComponent, StickyNavbarComponent, CookieAdvisoryBannerComponent, CookieStatementComponent, CookieExplicitBannerComponent, InlineDatepickerComponent, PopoverDirective, ModalComponent, ModalDialogDirective, ArrowModalDialogDirective, InputComponent, SelectComponent, HiddensComponent, RadioComponent, CheckboxComponent, CheckRadioComponent, TextAreaComponent, SelectButtonsComponent, BreadcrumbsComponent, ButtonDirective, InputDirective, SROnlyLabelDirective, ErrorBoxComponent, FormFieldComponent, InputDateComponent, FormControlComponent, ValidationCheckerComponent, SkipToMainComponent, PageLayoutComponent, ContainerLayoutComponent, NavBarComponent, HeaderComponent, ButtonGroupComponent, InputTypeaheadComponent, ResponsiveTableComponent, SearchComponent, CheckradioGroupComponent, MaintenanceComponent, NotificationComponent, ControlsFilterPipe, YesNoComponent, CarouselComponent, ToggleSwitchDirective, MessageLoaderComponent, MultiSelectToCheckboxComponent, StepsComponent, StepsHeaderComponent, InputTimePipe, InputTimeComponent, InputGroupComponent, BrowserDetectionComponent, ProgressBarComponent, TooltipComponent, ToggletipDirective, MultiSelectDropdownComponent, OptionFilterPipe, TabGroupComponent, InlineTimePickerComponent, InputTimePickerComponent, TimeLeadingZeroPipe, DateReformatPipe, InputDateRangeComponent, InputTimeRangeComponent, FormatTimeFieldValuePipe, ToastComponent, RadioButtonGroupComponent, ExpandCollapseComponent, RadioButtonComponent, InformationBannerComponent, PasswordCriteriaComponent, MobilePasswordCriteriaComponent, InputPasswordComponent, ModalAlertsComponent, BannerAlertsComponent, PanelAlertsComponent, TrainComponent]; } }); })();

function NorthAmericanPhoneValidator(translate, errorLangTerm = 'ui.validators.invalid_phone') {
    let errorMsg = '';
    translate.get(errorLangTerm).pipe(take(1)).subscribe(str => { errorMsg = str; });
    return (control) => {
        const value = control.value;
        const phonePatternRegex = /(?:\d{1}\s)?\(?(\d{3})\)?-?\s?(\d{3})-?\s?(\d{4})/g;
        return value && !value.toLowerCase().match(phonePatternRegex)
            ? { invalidEmail: value, customErrorMsg: errorMsg }
            : null;
    };
}

/**
 * Collapse animation, based on state
 * Transitions: void => *, * => void
 */
function collapseInTransition(duration = "250ms", delay = "250ms", easing = "ease-in") {
    const timings = '{{inDuration}} {{inDelay}} {{inEasing}}';
    return transition('void => *', animate(timings), { params: { inDuration: duration, inDelay: delay, inEasing: easing } });
}
;
function collapseOutTransition(duration = "250ms", delay = "250ms", easing = "ease-in") {
    const timings = '{{outDuration}} {{outDelay}} {{outEasing}}';
    return transition('* => void', animate(timings), { params: { outDuration: duration, outDelay: delay, outEasing: easing } });
}
;
function collapse() {
    return trigger('ui-collapse', [
        state('void', style({
            'height': 0,
            'overflow': 'hidden',
            'opacity': '0',
            'visibility': 'hidden'
        })),
        state('*', style({
            'opacity': '1',
            'overflow': 'hidden',
        })),
        collapseInTransition(),
        collapseOutTransition()
    ]);
}

/**
 * Simple fade animation, based on state
 * Transitions: void => *, * => void
 */
function fadeInTransition(duration = "250ms", delay = "250ms", easing = "ease-in") {
    const timings = '{{inDuration}} {{inDelay}} {{inEasing}}';
    return transition('void => *', animate(timings, keyframes([
        style({ height: 'auto', opacity: '0' }),
        style({ height: 'auto', opacity: '1' }),
    ])), { params: { inDuration: duration, inDelay: delay, inEasing: easing } });
}
function fadeOutTransition(duration = "250ms", delay = "250ms", easing = "ease-in") {
    const timings = '{{outDuration}} {{outDelay}} {{outEasing}}';
    return transition('* => void', animate(timings, keyframes([
        style({ height: 'auto', opacity: '1' }),
        style({ height: 'auto', opacity: '0' }),
    ])), { params: { outDuration: duration, outDelay: delay, outEasing: easing } });
}
function fadeInOut() {
    return trigger('ui-fadeinout', [
        state('void', style({
            height: 'auto',
            overflow: 'hidden',
            opacity: 0
        })),
        fadeInTransition(),
        fadeOutTransition()
    ]);
}

/**
 * Transition for navigating between routes.
 */
function fadeTransition(duration, fromTo) {
    return transition(fromTo || '* <=> *', [
        style({ position: 'relative' }),
        query(':enter, :leave', [
            style({
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%'
            })
        ], { optional: true }),
        query(':enter', [
            style({ opacity: '0' })
        ], { optional: true }),
        query(':leave', animateChild(), { optional: true }),
        group([
            fadeAnimLeave(duration),
            fadeAnimEnter(duration),
        ]),
        query(':enter', animateChild(), { optional: true }),
    ]);
}
;
function fadeAnimEnter(duration = 250, delay = 250, easing = 'ease-out') {
    return query(':enter', [
        animate((duration + 'ms ' + delay + 'ms ' + easing), keyframes([
            style({ opacity: '0' }),
            style({ opacity: '1' })
        ]))
    ], { optional: true });
}
;
function fadeAnimLeave(duration = 250, delay = 0, easing = 'ease-out') {
    return query(':leave', [
        animate((duration + 'ms ' + delay + 'ms ' + easing), keyframes([
            style({ opacity: '1' }),
            style({ opacity: '0' })
        ]))
    ], { optional: true });
}
;
/**
 * Fade transition between routes
 * Out-of-the-box animation
 * Add to component declaration as is
 */
function fadeAnimations() {
    return trigger('ui-routefadeanimations', [
        fadeTransition(300)
    ]);
}
/**
 * Slide Transition for navigating between routes.
 *
 */
function slideTransition(duration, fromTo) {
    return transition(fromTo || '* <=> *', [
        style({ position: 'relative' }),
        query(':enter, :leave', [
            style({
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%'
            })
        ], { optional: true }),
        query(':enter', [
            style({ left: '100%' })
        ], { optional: true }),
        query(':leave', animateChild(), { optional: true }),
        group([
            slideAnimLeave(duration),
            slideAnimEnter(duration),
        ]),
        query(':enter', animateChild(), { optional: true }),
    ]);
}
;
function slideAnimEnter(duration = 250, delay = 0, easing = 'ease-out') {
    return query(':enter', [
        animate((duration + 'ms ' + delay + 'ms ' + easing), keyframes([
            style({ left: '100%' }),
            style({ left: '0%' })
        ]))
    ], { optional: true });
}
;
function slideAnimLeave(duration = 250, delay = 0, easing = 'ease-out') {
    return query(':leave', [
        animate((duration + 'ms ' + delay + 'ms ' + easing), keyframes([
            style({ left: '0%' }),
            style({ left: '-100%' })
        ]))
    ], { optional: true });
}
;
/**
 * Slide transition between routes
 * Out-of-the-box animation
 * Add to component declaration as is
 */
function slideAnimations() {
    return trigger('ui-routeslideanimations', [
        slideTransition(300)
    ]);
}

function slideInLeftTransition(duration = '250ms', delay = '250ms', easing = 'ease-in', from = '100%', to = '0%', state = 'left') {
    const timings = '{{inLeftDuration}} {{inLeftDelay}} {{inLeftEasing}}';
    return transition((fromState, toState) => fromState === 'void' && toState === state, animate(timings, keyframes([
        style({ height: 'auto', opacity: '0', transform: 'translate({{inLeftFrom}})' }),
        style({ height: 'auto', opacity: '1', transform: 'translate({{inLeftTo}})' })
    ])), { params: { inLeftDuration: duration, inLeftDelay: delay, inLeftEasing: easing, inLeftFrom: from, inLeftTo: to } });
}
function slideOutLeftTransition(duration = '250ms', delay = '0ms', easing = 'ease-in', from = '0', to = '100%', state = 'left') {
    const timings = '{{outLeftDuration}} {{outLeftDelay}} {{outLeftEasing}}';
    return transition((fromState, toState) => fromState === state && toState === 'void', animate(timings, keyframes([
        style({ height: 'auto', opacity: '1', transform: 'translate({{outLeftFrom}})' }),
        style({ height: 'auto', opacity: '0', transform: 'translate({{outLeftTo}})' })
    ])), { params: { outLeftDuration: duration, outLeftDelay: delay, outLeftEasing: easing, outLeftFrom: from, outLeftTo: to } });
}
function slideInRightTransition(duration = '250ms', delay = '250ms', easing = 'ease-in', from = '-100%', to = '0', state = 'right') {
    const timings = '{{inRightDuration}} {{inRightDelay}} {{inRightEasing}}';
    return transition((fromState, toState) => fromState === 'void' && toState === state, animate(timings, keyframes([
        style({ height: 'auto', opacity: '0', transform: 'translate({{inRightFrom}})' }),
        style({ height: 'auto', opacity: '1', transform: 'translate({{inRightTo}})' })
    ])), { params: { inRightDuration: duration, inRightDelay: delay, inRightEasing: easing, inRightFrom: from, inRightTo: to } });
}
function slideOutRightTransition(duration = '250ms', delay = '0ms', easing = 'ease-in', from = '0', to = '-100%', state = 'right') {
    const timings = '{{outRightDuration}} {{outRightDelay}} {{outRightEasing}}';
    return transition((fromState, toState) => fromState === state && toState === 'void', animate(timings, keyframes([
        style({ height: 'auto', opacity: '1', transform: 'translate({{outRightFrom}})' }),
        style({ height: 'auto', opacity: '0', transform: 'translate({{outRightTo}})' })
    ])), { params: { outRightDuration: duration, outRightDelay: delay, outRightEasing: easing, outRightFrom: from, outRightTo: to } });
}
function slideInUpTransition(duration = '250ms', delay = '250ms', easing = 'ease-in', from = '100%', to = '0', state = 'up') {
    const timings = '{{inUpDuration}} {{inUpDelay}} {{inUpEasing}}';
    return transition((fromState, toState) => fromState === 'void' && toState === state, animate(timings, keyframes([
        style({ height: 'auto', opacity: '0', transform: 'translate(0, {{inUpFrom}})' }),
        style({ height: 'auto', opacity: '1', transform: 'translate(0, {{inUpTo}})' }),
    ])), { params: { inUpDuration: duration, inUpDelay: delay, inUpEasing: easing, inUpFrom: from, inUpTo: to } });
}
function slideOutUpTransition(duration = '250ms', delay = '250ms', easing = 'ease-in', from = '0', to = '100%', state = 'up') {
    const timings = '{{outUpDuration}} {{outUpDelay}} {{outUpEasing}}';
    return transition((fromState, toState) => fromState === state && toState === 'void', animate(timings, keyframes([
        style({ height: 'auto', opacity: '1', transform: 'translate(0, {{outUpFrom}})' }),
        style({ height: 'auto', opacity: '0', transform: 'translate(0, {{outUpTo}})' })
    ])), { params: { outUpDuration: duration, outUpDelay: delay, outUpEasing: easing, outUpFrom: from, outUpTo: to } });
}
function slideInDownTransition(duration = '250ms', delay = '250ms', easing = 'ease-in', from = '-100%', to = '0', state = 'down') {
    const timings = '{{inDownDuration}} {{inDownDelay}} {{inDownEasing}}';
    return transition((fromState, toState) => fromState === 'void' && toState === state, animate(timings, keyframes([
        style({ height: 'auto', opacity: '1', transform: 'translate(0, {{inDownFrom}})' }),
        style({ height: 'auto', opacity: '0', transform: 'translate(0, {{inDownTo}})' })
    ])), { params: { inDownDuration: duration, inDownDelay: delay, inDownEasing: easing, inDownFrom: from, inDownTo: to } });
}
function slideOutDownTransition(duration = '250ms', delay = '250ms', easing = 'ease-in', from = '0', to = '-100%', state = 'down') {
    const timings = '{{outDownDuration}} {{outDownDelay}} {{outDownEasing}}';
    return transition((fromState, toState) => fromState === state && toState === 'void', animate(timings, keyframes([
        style({ height: 'auto', opacity: '0', transform: 'translate(0, {{outDownFrom}})' }),
        style({ height: 'auto', opacity: '1', transform: 'translate(0, {{outDownTo}})' }),
    ])), { params: { outDownDuration: duration, outDownDelay: delay, outDownEasing: easing, outDownFrom: from, outDownTo: to } });
}
/**
 * Animation for navigating between steps.
 * To use, declare a variable: direction: 'up'|'down'|'left'|'right'.
 * Transitions: void => left, left => void,void => right, right => void, void => up, up => void, void => down, down => void
 */
function slideInOut() {
    return trigger('ui-slideinout', [
        state('void', style({
            height: 0,
            overflow: 'hidden',
            transform: 'translate(200%)'
        })),
        slideInLeftTransition(),
        slideOutLeftTransition(),
        slideInRightTransition(),
        slideOutRightTransition(),
        slideInUpTransition(),
        slideOutUpTransition(),
        slideInDownTransition(),
        slideOutDownTransition(),
    ]);
}

/**
 * Simple fade and slide animation, based on state
 * Transitions: void => *, * => void
 */
function zoomInTransition(duration = "300ms", delay = "300ms", easing = "ease-in") {
    const timings = '{{inDuration}} {{inDelay}} {{inEasing}}';
    return transition('void => *', animate(timings, keyframes([
        style({ opacity: '0', transform: 'scale(0)' }),
        style({ opacity: '0.5', transform: 'scale(0.88)' }),
        style({ opacity: '1', transform: 'scale(1.05)' }),
        style({ transform: 'scale(1.03)' }),
        style({ transform: 'scale(1)' })
    ])), { params: { inDuration: duration, inDelay: delay, inEasing: easing } });
}
function zoomOutTransition(duration = "300ms", delay = "300ms", easing = "ease-in") {
    const timings = '{{outDuration}} {{outDelay}} {{outEasing}}';
    return transition('* => void', animate(timings, keyframes([
        style({ transform: 'scale(1)' }),
        style({ transform: 'scale(1.03)' }),
        style({ opacity: '1', transform: 'scale(1.05)' }),
        style({ opacity: '0.5', transform: 'scale(0.88)' }),
        style({ opacity: '0', transform: 'scale(0)' })
    ])), { params: { outDuration: duration, outDelay: delay, outEasing: easing } });
}
function zoom() {
    return trigger('ui-zoom', [
        state('void', style({
            transform: 'scale(0)',
            opacity: '0',
        })),
        state('*', style({
            transform: 'scale(1.0)',
            opacity: '1'
        })),
        zoomInTransition(),
        zoomOutTransition()
    ]);
}

/*
 * Public API Surface of ui-ng
 */

/**
 * Generated bundle index. Do not edit.
 */

export { ArrowModalDialogDirective, AtleastOneCheckboxRequiredValidator, AttachmentsComponent, BannerAlertsComponent, BreadcrumbItem, BreadcrumbsComponent, BreadcrumbsService, BrowserDetectionComponent, BrowserDetectionService, ButtonDirective, ButtonGroupComponent, CarouselComponent, CheckRadioComponent, CheckboxComponent, CheckradioGroupComponent, ContainerLayoutComponent, ControlsFilterPipe, CookieAdvisoryBannerComponent, CookieExplicitBannerComponent, CookieStatementComponent, CopyrightComponent, DateReformatPipe, DateReformatPipeParams, Direction, DynamicHeadingComponent, DynamicHeadingDirective, ErrorBoxComponent, ErrorComponent, ExpandCollapseComponent, ExpandCollapseService, FieldComponent, FooterComponent, FormControlComponent, FormFieldComponent, FormHelper, FormatTimeFieldValuePipe, GenericEditComponent, HeaderComponent, HiddensComponent, HooksService, ImageContentComponent, InformationBannerComponent, InlineDatepickerComponent, InlineTimePickerComponent, InputComponent, InputDateComponent, InputDateRangeComponent, InputDirective, InputFileComponent, InputGroupComponent, InputPasswordComponent, InputRangeComponent, InputSwitchComponent, InputTimeComponent, InputTimePickerComponent, InputTimePipe, InputTimeRangeComponent, InputTypeaheadComponent, ListViewComponent, LoadingComponent, LoadingService, LoadingSpinnerComponent, MaintenanceComponent, MessageLoaderComponent, MobilePasswordCriteriaComponent, ModalAlertsComponent, ModalComponent, ModalDialogDirective, ModalService, MultiSelectDropdownComponent, MultiSelectToCheckboxComponent, NavBarComponent, NorthAmericanPhoneValidator, NotificationComponent, NotificationService, NotificationsAlertsService, OptionFilterPipe, PageLayoutComponent, PanelAlertsComponent, PasswordCriteriaComponent, PasswordCriterionValidatorService, PopoverDirective, ProgressBarComponent, ProxyUrlComponent, ProxyUrlService, RadioButtonComponent, RadioButtonGroupComponent, RadioComponent, ResponsiveImgComponent, ResponsiveTableComponent, SROnlyLabelDirective, ScrollService, SearchComponent, SelectButtonsComponent, SelectComponent, SkipToMainComponent, StepsComponent, StepsHeaderComponent, StepsService, StickyNavbarComponent, StorageMethod, StorageService, TabGroupComponent, TextAreaComponent, TileViewComponent, TimeLeadingZeroPipe, ToastComponent, ToastService, ToggleSwitchDirective, ToggletipDirective, TooltipComponent, TrackingPixelsComponent, TrackingPixelsService, TrainComponent, TrainService, UINgModule, ValidationCheckerComponent, YesNoComponent, collapse, collapseInTransition, collapseOutTransition, fadeAnimEnter, fadeAnimLeave, fadeAnimations, fadeInOut, fadeInTransition, fadeOutTransition, fadeTransition, slideAnimEnter, slideAnimLeave, slideAnimations, slideInDownTransition, slideInLeftTransition, slideInOut, slideInRightTransition, slideInUpTransition, slideOutDownTransition, slideOutLeftTransition, slideOutRightTransition, slideOutUpTransition, slideTransition, zoom, zoomInTransition, zoomOutTransition, stepsFeatureKey as ɵa, initialState as ɵb, uiStepsReducer as ɵc, sessionStorageMetaReducer as ɵd, metaReducers as ɵe, setSteps as ɵf, resetSteps as ɵg, clearSteps as ɵh, nextStep as ɵi, previousStep as ɵj, setActiveStep as ɵk, updateStepStatus as ɵl };

